/*
 * @license
 * Palo Alto Theme (c)
 *
 * This file is included for advanced development by
 * Shopify Agencies.  Modified versions of the theme
 * code are not supported by Shopify or Presidio Creative.
 *
 * In order to use this file you will need to change
 * theme.js to theme.dev.js in /layout/theme.liquid
 *
 */ (function (scrollLock, Flickity, themeCurrency, Ajaxinate) {
  "use strict";
  (function () {
    const env = { NODE_ENV: "production" };
    try {
      if (process) {
        (process.env = Object.assign({}, process.env)),
          Object.assign(process.env, env);
        return;
      }
    } catch {}
    globalThis.process = { env };
  })(),
    (window.theme = window.theme || {}),
    (window.theme.sizes = {
      mobile: 480,
      small: 768,
      large: 1024,
      widescreen: 1440,
    }),
    (window.theme.keyboardKeys = {
      TAB: "Tab",
      ENTER: "Enter",
      NUMPADENTER: "NumpadEnter",
      ESCAPE: "Escape",
      SPACE: "Space",
      LEFTARROW: "ArrowLeft",
      RIGHTARROW: "ArrowRight",
    }),
    (window.theme.focusable =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  function debounce(fn, time) {
    let timeout;
    return function () {
      if (fn) {
        const functionCall = () => fn.apply(this, arguments);
        clearTimeout(timeout), (timeout = setTimeout(functionCall, time));
      }
    };
  }
  const selectors$1g = {
      body: "body",
      main: "[data-main]",
      header: "[data-site-header]",
      preventTransparentHeader: "[data-prevent-transparent-header]",
    },
    classes$13 = {
      supportsTransparentHeader: "supports-transparent-header",
      siteHeaderTransparent: "site-header--transparent",
      isFirstSectionTransparent: "is-first-section-transparent",
    },
    attributes$T = { transparent: "data-transparent" },
    initTransparentHeader = () => {
      const body = document.querySelector(selectors$1g.body),
        header = body.querySelector(selectors$1g.header);
      if (!header) return;
      const headerTransparent =
          header.getAttribute(attributes$T.transparent) === "true",
        firstSection = body.querySelector(selectors$1g.main).children[0];
      if (!firstSection) return;
      const preventTransparentHeader = firstSection.querySelector(
        `${selectors$1g.preventTransparentHeader}:first-of-type`
      );
      (window.isHeaderTransparent =
        headerTransparent &&
        firstSection.classList.contains(classes$13.supportsTransparentHeader) &&
        !preventTransparentHeader),
        CSS.supports("(selector(:has(*)))") ||
          (body.classList.toggle(
            classes$13.isFirstSectionTransparent,
            window.isHeaderTransparent
          ),
          header.classList.toggle(
            classes$13.siteHeaderTransparent,
            window.isHeaderTransparent
          ));
    },
    selectors$1f = {
      footerParallax: ".section-footer--parallax",
      footerParallaxInner: "[data-section-type]",
      wave: ":scope > [data-wave]",
      sectionsWavy: ".wavy:not(.site-footer)",
      sectionsShadow: ".parallax-shadow:not(.site-footer)",
    },
    classes$12 = {
      wavy: "wavy",
      shadow: "parallax-shadow",
      rounded: "parallax-rounded-corners",
      footerParallax: "section-footer--parallax",
      bodyRoundedCornersLarge: "body--rounded-corners-large",
    },
    attributes$S = { parallaxWavy: "data-parallax-wavy" },
    removeFooterWave = (section) => {
      const currentSection = section,
        wavySections = document.querySelectorAll(selectors$1f.sectionsWavy),
        shadowSections = document.querySelectorAll(selectors$1f.sectionsShadow);
      wavySections.forEach((wavySection) => {
        wavySection.classList.remove(classes$12.wavy),
          [...wavySection.querySelectorAll(selectors$1f.wave)].map((wave) =>
            wave.remove()
          );
      }),
        shadowSections.forEach((shadowSection) => {
          shadowSection.classList.remove(classes$12.shadow),
            shadowSection.classList.remove(classes$12.rounded),
            document.body.classList.remove(classes$12.bodyRoundedCornersLarge),
            [...shadowSection.querySelectorAll(selectors$1f.wave)].map((wave) =>
              wave.remove()
            );
        });
      const footerParallax = document.querySelectorAll(
        selectors$1f.footerParallax
      );
      if (footerParallax.length > 0) {
        const footerParallaxInner = footerParallax[0].querySelector(
          selectors$1f.footerParallaxInner
        );
        footerParallaxInner.hasAttribute(attributes$S.parallaxWavy) &&
          footerParallaxInner.classList.add(classes$12.wavy);
      }
      currentSection.classList.contains(classes$12.footerParallax) ||
        document.dispatchEvent(new CustomEvent("theme:footer:unload"));
    };
  (window.Shopify = window.Shopify || {}),
    (window.Shopify.theme = window.Shopify.theme || {}),
    (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
    (window.Shopify.theme.sections.registered =
      window.Shopify.theme.sections.registered || {}),
    (window.Shopify.theme.sections.instances =
      window.Shopify.theme.sections.instances || []);
  const registered = window.Shopify.theme.sections.registered,
    instances = window.Shopify.theme.sections.instances,
    attributes$R = { id: "data-section-id", type: "data-section-type" };
  class Registration {
    constructor(type = null, components = []) {
      (this.type = type),
        (this.components = validateComponentsArray(components)),
        (this.callStack = {
          onLoad: [],
          onUnload: [],
          onSelect: [],
          onDeselect: [],
          onBlockSelect: [],
          onBlockDeselect: [],
          onReorder: [],
        }),
        components.forEach((comp) => {
          for (const [key, value] of Object.entries(comp)) {
            const arr = this.callStack[key];
            Array.isArray(arr) && typeof value == "function"
              ? arr.push(value)
              : (console.warn(
                  `Unregisted function: '${key}' in component: '${this.type}'`
                ),
                console.warn(value));
          }
        });
    }
    getStack() {
      return this.callStack;
    }
  }
  class Section {
    constructor(container, registration) {
      (this.container = validateContainerElement(container)),
        (this.id = container.getAttribute(attributes$R.id)),
        (this.type = registration.type),
        (this.callStack = registration.getStack());
      try {
        this.onLoad();
      } catch (e) {
        console.warn(`Error in section: ${this.id}`),
          console.warn(this),
          console.warn(e);
      }
    }
    callFunctions(key, e = null) {
      this.callStack[key].forEach((func) => {
        const props = {
          id: this.id,
          type: this.type,
          container: this.container,
        };
        e ? func.call(props, e) : func.call(props);
      });
    }
    onLoad() {
      this.callFunctions("onLoad");
    }
    onUnload() {
      this.callFunctions("onUnload");
    }
    onSelect(e) {
      this.callFunctions("onSelect", e);
    }
    onDeselect(e) {
      this.callFunctions("onDeselect", e);
    }
    onBlockSelect(e) {
      this.callFunctions("onBlockSelect", e);
    }
    onBlockDeselect(e) {
      this.callFunctions("onBlockDeselect", e);
    }
    onReorder(e) {
      this.callFunctions("onReorder", e);
    }
  }
  function validateContainerElement(container) {
    if (!(container instanceof Element))
      throw new TypeError(
        "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
      );
    if (container.getAttribute(attributes$R.id) === null)
      throw new Error(
        "Theme Sections: The section container provided does not have an id assigned to the " +
          attributes$R.id +
          " attribute."
      );
    return container;
  }
  function validateComponentsArray(value) {
    if ((typeof value < "u" && typeof value != "object") || value === null)
      throw new TypeError(
        "Theme Sections: The components object provided is not a valid"
      );
    return value;
  }
  function register(type, components) {
    if (typeof type != "string")
      throw new TypeError(
        "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
      );
    if (typeof registered[type] < "u")
      throw new Error(
        'Theme Sections: A section of type "' +
          type +
          '" has already been registered. You cannot register the same section type twice'
      );
    Array.isArray(components) || (components = [components]);
    const section = new Registration(type, components);
    return (registered[type] = section), registered;
  }
  function load(types, containers) {
    (types = normalizeType(types)),
      typeof containers > "u" &&
        (containers = document.querySelectorAll("[" + attributes$R.type + "]")),
      (containers = normalizeContainers(containers)),
      types.forEach(function (type) {
        const registration = registered[type];
        typeof registration > "u" ||
          (containers = containers.filter(function (container) {
            return isInstance(container) ||
              container.getAttribute(attributes$R.type) === null
              ? !1
              : container.getAttribute(attributes$R.type) !== type
              ? !0
              : (instances.push(new Section(container, registration)), !1);
          }));
      });
  }
  function reorder(selector) {
    var instancesToReorder = getInstances(selector);
    instancesToReorder.forEach(function (instance) {
      instance.onReorder();
    });
  }
  function unload(selector) {
    var instancesToUnload = getInstances(selector);
    instancesToUnload.forEach(function (instance) {
      var index = instances
        .map(function (e) {
          return e.id;
        })
        .indexOf(instance.id);
      instances.splice(index, 1), instance.onUnload();
    });
  }
  function getInstances(selector) {
    var filteredInstances = [];
    if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector))
      var firstElement = selector[0];
    if (selector instanceof Element || firstElement instanceof Element) {
      var containers = normalizeContainers(selector);
      containers.forEach(function (container) {
        filteredInstances = filteredInstances.concat(
          instances.filter(function (instance) {
            return instance.container === container;
          })
        );
      });
    } else if (typeof selector == "string" || typeof firstElement == "string") {
      var types = normalizeType(selector);
      types.forEach(function (type) {
        filteredInstances = filteredInstances.concat(
          instances.filter(function (instance) {
            return instance.type === type;
          })
        );
      });
    }
    return filteredInstances;
  }
  function getInstanceById(id) {
    for (var instance, i = 0; i < instances.length; i++)
      if (instances[i].id === id) {
        instance = instances[i];
        break;
      }
    return instance;
  }
  function isInstance(selector) {
    return getInstances(selector).length > 0;
  }
  function normalizeType(types) {
    return (
      types === "*"
        ? (types = Object.keys(registered))
        : typeof types == "string"
        ? (types = [types])
        : types.constructor === Section
        ? (types = [types.prototype.type])
        : Array.isArray(types) &&
          types[0].constructor === Section &&
          (types = types.map(function (Section2) {
            return Section2.type;
          })),
      (types = types.map(function (type) {
        return type.toLowerCase();
      })),
      types
    );
  }
  function normalizeContainers(containers) {
    return (
      NodeList.prototype.isPrototypeOf(containers) && containers.length > 0
        ? (containers = Array.prototype.slice.call(containers))
        : NodeList.prototype.isPrototypeOf(containers) &&
          containers.length === 0
        ? (containers = [])
        : containers === null
        ? (containers = [])
        : !Array.isArray(containers) &&
          containers instanceof Element &&
          (containers = [containers]),
      containers
    );
  }
  window.Shopify.designMode &&
    (document.addEventListener("shopify:section:load", function (event2) {
      var id = event2.detail.sectionId,
        container = event2.target.querySelector(
          "[" + attributes$R.id + '="' + id + '"]'
        );
      window.Shopify.visualPreviewMode === !0 &&
        container === null &&
        (container = event2.target.querySelector(`[${attributes$R.id}]`)),
        container !== null &&
          load(container.getAttribute(attributes$R.type), container);
    }),
    document.addEventListener("shopify:section:reorder", function (event2) {
      var id = event2.detail.sectionId,
        container = event2.target.querySelector(
          "[" + attributes$R.id + '="' + id + '"]'
        ),
        instance = getInstances(container)[0];
      typeof instance == "object" && reorder(container);
    }),
    document.addEventListener("shopify:section:unload", function (event2) {
      var id = event2.detail.sectionId,
        container = event2.target.querySelector(
          "[" + attributes$R.id + '="' + id + '"]'
        ),
        instance = getInstances(container)[0];
      typeof instance == "object" && unload(container);
    }),
    document.addEventListener("shopify:section:select", function (event2) {
      var instance = getInstanceById(event2.detail.sectionId);
      typeof instance == "object" && instance.onSelect(event2);
    }),
    document.addEventListener("shopify:section:deselect", function (event2) {
      var instance = getInstanceById(event2.detail.sectionId);
      typeof instance == "object" && instance.onDeselect(event2);
    }),
    document.addEventListener("shopify:block:select", function (event2) {
      var instance = getInstanceById(event2.detail.sectionId);
      typeof instance == "object" && instance.onBlockSelect(event2);
    }),
    document.addEventListener("shopify:block:deselect", function (event2) {
      var instance = getInstanceById(event2.detail.sectionId);
      typeof instance == "object" && instance.onBlockDeselect(event2);
    }));
  const selectors$1e = { cardScrolling: '[data-parallax="card-scrolling"]' },
    reloadCardScrolling = () => {
      setTimeout(() => {
        window.Shopify.theme.sections.instances
          .filter((instance) => {
            const isSliderSection = instance.type === "slider",
              isBannerImageSection = instance.type === "banner-image",
              hasCardScrollingEffect = instance.container.matches(
                selectors$1e.cardScrolling
              );
            return (
              (isSliderSection && hasCardScrollingEffect) ||
              (isBannerImageSection && hasCardScrollingEffect)
            );
          })
          .forEach((instance) => {
            unload(instance.id), setTimeout(() => load(instance.id));
          });
      });
    };
  let screenOrientation = getScreenOrientation();
  const selectors$1d = {
      body: "body",
      main: "[data-main]",
      collectionFilters: "[data-collection-filters]",
      footer: '[data-section-type*="footer"]',
      header: "[data-header-height]",
      stickyHeader: '[data-site-header][data-position="fixed"]',
      announcementBar: "[data-announcement-bar]",
      collectionStickyBar: "[data-collection-sticky-bar]",
      logoTextLink: "[data-logo-text-link]",
    },
    classes$11 = {
      templateCollection: "template-collection",
      templateSearch: "template-search",
      supportsTransparentHeader: "supports-transparent-header",
    };
  function readHeights() {
    const h = {};
    return (
      (h.windowHeight = Math.min(window.screen.height, window.innerHeight)),
      (h.footerHeight = getHeight(selectors$1d.footer)),
      (h.headerHeight = getHeight(selectors$1d.header)),
      (h.stickyHeaderHeight = isHeaderSticky() ? window.stickyHeaderHeight : 0),
      (h.headerInitialHeight =
        parseInt(
          document.querySelector(selectors$1d.header)?.dataset.height ||
            document.querySelector(selectors$1d.header)?.offsetHeight
        ) || 0),
      (h.announcementBarHeight = getHeight(selectors$1d.announcementBar)),
      (h.collectionStickyBarHeight = getHeight(
        selectors$1d.collectionStickyBar
      )),
      h
    );
  }
  function setVarsOnResize() {
    document.addEventListener("theme:resize", resizeVars),
      setVars(),
      document.dispatchEvent(new CustomEvent("theme:vars"), { bubbles: !1 });
  }
  function setVars() {
    calcVars();
  }
  function resizeVars() {
    calcVars(!0);
  }
  function calcVars(checkOrientation = !1) {
    const body = document.querySelector(selectors$1d.body),
      hasCollectionFilters = document.querySelector(
        selectors$1d.collectionFilters
      ),
      hasLogoTextLink =
        document.querySelector(selectors$1d.logoTextLink) !== null;
    let {
      windowHeight,
      headerHeight,
      headerInitialHeight,
      announcementBarHeight,
      footerHeight,
      collectionStickyBarHeight,
    } = readHeights();
    hasLogoTextLink && (headerHeight = recalcHeaderHeight());
    const contentFullHeight =
      window.isHeaderTransparent && checkFirstSectionTransparency()
        ? windowHeight - announcementBarHeight
        : windowHeight - headerInitialHeight - announcementBarHeight;
    let fullHeight = isHeaderSticky()
      ? windowHeight - window.stickyHeaderHeight
      : windowHeight;
    const isCollectionPage = body.classList.contains(
        classes$11.templateCollection
      ),
      isSearchPage = body.classList.contains(classes$11.templateSearch),
      isPageWithFilters =
        (isCollectionPage && hasCollectionFilters) ||
        (isSearchPage && hasCollectionFilters);
    if (
      (document.documentElement.style.setProperty(
        "--footer-height",
        `${footerHeight}px`
      ),
      document.documentElement.style.setProperty(
        "--content-full",
        `${contentFullHeight}px`
      ),
      document.documentElement.style.setProperty(
        "--content-min",
        `${windowHeight - headerHeight - footerHeight}px`
      ),
      document.documentElement.style.setProperty(
        "--collection-sticky-bar-height",
        `${collectionStickyBarHeight}px`
      ),
      isPageWithFilters && (fullHeight = windowHeight),
      !checkOrientation)
    ) {
      document.documentElement.style.setProperty(
        "--full-height",
        `${fullHeight}px`
      );
      return;
    }
    const currentScreenOrientation = getScreenOrientation();
    currentScreenOrientation !== screenOrientation &&
      (document.documentElement.style.setProperty(
        "--full-height",
        `${fullHeight}px`
      ),
      (screenOrientation = currentScreenOrientation));
  }
  function getHeight(selector) {
    const el = document.querySelector(selector);
    return el ? el.clientHeight : 0;
  }
  function checkFirstSectionTransparency() {
    return document
      .querySelector(selectors$1d.main)
      .firstElementChild.classList.contains(
        classes$11.supportsTransparentHeader
      );
  }
  function isHeaderSticky() {
    return document.querySelector(selectors$1d.stickyHeader);
  }
  function getScreenOrientation() {
    if (window.matchMedia("(orientation: portrait)").matches) return "portrait";
    if (window.matchMedia("(orientation: landscape)").matches)
      return "landscape";
  }
  function recalcHeaderHeight() {
    document.documentElement.style.setProperty("--header-height", "auto"),
      document.documentElement.style.setProperty(
        "--header-sticky-height",
        "auto"
      );
    const resetHeight = document.querySelector(
      selectors$1d.header
    ).offsetHeight;
    return (
      requestAnimationFrame(() => {
        document.documentElement.style.setProperty(
          "--header-height",
          `${resetHeight}px`
        ),
          document.documentElement.style.setProperty(
            "--header-sticky-height",
            `${resetHeight}px`
          );
      }),
      resetHeight
    );
  }
  const selectors$1c = {
    overflowBackground: "[data-overflow-background]",
    overflowFrame: "[data-overflow-frame]",
    overflowContent: "[data-overflow-content]",
    overflowContainer: "[data-overflow-container]",
    overflowWrapper: "[data-overflow-wrapper]",
  };
  function singles(frame, wrappers) {
    let tallest = 0;
    wrappers.forEach((wrap2) => {
      tallest = wrap2.offsetHeight > tallest ? wrap2.offsetHeight : tallest;
    });
    const images = frame.querySelectorAll(selectors$1c.overflowBackground);
    [frame, ...images].forEach((el) => {
      el.style.setProperty(
        "min-height",
        `calc(${tallest}px + var(--header-height))`
      );
    });
  }
  function doubles(section) {
    if (window.innerWidth < window.theme.sizes.small) {
      section
        .querySelectorAll(selectors$1c.overflowFrame)
        .forEach((singleframe) => {
          const wrappers = singleframe.querySelectorAll(
            selectors$1c.overflowContent
          );
          singles(singleframe, wrappers);
        });
      return;
    }
    let tallest = 0;
    const frames = section.querySelectorAll(selectors$1c.overflowFrame);
    section
      .querySelectorAll(selectors$1c.overflowContent)
      .forEach((content) => {
        content.offsetHeight > tallest && (tallest = content.offsetHeight);
      });
    const images = section.querySelectorAll(selectors$1c.overflowBackground);
    [...frames, ...images].forEach((el) => {
      el.style.setProperty("min-height", `${tallest}px`);
    }),
      section.style.setProperty("min-height", `${tallest}px`);
  }
  function preventOverflow(container) {
    const singleFrames = container.querySelectorAll(
      selectors$1c.overflowContainer
    );
    singleFrames &&
      singleFrames.forEach((frame) => {
        const wrappers = frame.querySelectorAll(selectors$1c.overflowContent);
        singles(frame, wrappers),
          document.addEventListener("theme:resize", () => {
            singles(frame, wrappers);
          });
      });
    const doubleSections = container.querySelectorAll(
      selectors$1c.overflowWrapper
    );
    doubleSections &&
      doubleSections.forEach((section) => {
        doubles(section),
          document.addEventListener("theme:resize", () => {
            doubles(section);
          });
      });
  }
  window.lastWindowWidth = window.innerWidth;
  function dispatchResizeEvent() {
    document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 })),
      window.lastWindowWidth !== window.innerWidth &&
        (document.dispatchEvent(
          new CustomEvent("theme:resize:width", { bubbles: !0 })
        ),
        (window.lastWindowWidth = window.innerWidth));
  }
  function resizeListener() {
    window.addEventListener("resize", debounce(dispatchResizeEvent, 50));
  }
  let prev = window.pageYOffset,
    up = null,
    down = null,
    wasUp = null,
    wasDown = null,
    scrollLockTimer$1 = 0;
  const classes$10 = {
    quickViewVisible: "js-quick-view-visible",
    cartDrawerOpen: "js-drawer-open-cart",
  };
  function dispatchScrollEvent() {
    const position = window.pageYOffset;
    position > prev
      ? ((down = !0), (up = !1))
      : position < prev
      ? ((down = !1), (up = !0))
      : ((up = null), (down = null)),
      (prev = position),
      document.dispatchEvent(
        new CustomEvent("theme:scroll", {
          detail: { up, down, position },
          bubbles: !1,
        })
      ),
      up &&
        !wasUp &&
        document.dispatchEvent(
          new CustomEvent("theme:scroll:up", {
            detail: { position },
            bubbles: !1,
          })
        ),
      down &&
        !wasDown &&
        document.dispatchEvent(
          new CustomEvent("theme:scroll:down", {
            detail: { position },
            bubbles: !1,
          })
        ),
      (wasDown = down),
      (wasUp = up);
  }
  function lock(e) {
    setTimeout(() => {
      scrollLockTimer$1 && clearTimeout(scrollLockTimer$1),
        scrollLock.disablePageScroll(e.detail, {
          allowTouchMove: (el) => el.tagName === "TEXTAREA",
        }),
        document.documentElement.setAttribute("data-scroll-locked", "");
    });
  }
  function unlock(e) {
    const timeout = e.detail;
    timeout
      ? (scrollLockTimer$1 = setTimeout(removeScrollLock, timeout))
      : removeScrollLock();
  }
  function removeScrollLock() {
    document.body.classList.contains(classes$10.quickViewVisible) ||
      document.body.classList.contains(classes$10.cartDrawerOpen) ||
      (scrollLock.clearQueueScrollLocks(),
      scrollLock.enablePageScroll(),
      document.documentElement.removeAttribute("data-scroll-locked"));
  }
  function scrollListener() {
    let timeout;
    window.addEventListener(
      "scroll",
      function () {
        timeout && window.cancelAnimationFrame(timeout),
          (timeout = window.requestAnimationFrame(function () {
            dispatchScrollEvent();
          }));
      },
      { passive: !0 }
    ),
      window.addEventListener("theme:scroll:lock", lock),
      window.addEventListener("theme:scroll:unlock", unlock);
  }
  const wrap = (toWrap, wrapperClass = "", wrapperOption) => {
    const wrapper = wrapperOption || document.createElement("div");
    return (
      wrapper.classList.add(wrapperClass),
      wrapper.setAttribute("data-scroll-lock-scrollable", ""),
      toWrap.parentNode.insertBefore(wrapper, toWrap),
      wrapper.appendChild(toWrap)
    );
  };
  function wrapElements(container) {
    container.querySelectorAll("table").forEach((table) => {
      wrap(table, "table-wrapper");
    });
  }
  function isTouchDevice() {
    return (
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    );
  }
  function isTouch() {
    isTouchDevice()
      ? ((document.documentElement.className =
          document.documentElement.className.replace(
            "no-touch",
            "supports-touch"
          )),
        (window.theme.touch = !0))
      : (window.theme.touch = !1);
  }
  const classes$$ = { loading: "is-loading", imgIn: "img-in" },
    selectors$1b = { img: "img.is-loading", section: "[data-section-type]" };
  function loadedImagesEventHook() {
    document.addEventListener(
      "load",
      (e) => {
        if (
          e.target.tagName.toLowerCase() == "img" &&
          e.target.classList.contains(classes$$.loading)
        ) {
          e.target.classList.remove(classes$$.loading),
            e.target.parentNode.classList.remove(classes$$.loading);
          const section = e.target.closest(selectors$1b.section);
          section && section.classList.add(classes$$.imgIn);
        }
      },
      !0
    );
  }
  function removeLoadingClassFromLoadedImages(container) {
    container.querySelectorAll(selectors$1b.img).forEach((img) => {
      if (img.complete) {
        img.classList.remove(classes$$.loading),
          img.parentNode.classList.remove(classes$$.loading);
        const section = img.closest(selectors$1b.section);
        section && section.classList.add(classes$$.imgIn);
      }
    });
  }
  const selectors$1a = {
      img: "img",
      template: "template",
      shopifySection: ".shopify-section",
      deferredContent: "[data-deferred-content]",
      reloadSrcsetException: "[data-product-image]",
    },
    attributes$Q = {
      srcset: "srcset",
      loaded: "data-loaded",
      deferredContainer: "data-deferred-container",
    };
  class DeferredLoading extends HTMLElement {
    constructor() {
      super(),
        (this.container = this),
        this.hasAttribute(attributes$Q.deferredContainer) &&
          (this.container =
            this.closest(this.getAttribute(attributes$Q.deferredContainer)) ||
            this.closest(selectors$1a.shopifySection)),
        (this.deferredTriggers = this.container.querySelectorAll(
          this.dataset.deferredTriggers
        ));
    }
    connectedCallback() {
      if (this.deferredTriggers.length == 0) {
        this.container.addEventListener(
          "mouseenter",
          () => {
            this.hasAttribute(attributes$Q.loaded) || this.loadTemplate();
          },
          { once: !0 }
        );
        return;
      }
      this.deferredTriggers.forEach((trigger) => {
        trigger.addEventListener(
          "mouseenter",
          () => {
            this.hasAttribute(attributes$Q.loaded) || this.loadTemplate();
          },
          { once: !0 }
        );
      });
    }
    loadTemplate() {
      const content = document.createElement("div"),
        template2 = this.querySelector(selectors$1a.template);
      if (!template2 || !template2?.content?.firstElementChild) return;
      content.appendChild(template2.content.firstElementChild.cloneNode(!0));
      const deferredContent = content.querySelector(
        selectors$1a.deferredContent
      );
      if (!deferredContent) return;
      this.append(deferredContent),
        this.setAttribute(attributes$Q.loaded, !0),
        deferredContent.querySelectorAll(selectors$1a.img).length > 0 &&
          this.reloadSrcset(this);
    }
    reloadSrcset(container) {
      container &&
        container.querySelectorAll(selectors$1a.img).forEach((img) => {
          if (!img.parentNode.matches(selectors$1a.reloadSrcsetException)) {
            const srcset = img.getAttribute(attributes$Q.srcset);
            img.setAttribute(attributes$Q.srcset, ""),
              img.setAttribute(attributes$Q.srcset, srcset);
          }
        });
    }
  }
  const selectors$19 = {
      link: "[data-has-highlight]",
      highlightHolder: "[data-highlight-holder]",
      path: "path",
      sup: "sup",
      flickityEnabled: ".flickity-enabled",
      activeSlide: "[data-slide].is-selected",
      stickyTextItem: "[data-sticky-text]",
      textCountUp: "text-count-up",
    },
    attributes$P = {
      highlightType: "data-highlight-type",
      isActive: "data-is-active",
    },
    classes$_ = { isActive: "is-active" },
    settings$b = {
      "circle-hand-drawn": {
        keyframes: [
          { strokeDashoffset: "1", opacity: "0" },
          { opacity: "1", offset: 0.01 },
          { strokeDashoffset: "0", opacity: "1" },
        ],
        timing: {
          duration: 1e3,
          delay: 500,
          iterations: 1,
          fill: "forwards",
          easing: "cubic-bezier(0.7, 0, 0.3, 1)",
        },
      },
      circle: {
        keyframes: [
          { strokeDashoffset: "506", opacity: "0" },
          { opacity: "1", offset: 0.01 },
          { strokeDashoffset: "0", opacity: "1" },
        ],
        timing: {
          duration: 800,
          delay: 500,
          iterations: 1,
          fill: "forwards",
          easing: "cubic-bezier(0.6, 0, 0.4, 1)",
        },
      },
      highlight: {
        keyframes: [{ transform: "scaleX(0)" }, { transform: "scaleX(1)" }],
        timing: {
          duration: 600,
          delay: 700,
          iterations: 1,
          fill: "forwards",
          easing: "ease",
          pseudoElement: "::before",
        },
        keyframesHover: [
          { transform: "scaleY(0.1)" },
          { transform: "scaleY(1)" },
        ],
      },
      "highlight-color": {
        keyframes: [
          { backgroundSize: "200% 100%", backgroundPosition: "100% 0" },
          {
            backgroundSize: "200% 100%",
            backgroundPosition: "0 0",
            offset: 0.2,
          },
          { backgroundSize: "1100% 100%", backgroundPosition: "0 0" },
        ],
        timing: {
          duration: 2e3,
          delay: 700,
          iterations: 1,
          fill: "forwards",
          easing: "cubic-bezier(0, 0, 0.9, 0.4)",
        },
      },
      squiggle: {
        keyframes: [{ maskPosition: "100% 0" }, { maskPosition: "0 0" }],
        timing: {
          duration: 1200,
          delay: 700,
          iterations: 1,
          fill: "forwards",
          easing: "cubic-bezier(0.6, 0, 0.4, 1)",
        },
      },
      stroke: {
        keyframes: [
          { backgroundPosition: "100% 0" },
          { backgroundPosition: "0 0" },
        ],
        timing: {
          duration: 1200,
          delay: 500,
          iterations: 1,
          fill: "forwards",
          easing: "cubic-bezier(0.25, 0.1, 0.9, 0.3)",
        },
      },
      underline: {
        keyframes: [{ transform: "scaleX(0)" }, { transform: "scaleX(1)" }],
        timing: {
          duration: 900,
          delay: 700,
          iterations: 1,
          fill: "forwards",
          easing: "ease",
          pseudoElement: "::before",
        },
      },
      "underline-hand-drawn": {
        keyframes: [
          { strokeDashoffset: "1", opacity: "0" },
          { opacity: "1", offset: 0.01 },
          { strokeDashoffset: "0", opacity: "1" },
        ],
        timing: {
          duration: 1e3,
          delay: 500,
          iterations: 1,
          fill: "forwards",
          easing: "cubic-bezier(0.7, 0, 0.3, 1)",
        },
      },
    };
  class TextHighlight extends HTMLElement {
    static observedAttributes = [attributes$P.isActive];
    constructor() {
      super(),
        (this.animation = null),
        (this.bind = null),
        (this.boundAnimation = null),
        (this.link = this.closest(selectors$19.link)),
        (this.type = this.getAttribute(attributes$P.highlightType)),
        (this.highlightHolder = this.querySelector(
          selectors$19.highlightHolder
        )),
        (this.textCountUp = this.closest(selectors$19.textCountUp)),
        (this.sup = this.querySelector(selectors$19.sup)),
        (this.target = this.highlightHolder),
        (this.type === "circle-hand-drawn" ||
          this.type === "circle" ||
          this.type === "underline-hand-drawn") &&
          (this.target = this.querySelector(selectors$19.path)),
        (this.type === "highlight-color" || this.type === "stroke") &&
          this.sup &&
          (this.bind = this.sup);
    }
    connectedCallback() {
      (this.timeout = null),
        (this.controller = new AbortController()),
        !(!this.type || !this.target) &&
          ((this.animation = this.target.animate(
            settings$b[this.type].keyframes,
            settings$b[this.type].timing
          )),
          this.animation.pause(),
          this.bindAnimation("init"),
          this.bindAnimation("pause"),
          this.modifyDefaults("slider"),
          this.animation &&
            (this.link && this.listen(),
            theme.settings.animationsEnabled ||
              (this.animation.play(), this.bindAnimation("play"))));
    }
    disconnectedCallback() {
      this.controller.abort();
    }
    attributeChangedCallback(name, oldValue, newValue) {
      const isActiveChange = name === attributes$P.isActive,
        initialActiveSetting = oldValue === null && isActiveChange,
        becomesActive = newValue === "true";
      isActiveChange &&
        becomesActive &&
        (this.textCountUp
          ? (clearTimeout(this.timeout),
            (this.timeout = setTimeout(() => {
              this.setAnimationDelay(0), this.animate();
            }, 100)))
          : this.animate()),
        !initialActiveSetting && !becomesActive && this.reset();
    }
    listen() {
      this.link.addEventListener(
        "mouseenter",
        (event2) => this.onMouseenter(event2),
        { signal: this.controller.signal }
      ),
        this.link.addEventListener(
          "mouseleave",
          (event2) => this.onMouseleave(event2),
          { signal: this.controller.signal }
        );
    }
    animate() {
      this.animation &&
        (this.animation.play(),
        this.bindAnimation("play"),
        (this.animation.onfinish = () => this.onFinish()));
    }
    shouldAnimate() {
      requestAnimationFrame(() => {
        let shouldAnimate = !0;
        !!this.closest(selectors$19.flickityEnabled) &&
          (shouldAnimate = !!this.closest(selectors$19.activeSlide));
        const stickyTextItem = this.closest(selectors$19.stickyTextItem);
        stickyTextItem &&
          (shouldAnimate = !!stickyTextItem.classList.contains(
            classes$_.isActive
          )),
          this.setTriggerAttribute(shouldAnimate);
      });
    }
    setTriggerAttribute(active = !0) {
      this.setAttribute(attributes$P.isActive, active);
    }
    reset() {
      this.animation &&
        (this.animation.cancel(),
        this.bindAnimation("cancel"),
        this.setAnimationDelay(settings$b[this.type].timing.delay));
    }
    onMouseenter(event2) {
      event2.stopImmediatePropagation(),
        this.setAnimationDelay(0),
        this.modifyDefaults("mouseenter"),
        this.animation.reverse(),
        this.bindAnimation("mouseenter");
    }
    onMouseleave(event2) {
      event2.stopImmediatePropagation(),
        this.modifyDefaults("mouseleave"),
        this.animation.reverse(),
        this.bindAnimation("mouseleave");
    }
    onFinish() {
      if (this.hasAttribute(attributes$P.isActive)) {
        const delay =
          this.getAttribute(attributes$P.isActive) === "true"
            ? 0
            : settings$b[this.type].timing.delay;
        this.setAnimationDelay(delay);
        return;
      }
      this.setAnimationDelay(0);
    }
    setAnimationDelay(number = 0) {
      this.animation.effect.getTiming().delay !== number &&
        (this.animation.effect.updateTiming({ delay: number }),
        this.bindAnimation("delay"));
    }
    modifyDefaults(usage = "mouseenter", animation) {
      if ((animation || (animation = this.animation), usage === "mouseenter")) {
        settings$b[this.type].keyframesHover &&
          animation.effect.setKeyframes(settings$b[this.type].keyframesHover),
          this.type === "highlight" &&
            animation.effect.updateTiming({ duration: 350, fill: "both" }),
          this.type === "highlight-color" &&
            animation.effect.updateTiming({ duration: 800 }),
          this.type === "underline" &&
            animation.effect.updateTiming({ duration: 400 });
        return;
      }
      if (usage === "mouseleave") {
        settings$b[this.type].keyframesHover &&
          animation.effect.setKeyframes(settings$b[this.type].keyframes),
          (this.type === "highlight" ||
            this.type === "highlight-color" ||
            this.type === "underline") &&
            animation.effect.updateTiming({
              duration: settings$b[this.type].timing.duration,
            });
        return;
      }
      if (
        usage === "slider" &&
        (theme.settings.animationsEnabled ||
          ((settings$b[this.type].timing.delay = 300),
          animation.effect.updateTiming({
            delay: settings$b[this.type].timing.delay,
          })),
        this.closest(selectors$19.flickityEnabled))
      ) {
        const slideshowDelay = settings$b[this.type].timing.delay + 200;
        this.type === "highlight" &&
          animation.effect.updateTiming({ delay: slideshowDelay });
      }
    }
    bindAnimation(event2 = !1) {
      if (
        !(!this.bind || !event2) &&
        (event2 === "init" &&
          (this.boundAnimation = this.bind.animate(
            settings$b[this.type].keyframes,
            settings$b[this.type].timing
          )),
        event2 === "pause" && this.boundAnimation.pause(),
        event2 === "play" && this.boundAnimation.play(),
        event2 === "cancel" && this.boundAnimation.cancel(),
        event2 === "mouseenter" &&
          (this.modifyDefaults("mouseenter", this.boundAnimation),
          this.boundAnimation.reverse()),
        event2 === "mouseleave" &&
          (this.modifyDefaults("mouseleave", this.boundAnimation),
          this.boundAnimation.reverse()),
        event2 === "delay")
      ) {
        const delay = this.animation.effect.getTiming().delay;
        this.boundAnimation.effect.getTiming().delay !== delay &&
          this.boundAnimation.effect.updateTiming({ delay });
      }
    }
  }
  const selectors$18 = {
      inputSearch: 'input[type="search"]',
      inputType: 'input[name="type"]',
      form: "form",
      allVisibleElements: '[role="option"]',
      ariaSelected: '[aria-selected="true"]',
      selectedOption: '[aria-selected="true"] a, button[aria-selected="true"]',
      popularSearches: "[data-popular-searches]",
      popdownBody: "[data-popdown-body]",
      mainInputSearch: "[data-main-input-search]",
      predictiveSearchResults: "[data-predictive-search-results]",
      predictiveSearch: "predictive-search",
      searchForm: "search-form",
    },
    classes$Z = {
      isSearched: "is-searched",
      templateSearch: "template-search",
    };
  class SearchForm extends HTMLElement {
    constructor() {
      super(),
        (this.input = this.querySelector(selectors$18.inputSearch)),
        (this.form = this.querySelector(selectors$18.form)),
        (this.popdownBody = this.closest(selectors$18.popdownBody)),
        (this.popularSearches = this.popdownBody?.querySelector(
          selectors$18.popularSearches
        )),
        (this.predictiveSearchResults = this.querySelector(
          selectors$18.predictiveSearchResults
        )),
        (this.predictiveSearch = this.matches(selectors$18.predictiveSearch)),
        (this.searchForm = this.matches(selectors$18.searchForm)),
        (this.selectedElement = null),
        (this.activeElement = null),
        (this.searchTerm = ""),
        (this.currentSearchTerm = ""),
        (this.isSearchPage = document.body.classList.contains(
          classes$Z.templateSearch
        )),
        this.input.addEventListener(
          "input",
          debounce((event2) => {
            this.onChange(event2);
          }, 300).bind(this)
        ),
        this.input.addEventListener("focus", this.onFocus.bind(this)),
        this.input.form.addEventListener(
          "submit",
          this.onFormSubmit.bind(this)
        ),
        this.addEventListener("keyup", this.onKeyup.bind(this)),
        this.addEventListener("keydown", this.onKeydown.bind(this)),
        this.isSearchPage &&
          ((this.mainInputType = document.querySelector(
            `${selectors$18.mainInputSearch} ${selectors$18.inputType}`
          )),
          (this.inputType = this.querySelector(selectors$18.inputType)),
          (this.inputType.value = this.mainInputType.value));
    }
    getQuery() {
      return this.input.value.trim();
    }
    onFocus() {
      this.currentSearchTerm = this.getQuery();
    }
    onChange() {
      this.classList.toggle(classes$Z.isSearched, !this.isFormCleared()),
        (this.searchTerm = this.getQuery());
    }
    isFormCleared() {
      return this.input.value.length === 0;
    }
    submit() {
      this.form.submit();
    }
    reset() {
      this.input.val = "";
    }
    onFormSubmit(event2) {
      (!this.getQuery().length ||
        this.querySelector(selectors$18.selectedLink)) &&
        event2.preventDefault();
    }
    onKeydown(event2) {
      (event2.code === "ArrowUp" || event2.code === "ArrowDown") &&
        event2.preventDefault();
    }
    onKeyup(event2) {
      switch (
        (!this.getQuery().length && this.predictiveSearch && this.close(!0),
        event2.preventDefault(),
        event2.code)
      ) {
        case "ArrowUp":
          this.switchOption("up");
          break;
        case "ArrowDown":
          this.switchOption("down");
          break;
        case "Enter":
          this.selectOption();
          break;
      }
    }
    switchOption(direction) {
      const moveUp = direction === "up",
        visibleElementsContainer =
          this.classList.contains(classes$Z.isSearched) &&
          this.predictiveSearchResults
            ? this.predictiveSearchResults
            : this.popularSearches;
      if (!visibleElementsContainer) return;
      this.selectedElement = visibleElementsContainer.querySelector(
        selectors$18.ariaSelected
      );
      const allVisibleElements = Array.from(
        visibleElementsContainer.querySelectorAll(
          selectors$18.allVisibleElements
        )
      ).filter((element) => element.offsetParent !== null);
      let activeElementIndex = 0;
      if (moveUp && !this.selectedElement) return;
      let selectedElementIndex = -1,
        i = 0;
      for (; selectedElementIndex === -1 && i <= allVisibleElements.length; )
        allVisibleElements[i] === this.selectedElement &&
          (selectedElementIndex = i),
          i++;
      !moveUp && this.selectedElement
        ? (activeElementIndex =
            selectedElementIndex === allVisibleElements.length - 1
              ? 0
              : selectedElementIndex + 1)
        : moveUp &&
          (activeElementIndex =
            selectedElementIndex === 0
              ? allVisibleElements.length - 1
              : selectedElementIndex - 1),
        activeElementIndex !== selectedElementIndex &&
          ((this.activeElement = allVisibleElements[activeElementIndex]),
          this.handleFocusableDescendants());
    }
    selectOption() {
      const selectedOption = this.querySelector(selectors$18.selectedOption);
      selectedOption && selectedOption.click();
    }
    handleFocusableDescendants(reset = !1) {
      const selected = this.selectedElement
        ? this.selectedElement
        : this.querySelector(selectors$18.ariaSelected);
      if (
        (selected && selected.setAttribute("aria-selected", !1),
        !this.activeElement || reset)
      ) {
        (this.selectedElement = null),
          this.activeElement?.setAttribute("aria-selected", !1),
          this.input.setAttribute("aria-expanded", !1),
          this.input.setAttribute("aria-activedescendant", "");
        return;
      }
      this.activeElement.setAttribute("aria-selected", !0),
        this.input.setAttribute("aria-activedescendant", this.activeElement.id);
    }
  }
  customElements.define("search-form", SearchForm);
  const selectors$17 = {
      predictiveSearch: "predictive-search",
      sectionPredictiveSearch: "#shopify-section-api-predictive-search",
      predictiveSearchResults: "[data-predictive-search-results]",
      predictiveSearchStatus: "[data-predictive-search-status]",
      searchResultsLiveRegion:
        "[data-predictive-search-live-region-count-value]",
      searchResultsWrapper: "[data-search-results-wrapper]",
    },
    classes$Y = { reset: "reset" },
    attributes$O = {
      aosAnchor: "data-aos-anchor",
      ariaHidden: "aria-hidden",
      open: "open",
      loading: "loading",
      loadingText: "data-loading-text",
      results: "results",
    };
  class PredictiveSearch extends SearchForm {
    constructor() {
      super(),
        (this.abortController = new AbortController()),
        (this.allPredictiveSearchInstances = document.querySelectorAll(
          selectors$17.predictiveSearch
        )),
        (this.predictiveSearchResults = this.querySelector(
          selectors$17.predictiveSearchResults
        )),
        (this.cachedResults = {});
    }
    connectedCallback() {
      this.predictiveSearchResults.addEventListener(
        "transitionend",
        (event2) => {
          event2.target === this.predictiveSearchResults &&
            !this.getQuery().length &&
            (this.classList.remove(classes$Y.reset),
            requestAnimationFrame(() => this.clearResultsHTML()));
        }
      );
    }
    onChange() {
      if (
        (super.onChange(),
        this.classList.remove(classes$Y.reset),
        !this.searchTerm.length)
      ) {
        this.classList.add(classes$Y.reset);
        return;
      }
      requestAnimationFrame(() => this.getSearchResults(this.searchTerm));
    }
    onFocus() {
      super.onFocus(),
        this.currentSearchTerm.length &&
          (this.searchTerm !== this.currentSearchTerm
            ? this.onChange()
            : this.getAttribute(attributes$O.results) === "true"
            ? this.open()
            : this.getSearchResults(this.searchTerm));
    }
    getSearchResults(searchTerm) {
      const queryKey = searchTerm.replace(" ", "-").toLowerCase(),
        suggestionsResultsLimit = parseInt(
          window.theme.settings.suggestionsResultsLimit
        );
      let resources = "query";
      if (
        ((resources += window.theme.settings.suggestArticles ? ",article" : ""),
        (resources += window.theme.settings.suggestCollections
          ? ",collection"
          : ""),
        (resources += window.theme.settings.suggestProducts ? ",product" : ""),
        (resources += window.theme.settings.suggestPages ? ",page" : ""),
        this.setLiveRegionLoadingState(),
        this.cachedResults[queryKey])
      ) {
        this.renderSearchResults(this.cachedResults[queryKey]);
        return;
      }
      fetch(
        `${theme.routes.predictiveSearchUrl}?q=${encodeURIComponent(
          searchTerm
        )}&resources[type]=${resources}&resources[limit]=${suggestionsResultsLimit}&section_id=api-predictive-search`,
        { signal: this.abortController.signal }
      )
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            throw (this.close(), error);
          }
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector(selectors$17.sectionPredictiveSearch).innerHTML;
          this.allPredictiveSearchInstances.forEach(
            (predictiveSearchInstance) => {
              predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
            }
          ),
            this.renderSearchResults(resultsMarkup);
        })
        .catch((error) => {
          if (error?.code !== 20) throw (this.close(), error);
        });
    }
    switchOption(direction) {
      super.switchOption(direction),
        this.statusElement && (this.statusElement.textContent = "");
    }
    setLiveRegionLoadingState() {
      (this.statusElement =
        this.statusElement ||
        this.querySelector(selectors$17.predictiveSearchStatus)),
        (this.loadingText =
          this.loadingText || this.getAttribute(attributes$O.loadingText)),
        this.setLiveRegionText(this.loadingText),
        this.setAttribute(attributes$O.loading, !0);
    }
    setLiveRegionText(statusText) {
      this.statusElement.setAttribute(attributes$O.ariaHidden, "false"),
        (this.statusElement.textContent = statusText),
        setTimeout(() => {
          this.statusElement.setAttribute(attributes$O.ariaHidden, "true");
        }, 1e3);
    }
    renderSearchResults(resultsMarkup) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;
      const parentId = this.predictiveSearchResults.parentElement.id,
        el = this.predictiveSearchResults.querySelector(
          selectors$17.searchResultsWrapper
        ),
        tempId = el.id;
      (el.id = `${tempId}--${parentId}`),
        el.setAttribute(attributes$O.aosAnchor, `#${el.id}`),
        this.setAttribute(attributes$O.results, !0),
        this.setLiveRegionResults(),
        this.open();
    }
    setLiveRegionResults() {
      this.removeAttribute(attributes$O.loading),
        this.setLiveRegionText(
          this.querySelector(selectors$17.searchResultsLiveRegion).textContent
        );
    }
    open() {
      this.setAttribute(attributes$O.open, !0);
    }
    close(clearSearchTerm = !1) {
      this.closeResults(clearSearchTerm);
    }
    closeResults(clearSearchTerm = !1) {
      clearSearchTerm &&
        (this.reset(),
        this.removeAttribute(attributes$O.results),
        this.classList.remove(classes$Y.reset)),
        this.removeAttribute(attributes$O.loading),
        this.removeAttribute(attributes$O.open);
    }
    clearResultsHTML() {
      this.predictiveSearchResults.innerHTML = "";
    }
  }
  customElements.define("predictive-search", PredictiveSearch);
  class LoadingOverlay extends HTMLElement {
    constructor() {
      super(),
        document.addEventListener("DOMContentLoaded", () => {
          document.documentElement.classList.remove("page-loading");
        });
    }
  }
  function getWindowWidth() {
    return (
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
    );
  }
  function isDesktop() {
    return getWindowWidth() >= window.theme.sizes.small;
  }
  function isMobile() {
    return getWindowWidth() < window.theme.sizes.small;
  }
  const selectors$16 = {
      aos: "[data-aos]:not(.aos-animate)",
      aosAnchor: "[data-aos-anchor]",
      animatable: "[data-aos], [data-aos-anchor]",
      watchMutations:
        '[id^="api-cart-items-"], [data-collection-filters], [data-collection-products], #AjaxinateLoop, [data-tab="resultsProducts"]',
      skeletonLoading: ".skeleton-loading",
      textHighlight: "text-highlight",
      counterUps: "text-count-up",
      flickitySlider: ".flickity-slider",
      slide: "[data-slide]",
      carouselMobile: ".carousel--mobile",
    },
    classes$X = {
      aosAnimate: "aos-animate",
      isLoading: "is-loading",
      isSelected: ".is-selected",
    },
    attributes$N = {
      aos: "data-aos",
      aosAnchor: "data-aos-anchor",
      aosIntersection: "data-aos-intersection",
      aosDebounce: "data-aos-debounce",
      aosCustomInit: "data-aos-custom-init",
      aosWatchAnchors: "data-aos-watch-anchors",
      aosTrigger: "data-aos-trigger",
      aosCarouselMobile: "data-aos-carousel-mobile",
      aosCarouselDesktop: "data-aos-carousel-desktop",
    },
    settings$a = { intersectionRatio: 0.1, debounceTime: 0 };
  let anchorObserversCollection = new Set();
  function anchorsIntersectionObserver() {
    const anchors = document.querySelectorAll(selectors$16.aosAnchor);
    initAnchorObservers(anchors);
  }
  function initAnchorObservers(anchors) {
    anchors.length &&
      (anchors.forEach((anchor) => {
        const containerId = anchor.dataset.aosAnchor;
        let container;
        containerId != "" && (container = document.querySelector(containerId)),
          container &&
            !anchorObserversCollection.has(anchor) &&
            anchorObserversCollection.add(container);
      }),
      anchorObserversCollection.forEach((container) => {
        aosAnchorObserver.observe(container);
      }));
  }
  const aosAnchorObserver = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        const target = entry.target,
          intersectionRatio = entry.intersectionRatio,
          isIntersecting = entry.isIntersecting;
        let intersectAt = settings$a.intersectionRatio;
        target.hasAttribute(attributes$N.aosIntersection) &&
          (intersectAt = Number(
            target.getAttribute(attributes$N.aosIntersection)
          ));
        let timeout,
          debounceTime = settings$a.debounceTime;
        target.hasAttribute(attributes$N.aosDebounce) &&
          (debounceTime = Number(
            target.getAttribute(attributes$N.aosDebounce)
          )),
          isIntersecting &&
            intersectionRatio > intersectAt &&
            (debounceTime !== 0
              ? (timeout && clearTimeout(timeout),
                (timeout = setTimeout(
                  () => onIntersecting(target),
                  debounceTime
                )))
              : onIntersecting(target),
            observer.unobserve(target),
            anchorObserversCollection.delete(target));
      });
    },
    {
      root: null,
      rootMargin: "0px",
      threshold: [0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.5, 0.75, 1],
    }
  );
  function onIntersecting(target) {
    if (!target) return;
    animate(target);
    const skeletonLoading = target.closest(selectors$16.skeletonLoading);
    if (
      (skeletonLoading &&
        skeletonLoading.querySelectorAll("img").forEach((image) => {
          image.classList.contains(classes$X.isLoading) &&
            image.setAttribute("loading", "eager");
        }),
      target.hasAttribute(attributes$N.aosCarouselDesktop) &&
        isDesktop() &&
        target.querySelector(selectors$16.flickitySlider))
    ) {
      const slide = target.querySelectorAll(selectors$16.slide),
        activeSlides = [...slide].filter((slide2) => {
          if (slide2.matches(classes$X.isSelected)) return slide2;
        }),
        inactiveSlides = [...slide].filter((slide2) => {
          if (!slide2.matches(classes$X.isSelected)) return slide2;
        });
      if (activeSlides.length > 0) {
        const triggerId = activeSlides[activeSlides.length - 1].id;
        activeSlides[activeSlides.length - 1].setAttribute(
          attributes$N.aosTrigger,
          `#${triggerId}`
        ),
          inactiveSlides.forEach((slide2) => {
            slide2
              .querySelectorAll(selectors$16.animatable)
              .forEach((element) => {
                element.setAttribute(attributes$N.aosAnchor, `#${triggerId}`);
              });
          });
      }
    }
    if (target.hasAttribute(attributes$N.aosCarouselMobile) && isMobile()) {
      const slider2 = target.querySelector(selectors$16.carouselMobile);
      if (slider2) {
        const slides = [...slider2.children],
          triggerId = slides[0].id;
        slides.length > 1 &&
          (slides[0].setAttribute(attributes$N.aosTrigger, `#${triggerId}`),
          slides.forEach((slide) => {
            slide
              .querySelectorAll(selectors$16.animatable)
              .forEach((element) => {
                element.setAttribute(attributes$N.aosAnchor, `#${triggerId}`);
              });
          }));
      }
    }
    if (target.hasAttribute(attributes$N.aosTrigger)) {
      const triggerId = target.getAttribute(attributes$N.aosTrigger);
      document
        .querySelectorAll(`[${attributes$N.aosAnchor}="${triggerId}"]`)
        .forEach((element) => animate(element));
    }
    let elementsToAnimate = target.querySelectorAll(selectors$16.aos);
    target.hasAttribute(attributes$N.aosWatchAnchors) &&
      (elementsToAnimate = [...elementsToAnimate].filter((element) => {
        const anchor = element.hasAttribute(attributes$N.aosAnchor)
          ? element.getAttribute(attributes$N.aosAnchor)
          : !1;
        if (anchor && `#${target.id}` === anchor) return element;
      })),
      elementsToAnimate.forEach((item) => {
        if (item.hasAttribute(attributes$N.aosCustomInit)) {
          target.dispatchEvent(
            new CustomEvent("theme:target:animate", {
              bubbles: !0,
              detail: item,
            })
          );
          return;
        }
        animate(item);
      });
  }
  function animate(element) {
    requestAnimationFrame(() => element.classList.add(classes$X.aosAnimate)),
      animateTextHighlights(element),
      animateCounterUps(element);
  }
  function animateTextHighlights(element) {
    element
      .querySelectorAll(selectors$16.textHighlight)
      .forEach((highlight) => highlight.shouldAnimate());
  }
  function animateCounterUps(element) {
    element
      .querySelectorAll(selectors$16.counterUps)
      .forEach((countUp) => countUp.shouldAnimate());
  }
  function bodyMutationObserver() {
    const isNode = (element) => element instanceof HTMLElement;
    new MutationObserver((mutationList) => {
      for (const mutation of mutationList) {
        if (!mutation.type === "childList") return;
        const target = mutation.target,
          addedNodes = [...mutation.addedNodes],
          removedNodes = [...mutation.removedNodes],
          watchMutations =
            target.matches(selectors$16.watchMutations) ||
            addedNodes.some((item) =>
              isNode(item) ? item.matches(selectors$16.watchMutations) : !1
            ) ||
            removedNodes.some((item) =>
              isNode(item) ? item.matches(selectors$16.watchMutations) : !1
            ),
          isAnimatableElement =
            target.matches(selectors$16.animatable) ||
            addedNodes.some((item) =>
              isNode(item) ? item.matches(selectors$16.animatable) : !1
            ),
          hasElementToAnimate =
            target.querySelector(
              `[${attributes$N.aosAnchor}="#${target.id}"]`
            ) !== null;
        if (isAnimatableElement || hasElementToAnimate || watchMutations) {
          const anchors = target.querySelectorAll(selectors$16.aosAnchor);
          initAnchorObservers(anchors);
        }
      }
    }).observe(document.body, { attributes: !1, childList: !0, subtree: !0 });
  }
  function initAnimations() {
    anchorsIntersectionObserver(), bodyMutationObserver();
  }
  const counterUp = (el, options2 = {}) => {
      const { action = "start", duration = 1e3, delay = 16 } = options2;
      if (action === "stop") {
        stopCountUp(el);
        return;
      }
      if ((stopCountUp(el), !/[0-9]/.test(el.innerHTML))) return;
      const nums = divideNumbers(el.innerHTML, {
        duration: duration || el.getAttribute("data-duration"),
        delay: delay || el.getAttribute("data-delay"),
      });
      (el._countUpOrigInnerHTML = el.innerHTML),
        (el.innerHTML = nums[0] || "&nbsp;"),
        (el.style.visibility = "visible");
      const output = function () {
        (el.innerHTML = nums.shift() || "&nbsp;"),
          nums.length
            ? (clearTimeout(el.countUpTimeout),
              (el.countUpTimeout = setTimeout(output, delay)))
            : (el._countUpOrigInnerHTML = void 0);
      };
      el.countUpTimeout = setTimeout(output, delay);
    },
    stopCountUp = (el) => {
      clearTimeout(el.countUpTimeout),
        el._countUpOrigInnerHTML &&
          ((el.innerHTML = el._countUpOrigInnerHTML),
          (el._countUpOrigInnerHTML = void 0)),
        (el.style.visibility = "");
    },
    divideNumbers = (numToDivide, options2 = {}) => {
      const { duration = 1e3, delay = 16 } = options2,
        divisions = duration / delay,
        splitValues = numToDivide
          .toString()
          .split(/(<[^>]+>|[0-9.][,.0-9]*[0-9]*)/),
        nums = [];
      for (let k = 0; k < divisions; k++) nums.push("");
      for (let i = 0; i < splitValues.length; i++)
        if (
          /([0-9.][,.0-9]*[0-9]*)/.test(splitValues[i]) &&
          !/<[^>]+>/.test(splitValues[i])
        ) {
          let num = splitValues[i];
          const symbols = [...num.matchAll(/[.,]/g)]
            .map((m) => ({ char: m[0], i: num.length - m.index - 1 }))
            .sort((a, b) => a.i - b.i);
          num = num.replace(/[.,]/g, "");
          let k = nums.length - 1;
          for (let val = divisions; val >= 1; val--) {
            let newNum = parseInt((num / divisions) * val, 10);
            (newNum = symbols.reduce(
              (num2, { char, i: i2 }) =>
                num2.length <= i2
                  ? num2
                  : num2.slice(0, -i2) + char + num2.slice(-i2),
              newNum.toString()
            )),
              (nums[k--] += newNum);
          }
        } else for (let k = 0; k < divisions; k++) nums[k] += splitValues[i];
      return (nums[nums.length] = numToDivide.toString()), nums;
    },
    attributes$M = {
      countUpDuration: "data-count-up-duration",
      countUpInit: "data-count-up-init",
    };
  class TextCountUp extends HTMLElement {
    static observedAttributes = [attributes$M.countUpInit];
    constructor() {
      super(),
        (this.container = this),
        (this.countUpDuration = this.getAttribute(
          attributes$M.countUpDuration
        )),
        (this.duration = 1e3 * (100 / parseInt(this.countUpDuration, 10)));
    }
    connectedCallback() {
      theme.settings.animationsEnabled || this.startCountUp();
    }
    attributeChangedCallback(name, oldValue, newValue) {
      const countUpInitChange = name === attributes$M.countUpInit;
      oldValue === null &&
        countUpInitChange &&
        newValue === "true" &&
        this.startCountUp();
    }
    shouldAnimate() {
      requestAnimationFrame(() => this.setTriggerAttribute());
    }
    setTriggerAttribute(active = !0) {
      this.setAttribute(attributes$M.countUpInit, active);
    }
    startCountUp() {
      counterUp(this, {
        duration: this.duration,
        delay: 0.016 * this.duration,
      });
    }
  }
  (window.requestIdleCallback =
    window.requestIdleCallback ||
    function (cb) {
      var start = Date.now();
      return setTimeout(function () {
        cb({
          didTimeout: !1,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - start));
          },
        });
      }, 1);
    }),
    (window.cancelIdleCallback =
      window.cancelIdleCallback ||
      function (id) {
        clearTimeout(id);
      }),
    resizeListener(),
    scrollListener(),
    isTouch(),
    loadedImagesEventHook();
  const headerFunctions = debounce(() => {
    initTransparentHeader();
  }, 300);
  window.addEventListener("DOMContentLoaded", () => {
    setVarsOnResize(),
      preventOverflow(document),
      wrapElements(document),
      removeLoadingClassFromLoadedImages(document),
      window.theme.settings.animationsEnabled && initAnimations();
  }),
    document.addEventListener("shopify:section:load", (e) => {
      const container = e.target;
      window.dispatchEvent(new Event("resize"), { bubbles: !0 }),
        preventOverflow(container),
        wrapElements(container),
        setVarsOnResize(),
        headerFunctions(),
        removeFooterWave(container),
        reloadCardScrolling(),
        window.theme.settings.animationsEnabled && initAnimations();
    }),
    document.addEventListener("shopify:section:reorder", (e) => {
      const container = e.target;
      headerFunctions(),
        removeFooterWave(container),
        reloadCardScrolling(),
        window.theme.settings.animationsEnabled && initAnimations();
    }),
    document.addEventListener("shopify:section:unload", (e) => {
      const container = e.target;
      headerFunctions(), removeFooterWave(container), reloadCardScrolling();
    }),
    customElements.get("text-highlight") ||
      customElements.define("text-highlight", TextHighlight),
    customElements.get("deferred-loading") ||
      customElements.define("deferred-loading", DeferredLoading),
    customElements.get("loading-overlay") ||
      customElements.define("loading-overlay", LoadingOverlay),
    customElements.get("text-count-up") ||
      customElements.define("text-count-up", TextCountUp),
    (function () {
      function n(n2) {
        var i2 = window.innerWidth || document.documentElement.clientWidth,
          r2 = window.innerHeight || document.documentElement.clientHeight,
          t2 = n2.getBoundingClientRect();
        return t2.top >= 0 && t2.bottom <= r2 && t2.left >= 0 && t2.right <= i2;
      }
      function t(n2) {
        var i2 = window.innerWidth || document.documentElement.clientWidth,
          r2 = window.innerHeight || document.documentElement.clientHeight,
          t2 = n2.getBoundingClientRect(),
          u =
            (t2.left >= 0 && t2.left <= i2) ||
            (t2.right >= 0 && t2.right <= i2),
          f =
            (t2.top >= 0 && t2.top <= r2) ||
            (t2.bottom >= 0 && t2.bottom <= r2);
        return u && f;
      }
      function i(n2, i2) {
        function r2() {
          var r3 = t(n2);
          r3 != u && ((u = r3), typeof i2 == "function" && i2(r3, n2));
        }
        var u = t(n2);
        window.addEventListener("load", r2),
          window.addEventListener("resize", r2),
          window.addEventListener("scroll", r2);
      }
      function r(t2, i2) {
        function r2() {
          var r3 = n(t2);
          r3 != u && ((u = r3), typeof i2 == "function" && i2(r3, t2));
        }
        var u = n(t2);
        window.addEventListener("load", r2),
          window.addEventListener("resize", r2),
          window.addEventListener("scroll", r2);
      }
      window.visibilityHelper = {
        isElementTotallyVisible: n,
        isElementPartiallyVisible: t,
        inViewportPartially: i,
        inViewportTotally: r,
      };
    })();
  const throttle = (fn, wait) => {
    let prev2, next;
    return function invokeFn(...args) {
      const now = Date.now();
      (next = clearTimeout(next)),
        !prev2 || now - prev2 >= wait
          ? (fn.apply(null, args), (prev2 = now))
          : (next = setTimeout(
              invokeFn.bind(null, ...args),
              wait - (now - prev2)
            ));
    };
  };
  function FetchError(object) {
    (this.status = object.status || null),
      (this.headers = object.headers || null),
      (this.json = object.json || null),
      (this.body = object.body || null);
  }
  FetchError.prototype = Error.prototype;
  const selectors$15 = {
      single: "[data-collapsible-single]",
      trigger: "[data-collapsible-trigger]",
      content: "[data-collapsible-content]",
    },
    classes$W = { isExpanded: "is-expanded" },
    attributes$L = {
      expanded: "aria-expanded",
      controls: "aria-controls",
      triggerMobile: "data-collapsible-trigger-mobile",
      transitionOverride: "data-collapsible-transition-override",
    },
    settings$9 = { animationDelay: 500 },
    sections$G = {};
  class Collapsible {
    constructor(container) {
      (this.container = container),
        (this.single = this.container.querySelector(selectors$15.single)),
        (this.triggers = this.container.querySelectorAll(selectors$15.trigger)),
        (this.resetHeightTimer = 0),
        (this.isTransitioning = !1),
        (this.transitionOverride = this.container.hasAttribute(
          attributes$L.transitionOverride
        )),
        (this.collapsibleToggleEvent = (event2) =>
          throttle(this.collapsibleToggle(event2), 1250)),
        this.init();
    }
    init() {
      this.triggers.forEach((trigger) => {
        trigger.addEventListener("click", this.collapsibleToggleEvent),
          trigger.addEventListener("keyup", this.collapsibleToggleEvent);
      });
    }
    collapsibleToggle(e) {
      e.preventDefault();
      const trigger = e.target.matches(selectors$15.trigger)
          ? e.target
          : e.target.closest(selectors$15.trigger),
        dropdownId = trigger.getAttribute(attributes$L.controls),
        dropdown = document.getElementById(dropdownId),
        triggerMobile = trigger.hasAttribute(attributes$L.triggerMobile),
        isExpanded = trigger.classList.contains(classes$W.isExpanded),
        isSpace = e.code === theme.keyboardKeys.SPACE,
        isEscape = e.code === theme.keyboardKeys.ESCAPE,
        isMobile2 = window.innerWidth < theme.sizes.small;
      (this.isTransitioning && !this.transitionOverride) ||
        (e.code && !isSpace && !isEscape) ||
        (!isExpanded && isEscape) ||
        (triggerMobile && !isMobile2) ||
        ((this.isTransitioning = !0),
        (trigger.disabled = !0),
        this.single &&
          this.triggers.forEach((otherTrigger) => {
            const isExpanded2 = otherTrigger.classList.contains(
              classes$W.isExpanded
            );
            if (trigger == otherTrigger || !isExpanded2) return;
            const dropdownId2 = otherTrigger.getAttribute(
                attributes$L.controls
              ),
              dropdown2 = document.getElementById(dropdownId2);
            requestAnimationFrame(() => {
              this.closeItem(dropdown2, otherTrigger);
            });
          }),
        requestAnimationFrame(
          isExpanded
            ? () => {
                this.closeItem(dropdown, trigger);
              }
            : () => {
                this.openItem(dropdown, trigger);
              }
        ));
    }
    openItem(dropdown, trigger) {
      let dropdownHeight = dropdown.querySelector(
        selectors$15.content
      ).offsetHeight;
      this.setDropdownHeight(dropdown, dropdownHeight, trigger, !0),
        trigger.classList.add(classes$W.isExpanded),
        trigger.setAttribute(attributes$L.expanded, !0),
        trigger.dispatchEvent(
          new CustomEvent("theme:form:sticky", {
            bubbles: !0,
            detail: { element: "accordion" },
          })
        );
    }
    closeItem(dropdown, trigger) {
      let dropdownHeight = dropdown.querySelector(
        selectors$15.content
      ).offsetHeight;
      requestAnimationFrame(() => {
        (dropdownHeight = 0),
          this.setDropdownHeight(dropdown, dropdownHeight, trigger, !1),
          trigger.classList.remove(classes$W.isExpanded);
      }),
        this.setDropdownHeight(dropdown, dropdownHeight, trigger, !1),
        trigger.classList.remove(classes$W.isExpanded),
        trigger.setAttribute(attributes$L.expanded, !1);
    }
    setDropdownHeight(dropdown, dropdownHeight, trigger, isExpanded) {
      (dropdown.style.height = `${dropdownHeight}px`),
        dropdown.setAttribute(attributes$L.expanded, isExpanded),
        dropdown.classList.toggle(classes$W.isExpanded, isExpanded),
        this.resetHeightTimer && clearTimeout(this.resetHeightTimer),
        dropdownHeight == 0 &&
          (this.resetHeightTimer = setTimeout(() => {
            dropdown.style.height = "";
          }, settings$9.animationDelay)),
        isExpanded
          ? (this.resetHeightTimer = setTimeout(() => {
              (dropdown.style.height = "auto"), (this.isTransitioning = !1);
            }, settings$9.animationDelay))
          : (this.isTransitioning = !1),
        setTimeout(() => {
          trigger.disabled = !1;
        }, settings$9.animationDelay);
    }
    onUnload() {
      this.triggers.forEach((trigger) => {
        trigger.removeEventListener("click", this.collapsibleToggleEvent),
          trigger.removeEventListener("keyup", this.collapsibleToggleEvent);
      });
    }
  }
  const collapsible = {
      onLoad() {
        sections$G[this.id] = new Collapsible(this.container);
      },
      onUnload() {
        sections$G[this.id].onUnload();
      },
    },
    selectors$14 = {
      quantityHolder: "[data-quantity-holder]",
      quantityField: "[data-quantity-field]",
      quantityButton: "[data-quantity-button]",
      quantityMinusButton: "[data-quantity-minus]",
      quantityPlusButton: "[data-quantity-plus]",
    },
    classes$V = { quantityReadOnly: "read-only", isDisabled: "is-disabled" };
  class QuantityCounter {
    constructor(holder, inCart = !1) {
      (this.holder = holder), (this.quantityUpdateCart = inCart);
    }
    init() {
      (this.quantity = this.holder.querySelector(selectors$14.quantityHolder)),
        this.quantity &&
          ((this.field = this.quantity.querySelector(
            selectors$14.quantityField
          )),
          (this.buttons = this.quantity.querySelectorAll(
            selectors$14.quantityButton
          )),
          (this.increaseButton = this.quantity.querySelector(
            selectors$14.quantityPlusButton
          )),
          (this.quantityValue = Number(this.field.value || 0)),
          (this.cartItemID = this.field.getAttribute("data-id")),
          (this.maxValue =
            Number(this.field.getAttribute("max")) > 0
              ? Number(this.field.getAttribute("max"))
              : null),
          (this.minValue =
            Number(this.field.getAttribute("min")) > 0
              ? Number(this.field.getAttribute("min"))
              : 0),
          (this.disableIncrease = this.disableIncrease.bind(this)),
          (this.emptyField = !1),
          (this.updateQuantity = this.updateQuantity.bind(this)),
          (this.decrease = this.decrease.bind(this)),
          (this.increase = this.increase.bind(this)),
          this.disableIncrease(),
          this.quantity.classList.contains(classes$V.quantityReadOnly) ||
            (this.changeValueOnClick(), this.changeValueOnInput()));
    }
    changeValueOnClick() {
      this.buttons.forEach((element) => {
        element.addEventListener("click", (event2) => {
          event2.preventDefault(),
            (this.quantityValue = Number(this.field.value || 0));
          const clickedElement = event2.target,
            isDescrease =
              clickedElement.matches(selectors$14.quantityMinusButton) ||
              clickedElement.closest(selectors$14.quantityMinusButton),
            isIncrease =
              clickedElement.matches(selectors$14.quantityPlusButton) ||
              clickedElement.closest(selectors$14.quantityPlusButton);
          isDescrease && this.decrease(),
            isIncrease && this.increase(),
            this.updateQuantity();
        });
      });
    }
    changeValueOnInput() {
      this.field.addEventListener("input", () => {
        (this.quantityValue = this.field.value), this.updateQuantity();
      });
    }
    updateQuantity() {
      this.maxValue < this.quantityValue &&
        this.maxValue !== null &&
        (this.quantityValue = this.maxValue),
        this.minValue > this.quantityValue &&
          (this.quantityValue = this.minValue),
        (this.field.value = this.quantityValue),
        this.disableIncrease(),
        document.dispatchEvent(new CustomEvent("theme:cart:update")),
        this.quantityUpdateCart && this.updateCart();
    }
    decrease() {
      if (this.quantityValue > this.minValue) {
        this.quantityValue--;
        return;
      }
      this.quantityValue = 0;
    }
    increase() {
      this.quantityValue++;
    }
    disableIncrease() {
      this.increaseButton.classList.toggle(
        classes$V.isDisabled,
        this.quantityValue >= this.maxValue && this.maxValue !== null
      );
    }
    updateCart() {
      if (this.quantityValue === "") return;
      const event2 = new CustomEvent("theme:cart:update", {
        bubbles: !0,
        detail: { id: this.cartItemID, quantity: this.quantityValue },
      });
      this.holder.dispatchEvent(event2);
    }
  }
  const a11y = {
    state: { firstFocusable: null, lastFocusable: null, trigger: null },
    trapFocus: function (options2) {
      var focusableElements = Array.from(
        options2.container.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
        )
      ).filter(function (element) {
        var width = element.offsetWidth,
          height = element.offsetHeight;
        return (
          width !== 0 &&
          height !== 0 &&
          getComputedStyle(element).getPropertyValue("display") !== "none"
        );
      });
      (focusableElements = focusableElements.filter(function (element) {
        return !element.classList.contains("deferred-media__poster");
      })),
        (this.state.firstFocusable = focusableElements[0]),
        (this.state.lastFocusable =
          focusableElements[focusableElements.length - 1]),
        options2.elementToFocus ||
          (options2.elementToFocus =
            this.state.firstFocusable || options2.container),
        this._setupHandlers(),
        document.addEventListener("focusin", this._onFocusInHandler),
        document.addEventListener("focusout", this._onFocusOutHandler),
        options2.container.setAttribute("tabindex", "-1"),
        options2.elementToFocus.focus();
    },
    removeTrapFocus: function (options2) {
      const focusVisible = !document.body.classList.contains("no-outline");
      options2 &&
        options2.container &&
        options2.container.removeAttribute("tabindex"),
        document.removeEventListener("focusin", this._onFocusInHandler),
        this.state.trigger && focusVisible && this.state.trigger.focus();
    },
    _manageFocus: function (evt) {
      evt.code === theme.keyboardKeys.TAB &&
        (evt.target === this.state.lastFocusable &&
          !evt.shiftKey &&
          (evt.preventDefault(), this.state.firstFocusable.focus()),
        evt.target === this.state.firstFocusable &&
          evt.shiftKey &&
          (evt.preventDefault(), this.state.lastFocusable.focus()));
    },
    _onFocusOut: function () {
      document.removeEventListener("keydown", this._manageFocusHandler);
    },
    _onFocusIn: function (evt) {
      (evt.target !== this.state.lastFocusable &&
        evt.target !== this.state.firstFocusable) ||
        document.addEventListener("keydown", this._manageFocusHandler);
    },
    _setupHandlers: function () {
      this._onFocusInHandler ||
        (this._onFocusInHandler = this._onFocusIn.bind(this)),
        this._onFocusOutHandler ||
          (this._onFocusOutHandler = this._onFocusIn.bind(this)),
        this._manageFocusHandler ||
          (this._manageFocusHandler = this._manageFocus.bind(this));
    },
  };
  function getScript(url, callback, callbackError) {
    let head = document.getElementsByTagName("head")[0],
      done = !1,
      script = document.createElement("script");
    (script.src = url),
      (script.onload = script.onreadystatechange =
        function () {
          !done &&
          (!this.readyState ||
            this.readyState == "loaded" ||
            this.readyState == "complete")
            ? ((done = !0), callback())
            : callbackError();
        }),
      head.appendChild(script);
  }
  const loaders = {};
  (window.isYoutubeAPILoaded = !1), (window.isVimeoAPILoaded = !1);
  function loadScript(options2 = {}) {
    if ((options2.type || (options2.type = "json"), options2.url))
      return loaders[options2.url]
        ? loaders[options2.url]
        : getScriptWithPromise(options2.url, options2.type);
    if (options2.json)
      return loaders[options2.json]
        ? Promise.resolve(loaders[options2.json])
        : window
            .fetch(options2.json)
            .then((response) => response.json())
            .then(
              (response) => ((loaders[options2.json] = response), response)
            );
    if (options2.name) {
      const key = "".concat(options2.name, options2.version);
      return loaders[key] ? loaders[key] : loadShopifyWithPromise(options2);
    } else return Promise.reject();
  }
  function getScriptWithPromise(url, type) {
    const loader = new Promise((resolve, reject) => {
      type === "text"
        ? fetch(url)
            .then((response) => response.text())
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            })
        : getScript(
            url,
            function () {
              resolve();
            },
            function () {
              reject();
            }
          );
    });
    return (loaders[url] = loader), loader;
  }
  function loadShopifyWithPromise(options2) {
    const key = "".concat(options2.name, options2.version),
      loader = new Promise((resolve, reject) => {
        try {
          window.Shopify.loadFeatures([
            {
              name: options2.name,
              version: options2.version,
              onLoad: (err) => {
                onLoadFromShopify(resolve, reject, err);
              },
            },
          ]);
        } catch (err) {
          reject(err);
        }
      });
    return (loaders[key] = loader), loader;
  }
  function onLoadFromShopify(resolve, reject, err) {
    return err ? reject(err) : resolve();
  }
  const selectors$13 = { videoIframe: "[data-video-id]" },
    classes$U = { loaded: "loaded" },
    attributes$K = {
      dataEnableSound: "data-enable-sound",
      dataEnableBackground: "data-enable-background",
      dataEnableAutoplay: "data-enable-autoplay",
      dataEnableLoop: "data-enable-loop",
      dataVideoId: "data-video-id",
      dataVideoType: "data-video-type",
    };
  class LoadVideoVimeo {
    constructor(container) {
      (this.container = container),
        (this.player = this.container.querySelector(selectors$13.videoIframe)),
        this.player &&
          ((this.videoID = this.player.getAttribute(attributes$K.dataVideoId)),
          (this.videoType = this.player.getAttribute(
            attributes$K.dataVideoType
          )),
          (this.enableBackground =
            this.player.getAttribute(attributes$K.dataEnableBackground) ===
            "true"),
          (this.disableSound =
            this.player.getAttribute(attributes$K.dataEnableSound) === "false"),
          (this.enableAutoplay =
            this.player.getAttribute(attributes$K.dataEnableAutoplay) !==
            "false"),
          (this.enableLoop =
            this.player.getAttribute(attributes$K.dataEnableLoop) !== "false"),
          this.videoType == "vimeo" && this.init());
    }
    init() {
      this.loadVimeoPlayer();
    }
    loadVimeoPlayer() {
      const oembedUrl = "https://vimeo.com/api/oembed.json",
        vimeoUrl = "https://vimeo.com/" + this.videoID;
      let paramsString = "";
      const state = this.player,
        params = {
          url: vimeoUrl,
          background: this.enableBackground,
          muted: this.disableSound,
          autoplay: this.enableAutoplay,
          loop: this.enableLoop,
        };
      for (let key in params)
        paramsString +=
          encodeURIComponent(key) + "=" + encodeURIComponent(params[key]) + "&";
      fetch(`${oembedUrl}?${paramsString}`)
        .then((response) => response.json())
        .then(function (data) {
          (state.innerHTML = data.html),
            setTimeout(function () {
              state.parentElement.classList.add(classes$U.loaded);
            }, 1e3);
        })
        .catch(function () {
          console.log("error");
        });
    }
  }
  const selectors$12 = {
      videoIframe: "[data-video-id]",
      videoWrapper: ".video-wrapper",
      youtubeWrapper: "[data-youtube-wrapper]",
    },
    attributes$J = {
      dataSectionId: "data-section-id",
      dataEnableSound: "data-enable-sound",
      dataHideOptions: "data-hide-options",
      dataCheckPlayerVisibility: "data-check-player-visibility",
      dataVideoId: "data-video-id",
      dataVideoType: "data-video-type",
    },
    classes$T = { loaded: "loaded" },
    players = [];
  class LoadVideoYT {
    constructor(container) {
      (this.container = container),
        (this.player = this.container.querySelector(selectors$12.videoIframe)),
        this.player &&
          ((this.videoOptionsVars = {}),
          (this.videoID = this.player.getAttribute(attributes$J.dataVideoId)),
          (this.videoType = this.player.getAttribute(
            attributes$J.dataVideoType
          )),
          this.videoType == "youtube" &&
            ((this.checkPlayerVisibilityFlag =
              this.player.getAttribute(
                attributes$J.dataCheckPlayerVisibility
              ) === "true"),
            (this.playerID = this.player.querySelector(
              selectors$12.youtubeWrapper
            )
              ? this.player.querySelector(selectors$12.youtubeWrapper).id
              : this.player.id),
            this.player.hasAttribute(selectors$12.dataHideOptions) &&
              (this.videoOptionsVars = {
                cc_load_policy: 0,
                iv_load_policy: 3,
                modestbranding: 1,
                playsinline: 1,
                autohide: 0,
                controls: 0,
                branding: 0,
                showinfo: 0,
                rel: 0,
                fs: 0,
                wmode: "opaque",
              }),
            this.init(),
            this.container.addEventListener(
              "touchstart",
              function (e) {
                if (
                  e.target.matches(selectors$12.videoWrapper) ||
                  e.target.closest(selectors$12.videoWrapper)
                ) {
                  const playerID = e.target.querySelector(
                    selectors$12.videoIframe
                  ).id;
                  players[playerID].playVideo();
                }
              },
              { passive: !0 }
            )));
    }
    init() {
      window.isYoutubeAPILoaded
        ? this.loadYoutubePlayer()
        : loadScript({ url: "https://www.youtube.com/iframe_api" }).then(() =>
            this.loadYoutubePlayer()
          );
    }
    loadYoutubePlayer() {
      const currentYoutubeOptions = {
        ...{
          height: "720",
          width: "1280",
          playerVars: this.videoOptionsVars,
          events: {
            onReady: (event2) => {
              const id = event2.target.getIframe().id;
              document
                .querySelector(`#${id}`)
                .getAttribute(attributes$J.dataEnableSound) === "true"
                ? event2.target.unMute()
                : event2.target.mute(),
                event2.target.playVideo(),
                this.checkPlayerVisibilityFlag &&
                  (this.checkPlayerVisibility(id),
                  window.addEventListener(
                    "scroll",
                    throttle(() => {
                      this.checkPlayerVisibility(id);
                    }, 150)
                  ));
            },
            onStateChange: (event2) => {
              event2.data == 0 && event2.target.playVideo(),
                event2.data == 1 &&
                  event2.target
                    .getIframe()
                    .parentElement.classList.add(classes$T.loaded);
            },
          },
        },
      };
      (currentYoutubeOptions.videoId = this.videoID),
        this.videoID.length &&
          YT.ready(() => {
            players[this.playerID] = new YT.Player(
              this.playerID,
              currentYoutubeOptions
            );
          }),
        (window.isYoutubeAPILoaded = !0);
    }
    checkPlayerVisibility(id) {
      let playerID;
      if (typeof id == "string") playerID = id;
      else if (id.data != null) playerID = id.data.id;
      else return;
      const playerElement = document.getElementById(playerID + "-container");
      if (!playerElement) return;
      const player = players[playerID],
        box = playerElement.getBoundingClientRect();
      let isVisible =
        visibilityHelper.isElementPartiallyVisible(playerElement) ||
        visibilityHelper.isElementTotallyVisible(playerElement);
      box.top < 0 &&
        playerElement.clientHeight + box.top >= 0 &&
        (isVisible = !0),
        isVisible && player && typeof player.playVideo == "function"
          ? player.playVideo()
          : !isVisible &&
            player &&
            typeof player.pauseVideo == "function" &&
            player.pauseVideo();
    }
    onUnload() {
      const playerID =
        "youtube-" + this.container.getAttribute(attributes$J.dataSectionId);
      players[playerID] && players[playerID].destroy();
    }
  }
  const selectors$11 = {
      notificationForm: "[data-notification-form]",
      notification: "[data-notification]",
      popupClose: "[data-popup-close]",
    },
    classes$S = {
      popupSuccess: "pswp--success",
      notificationPopupVisible: "notification-popup-visible",
    };
  class LoadNotification {
    constructor(popup, pswpElement) {
      (this.popup = popup),
        (this.pswpElement = pswpElement),
        (this.notificationForm = null),
        (this.notificationStopSubmit = !0),
        (this.sessionStorage = window.sessionStorage);
      const notificationWrapper = this.pswpElement.querySelector(
        selectors$11.notification
      );
      (this.outerCloseEvent = (e) => {
        notificationWrapper.contains(e.target) || this.popup.close();
      }),
        this.init();
    }
    init() {
      this.popup.listen("preventDragEvent", (e, isDown, preventObj) => {
        preventObj.prevent = !1;
      });
      const notificationFormSuccess =
        window.location.search.indexOf("?customer_posted=true") !== -1;
      this.notificationForm = this.pswpElement.querySelector(
        selectors$11.notificationForm
      );
      const closeBtn = this.pswpElement.querySelector(selectors$11.popupClose);
      document.body.classList.add(classes$S.notificationPopupVisible),
        this.pswpElement.addEventListener("mousedown", () => {
          this.popup.framework.unbind(
            window,
            "pointermove pointerup pointercancel",
            this.popup
          );
        }),
        notificationFormSuccess &&
          this.pswpElement.classList.add(classes$S.popupSuccess),
        this.notificationForm.addEventListener("submit", (e) =>
          this.notificationSubmitEvent(e)
        ),
        this.pswpElement.addEventListener("click", this.outerCloseEvent),
        closeBtn.addEventListener("click", () => {
          this.popup.close();
        }),
        this.popup.listen("destroy", () => {
          this.notificationRemoveStorage(),
            this.pswpElement.removeEventListener("click", this.outerCloseEvent),
            document.body.classList.remove(classes$S.notificationPopupVisible);
        });
    }
    notificationSubmitEvent(e) {
      this.notificationStopSubmit &&
        (e.preventDefault(),
        this.notificationRemoveStorage(),
        this.notificationWriteStorage(),
        (this.notificationStopSubmit = !1),
        this.notificationForm.submit());
    }
    notificationWriteStorage() {
      this.sessionStorage !== void 0 &&
        this.sessionStorage.setItem(
          "notification_form_id",
          this.notificationForm.id
        );
    }
    notificationRemoveStorage() {
      this.sessionStorage.removeItem("notification_form_id");
    }
  }
  function flickitySmoothScrolling(slider2) {
    const flkty = Flickity.data(slider2);
    flkty &&
      (flkty.on("dragStart", (event2, pointer) => {
        document.ontouchmove = function (e) {
          e.preventDefault();
        };
      }),
      flkty.on("dragEnd", (event2, pointer) => {
        document.ontouchmove = function (e) {
          return !0;
        };
      }));
  }
  const hosts = { html5: "html5", youtube: "youtube", vimeo: "vimeo" },
    selectors$10 = {
      deferredMedia: "[data-deferred-media]",
      deferredMediaButton: "[data-deferred-media-button]",
      productMediaWrapper: "[data-product-single-media-wrapper]",
      mediaContainer: "[data-video]",
      mediaHidden: ".media--hidden",
    },
    classes$R = { mediaHidden: "media--hidden" },
    attributes$I = {
      loaded: "loaded",
      sectionId: "data-section-id",
      dataAutoplayVideo: "data-autoplay-video",
      mediaId: "data-media-id",
    };
  class ProductVideo {
    constructor(container) {
      (this.container = container),
        (this.id = this.container.getAttribute(attributes$I.sectionId)),
        (this.autoplayVideo =
          this.container.getAttribute(attributes$I.dataAutoplayVideo) ===
          "true"),
        (this.players = {}),
        (this.pauseContainerMedia = (mediaId, container2 = this.container) =>
          this.pauseOtherMedia(mediaId, container2)),
        this.init();
    }
    init() {
      this.container
        .querySelectorAll(selectors$10.mediaContainer)
        .forEach((mediaContainer) => {
          const deferredMediaButton = mediaContainer.querySelector(
            selectors$10.deferredMediaButton
          );
          deferredMediaButton &&
            deferredMediaButton.addEventListener(
              "click",
              this.loadContent.bind(this, mediaContainer)
            ),
            this.autoplayVideo && this.loadContent(mediaContainer);
        });
    }
    loadContent(mediaContainer) {
      if (
        mediaContainer
          .querySelector(selectors$10.deferredMedia)
          .getAttribute(attributes$I.loaded)
      )
        return;
      const content = document.createElement("div");
      content.appendChild(
        mediaContainer
          .querySelector("template")
          .content.firstElementChild.cloneNode(!0)
      );
      const mediaId = mediaContainer.dataset.mediaId,
        element = content.querySelector("video, iframe"),
        host = this.hostFromVideoElement(element),
        deferredMedia = mediaContainer.querySelector(
          selectors$10.deferredMedia
        );
      deferredMedia.appendChild(element),
        deferredMedia.setAttribute("loaded", !0),
        (this.players[mediaId] = {
          mediaId,
          sectionId: this.id,
          container: mediaContainer,
          element,
          host,
          ready: () => {
            this.createPlayer(mediaId);
          },
        });
      const video = this.players[mediaId];
      switch (video.host) {
        case hosts.html5:
          this.loadVideo(video, hosts.html5);
          break;
        case hosts.vimeo:
          window.isVimeoAPILoaded
            ? this.loadVideo(video, hosts.vimeo)
            : loadScript({
                url: "https://player.vimeo.com/api/player.js",
              }).then(() => this.loadVideo(video, hosts.vimeo));
          break;
        case hosts.youtube:
          window.isYoutubeAPILoaded
            ? this.loadVideo(video, hosts.youtube)
            : loadScript({ url: "https://www.youtube.com/iframe_api" }).then(
                () => this.loadVideo(video, hosts.youtube)
              );
          break;
      }
    }
    hostFromVideoElement(video) {
      if (video.tagName === "VIDEO") return hosts.html5;
      if (video.tagName === "IFRAME") {
        if (
          /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
            video.src
          )
        )
          return hosts.youtube;
        if (video.src.includes("vimeo.com")) return hosts.vimeo;
      }
      return null;
    }
    loadVideo(video, host) {
      video.host === host && video.ready();
    }
    createPlayer(mediaId) {
      const video = this.players[mediaId];
      switch (video.host) {
        case hosts.html5:
          video.element.addEventListener("play", () => {
            video.container.dispatchEvent(new CustomEvent("theme:media:play"), {
              bubbles: !0,
            });
          }),
            video.element.addEventListener("pause", () => {
              video.container.dispatchEvent(
                new CustomEvent("theme:media:pause"),
                { bubbles: !0 }
              );
            }),
            this.autoplayVideo && this.observeVideo(video, mediaId);
          break;
        case hosts.vimeo:
          (video.player = new Vimeo.Player(video.element)),
            video.player.play(),
            video.container.dispatchEvent(new CustomEvent("theme:media:play"), {
              bubbles: !0,
            }),
            (window.isVimeoAPILoaded = !0),
            video.player.on("play", () => {
              video.container.dispatchEvent(
                new CustomEvent("theme:media:play"),
                { bubbles: !0 }
              );
            }),
            video.player.on("pause", () => {
              video.container.dispatchEvent(
                new CustomEvent("theme:media:pause"),
                { bubbles: !0 }
              );
            }),
            this.autoplayVideo && this.observeVideo(video, mediaId);
          break;
        case hosts.youtube:
          if (video.host == hosts.youtube && video.player) return;
          YT.ready(() => {
            const videoId = video.container.dataset.videoId;
            (video.player = new YT.Player(video.element, {
              videoId,
              events: {
                onReady: (event2) => {
                  event2.target.playVideo(),
                    video.container.dispatchEvent(
                      new CustomEvent("theme:media:play"),
                      { bubbles: !0 }
                    );
                },
                onStateChange: (event2) => {
                  event2.data == 1 &&
                    video.container.dispatchEvent(
                      new CustomEvent("theme:media:play"),
                      { bubbles: !0 }
                    ),
                    event2.data == 2 &&
                      video.container.dispatchEvent(
                        new CustomEvent("theme:media:pause"),
                        { bubbles: !0 }
                      ),
                    event2.data == 0 &&
                      video.container.dispatchEvent(
                        new CustomEvent("theme:media:pause"),
                        { bubbles: !0 }
                      );
                },
              },
            })),
              (window.isYoutubeAPILoaded = !0),
              this.autoplayVideo && this.observeVideo(video, mediaId);
          });
          break;
      }
      video.container.addEventListener("theme:media:visible", (event2) =>
        this.onVisible(event2)
      ),
        video.container.addEventListener("theme:media:hidden", (event2) =>
          this.onHidden(event2)
        ),
        video.container.addEventListener("xrLaunch", (event2) =>
          this.onHidden(event2)
        );
    }
    observeVideo(video) {
      new IntersectionObserver(
        (entries, observer2) => {
          entries.forEach((entry) => {
            const outsideViewport = entry.intersectionRatio == 0,
              isVisible = !video.element.closest(selectors$10.mediaHidden);
            outsideViewport
              ? this.pauseVideo(video)
              : isVisible && this.playVideo(video);
          });
        },
        { rootMargin: "200px", threshold: [0, 0.25, 0.75, 1] }
      ).observe(video.element);
    }
    playVideo(video) {
      video.player && video.player.playVideo
        ? video.player.playVideo()
        : video.element && video.element.play
        ? video.element.play()
        : video.player && video.player.play && video.player.play(),
        video.container.dispatchEvent(new CustomEvent("theme:media:play"), {
          bubbles: !0,
        });
    }
    pauseVideo(video) {
      video.player && video.player.pauseVideo
        ? video.player.playerInfo.playerState == "1" &&
          video.player.pauseVideo()
        : video.player && video.player.pause
        ? video.player.pause()
        : video.element &&
          !video.element.paused &&
          typeof video.element.pause == "function" &&
          video.element?.pause();
    }
    onHidden(event2) {
      if (typeof event2.target.dataset.mediaId < "u") {
        const mediaId = event2.target.dataset.mediaId,
          video = this.players[mediaId];
        this.pauseVideo(video);
      }
    }
    onVisible(event2) {
      if (typeof event2.target.dataset.mediaId < "u") {
        const mediaId = event2.target.dataset.mediaId,
          video = this.players[mediaId];
        setTimeout(() => {
          this.playVideo(video);
        }, 50),
          this.pauseContainerMedia(mediaId);
      }
    }
    pauseOtherMedia(mediaId, container) {
      const currentMedia = `[${attributes$I.mediaId}="${mediaId}"]`,
        otherMedia = container.querySelectorAll(
          `${selectors$10.productMediaWrapper}:not(${currentMedia})`
        );
      otherMedia.length &&
        otherMedia.forEach((media) => {
          media.dispatchEvent(new CustomEvent("theme:media:hidden"), {
            bubbles: !0,
          }),
            media.classList.add(classes$R.mediaHidden);
        });
    }
  }
  function getSearchParams(
    searchForm,
    filtersForm,
    deleteParams = [],
    type = !1
  ) {
    const searchFormData = new FormData(searchForm),
      searchFormParams = new URLSearchParams(searchFormData);
    if (!filtersForm) return searchFormParams.toString();
    const filtersFormData = new FormData(filtersForm),
      filtersFormParams = new URLSearchParams(filtersFormData),
      emptyParams = [];
    for (const pair of searchFormData.entries())
      pair[1] === "" && emptyParams.push(pair[0]);
    for (const pair of filtersFormData.entries())
      pair[1] === "" && emptyParams.push(pair[0]);
    for (let index = 0; index < emptyParams.length; index++) {
      const param = emptyParams[index];
      searchFormParams.has(param) && searchFormParams.delete(param),
        filtersFormParams.has(param) && filtersFormParams.delete(param);
    }
    for (const key of searchFormParams.keys())
      filtersFormParams.has(key) && filtersFormParams.delete(key);
    if (deleteParams.length > 0)
      for (let index = 0; index < deleteParams.length; index++) {
        const param = deleteParams[index];
        searchFormParams.has(param) && searchFormParams.delete(param),
          filtersFormParams.has(param) && filtersFormParams.delete(param);
      }
    return (
      type &&
        (filtersFormParams.has("type") && filtersFormParams.delete("type"),
        searchFormParams.set("type", type)),
      `${searchFormParams.toString()}&${filtersFormParams.toString()}`
    );
  }
  const selectors$$ = {
    scrollbar: "[data-custom-scrollbar]",
    scrollbarItems: "[data-custom-scrollbar-items]",
    scrollbarThumb: "[data-custom-scrollbar-thumb]",
    current: ".current",
  };
  class CustomScrollbar {
    constructor(container) {
      (this.container = container),
        (this.scrollbarItems = container.querySelector(
          selectors$$.scrollbarItems
        )),
        (this.scrollbar = container.querySelector(selectors$$.scrollbar)),
        (this.scrollbarThumb = container.querySelector(
          selectors$$.scrollbarThumb
        )),
        (this.trackWidth = 0),
        (this.calcScrollbarEvent = () => this.calculateScrollbar()),
        (this.onScrollbarChangeEvent = (e) => this.onScrollbarChange(e)),
        this.scrollbar &&
          this.scrollbarItems &&
          (this.events(),
          this.calculateScrollbar(),
          this.scrollbarItems.children.length &&
            this.calculateTrack(
              this.scrollbarItems.querySelector(selectors$$.current)
            ));
    }
    calculateTrack(element) {
      if (!element) {
        this.scrollbar.style.setProperty("--thumb-scale", 0),
          this.scrollbar.style.setProperty("--thumb-position", "0px");
        return;
      }
      const thumbScale =
          element.clientWidth / this.scrollbarThumb.parentElement.clientWidth,
        thumbPosition =
          element.offsetLeft / this.scrollbarThumb.parentElement.clientWidth;
      this.scrollbar.style.setProperty("--thumb-scale", thumbScale),
        this.scrollbar.style.setProperty(
          "--thumb-position",
          `${this.trackWidth * thumbPosition}px`
        );
    }
    calculateScrollbar() {
      if (this.scrollbarItems.children.length) {
        const childrenArr = [...this.scrollbarItems.children];
        (this.trackWidth = 0),
          childrenArr.forEach((element) => {
            this.trackWidth +=
              element.getBoundingClientRect().width +
              parseInt(window.getComputedStyle(element).marginRight);
          }),
          this.scrollbar.style.setProperty(
            "--track-width",
            `${this.trackWidth}px`
          );
      }
    }
    onScrollbarChange(e) {
      e &&
        e.detail &&
        e.detail.element &&
        this.container.contains(e.detail.element) &&
        this.calculateTrack(e.detail.element);
    }
    events() {
      document.addEventListener("theme:resize:width", this.calcScrollbarEvent),
        document.addEventListener(
          "theme:custom-scrollbar:change",
          this.onScrollbarChangeEvent
        );
    }
    unload() {
      document.removeEventListener(
        "theme:resize:width",
        this.calcScrollbarEvent
      ),
        document.removeEventListener(
          "theme:custom-scrollbar:change",
          this.onScrollbarChangeEvent
        );
    }
  }
  const selectors$_ = {
      tooltip: "[data-tooltip]",
      tooltipContainer: "[data-tooltip-container]",
      tooltipArrow: "[data-tooltip-arrow]",
      aos: "[data-aos]",
    },
    classes$Q = {
      root: "tooltip-default",
      isAnimating: "is-animating",
      visible: "is-visible",
      hiding: "is-hiding",
    },
    attributes$H = {
      aos: "data-aos",
      tooltip: "data-tooltip",
      tooltipContainer: "data-tooltip-container",
      tooltipStopMouseEnter: "data-tooltip-stop-mouseenter",
    },
    sections$F = {};
  class Tooltip {
    constructor(el) {
      (this.tooltip = el),
        this.tooltip.hasAttribute(attributes$H.tooltip) &&
          ((this.rootClass = classes$Q.root),
          (this.isAnimatingClass = classes$Q.isAnimating),
          (this.label = this.tooltip.getAttribute(attributes$H.tooltip)),
          (this.transitionSpeed = 200),
          (this.hideTransitionTimeout = 0),
          (this.animatedContainer = this.tooltip.closest(selectors$_.aos)),
          (this.addPinEvent = () => this.addPin()),
          (this.addPinMouseEvent = () => this.addPin(!0)),
          (this.removePinEvent = (event2) =>
            throttle(this.removePin(event2), 50)),
          (this.removePinMouseEvent = (event2) =>
            this.removePin(event2, !0, !0)),
          this.init());
    }
    init() {
      if (!document.querySelector(selectors$_.tooltipContainer)) {
        const tooltipTemplate = `<div class="${this.rootClass}__inner"><div class="${this.rootClass}__arrow" data-tooltip-arrow></div><div class="${this.rootClass}__text label-typography"></div></div>`,
          tooltipElement = document.createElement("div");
        (tooltipElement.className = `${this.rootClass} ${this.isAnimatingClass}`),
          tooltipElement.setAttribute(attributes$H.tooltipContainer, ""),
          (tooltipElement.innerHTML = tooltipTemplate),
          document.body.appendChild(tooltipElement);
      }
      this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent),
        this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent),
        this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent),
        document.addEventListener("theme:tooltip:close", this.removePinEvent);
      const tooltipTarget = document.querySelector(
        selectors$_.tooltipContainer
      );
      theme.settings.animationsEnabled &&
        this.animatedContainer &&
        (this.animatedContainer.getAttribute(attributes$H.aos) === "hero"
          ? this.animatedContainer.addEventListener("animationend", () => {
              tooltipTarget.classList.remove(classes$Q.isAnimating);
            })
          : this.animatedContainer.addEventListener(
              "transitionend",
              (event2) => {
                event2.propertyName === "transform" &&
                  tooltipTarget.classList.remove(classes$Q.isAnimating);
              }
            ));
    }
    addPin(stopMouseEnter = !1) {
      const tooltipTarget = document.querySelector(
          selectors$_.tooltipContainer
        ),
        tooltipTargetArrow = tooltipTarget.querySelector(
          selectors$_.tooltipArrow
        );
      if (
        tooltipTarget &&
        ((stopMouseEnter &&
          !this.tooltip.hasAttribute(attributes$H.tooltipStopMouseEnter)) ||
          !stopMouseEnter)
      ) {
        const tooltipTargetInner = tooltipTarget.querySelector(
            `.${this.rootClass}__inner`
          ),
          tooltipTargetText = tooltipTarget.querySelector(
            `.${this.rootClass}__text`
          );
        tooltipTargetText.textContent = this.label;
        const tooltipTargetWidth = tooltipTargetInner.offsetWidth,
          tooltipRect = this.tooltip.getBoundingClientRect(),
          tooltipTop = tooltipRect.top,
          tooltipWidth = tooltipRect.width,
          tooltipHeight = tooltipRect.height,
          tooltipTargetPositionTop =
            tooltipTop + tooltipHeight + window.scrollY;
        let tooltipTargetPositionLeft =
            tooltipRect.left - tooltipTargetWidth / 2 + tooltipWidth / 2,
          tooltipArrowPositionLeft = "50%";
        const tooltipTargetWindowDifference =
          tooltipTargetPositionLeft + tooltipTargetWidth - window.innerWidth;
        tooltipTargetWindowDifference > 0 &&
          (tooltipTargetPositionLeft -= tooltipTargetWindowDifference),
          tooltipTargetPositionLeft < 0 &&
            ((tooltipArrowPositionLeft = `calc(50% + ${tooltipTargetPositionLeft}px)`),
            (tooltipTargetPositionLeft = 0)),
          (tooltipTargetArrow.style.left = tooltipArrowPositionLeft),
          (tooltipTarget.style.transform = `translate(${tooltipTargetPositionLeft}px, ${tooltipTargetPositionTop}px)`),
          tooltipTarget.classList.remove(classes$Q.hiding);
        const onTooltipHiding = (event2) => {
          event2.target === tooltipTargetInner &&
            ((event2.propertyName === "transform" ||
              event2.propertyName === "opacity") &&
              requestAnimationFrame(
                () => (tooltipTarget.style.transform = "translate(0, -100%)")
              ),
            tooltipTarget.removeEventListener(
              "transitionend",
              onTooltipHiding
            ));
        };
        tooltipTarget.addEventListener("transitionend", onTooltipHiding),
          tooltipTarget.classList.add(classes$Q.visible),
          document.addEventListener("theme:scroll", this.removePinEvent);
      }
    }
    removePin(event2, stopMouseEnter = !1, hideTransition = !1) {
      const tooltipTarget = document.querySelector(
          selectors$_.tooltipContainer
        ),
        tooltipVisible = tooltipTarget.classList.contains(classes$Q.visible);
      tooltipTarget &&
        ((stopMouseEnter &&
          !this.tooltip.hasAttribute(attributes$H.tooltipStopMouseEnter)) ||
          !stopMouseEnter) &&
        (tooltipVisible &&
          (hideTransition || event2.detail.hideTransition) &&
          (tooltipTarget.classList.add(classes$Q.hiding),
          this.hideTransitionTimeout &&
            clearTimeout(this.hideTransitionTimeout),
          (this.hideTransitionTimeout = setTimeout(() => {
            tooltipTarget.classList.remove(classes$Q.hiding);
          }, this.transitionSpeed))),
        tooltipTarget.classList.remove(classes$Q.visible),
        document.removeEventListener("theme:scroll", this.removePinEvent));
    }
    unload() {
      this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent),
        this.tooltip.removeEventListener(
          "mouseleave",
          this.removePinMouseEvent
        ),
        this.tooltip.removeEventListener(
          "theme:tooltip:init",
          this.addPinEvent
        ),
        document.removeEventListener(
          "theme:tooltip:close",
          this.removePinEvent
        ),
        document.removeEventListener("theme:scroll", this.removePinEvent);
    }
  }
  const tooltip = {
      onLoad() {
        (sections$F[this.id] = []),
          this.container
            .querySelectorAll(selectors$_.tooltip)
            .forEach((tooltip2) => {
              sections$F[this.id].push(new Tooltip(tooltip2));
            });
      },
      onUnload() {
        sections$F[this.id].forEach((tooltip2) => {
          typeof tooltip2.unload == "function" && tooltip2.unload();
        });
      },
    },
    selectors$Z = {
      rangeSlider: "[data-range-slider]",
      rangeDotLeft: "[data-range-left]",
      rangeDotRight: "[data-range-right]",
      rangeLine: "[data-range-line]",
      rangeHolder: "[data-range-holder]",
      dataMin: "data-se-min",
      dataMax: "data-se-max",
      dataMinValue: "data-se-min-value",
      dataMaxValue: "data-se-max-value",
      dataStep: "data-se-step",
      dataFilterUpdate: "data-range-filter-update",
      priceMin: "[data-field-price-min]",
      priceMax: "[data-field-price-max]",
    },
    classes$P = { isInitialized: "is-initialized" };
  class RangeSlider {
    constructor(container) {
      (this.container = container),
        this.init(),
        (this.initListener = () => this.init()),
        document.addEventListener("theme:filters:init", this.initListener);
    }
    init() {
      if (
        ((this.slider = this.container.querySelector(selectors$Z.rangeSlider)),
        !this.slider)
      )
        return;
      (this.resizeFilters = debounce(this.reset.bind(this), 50)),
        (this.onMoveEvent = (event2) => this.onMove(event2)),
        (this.onStopEvent = (event2) => this.onStop(event2)),
        (this.onStartEvent = (event2) => this.onStart(event2)),
        (this.startX = 0),
        (this.x = 0),
        (this.touchLeft = this.slider.querySelector(selectors$Z.rangeDotLeft)),
        (this.touchRight = this.slider.querySelector(
          selectors$Z.rangeDotRight
        )),
        (this.lineSpan = this.slider.querySelector(selectors$Z.rangeLine)),
        (this.min = parseFloat(this.slider.getAttribute(selectors$Z.dataMin))),
        (this.max = parseFloat(this.slider.getAttribute(selectors$Z.dataMax))),
        (this.step = 0),
        (this.normalizeFact = 20);
      let defaultMinValue = this.min;
      this.slider.hasAttribute(selectors$Z.dataMinValue) &&
        (defaultMinValue = parseFloat(
          this.slider.getAttribute(selectors$Z.dataMinValue)
        ));
      let defaultMaxValue = this.max;
      this.slider.hasAttribute(selectors$Z.dataMaxValue) &&
        (defaultMaxValue = parseFloat(
          this.slider.getAttribute(selectors$Z.dataMaxValue)
        )),
        defaultMinValue < this.min && (defaultMinValue = this.min),
        defaultMaxValue > this.max && (defaultMaxValue = this.max),
        defaultMinValue > defaultMaxValue &&
          (defaultMinValue = defaultMaxValue),
        this.slider.getAttribute(selectors$Z.dataStep) &&
          (this.step = Math.abs(
            parseFloat(this.slider.getAttribute(selectors$Z.dataStep))
          )),
        this.reset(),
        window.addEventListener("theme:resize", this.resizeFilters),
        (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
        (this.selectedTouch = null),
        (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
        this.setMinValue(defaultMinValue),
        this.setMaxValue(defaultMaxValue),
        this.touchLeft.addEventListener("mousedown", this.onStartEvent),
        this.touchRight.addEventListener("mousedown", this.onStartEvent),
        this.touchLeft.addEventListener("touchstart", this.onStartEvent, {
          passive: !0,
        }),
        this.touchRight.addEventListener("touchstart", this.onStartEvent, {
          passive: !0,
        }),
        this.slider.classList.add(classes$P.isInitialized);
    }
    reset() {
      (this.touchLeft.style.left = "0px"),
        (this.touchRight.style.left =
          this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
        (this.lineSpan.style.marginLeft = "0px"),
        (this.lineSpan.style.width =
          this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
        (this.startX = 0),
        (this.x = 0),
        (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
        (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact);
    }
    setMinValue(minValue) {
      const ratio = (minValue - this.min) / (this.max - this.min);
      (this.touchLeft.style.left =
        Math.ceil(
          ratio *
            (this.slider.offsetWidth -
              (this.touchLeft.offsetWidth + this.normalizeFact))
        ) + "px"),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.slider.setAttribute(selectors$Z.dataMinValue, minValue);
    }
    setMaxValue(maxValue) {
      const ratio = (maxValue - this.min) / (this.max - this.min);
      (this.touchRight.style.left =
        Math.ceil(
          ratio *
            (this.slider.offsetWidth -
              (this.touchLeft.offsetWidth + this.normalizeFact)) +
            this.normalizeFact
        ) + "px"),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.slider.setAttribute(selectors$Z.dataMaxValue, maxValue);
    }
    onStart(event2) {
      event2.preventDefault();
      let eventTouch = event2;
      event2.touches && (eventTouch = event2.touches[0]),
        event2.currentTarget === this.touchLeft
          ? (this.x = this.touchLeft.offsetLeft)
          : event2.currentTarget === this.touchRight &&
            (this.x = this.touchRight.offsetLeft),
        (this.startX = eventTouch.pageX - this.x),
        (this.selectedTouch = event2.currentTarget),
        document.addEventListener("mousemove", this.onMoveEvent),
        document.addEventListener("mouseup", this.onStopEvent),
        document.addEventListener("touchmove", this.onMoveEvent, {
          passive: !0,
        }),
        document.addEventListener("touchend", this.onStopEvent, {
          passive: !0,
        });
    }
    onMove(event2) {
      let eventTouch = event2;
      event2.touches && (eventTouch = event2.touches[0]),
        (this.x = eventTouch.pageX - this.startX),
        this.selectedTouch === this.touchLeft
          ? (this.x >
            this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10
              ? (this.x =
                  this.touchRight.offsetLeft -
                  this.selectedTouch.offsetWidth +
                  10)
              : this.x < 0 && (this.x = 0),
            (this.selectedTouch.style.left = this.x + "px"))
          : this.selectedTouch === this.touchRight &&
            (this.x <
            this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10
              ? (this.x =
                  this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10)
              : this.x > this.maxX && (this.x = this.maxX),
            (this.selectedTouch.style.left = this.x + "px")),
        (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
        (this.lineSpan.style.width =
          this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
        this.calculateValue(),
        this.slider.getAttribute("on-change") &&
          new Function("min, max", this.slider.getAttribute("on-change"))(
            this.slider.getAttribute(selectors$Z.dataMinValue),
            this.slider.getAttribute(selectors$Z.dataMaxValue)
          ),
        this.onChange(
          this.slider.getAttribute(selectors$Z.dataMinValue),
          this.slider.getAttribute(selectors$Z.dataMaxValue)
        );
    }
    onStop(event2) {
      document.removeEventListener("mousemove", this.onMoveEvent),
        document.removeEventListener("mouseup", this.onStopEvent),
        document.removeEventListener("touchmove", this.onMoveEvent, {
          passive: !0,
        }),
        document.removeEventListener("touchend", this.onStopEvent, {
          passive: !0,
        }),
        (this.selectedTouch = null),
        this.calculateValue(),
        this.onChanged(
          this.slider.getAttribute(selectors$Z.dataMinValue),
          this.slider.getAttribute(selectors$Z.dataMaxValue)
        );
    }
    onChange(min, max) {
      const rangeHolder = this.slider.closest(selectors$Z.rangeHolder);
      if (rangeHolder) {
        const priceMin = rangeHolder.querySelector(selectors$Z.priceMin),
          priceMax = rangeHolder.querySelector(selectors$Z.priceMax);
        priceMin &&
          priceMax &&
          ((priceMin.value = parseInt(min)), (priceMax.value = parseInt(max)));
      }
    }
    onChanged(min, max) {
      this.slider.hasAttribute(selectors$Z.dataFilterUpdate) &&
        this.slider.dispatchEvent(
          new CustomEvent("theme:filter:range-update", { bubbles: !0 })
        );
    }
    calculateValue() {
      const newValue =
        (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
      let minValue = this.lineSpan.offsetLeft / this.initialValue,
        maxValue = minValue + newValue;
      if (
        ((minValue = minValue * (this.max - this.min) + this.min),
        (maxValue = maxValue * (this.max - this.min) + this.min),
        this.step !== 0)
      ) {
        let multi = Math.floor(minValue / this.step);
        (minValue = this.step * multi),
          (multi = Math.floor(maxValue / this.step)),
          (maxValue = this.step * multi);
      }
      this.selectedTouch === this.touchLeft &&
        this.slider.setAttribute(selectors$Z.dataMinValue, minValue),
        this.selectedTouch === this.touchRight &&
          this.slider.setAttribute(selectors$Z.dataMaxValue, maxValue);
    }
    unload() {
      document.removeEventListener("theme:filters:init", this.initListener),
        window.removeEventListener("theme:resize", this.resizeFilters);
    }
  }
  function Listeners() {
    this.entries = [];
  }
  (Listeners.prototype.add = function (element, event2, fn) {
    this.entries.push({ element, event: event2, fn }),
      element.addEventListener(event2, fn);
  }),
    (Listeners.prototype.removeAll = function () {
      this.entries = this.entries.filter(function (listener) {
        return (
          listener.element.removeEventListener(listener.event, listener.fn), !1
        );
      });
    });
  function getVariantFromSerializedArray(product, collection) {
    _validateProductStructure(product);
    var optionArray = _createOptionArrayFromOptionCollection(
      product,
      collection
    );
    return getVariantFromOptionArray(product, optionArray);
  }
  function getVariantFromOptionArray(product, options2) {
    _validateProductStructure(product), _validateOptionsArray(options2);
    var result = product.variants.filter(function (variant) {
      return options2.every(function (option, index) {
        return variant.options[index] === option;
      });
    });
    return result[0] || null;
  }
  function _createOptionArrayFromOptionCollection(product, collection) {
    _validateProductStructure(product), _validateSerializedArray(collection);
    var optionArray = [];
    return (
      collection.forEach(function (option) {
        for (var i = 0; i < product.options.length; i++) {
          var name = product.options[i].name || product.options[i];
          if (name.toLowerCase() === option.name.toLowerCase()) {
            optionArray[i] = option.value;
            break;
          }
        }
      }),
      optionArray
    );
  }
  function _validateProductStructure(product) {
    if (typeof product != "object")
      throw new TypeError(product + " is not an object.");
    if (Object.keys(product).length === 0 && product.constructor === Object)
      throw new Error(product + " is empty.");
  }
  function _validateSerializedArray(collection) {
    if (!Array.isArray(collection))
      throw new TypeError(collection + " is not an array.");
    if (collection.length === 0) throw new Error(collection + " is empty.");
    if (collection[0].hasOwnProperty("name")) {
      if (typeof collection[0].name != "string")
        throw new TypeError(
          "Invalid value type passed for name of option " +
            collection[0].name +
            ". Value should be string."
        );
    } else throw new Error(collection[0] + "does not contain name key.");
  }
  function _validateOptionsArray(options2) {
    if (Array.isArray(options2) && typeof options2[0] == "object")
      throw new Error(options2 + "is not a valid array of options.");
  }
  var selectors$Y = {
    idInput: '[name="id"]',
    planInput: '[name="selling_plan"]',
    optionInput: '[name^="options"]',
    quantityInput: '[name="quantity"]',
    propertyInput: '[name^="properties"]',
  };
  function getUrlWithVariant(url, id) {
    return /variant=/.test(url)
      ? url.replace(/(variant=)[^&]+/, "$1" + id)
      : /\?/.test(url)
      ? url.concat("&variant=").concat(id)
      : url.concat("?variant=").concat(id);
  }
  class ProductForm {
    constructor(element, product, options2) {
      (this.element = element),
        (this.form =
          this.element.tagName == "FORM"
            ? this.element
            : this.element.querySelector("form")),
        (this.product = this._validateProductObject(product)),
        (this.variantElement = this.element.querySelector(selectors$Y.idInput)),
        (options2 = options2 || {}),
        (this._listeners = new Listeners()),
        this._listeners.add(
          this.element,
          "submit",
          this._onSubmit.bind(this, options2)
        ),
        (this.optionInputs = this._initInputs(
          selectors$Y.optionInput,
          options2.onOptionChange
        )),
        (this.planInputs = this._initInputs(
          selectors$Y.planInput,
          options2.onPlanChange
        )),
        (this.quantityInputs = this._initInputs(
          selectors$Y.quantityInput,
          options2.onQuantityChange
        )),
        (this.propertyInputs = this._initInputs(
          selectors$Y.propertyInput,
          options2.onPropertyChange
        ));
    }
    destroy() {
      this._listeners.removeAll();
    }
    options() {
      return this._serializeInputValues(this.optionInputs, function (item) {
        var regex = /(?:^(options\[))(.*?)(?:\])/;
        return (item.name = regex.exec(item.name)[2]), item;
      });
    }
    variant() {
      const opts = this.options();
      return opts.length
        ? getVariantFromSerializedArray(this.product, opts)
        : this.product.variants[0];
    }
    plan(variant) {
      let plan = { allocation: null, group: null, detail: null };
      const id = new FormData(this.form).get("selling_plan");
      return (
        id &&
          variant &&
          (plan.allocation = variant.selling_plan_allocations.find(function (
            item
          ) {
            return item.selling_plan_id.toString() === id.toString();
          })),
        plan.allocation &&
          (plan.group = this.product.selling_plan_groups.find(function (item) {
            return (
              item.id.toString() ===
              plan.allocation.selling_plan_group_id.toString()
            );
          })),
        plan.group &&
          (plan.detail = plan.group.selling_plans.find(function (item) {
            return item.id.toString() === id.toString();
          })),
        plan && plan.allocation && plan.detail && plan.allocation ? plan : null
      );
    }
    properties() {
      return this._serializeInputValues(this.propertyInputs, function (item) {
        var regex = /(?:^(properties\[))(.*?)(?:\])/;
        return (item.name = regex.exec(item.name)[2]), item;
      });
    }
    quantity() {
      return this.quantityInputs[0]
        ? Number.parseInt(this.quantityInputs[0].value, 10)
        : 1;
    }
    getFormState() {
      const variant = this.variant();
      return {
        options: this.options(),
        variant,
        properties: this.properties(),
        quantity: this.quantity(),
        plan: this.plan(variant),
      };
    }
    _setIdInputValue(variant) {
      variant && variant.id
        ? (this.variantElement.value = variant.id.toString())
        : (this.variantElement.value = ""),
        this.variantElement.dispatchEvent(new Event("change"));
    }
    _onSubmit(options2, event2) {
      (event2.dataset = this.getFormState()),
        options2.onFormSubmit && options2.onFormSubmit(event2);
    }
    _onOptionChange(event2) {
      this._setIdInputValue(event2.dataset.variant);
    }
    _onFormEvent(cb) {
      return typeof cb > "u"
        ? Function.prototype.bind()
        : function (event2) {
            (event2.dataset = this.getFormState()),
              this._setIdInputValue(event2.dataset.variant),
              cb(event2);
          }.bind(this);
    }
    _initInputs(selector, cb) {
      var elements = Array.prototype.slice.call(
        this.element.querySelectorAll(selector)
      );
      return elements.map(
        function (element) {
          return (
            this._listeners.add(element, "change", this._onFormEvent(cb)),
            element
          );
        }.bind(this)
      );
    }
    _serializeInputValues(inputs, transform) {
      return inputs.reduce(function (options2, input) {
        return (
          (input.checked ||
            (input.type !== "radio" && input.type !== "checkbox")) &&
            options2.push(transform({ name: input.name, value: input.value })),
          options2
        );
      }, []);
    }
    _validateProductObject(product) {
      if (typeof product != "object")
        throw new TypeError(product + " is not an object.");
      if (typeof product.variants[0].options > "u")
        throw new TypeError(
          "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
        );
      return product;
    }
  }
  function fetchProduct(handle) {
    const requestRoute = `${theme.routes.root}products/${handle}.js`;
    return window
      .fetch(requestRoute)
      .then((response) => response.json())
      .catch((e) => {
        console.error(e);
      });
  }
  const defaults$1 = { color: "ash" },
    selectors$X = {
      swatch: "[data-swatch]",
      swatchColor: "[data-swatch-color]",
      productBlock: "[data-product-block]",
      productImage: "[data-product-image]",
      productImageSecondary: "[data-product-image-secondary]",
      productImageHover: "[data-product-image-hover]",
      quickView: "[data-button-quick-view]",
      gridImage: "[data-grid-image]",
      link: "[data-grid-link]",
      swatchesMore: "[data-swatches-more]",
      sectionType: "[data-section-type]",
      swatchesContainer: "[data-swatches-container]",
      swatchesLabel: "[data-swatches-label]",
      swatchesButton: "[data-swatches-button]",
      selectorWrapper: "[data-option-position]",
      slider: "[data-slider]",
    },
    classes$O = {
      mediaVisible: "product__media--featured-visible",
      mediaHoverVisible: "product__media__hover-img--visible",
      noImage: "swatch__link--no-image",
      noOutline: "no-outline",
      isVisible: "is-visible",
      selectorLarge: "selector-wrapper--large",
    },
    attributes$G = {
      swatch: "data-swatch",
      handle: "data-swatch-handle",
      label: "data-swatch-label",
      image: "data-swatch-image",
      imageId: "data-swatch-image-id",
      variant: "data-swatch-variant",
      variantId: "data-variant-id",
      variantSecondaryId: "data-variant-secondary-id",
      loaded: "data-loaded",
      href: "href",
    };
  let swatches = {};
  const sections$E = {};
  class ColorMatch {
    constructor(options2 = {}) {
      (this.settings = { ...defaults$1, ...options2 }),
        (this.match = this.init());
    }
    getColor() {
      return this.match;
    }
    init() {
      return loadScript({ json: theme.assets.swatches })
        .then((colors) => this.matchColors(colors, this.settings.color))
        .catch((e) => {
          console.log("failed to load swatch colors script"), console.log(e);
        });
    }
    matchColors(colors, name) {
      let bg = "#E5E5E5",
        img = null;
      const path = theme.assets.base || "/",
        comparisonName = name.toLowerCase().replace(/\s/g, ""),
        array = colors.colors;
      if (array) {
        let indexArray = null;
        if (
          array.filter((colorObj, index) => {
            if (
              Object.keys(colorObj)
                .toString()
                .toLowerCase()
                .replace(/\s/g, "") === comparisonName
            )
              return (indexArray = index), colorObj;
          }).length &&
          indexArray !== null
        ) {
          const value = Object.values(array[indexArray])[0];
          (bg = value),
            (value.includes(".jpg") ||
              value.includes(".jpeg") ||
              value.includes(".png") ||
              value.includes(".svg")) &&
              ((img = `${path}${value}`), (bg = "#888888"));
        }
      }
      return { color: this.settings.color, path: img, hex: bg };
    }
  }
  class Swatch {
    constructor(element) {
      (this.element = element),
        (this.swatchLink = this.element.nextElementSibling),
        (this.colorString = element.getAttribute(attributes$G.swatch)),
        (this.image = this.element.getAttribute(attributes$G.image)),
        (this.imageId = this.element.getAttribute(attributes$G.imageId)),
        (this.variant = this.element.getAttribute(attributes$G.variant)),
        (this.outer = this.element.closest(selectors$X.productBlock)),
        (this.hoverImages = []),
        new ColorMatch({ color: this.colorString })
          .getColor()
          .then((result) => {
            (this.colorMatch = result), this.init();
          });
    }
    init() {
      this.setStyles(),
        this.variant && this.outer && this.handleClicks(),
        !this.image &&
          this.swatchLink &&
          this.swatchLink.classList.add(classes$O.noImage);
    }
    setStyles() {
      window.theme.settings.colorSwatchesType != "native" &&
        (this.colorMatch &&
          this.colorMatch.hex &&
          this.element.style.setProperty("--swatch", `${this.colorMatch.hex}`),
        this.colorMatch &&
          this.colorMatch.path &&
          this.element.style.setProperty(
            "background-image",
            `url(${this.colorMatch.path})`
          ));
    }
    handleClicks() {
      this.swatchLink.addEventListener("click", (event2) => {
        const isFocusEnabled = !document.body.classList.contains(
            classes$O.noOutline
          ),
          variantId = this.swatchLink.getAttribute(attributes$G.variant);
        isFocusEnabled ||
          (event2.preventDefault(),
          this.updateImagesAndLinksOnEvent(variantId));
      }),
        this.swatchLink.addEventListener("keyup", (event2) => {
          const isFocusEnabled = !document.body.classList.contains(
              classes$O.noOutline
            ),
            variantId = this.swatchLink.getAttribute(attributes$G.variant);
          (event2.code !== theme.keyboardKeys.ENTER &&
            event2.code !== theme.keyboardKeys.NUMPADENTER) ||
            isFocusEnabled ||
            (event2.preventDefault(),
            this.swatchLink.dispatchEvent(
              new Event("mouseenter", { bubbles: !0 })
            ),
            this.updateImagesAndLinksOnEvent(variantId));
        });
    }
    updateImagesAndLinksOnEvent(variantId) {
      this.updateLinks(), this.replaceImages(variantId);
    }
    updateLinks() {
      (this.linkElements = this.outer.querySelectorAll(selectors$X.link)),
        (this.quickView = this.outer.querySelector(selectors$X.quickView)),
        this.linkElements.length &&
          this.linkElements.forEach((element) => {
            const destination = getUrlWithVariant(
              element.getAttribute("href"),
              this.variant
            );
            element.setAttribute("href", destination);
          }),
        this.quickView &&
          theme.settings.quickBuy === "quick_buy" &&
          this.quickView.setAttribute(attributes$G.variantId, this.variant);
    }
    replaceImages(id) {
      const imageSecondary = this.outer.querySelector(
          `[${attributes$G.variantSecondaryId}="${id}"]`
        ),
        gridImage = this.outer.querySelector(
          `[${attributes$G.variantId}="${id}"]`
        ),
        currentGridImage = [
          ...this.outer.querySelectorAll(selectors$X.gridImage),
        ].find((image) => image.classList.contains(classes$O.mediaVisible));
      if (gridImage && this.imageId) {
        if (!imageSecondary || !currentGridImage) return;
        const onAnimationEnd = () => {
          requestAnimationFrame(() => {
            currentGridImage.classList.remove(classes$O.mediaVisible),
              gridImage.classList.add(classes$O.mediaVisible),
              requestAnimationFrame(() => {
                imageSecondary.classList.remove(classes$O.mediaVisible);
              });
          }),
            imageSecondary.removeEventListener("animationend", onAnimationEnd);
        };
        requestAnimationFrame(() => {
          imageSecondary.classList.add(classes$O.mediaVisible);
        }),
          imageSecondary.addEventListener("animationend", onAnimationEnd);
      }
      theme.settings.productGridHover === "image" &&
        (this.hoverImages = this.outer.querySelectorAll(
          selectors$X.productImageHover
        )),
        this.hoverImages.length > 1 &&
          this.hoverImages.forEach((hoverImage) => {
            hoverImage.classList.remove(classes$O.mediaHoverVisible),
              hoverImage.getAttribute(attributes$G.variantId) === this.variant
                ? hoverImage.classList.add(classes$O.mediaHoverVisible)
                : this.hoverImages[0].classList.add(
                    classes$O.mediaHoverVisible
                  );
          });
    }
  }
  class GridSwatch extends HTMLElement {
    constructor() {
      super(),
        (this.handle = this.getAttribute(attributes$G.handle)),
        (this.label = this.getAttribute(attributes$G.label)
          .trim()
          .toLowerCase()),
        fetchProduct(this.handle).then((product) => {
          (this.product = product),
            (this.colorOption = product.options.find(
              (element) => element.name.toLowerCase() === this.label || null
            )),
            this.colorOption &&
              ((this.swatches = this.colorOption.values), this.init());
        });
    }
    init() {
      (this.swatchElements = this.querySelectorAll(selectors$X.swatch)),
        this.swatchElements.forEach((el) => {
          new Swatch(el);
        }),
        this.handleShowMore();
    }
    handleShowMore() {
      (this.initialHeight = this.offsetHeight),
        (this.expandedHeight = this.initialHeight);
      const section = this.closest(selectors$X.sectionType),
        moreLink = this.querySelector(selectors$X.swatchesMore);
      moreLink &&
        (moreLink?.addEventListener("click", () => {
          this.classList.add(classes$O.isVisible);
        }),
        section?.addEventListener("touchstart", (e) => {
          this.contains(e.target) ||
            (this.classList.remove(classes$O.isVisible),
            this.dispatchEvent(new Event("mouseleave", { bubbles: !0 })));
        }),
        this.addEventListener("mouseenter", () => {
          const onAnimationStart = (event2) => {
            this.expandedHeight = this.offsetHeight;
            const slider2 = event2.target.closest(selectors$X.slider);
            this.expandedHeight > this.initialHeight &&
              slider2 &&
              requestAnimationFrame(() =>
                slider2.dispatchEvent(
                  new CustomEvent("theme:slider:resize", { bubbles: !1 })
                )
              ),
              this.removeEventListener("animationstart", onAnimationStart);
          };
          this.addEventListener("animationstart", onAnimationStart);
        }),
        this.addEventListener("mouseleave", () => {
          const onAnimationStart = (event2) => {
            const slider2 = event2.target.closest(selectors$X.slider);
            this.expandedHeight > this.initialHeight &&
              slider2 &&
              requestAnimationFrame(() =>
                slider2.dispatchEvent(
                  new CustomEvent("theme:slider:resize", { bubbles: !1 })
                )
              ),
              this.removeEventListener("animationstart", onAnimationStart);
          };
          this.addEventListener("animationstart", onAnimationStart);
        }));
    }
  }
  class SwatchesContainer {
    constructor(container) {
      (this.container = container),
        (this.swatchesContainers = this.container.querySelectorAll(
          selectors$X.swatchesContainer
        )),
        this.swatchesContainers.forEach((swatchesContainer2) => {
          (this.checkSwatchesHeightOnResize = () =>
            this.checkSwatchesHeight(swatchesContainer2)),
            this.checkSwatchesHeight(swatchesContainer2),
            document.addEventListener(
              "theme:resize:width",
              this.checkSwatchesHeightOnResize
            );
        });
    }
    checkSwatchesHeight(swatchesContainer2) {
      const label = swatchesContainer2.querySelector(selectors$X.swatchesLabel),
        swatch = swatchesContainer2.querySelector(selectors$X.swatchesButton),
        containerPaddingTop = parseInt(
          window
            .getComputedStyle(swatchesContainer2)
            .getPropertyValue("padding-top")
        ),
        labelMargin = parseInt(
          window.getComputedStyle(label).getPropertyValue("margin-bottom")
        ),
        swatchMargin = parseInt(
          window.getComputedStyle(swatch).getPropertyValue("margin-bottom")
        ),
        selectorWrapper = swatchesContainer2.closest(
          selectors$X.selectorWrapper
        );
      selectorWrapper.classList.remove(classes$O.selectorLarge),
        swatchesContainer2.offsetHeight - containerPaddingTop >
          label.offsetHeight +
            labelMargin +
            swatch.offsetHeight * 2 +
            swatchMargin * 2 &&
          (swatchesContainer2.style.setProperty(
            "--swatches-max-height",
            `${swatchesContainer2.offsetHeight}px`
          ),
          selectorWrapper.classList.add(classes$O.selectorLarge));
    }
    onUnload() {
      this.swatchesContainers.forEach((swatchesContainer2) => {
        document.removeEventListener(
          "theme:resize:width",
          this.checkSwatchesHeightOnResize
        );
      });
    }
  }
  const makeSwatches = (container) => {
      (swatches = []),
        container.querySelectorAll(selectors$X.swatch).forEach((el) => {
          swatches.push(new Swatch(el));
        });
    },
    swatchSection = {
      onLoad() {
        makeSwatches(this.container);
      },
    },
    swatchesContainer = {
      onLoad() {
        sections$E[this.id] = new SwatchesContainer(this.container);
      },
      onUnload() {
        sections$E[this.id].onUnload();
      },
    },
    selectors$W = {
      slider: "[data-slider]",
      productMediaContainer: "[data-product-media-container]",
      productMediaSlider: "[data-product-media-slideshow]",
      productMediaSlide: "[data-product-media-slideshow-slide]",
      progressBar: "[data-product-slideshow-progress]",
      flickityButton: ".flickity-button",
      popupProduct: "[data-product]",
      popupClose: "[data-popup-close]",
    },
    classes$N = { fill: "fill", quickViewVisible: "js-quick-view-visible" },
    sections$D = {};
  class ProductGrid {
    constructor(container) {
      (this.container = container),
        (this.body = document.body),
        (this.sliders = this.container.querySelectorAll(selectors$W.slider)),
        theme.settings.productGridHover === "slideshow" &&
          !window.theme.touch &&
          this.productGridSlideshow(),
        new QuickViewPopup(this.container);
    }
    productGridSlideshow() {
      const productMediaSlider = this.container.querySelectorAll(
          selectors$W.productMediaSlider
        ),
        linkedImages = this.container.querySelectorAll(
          selectors$W.productMediaContainer
        );
      productMediaSlider.length &&
        productMediaSlider.forEach((slider2) => {
          const mediaContainer = slider2.closest(
              selectors$W.productMediaContainer
            ),
            progressBar = mediaContainer.querySelector(selectors$W.progressBar),
            countImages = slider2.querySelectorAll(
              selectors$W.productMediaSlide
            ).length,
            autoplaySpeed = 2200,
            draggable = !this.sliders.length;
          let flkty = new Flickity.data(slider2),
            timer = 0,
            cellSelector = selectors$W.productMediaSlide;
          !flkty.isActive &&
            countImages > 1 &&
            ((flkty = new Flickity(slider2, {
              draggable,
              cellSelector,
              contain: !0,
              wrapAround: !0,
              imagesLoaded: !0,
              pageDots: !1,
              prevNextButtons: !1,
              adaptiveHeight: !1,
              pauseAutoPlayOnHover: !1,
              selectedAttraction: 0.2,
              friction: 1,
              on: {
                ready: () => {
                  this.container.style.setProperty(
                    "--autoplay-speed",
                    `${autoplaySpeed}ms`
                  );
                },
                change: () => {
                  timer && clearTimeout(timer),
                    progressBar.classList.remove(classes$N.fill),
                    progressBar.offsetWidth,
                    requestAnimationFrame(() => {
                      progressBar.classList.add(classes$N.fill);
                    }),
                    (timer = setTimeout(() => {
                      progressBar.classList.remove(classes$N.fill);
                    }, autoplaySpeed));
                },
                dragEnd: () => {
                  flkty.playPlayer();
                },
              },
            })),
            window.theme.touch ||
              (mediaContainer.addEventListener("mouseenter", () => {
                progressBar.classList.add(classes$N.fill),
                  timer && clearTimeout(timer),
                  (timer = setTimeout(() => {
                    progressBar.classList.remove(classes$N.fill);
                  }, autoplaySpeed)),
                  (flkty.options.autoPlay = autoplaySpeed),
                  flkty.playPlayer();
              }),
              mediaContainer.addEventListener("mouseleave", () => {
                flkty.stopPlayer(),
                  timer && clearTimeout(timer),
                  progressBar.classList.remove(classes$N.fill);
              })));
        }),
        linkedImages.length &&
          linkedImages.forEach((item) => {
            item.addEventListener("click", (e) => {
              e.target.matches(selectors$W.flickityButton) &&
                e.preventDefault();
            });
          });
    }
    popupClose() {
      const popupProduct = document.querySelector(selectors$W.popupProduct);
      popupProduct &&
        popupProduct
          .querySelector(selectors$W.popupClose)
          .dispatchEvent(new Event("click"));
    }
    onBlockSelect() {
      this.body.classList.contains(classes$N.quickViewVisible) &&
        this.popupClose();
    }
    onDeselect() {
      this.body.classList.contains(classes$N.quickViewVisible) &&
        this.popupClose();
    }
    onUnload() {
      this.body.classList.contains(classes$N.quickViewVisible) &&
        this.popupClose();
    }
  }
  const productGrid = {
      onLoad() {
        sections$D[this.id] = new ProductGrid(this.container);
      },
      onBlockSelect() {
        sections$D[this.id].onBlockSelect();
      },
      onDeselect() {
        sections$D[this.id].onDeselect();
      },
      onUnload() {
        sections$D[this.id].onUnload();
      },
    },
    selectors$V = {
      ajaxinateContainer: "#AjaxinateLoop",
      ajaxinatePagination: "#AjaxinatePagination",
      productItem: "[data-product-block]",
      promo: "[data-promo]",
    },
    attributes$F = {
      ajaxinateId: "data-ajaxinate-id",
      columnsTablet: "data-columns-tablet",
      columnsMobile: "data-columns-mobile",
    },
    classes$M = {
      isLoaded: "is-loaded",
      loadedItem: "loaded-item",
      promoFull: "collection-promo--full",
      promoTwoColumns: "collection-promo--two-columns",
      promoGridSecond: "collection-promo--grid-second",
      promoGridThird: "collection-promo--grid-third",
      promoGridEven: "collection-promo--grid-even",
      promoOneColumn: "collection-promo--one-column",
    };
  let sections$C = {};
  class Ajaxify {
    constructor(container) {
      (this.container = container),
        (this.endlessScroll = []),
        theme.settings.enableInfinityScroll && this.init();
    }
    init() {
      this.loadMoreFix(),
        (this.ajaxinateContainer = this.container.querySelectorAll(
          selectors$V.ajaxinateContainer
        )),
        this.ajaxinateContainer.forEach((element) => {
          const ajaxinateContainer = `${selectors$V.ajaxinateContainer}[${attributes$F.ajaxinateId}="${element.dataset.ajaxinateId}"]`,
            ajaxinatePagination = `${selectors$V.ajaxinatePagination}[${attributes$F.ajaxinateId}="${element.dataset.ajaxinateId}"]`;
          if (element.children.length > 0) {
            const endlessScroll = new Ajaxinate({
                container: ajaxinateContainer,
                pagination: ajaxinatePagination,
                method: "scroll",
              }),
              promos = element.querySelectorAll(selectors$V.promo),
              columnsTablet = Number(
                element.getAttribute(attributes$F.columnsTablet)
              ),
              columnsMobile = Number(
                element.getAttribute(attributes$F.columnsMobile)
              );
            if (columnsTablet >= 3) {
              let tabletCounter = 0;
              if (
                (promos.forEach((promo) => {
                  promo.classList.contains(classes$M.promoFull)
                    ? promo.classList.contains(classes$M.promoGridThird)
                      ? (tabletCounter += 1)
                      : promo.classList.contains(classes$M.promoGridSecond)
                      ? (tabletCounter += 2)
                      : (tabletCounter += 3)
                    : promo.classList.contains(classes$M.promoTwoColumns)
                    ? promo.classList.contains(classes$M.promoGridThird)
                      ? (tabletCounter += 1)
                      : (tabletCounter += 2)
                    : (tabletCounter += 1);
                }),
                tabletCounter > 0)
              ) {
                let emptySpacesTablet =
                  columnsTablet - (tabletCounter % columnsTablet);
                emptySpacesTablet === columnsTablet && (emptySpacesTablet = 0),
                  element.classList.add(
                    `grid--empty-items-tablet-${emptySpacesTablet}`
                  );
              }
            }
            if (columnsMobile === 2) {
              let mobileCounter = 0;
              if (
                (promos.forEach((promo) => {
                  (promo.classList.contains(classes$M.promoGridEven) ||
                    promo.classList.contains(classes$M.promoOneColumn)) &&
                    (mobileCounter += 1);
                }),
                mobileCounter > 0)
              ) {
                let emptySpacesMobile =
                  columnsMobile - (mobileCounter % columnsMobile);
                emptySpacesMobile === columnsMobile && (emptySpacesMobile = 0),
                  element.classList.add(
                    `grid--empty-items-mobile-${emptySpacesMobile}`
                  );
              }
            }
            element.classList.add(classes$M.isLoaded),
              this.endlessScroll.push(endlessScroll);
          }
        });
    }
    update(id) {
      this.ajaxinateContainer = this.container.querySelectorAll(
        selectors$V.ajaxinateContainer
      );
      const instanceIDMatch = (instance) => instance.settings.container === id,
        elementIDMatch = (element2) =>
          `${selectors$V.ajaxinateContainer}[${attributes$F.ajaxinateId}="${element2.dataset.ajaxinateId}"]` ===
          id,
        instanceExists = this.endlessScroll.find(instanceIDMatch);
      if (instanceExists) {
        const index = this.endlessScroll.findIndex(instanceIDMatch);
        this.endlessScroll.splice(index, 1),
          (instanceExists.settings.method = "scroll"),
          instanceExists.destroy();
      }
      const element = [...this.ajaxinateContainer].find(elementIDMatch);
      if (!element) return;
      const ajaxinateContainer = `${selectors$V.ajaxinateContainer}[${attributes$F.ajaxinateId}="${element.dataset.ajaxinateId}"]`,
        ajaxinatePagination = `${selectors$V.ajaxinatePagination}[${attributes$F.ajaxinateId}="${element.dataset.ajaxinateId}"]`;
      if (!(element.children.length > 0)) return;
      const endlessScroll = new Ajaxinate({
        container: ajaxinateContainer,
        pagination: ajaxinatePagination,
        method: "scroll",
      });
      element.classList.add(classes$M.isLoaded),
        this.endlessScroll.push(endlessScroll);
    }
    loadMoreFix() {
      Ajaxinate.prototype.loadMore = function () {
        (this.request = new XMLHttpRequest()),
          (this.request.onreadystatechange = function () {
            if (
              !this.request.responseXML ||
              !this.request.readyState === 4 ||
              !this.request.status === 200
            )
              return;
            const newContainer = this.request.responseXML.querySelector(
                this.settings.container
              ),
              newPagination = this.request.responseXML.querySelector(
                this.settings.pagination
              );
            newContainer
              .querySelectorAll(selectors$V.productItem)
              .forEach((item) => item.classList.add(classes$M.loadedItem)),
              this.containerElement.insertAdjacentHTML(
                "beforeend",
                newContainer.innerHTML
              ),
              typeof newPagination > "u" || newPagination === null
                ? this.removePaginationElement()
                : ((this.paginationElement.innerHTML = newPagination.innerHTML),
                  this.settings.callback &&
                    typeof this.settings.callback == "function" &&
                    this.settings.callback(this.request.responseXML),
                  this.initialize());
          }.bind(this)),
          this.request.open("GET", this.nextPageUrl, !0),
          (this.request.responseType = "document"),
          this.request.send();
      };
    }
    unload() {
      this.endlessScroll.length > 0 &&
        (this.endlessScroll.forEach((instance) => {
          (instance.settings.method = "scroll"), instance.destroy();
        }),
        this.ajaxinateContainer.forEach((element) =>
          element.classList.remove(classes$M.isLoaded)
        ));
    }
  }
  const ajaxify = {
      onLoad() {
        sections$C = new Ajaxify(this.container);
      },
      onUnload: function () {
        typeof sections$C.unload == "function" && sections$C.unload();
      },
    },
    settings$8 = { loadingTimeout: 300 },
    selectors$U = {
      buttons: "button",
      toggleFilters: "[data-toggle-filters]",
      closeFilters: "[data-close-filters]",
      openFilters: "[data-open-filters]",
      collectionWrapper: "[data-collection-wrapper]",
      collapsibleTrigger: "[data-collapsible-trigger]",
      sortToggle: "[data-sort-toggle]",
      collectionSortOptions: "[data-collection-sort-options]",
      inputs: "input, select, label, textarea",
      inputSort: "[data-input-sort]",
      filters: "[data-collection-filters]",
      filtersWrapper: "[data-collection-filters-wrapper]",
      filtersList: "[data-collection-filters-list]",
      filtersStickyBar: "[data-collection-sticky-bar]",
      filter: "[data-collection-filter]",
      filterTag: "[data-collection-filter-tag]",
      filterTagButton: "[data-collection-filter-tag-button]",
      filtersForm: "[data-collection-filters-form]",
      filterResetButton: "[data-filter-reset-button]",
      filterTagClearButton: "[data-filter-tag-reset-button]",
      popupsSection: '[data-section-type="popups"]',
      productGrid: "[data-collection-products]",
      productsCount: "[data-products-count]",
      priceMin: "[data-field-price-min]",
      priceMax: "[data-field-price-max]",
      rangeMin: "[data-se-min-value]",
      rangeMax: "[data-se-max-value]",
      rangeMinValue: "data-se-min-value",
      rangeMaxValue: "data-se-max-value",
      rangeMinDefault: "data-se-min",
      rangeMaxDefault: "data-se-max",
      tooltip: "[data-tooltip]",
      tooltipContainer: "[data-tooltip-container]",
      showMore: "[data-show-more]",
      showMoreActions: "[data-show-more-actions]",
      showMoreContainer: "[data-show-more-container]",
      showMoreTrigger: "[data-show-more-trigger]",
      searchPerformed: "[data-search-performed]",
      searchForm: "[data-search-form]",
      scrollable: "[data-custom-scrollbar]",
    },
    classes$L = {
      isActive: "is-active",
      isExpanded: "is-expanded",
      isVisible: "is-visible",
      isLoading: "is-loading",
      popupVisible: "popup--visible",
      collectionFiltersVisible: "collection__filters--visible",
      collectionSortOptionWrapperVisible:
        "collection__sort__option-wrapper--visible",
      hidden: "is-hidden",
    },
    attributes$E = {
      filterActive: "data-filter-active",
      preventScrollLock: "data-prevent-scroll-lock",
      filtersDefaultState: "data-filters-default-state",
      tabIndex: "tabindex",
      ariaExpanded: "aria-expanded",
      currentType: "data-current-type",
    },
    sections$B = {};
  class Filters {
    constructor(container) {
      (this.container = container),
        (this.sectionId = container.dataset.sectionId),
        (this.enableFilters = container.dataset.enableFilters === "true"),
        (this.enableSorting = container.dataset.enableSorting === "true"),
        (this.filterMode = container.dataset.filterMode),
        (this.collectionHandle = this.container.dataset.collection),
        (this.isSearchPage =
          container.closest(selectors$U.searchPerformed) != null),
        (this.productGrid = this.container.querySelector(
          selectors$U.productGrid
        )),
        (this.productsCount = this.container.querySelector(
          selectors$U.productsCount
        )),
        (this.groupTagFilters = this.container.querySelectorAll(
          selectors$U.filter
        )),
        (this.filters = this.container.querySelector(selectors$U.filters)),
        (this.filterTriggers = this.container.querySelectorAll(
          selectors$U.collapsibleTrigger
        )),
        (this.filtersStickyBar = this.container.querySelector(
          selectors$U.filtersStickyBar
        )),
        (this.filtersForm = this.container.querySelector(
          selectors$U.filtersForm
        )),
        (this.inputSort = this.container.querySelectorAll(
          selectors$U.inputSort
        )),
        (this.sortToggle = this.container.querySelector(
          selectors$U.sortToggle
        )),
        (this.collectionSortOptions = this.container.querySelector(
          selectors$U.collectionSortOptions
        )),
        (this.a11y = a11y),
        (this.filterData = []),
        (this.rangeSlider = null),
        (this.sortDropdownEvent = () => this.sortDropdownToggle()),
        (this.onTabHandlerEvent = (event2) => this.onTabHandler(event2)),
        (this.updateCollectionFormSortEvent = (event2) =>
          this.updateCollectionFormSort(event2)),
        (this.bodyClickEvent = (event2) => this.bodyClick(event2)),
        (this.onFilterResetClick = this.onFilterResetClick.bind(this)),
        (this.onFilterTagResetClick = this.onFilterTagResetClick.bind(this)),
        (this.onFilterTagClearClick = this.onFilterTagClearClick.bind(this)),
        (this.onFilterToggleClick = this.onFilterToggleClick.bind(this)),
        (this.onKeyUpHandler = this.onKeyUpHandler.bind(this)),
        (this.updateRangeEvent = this.updateRange.bind(this)),
        (this.debouncedSubmitEvent = debounce((event2) => {
          this.onSubmitHandler(event2);
        }, 500)),
        (this.debouncedSortEvent = debounce((event2) => {
          this.onSortChange(event2);
        }, 500)),
        (this.productGridEvents = {}),
        this.filters &&
          ((this.hideFiltersDrawer = this.hideFiltersDrawer.bind(this)),
          (this.showFiltersDrawer = this.showFiltersDrawer.bind(this)),
          (this.resizeEvent = debounce(() => {
            this.filtersResizeEvents();
          }, 500)),
          this.filtersResizeEvents(),
          document.addEventListener("theme:resize:width", this.resizeEvent)),
        this.initTagFilters(),
        this.initFacetedFilters(),
        this.bindToggleButtonsEvents(),
        this.bindFilterButtonsEvents(),
        this.initProductGridEvents(theme.settings.enableInfinityScroll),
        makeSwatches(this.container),
        (this.collapsible = new Collapsible(this.container)),
        setVars(),
        window.addEventListener("popstate", this.onHistoryChange.bind(this)),
        this.sortToggle?.addEventListener("click", this.sortDropdownEvent),
        document.addEventListener("click", this.bodyClickEvent),
        this.filterShowMore();
    }
    initFacetedFilters() {
      this.filterMode == "tag" ||
        this.filterMode == "group" ||
        !this.enableFilters ||
        (this.rangeSlider = new RangeSlider(this.container));
    }
    initTooltips() {
      (this.tooltips = this.container.querySelectorAll(selectors$U.tooltip)),
        window.innerWidth < theme.sizes.small &&
          (this.tooltips = this.productGrid?.querySelectorAll(
            selectors$U.tooltip
          )),
        this.tooltips?.forEach((tooltip2) => {
          new Tooltip(tooltip2);
        }),
        this.handleVisibleTooltips();
    }
    handleVisibleTooltips() {
      if (this.tooltips.length > 0) {
        const tooltipTarget = document.querySelector(
          selectors$U.tooltipContainer
        );
        tooltipTarget.classList.contains(classes$L.isVisible) &&
          tooltipTarget.classList.remove(classes$L.isVisible);
      }
    }
    updateRange() {
      const rangeMin = this.filtersForm.querySelector(selectors$U.rangeMin),
        rangeMax = this.filtersForm.querySelector(selectors$U.rangeMax),
        priceMin = this.filtersForm.querySelector(selectors$U.priceMin),
        priceMax = this.filtersForm.querySelector(selectors$U.priceMax);
      if (
        rangeMin.hasAttribute(selectors$U.rangeMinValue) &&
        rangeMax.hasAttribute(selectors$U.rangeMaxValue)
      ) {
        const priceMinValue = parseFloat(priceMin.placeholder, 10),
          priceMaxValue = parseFloat(priceMax.placeholder, 10),
          rangeMinValue = parseFloat(
            rangeMin.getAttribute(selectors$U.rangeMinValue),
            10
          ),
          rangeMaxValue = parseFloat(
            rangeMax.getAttribute(selectors$U.rangeMaxValue),
            10
          );
        (priceMinValue !== rangeMinValue || priceMaxValue !== rangeMaxValue) &&
          ((priceMin.value = parseInt(rangeMinValue)),
          (priceMax.value = parseInt(rangeMaxValue)),
          this.filtersForm.dispatchEvent(new Event("input", { bubbles: !0 })));
      }
    }
    onSubmitHandler(event2) {
      event2.preventDefault();
      const formData = new FormData(this.filtersForm),
        searchParams = new URLSearchParams(formData),
        deleteParams = [];
      let searchParamsString = "";
      this.isSearchPage &&
        ((this.searchForm = this.container.querySelector(
          selectors$U.searchForm
        )),
        (this.currentType = this.container.getAttribute(
          attributes$E.currentType
        )));
      const rangeMin = this.filtersForm.querySelector(selectors$U.rangeMin),
        rangeMax = this.filtersForm.querySelector(selectors$U.rangeMax),
        priceMin = this.filtersForm.querySelector(selectors$U.priceMin),
        priceMax = this.filtersForm.querySelector(selectors$U.priceMax);
      if (
        rangeMin &&
        rangeMax &&
        priceMin &&
        priceMax &&
        rangeMin.hasAttribute(selectors$U.rangeMinDefault) &&
        rangeMax.hasAttribute(selectors$U.rangeMaxDefault)
      ) {
        const rangeMinDefault = parseFloat(
            rangeMin.getAttribute(selectors$U.rangeMinDefault),
            10
          ),
          rangeMaxDefault = parseFloat(
            rangeMax.getAttribute(selectors$U.rangeMaxDefault),
            10
          ),
          priceMinValue = priceMin.value
            ? parseFloat(priceMin.value, 10)
            : rangeMinDefault,
          priceMaxValue = priceMax.value
            ? parseFloat(priceMax.value, 10)
            : rangeMaxDefault;
        priceMinValue <= rangeMinDefault &&
          priceMaxValue >= rangeMaxDefault &&
          (deleteParams.push("filter.v.price.gte"),
          deleteParams.push("filter.v.price.lte"),
          searchParams.delete("filter.v.price.gte"),
          searchParams.delete("filter.v.price.lte"));
      }
      if (((searchParamsString = searchParams.toString()), this.isSearchPage)) {
        searchParamsString = getSearchParams(
          this.searchForm,
          this.filtersForm,
          deleteParams
        );
        let typeString = "";
        this.currentType === "all" && (typeString = "&type=product"),
          searchParamsString.indexOf("&type=product") > -1 && (typeString = ""),
          (searchParamsString += typeString);
      }
      this.renderSection(searchParamsString, event2);
    }
    onHistoryChange(event2) {
      if (!this.filters) return;
      let searchParams = event2.state?.searchParams || "";
      (this.isSearchPage &&
        (event2.state || (searchParams = window.location.search),
        !(searchParams.indexOf("type=product") > -1))) ||
        this.renderSection(searchParams, null, !1);
    }
    renderSection(searchParams, event2, updateURLHash = !0) {
      this.startLoading();
      const url = `${window.location.pathname}?section_id=${this.sectionId}&${searchParams}`,
        filterDataUrl = (element) => element.url === url;
      this.filterData.some(filterDataUrl)
        ? this.renderSectionFromCache(filterDataUrl, event2)
        : this.renderSectionFromFetch(url, event2),
        updateURLHash && this.updateURLHash(searchParams);
    }
    renderSectionFromFetch(url) {
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          (this.filterData = [...this.filterData, { html, url }]),
            (this.inputSort = this.container.querySelectorAll(
              selectors$U.inputSort
            )),
            this.renderFilters(html),
            this.bindFilterButtonsEvents(),
            this.hideFiltersOnMobile(),
            this.renderProductGrid(html),
            this.updateProductsCount(html),
            this.finishLoading(),
            this.mobileFiltersScrollLock(),
            this.handleSearchPageActiveTab();
        });
    }
    renderSectionFromCache(filterDataUrl, event2) {
      const html = this.filterData.find(filterDataUrl).html;
      this.renderFilters(html, event2),
        this.hideFiltersOnMobile(),
        this.renderProductGrid(html),
        this.updateProductsCount(html),
        this.finishLoading(),
        this.mobileFiltersScrollLock(),
        this.handleSearchPageActiveTab();
    }
    handleSearchPageActiveTab() {
      this.isSearchPage &&
        ((this.scrollable = this.container.querySelector(
          selectors$U.scrollable
        )),
        !(!this.scrollable || this.customScrollbar) &&
          (this.customScrollbar = new CustomScrollbar(this.container)));
    }
    renderProductGrid(html) {
      const newProductGrid = new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selectors$U.productGrid);
      newProductGrid &&
        ((this.productGrid.innerHTML = newProductGrid.innerHTML),
        this.initProductGridEvents(theme.settings.enableInfinityScroll),
        this.filterShowMore());
    }
    updateProductsCount(html) {
      const newProductsCount = new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selectors$U.productsCount);
      newProductsCount &&
        (this.productsCount.innerHTML = newProductsCount.innerHTML);
    }
    renderFilters(html) {
      const newFilters = new DOMParser()
        .parseFromString(html, "text/html")
        .querySelector(selectors$U.filters);
      newFilters &&
        ((this.filters.innerHTML = newFilters.innerHTML),
        (this.filtersForm = document.querySelector(selectors$U.filtersForm)),
        this.bindFilterButtonsEvents(),
        this.bindToggleButtonsEvents(),
        makeSwatches(this.container),
        (this.collapsible = new Collapsible(this.container)),
        document.dispatchEvent(
          new CustomEvent("theme:filters:init", { bubbles: !0 })
        ));
    }
    updateURLHash(searchParams) {
      history.pushState(
        { searchParams },
        "",
        `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
      );
    }
    bindFilterButtonsEvents() {
      this.inputSort.length > 0 &&
        this.inputSort.forEach((input) => {
          input.addEventListener("change", this.updateCollectionFormSortEvent);
        }),
        this.filtersForm &&
          (this.filtersForm.addEventListener(
            "input",
            this.debouncedSubmitEvent.bind(this)
          ),
          this.filtersForm.addEventListener(
            "theme:filter:range-update",
            this.updateRangeEvent
          )),
        this.collectionSortOptions &&
          this.collectionSortOptions.addEventListener(
            "keyup",
            this.onTabHandlerEvent
          ),
        !(
          this.filterMode == "tag" ||
          this.filterMode == "group" ||
          !this.enableFilters
        ) &&
          this.container
            .querySelectorAll(selectors$U.filterResetButton)
            .forEach((button) => {
              button.addEventListener("click", this.onFilterResetClick, {
                once: !0,
              });
            });
    }
    onFilterResetClick(event2) {
      event2.preventDefault(),
        this.renderSection(
          new URL(event2.currentTarget.href).searchParams.toString()
        );
    }
    bindToggleButtonsEvents() {
      this.container
        .querySelectorAll(selectors$U.toggleFilters)
        .forEach((button) => {
          button.addEventListener("click", this.onFilterToggleClick);
        }),
        this.container
          .querySelectorAll(selectors$U.closeFilters)
          .forEach((button) => {
            button.addEventListener("click", this.hideFiltersDrawer);
          }),
        this.container
          .querySelectorAll(selectors$U.openFilters)
          .forEach((button) => {
            button.addEventListener("click", this.showFiltersDrawer);
          }),
        this.container
          .querySelector(selectors$U.collectionWrapper)
          ?.addEventListener("keyup", this.onKeyUpHandler);
    }
    onTabHandler(event2) {
      if (
        event2.code === theme.keyboardKeys.SPACE ||
        event2.code === theme.keyboardKeys.ENTER ||
        event2.code === theme.keyboardKeys.NUMPADENTER
      ) {
        const newSortValue = event2.target.previousElementSibling.value;
        this.filtersForm
          .querySelectorAll(selectors$U.inputSort)
          .forEach((input) => {
            input.checked && (input.checked = !1),
              input.value === newSortValue && (input.checked = !0);
          }),
          this.filtersForm.dispatchEvent(new Event("input", { bubbles: !0 })),
          event2.target.dispatchEvent(new Event("click", { bubbles: !0 }));
      }
    }
    onKeyUpHandler(event2) {
      event2.code === theme.keyboardKeys.ESCAPE && this.hideFiltersDrawer();
    }
    onFilterToggleClick(event2) {
      event2.preventDefault(),
        setVars(),
        this.filters.classList.contains(classes$L.collectionFiltersVisible)
          ? this.hideFiltersDrawer()
          : this.showFiltersDrawer();
    }
    sortDropdownToggle() {
      this.collectionSortOptions &&
        this.collectionSortOptions.classList.toggle(
          classes$L.collectionSortOptionWrapperVisible
        );
    }
    bodyClick(event2) {
      if (!this.collectionSortOptions) return;
      const isSortBar = this.sortToggle.contains(event2.target);
      this.collectionSortOptions.classList.contains(
        classes$L.collectionSortOptionWrapperVisible
      ) &&
        !isSortBar &&
        this.sortDropdownToggle();
    }
    updateCollectionFormSort(event2) {
      const target = event2.target,
        newSortValue = target.value,
        secondarySortBy = target.closest(selectors$U.collectionSortOptions);
      this.container
        .querySelectorAll(selectors$U.inputSort)
        .forEach((input) => {
          input.value === newSortValue && (input.checked = !0);
        }),
        secondarySortBy !== null &&
          this.filtersForm.dispatchEvent(new Event("input", { bubbles: !0 }));
    }
    showFiltersDrawer() {
      const instance = this;
      (this.a11y.state.trigger = document.querySelector(
        selectors$U.toggleFilters
      )),
        this.a11y.trapFocus({ container: instance.filters }),
        this.mobileFiltersScrollLock();
    }
    mobileFiltersScrollLock() {
      if (window.innerWidth < theme.sizes.small) {
        const scrollableElement = document.querySelector(
          selectors$U.filtersList
        );
        this.filters.classList.contains(classes$L.collectionFiltersVisible) ||
          this.filters.classList.add(classes$L.collectionFiltersVisible),
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", {
              bubbles: !0,
              detail: scrollableElement,
            })
          );
      }
    }
    hideFiltersOnMobile() {
      const filterTriggers = this.container.querySelectorAll(
        `${selectors$U.collapsibleTrigger}:not(${selectors$U.showMoreTrigger})`
      );
      window.innerWidth < theme.sizes.small &&
        requestAnimationFrame(() => {
          filterTriggers.forEach((element) => {
            const isFilterActive =
              element.getAttribute(attributes$E.filterActive) === "true";
            element.classList.contains(classes$L.isExpanded) &&
              !isFilterActive &&
              element.dispatchEvent(new Event("click"));
          });
        });
    }
    showFiltersOnDesktop() {
      const filterTriggers = this.container.querySelectorAll(
          `${selectors$U.collapsibleTrigger}:not(${selectors$U.showMoreTrigger})`
        ),
        filtersDefaultState = this.container.getAttribute(
          attributes$E.filtersDefaultState
        ),
        openFirstFilterOnly = filtersDefaultState === "first-open",
        openAllFilters = filtersDefaultState === "open",
        closeAllFilters = filtersDefaultState === "closed",
        firstTriggerIndex = this.enableSorting ? 1 : 0;
      filterTriggers.forEach((element, index) => {
        const isCurrentFilterExpanded = element.classList.contains(
            classes$L.isExpanded
          ),
          isCurrentFilterActive =
            element.getAttribute(attributes$E.filterActive) === "true",
          isFirstClosed =
            !isCurrentFilterExpanded && index === firstTriggerIndex,
          allElseExpanded =
            isCurrentFilterExpanded && index !== firstTriggerIndex,
          shouldOpenFirst = openFirstFilterOnly && isFirstClosed,
          shouldCloseAllExceptFirst = openFirstFilterOnly && allElseExpanded,
          shouldOpenAllClosedOnes = openAllFilters && !isCurrentFilterExpanded,
          shouldOpenActiveOnes =
            isCurrentFilterActive && !isCurrentFilterExpanded && openAllFilters,
          shouldCloseExpandedOnes = closeAllFilters && isCurrentFilterExpanded;
        (isCurrentFilterActive && !shouldOpenActiveOnes) ||
          ((shouldCloseExpandedOnes ||
            shouldOpenFirst ||
            shouldCloseAllExceptFirst ||
            shouldOpenAllClosedOnes ||
            shouldOpenActiveOnes) &&
            element.dispatchEvent(new Event("click")));
      });
    }
    hideFiltersDrawer() {
      let filtersVisible = this.filters.classList.contains(
          classes$L.collectionFiltersVisible
        ),
        loading = this.container.classList.contains(classes$L.isLoading);
      filtersVisible &&
        (this.filters.classList.remove(classes$L.collectionFiltersVisible),
        this.a11y.removeTrapFocus()),
        loading ||
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", {
              bubbles: !0,
              detail: settings$8.loadingTimeout,
            })
          );
    }
    filtersResizeEvents() {
      window.innerWidth >= theme.sizes.small
        ? (this.showFiltersOnDesktop(), this.hideFiltersDrawer())
        : this.hideFiltersOnMobile();
    }
    filterShowMore() {
      (this.showMore = this.container.querySelectorAll(selectors$U.showMore)),
        this.showMore.length !== 0 &&
          this.showMore.forEach((element) => {
            const filterCollapsibleTrigger = element.querySelector(
                selectors$U.collapsibleTrigger
              ),
              showMoreActions = element.querySelector(
                selectors$U.showMoreActions
              );
            if (!showMoreActions) return;
            const showMoreTrigger = showMoreActions.querySelector(
                selectors$U.showMoreTrigger
              ),
              showMoreContainer = showMoreActions.querySelector(
                selectors$U.showMoreContainer
              ),
              focusable = showMoreContainer.querySelectorAll(
                window.theme.focusable
              );
            showMoreContainer.getAttribute(attributes$E.ariaExpanded) ===
              "true" ||
              focusable.forEach((item) => {
                item.setAttribute(attributes$E.tabIndex, "-1");
              }),
              showMoreTrigger.addEventListener("keyup", (event2) => {
                (event2.code === theme.keyboardKeys.SPACE ||
                  event2.code === theme.keyboardKeys.ENTER ||
                  event2.code === theme.keyboardKeys.NUMPADENTER) &&
                  this.updateShowMoreFocusableElements(event2, focusable);
              }),
              showMoreTrigger.addEventListener("click", (event2) => {
                this.updateShowMoreFocusableElements(event2, focusable);
              }),
              filterCollapsibleTrigger.addEventListener("keyup", (event2) => {
                (event2.code === theme.keyboardKeys.SPACE ||
                  event2.code === theme.keyboardKeys.ENTER ||
                  event2.code === theme.keyboardKeys.NUMPADENTER) &&
                  this.updateCollapsedContainerFocusableElements(
                    filterCollapsibleTrigger,
                    showMoreTrigger,
                    focusable
                  );
              }),
              filterCollapsibleTrigger.addEventListener("click", () => {
                this.updateCollapsedContainerFocusableElements(
                  filterCollapsibleTrigger,
                  showMoreTrigger,
                  focusable
                );
              });
          });
    }
    updateCollapsedContainerFocusableElements(
      filterCollapsibleTrigger,
      showMoreTrigger,
      focusable
    ) {
      requestAnimationFrame(() => {
        const isFilterExpanded =
            filterCollapsibleTrigger.getAttribute(attributes$E.ariaExpanded) ===
            "true",
          isShowMoreExpanded =
            showMoreTrigger.getAttribute(attributes$E.ariaExpanded) === "true";
        focusable.forEach((item) => {
          !isFilterExpanded &&
            isShowMoreExpanded &&
            item.setAttribute(attributes$E.tabIndex, "-1"),
            isFilterExpanded &&
              isShowMoreExpanded &&
              item.removeAttribute(attributes$E.tabIndex);
        });
      });
    }
    updateShowMoreFocusableElements(event2, focusable) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          const isExpanded =
            event2.target.getAttribute(attributes$E.ariaExpanded) === "true";
          focusable.forEach((item, index) => {
            if (isExpanded) {
              item.removeAttribute(attributes$E.tabIndex),
                index === 0 && item.focus();
              return;
            }
            item.setAttribute(attributes$E.tabIndex, "-1");
          });
        });
      });
    }
    initTagFilters() {
      (this.filterMode != "tag" && this.filterMode != "group") ||
        !this.enableFilters ||
        ((this.tags = this.container.dataset.tags
          .split("+")
          .filter((item) => item)),
        this.bindFilterTagButtonsEvents(),
        this.bindSortChangeEvent());
    }
    renderTagFiltersProducts(url) {
      this.startLoading(),
        typeof this.endlessCollection == "object" &&
          this.endlessCollection.unload(),
        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = responseText,
              parsedData = new DOMParser().parseFromString(html, "text/html"),
              productsHTML = parsedData.querySelector(
                selectors$U.productGrid
              ).innerHTML,
              filtersHTML = parsedData.querySelector(
                selectors$U.filters
              ).innerHTML;
            (this.productGrid.innerHTML = productsHTML),
              (this.filters.innerHTML = filtersHTML),
              (this.inputSort = this.container.querySelectorAll(
                selectors$U.inputSort
              )),
              (this.filtersForm = document.querySelector(
                selectors$U.filtersForm
              )),
              (this.filterData = [...this.filterData, { html, url }]),
              (this.alreadyClicked = !1),
              this.bindFilterTagButtonsEvents(),
              this.bindFilterButtonsEvents(),
              this.bindSortChangeEvent(),
              this.bindToggleButtonsEvents(),
              this.initProductGridEvents(theme.settings.enableInfinityScroll),
              this.updateProductsCount(html),
              this.mobileFiltersScrollLock(),
              this.hideFiltersOnMobile(),
              makeSwatches(this.container),
              (this.collapsible = new Collapsible(this.container)),
              this.filterShowMore(),
              history.replaceState &&
                window.history.pushState({ path: url }, "", url);
          })
          .catch((error) => {
            this.finishLoading(), console.log(`Error: ${error}`);
          });
    }
    bindFilterTagButtonsEvents() {
      this.container
        .querySelectorAll(selectors$U.filterTagButton)
        .forEach((button) => {
          button.addEventListener(
            "click",
            this.onFilterTagButtonClick.bind(this)
          );
        }),
        this.container
          .querySelectorAll(selectors$U.filterTagClearButton)
          .forEach((button) => {
            button.addEventListener("click", this.onFilterTagClearClick);
          }),
        this.container
          .querySelectorAll(selectors$U.filterResetButton)
          .forEach((button) => {
            button.addEventListener("click", this.onFilterTagResetClick);
          });
    }
    bindSortChangeEvent() {
      this.container
        .querySelectorAll(selectors$U.inputSort)
        .forEach((input) => {
          input.addEventListener("input", this.debouncedSortEvent.bind(this));
        });
    }
    onFilterTagButtonClick(event2) {
      if ((event2.preventDefault(), this.alreadyClicked)) return;
      this.alreadyClicked = !0;
      const button = event2.currentTarget,
        selectedTag = button.dataset.tag;
      if (button.parentNode.classList.contains(classes$L.isActive)) {
        let tagIndex = this.tags.indexOf(selectedTag);
        button.parentNode.classList.remove(classes$L.isActive),
          tagIndex > -1 && this.tags.splice(tagIndex, 1);
      } else
        button.parentNode.classList.add(classes$L.isActive),
          this.tags.push(selectedTag);
      let url =
        this.collectionHandle +
        "/" +
        this.tags.join("+") +
        "?sort_by=" +
        this.getSortValue();
      this.container
        .querySelector(selectors$U.filter)
        .classList.remove(classes$L.isExpanded),
        this.container
          .querySelector(selectors$U.filter)
          .setAttribute(attributes$E.ariaExpanded, !1),
        this.container.setAttribute("data-tags", "[" + this.tags + "]"),
        this.renderTagFiltersProducts(url);
    }
    onFilterTagClearClick(event2) {
      if ((event2.preventDefault(), this.alreadyClicked)) return;
      this.alreadyClicked = !0;
      const selectedTag = event2.currentTarget.dataset.tag,
        tagIndex = this.tags.indexOf(selectedTag);
      tagIndex > -1 && this.tags.splice(tagIndex, 1);
      const url =
        this.collectionHandle +
        "/" +
        this.tags.join("+") +
        "?sort_by=" +
        this.getSortValue();
      this.container.setAttribute("data-tags", "[" + this.tags + "]"),
        this.renderTagFiltersProducts(url);
    }
    onSortChange() {
      let url =
        this.collectionHandle +
        "/" +
        this.tags.join("+") +
        "?sort_by=" +
        this.getSortValue();
      this.renderTagFiltersProducts(url);
    }
    getSortValue() {
      let sortValue = "";
      return (
        this.inputSort.forEach((input) => {
          input.checked && (sortValue = input.value);
        }),
        sortValue
      );
    }
    onFilterTagResetClick(event2) {
      if ((event2?.preventDefault(), this.alreadyClicked)) return;
      (this.alreadyClicked = !0),
        this.container
          .querySelectorAll(selectors$U.filterTag)
          .forEach((element) => {
            element.classList.remove(classes$L.isActive);
          }),
        this.container
          .querySelectorAll(selectors$U.filter)
          .forEach((element) => {
            element.classList.remove(classes$L.isExpanded),
              element.setAttribute(attributes$E.ariaExpanded, !1);
          }),
        (this.tags = []),
        this.container.setAttribute("data-tags", "");
      let url = this.collectionHandle + "/?sort_by=" + this.getSortValue();
      this.renderTagFiltersProducts(url);
    }
    getProductsOffsetTop() {
      return (
        this.productGrid.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top -
        this.filtersStickyBar.offsetHeight
      );
    }
    getStickyBarOffsetTop() {
      return (
        this.filtersStickyBar.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top
      );
    }
    initProductGridEvents(infinityScroll) {
      if (infinityScroll) {
        this.initInfinityScroll(), this.initProductGridEvents(!1);
        return;
      }
      (this.productGridEvents = new ProductGrid(this.container)),
        this.initTooltips(),
        setTimeout(() => {
          this.finishLoading();
        }, settings$8.loadingTimeout * 1.5);
    }
    initInfinityScroll() {
      const callback = () => this.initProductGridEvents(!1);
      if (this.isSearchPage) {
        if (!this.enableFilters) return;
        document.dispatchEvent(
          new CustomEvent("theme:tab:ajaxinate", {
            bubbles: !0,
            detail: "product",
          })
        );
        return;
      }
      typeof this.endlessCollection == "object" &&
        this.endlessCollection.unload(),
        (this.endlessCollection = new Ajaxify(this.container)),
        this.endlessCollection.endlessScroll.length !== 0 &&
          (this.endlessCollection.endlessScroll[0].settings.callback =
            callback);
    }
    startLoading() {
      this.container.classList.add(classes$L.isLoading),
        window.innerWidth >= theme.sizes.small &&
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", { bubbles: !0 })
          );
      let productsTop = this.getProductsOffsetTop();
      window.scrollTo({ top: productsTop, left: 0, behavior: "smooth" });
    }
    finishLoading() {
      const popups2 = document.querySelectorAll(
          `${selectors$U.popupsSection} .${classes$L.popupVisible}`
        ),
        isPopupActive = popups2.length > 0;
      if (
        (this.container.classList.remove(classes$L.isLoading), isPopupActive)
      ) {
        let preventScrollPopupsCount = 0;
        [...popups2].forEach((popup) => {
          popup.hasAttribute(attributes$E.preventScrollLock) &&
            (preventScrollPopupsCount += 1);
        }),
          preventScrollPopupsCount === popups2.length &&
            document.dispatchEvent(
              new CustomEvent("theme:scroll:unlock", {
                bubbles: !0,
                detail: settings$8.loadingTimeout,
              })
            );
      } else
        window.innerWidth >= theme.sizes.small &&
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", {
              bubbles: !0,
              detail: settings$8.loadingTimeout,
            })
          );
    }
    onDeselect() {
      this.productGridEvents && this.productGridEvents.onDeselect();
    }
    onUnload() {
      typeof this.endlessCollection == "object" &&
        this.endlessCollection.unload(),
        this.productGridEvents && this.productGridEvents.onUnload(),
        this.collapsible && this.collapsible.onUnload(),
        this.rangeSlider && this.rangeSlider.unload(),
        this.filters &&
          document.removeEventListener("theme:resize:width", this.resizeEvent),
        document.removeEventListener("click", this.bodyClickEvent),
        this.groupTagFilters.length > 0 && this.onFilterTagResetClick(),
        this.finishLoading();
    }
  }
  const filters = {
      onLoad() {
        sections$B[this.id] = new Filters(this.container);
      },
      onDeselect() {
        sections$B[this.id].onDeselect();
      },
      onUnload() {
        sections$B[this.id].onUnload();
      },
    },
    selectors$T = {
      aosItem: "[data-aos]",
      aosAnchor: "[data-aos-anchor]",
      tabsLink: "[data-tabs-link]",
      tab: "[data-tab]",
      tabRef: "[data-tab-ref]",
      scrollable: "[data-custom-scrollbar]",
      scrollableHolder: "[data-custom-scrollbar-holder]",
      slider: "[data-slider]",
      tabsContents: "[data-tabs-contents]",
      searchForm: "[data-search-form]",
      allTypesContainer: "[data-all-types-container]",
      filtersForm: "[data-collection-filters-form]",
      currentPage: "[data-current-page]",
      tooltip: "[data-tooltip]",
      productGrid: "[data-collection-products]",
      ajaxinateContainer: "#AjaxinateLoop",
      ajaxinatePagination: "#AjaxinatePagination",
    },
    classes$K = {
      current: "current",
      hide: "hide",
      alt: "alt",
      aosAnimate: "aos-animate",
      isLoaded: "is-loaded",
    },
    attributes$D = {
      tabsLink: "data-tabs-link",
      tab: "data-tab",
      tabRef: "data-tab-ref",
      tabStartIndex: "data-start-index",
      searchPerformed: "data-search-performed",
      type: "data-type",
      currentType: "data-current-type",
      allTypes: "data-all-types",
      currentPage: "data-current-page",
      ajaxinateId: "data-ajaxinate-id",
    },
    sections$A = {};
  class Tabs {
    constructor(container) {
      (this.container = container),
        (this.tabsContents = container.querySelector(selectors$T.tabsContents)),
        (this.animateElementsTimer = null),
        (this.isSearchPage =
          container.closest(`[${attributes$D.searchPerformed}="true"]`) !=
          null),
        this.container &&
          ((this.scrollable = this.container.querySelector(
            selectors$T.scrollable
          )),
          (this.tabRef = this.container.querySelectorAll(selectors$T.tabRef)),
          (this.tabsLink = this.container.querySelectorAll(
            selectors$T.tabsLink
          )),
          (this.tab = this.container.querySelectorAll(selectors$T.tab)),
          this.assignSearchPageArguments(),
          this.init(),
          this.initCustomScrollbar(),
          this.isSearchPage || this.initTooltips(),
          (this.inactiveTabsAnimationsCallback = debounce(
            () => this.handleInactiveTabsAnimations(),
            200
          )),
          document.addEventListener(
            "theme:scroll",
            this.inactiveTabsAnimationsCallback
          ),
          this.container.addEventListener("mouseenter", () => {
            this.handleInactiveTabsAnimations();
          }));
    }
    assignSearchPageArguments() {
      this.isSearchPage &&
        ((this.searchForm = this.container.querySelector(
          selectors$T.searchForm
        )),
        (this.searchFormData = new FormData(this.searchForm)),
        (this.searchTerm = encodeURIComponent(this.searchFormData.get("q"))),
        (this.currentType = this.container.getAttribute(
          attributes$D.currentType
        )),
        (this.sectionId = this.container.dataset.sectionId),
        (this.searchForAllTypes =
          this.container.getAttribute(attributes$D.allTypes) === "true"),
        (this.fetchURL = ""),
        (this.searchParams = ""),
        (this.cachedResults = {}),
        this.handleTabsHistory(),
        this.infiniteScrollListener(),
        this.initInfinityScroll(this.currentType));
    }
    init() {
      const tabsNavList = this.container.querySelectorAll(selectors$T.tabsLink),
        firstTabsLink = this.container.querySelector(
          `[${attributes$D.tabsLink}="${
            this.container.hasAttribute(attributes$D.tabStartIndex)
              ? this.container.getAttribute(attributes$D.tabStartIndex)
              : 0
          }"]`
        );
      this.container
        .querySelector(
          `[${attributes$D.tab}="${
            this.container.hasAttribute(attributes$D.tabStartIndex)
              ? this.container.getAttribute(attributes$D.tabStartIndex)
              : 0
          }"]`
        )
        ?.classList.add(classes$K.current),
        firstTabsLink?.classList.add(classes$K.current),
        this.checkVisibleTabsLinks(),
        tabsNavList.forEach((element) => {
          this.handleTabsNavListeners(element);
        });
    }
    handleTabsHistory() {
      window.addEventListener("popstate", this.onHistoryChange.bind(this)),
        (this.openTabFromHistoryEvent = (event2) =>
          this.openTabFromHistory(event2)),
        this.tabsLink.forEach((element) => {
          element.addEventListener(
            "theme:tab:open-from-history",
            this.openTabFromHistoryEvent
          );
        });
    }
    handleTabsNavListeners(element) {
      const tabId = element.getAttribute(attributes$D.tabsLink),
        tab = this.container.querySelector(`[${attributes$D.tab}="${tabId}"]`);
      tab &&
        (element.addEventListener("click", (event2) => {
          this.isSearchPage && this.handleURLSearchParams(event2, !0),
            this.tabChange(element, tab);
        }),
        element.addEventListener("keyup", (event2) => {
          (event2.code === theme.keyboardKeys.SPACE ||
            event2.code === theme.keyboardKeys.ENTER ||
            event2.code === theme.keyboardKeys.NUMPADENTER) &&
            (this.isSearchPage && this.handleURLSearchParams(event2, !0),
            this.tabChange(element, tab));
        }));
    }
    openTabFromHistory(event2) {
      const target = event2.target,
        tabId = this.container
          .querySelector(event2.detail.element)
          .getAttribute(attributes$D.tabsLink),
        tab = this.container.querySelector(`[${attributes$D.tab}="${tabId}"]`);
      tab &&
        (this.handleURLSearchParams(event2, !1), this.tabChange(target, tab));
    }
    handleURLSearchParams(event2, updateHistory = !0) {
      const target = event2.target.matches(selectors$T.tabsLink)
          ? event2.target
          : event2.target.closest(selectors$T.tabsLink),
        type = target.getAttribute(attributes$D.type),
        tabId = target.getAttribute(attributes$D.tabsLink),
        currentPage = this.container
          .querySelector(`[${attributes$D.tab}="${tabId}"]`)
          .querySelector(selectors$T.currentPage),
        filtersForm = document.querySelector(selectors$T.filtersForm);
      let currentPageStr = currentPage
        ? `&page=${currentPage.getAttribute(attributes$D.currentPage)}`
        : "";
      if (
        ((this.searchParams = getSearchParams(
          this.searchForm,
          filtersForm,
          [],
          type
        )),
        type === "product")
      ) {
        const sanitized = this.searchParams.replace("&type=product", "");
        this.searchParams = `${sanitized}&type=product`;
      } else this.searchParams = `q=${this.searchTerm}&type=${type}`;
      !theme.settings.enableInfinityScroll &&
        currentPageStr !== "" &&
        (this.searchParams += currentPageStr),
        (this.fetchURL = `${theme.routes.searchUrl}?${this.searchParams}&section_id=${this.sectionId}`),
        updateHistory &&
          history.pushState(
            { searchParams: this.searchParams },
            "",
            `${window.location.pathname}${
              this.searchParams && "?".concat(this.searchParams)
            }`
          );
    }
    tabChangeFetchContent(element, tab) {
      const type = element.getAttribute(attributes$D.type),
        tabId = element.getAttribute(attributes$D.tabsLink),
        tabContainer = this.container.querySelector(
          `[${attributes$D.tab}="${tabId}"]`
        ),
        typeRendered = this.currentType === type;
      if (this.cachedResults[tabId] || typeRendered) {
        type === "product" &&
          !this.searchFilters &&
          (this.searchFilters = new Filters(this.container)),
          requestAnimationFrame(() => {
            this.handleActiveTabClasses(element, tab),
              this.scrollToCurrentTabLink(element),
              this.triggerTabAnimations(tab),
              this.checkVisibleTabsLinks(),
              this.updateAjaxify(tab, type);
          });
        return;
      }
      fetch(this.fetchURL)
        .then((response) => {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector(`[${attributes$D.tab}="${tabId}"]`).innerHTML;
          this.searchForAllTypes &&
            this.container
              .querySelector(selectors$T.allTypesContainer)
              ?.remove(),
            (this.cachedResults[tabId] = resultsMarkup),
            (tabContainer.innerHTML = resultsMarkup),
            type === "product" &&
              !this.searchFilters &&
              (this.searchFilters = new Filters(this.container)),
            requestAnimationFrame(() => {
              this.handleActiveTabClasses(element, tab),
                this.scrollToCurrentTabLink(element),
                this.triggerTabAnimations(tab),
                this.checkVisibleTabsLinks(),
                this.initInfinityScroll(type);
            });
        })
        .catch((error) => {
          throw error;
        });
    }
    onHistoryChange(event2) {
      const searchParams = event2.state?.searchParams || window.location.search,
        productResults = searchParams.indexOf("type=product") > -1,
        articleResults = searchParams.indexOf("type=article") > -1,
        pageResults = searchParams.indexOf("type=page") > -1,
        shouldOpenTab = productResults || articleResults || pageResults,
        typeProduct = this.container.querySelector(
          `${selectors$T.tabsLink}[${attributes$D.type}="product"]`
        ),
        typeArticle = this.container.querySelector(
          `${selectors$T.tabsLink}[${attributes$D.type}="article"]`
        ),
        typePage = this.container.querySelector(
          `${selectors$T.tabsLink}[${attributes$D.type}="page"]`
        );
      if (!shouldOpenTab) {
        window.location = searchParams;
        return;
      }
      productResults &&
        typeProduct?.dispatchEvent(
          new CustomEvent("theme:tab:open-from-history", {
            bubbles: !0,
            detail: { element: `[${attributes$D.type}="product"]` },
          })
        ),
        articleResults &&
          typeArticle?.dispatchEvent(
            new CustomEvent("theme:tab:open-from-history", {
              bubbles: !0,
              detail: { element: `[${attributes$D.type}="article"]` },
            })
          ),
        pageResults &&
          typePage?.dispatchEvent(
            new CustomEvent("theme:tab:open-from-history", {
              bubbles: !0,
              detail: { element: `[${attributes$D.type}="page"]` },
            })
          );
    }
    initCustomScrollbar() {
      !this.scrollable ||
        this.customScrollbar ||
        (this.customScrollbar = new CustomScrollbar(this.container));
    }
    infiniteScrollListener() {
      theme.settings.enableInfinityScroll &&
        ((this.ajaxifyFromFiltersEvent = (event2) =>
          this.ajaxifyFromFilters(event2)),
        document.addEventListener(
          "theme:tab:ajaxinate",
          this.ajaxifyFromFiltersEvent
        ));
    }
    ajaxifyFromFilters(event2) {
      this.initInfinityScroll(event2.detail);
    }
    initInfinityScroll(type) {
      if (
        !theme.settings.enableInfinityScroll ||
        this.container.querySelectorAll(selectors$T.ajaxinateContainer)
          .length === 0
      )
        return;
      const activeTab = this.container.querySelector(
          `${selectors$T.tab}.${classes$K.current}`
        ),
        tabAjaxinateContainer = activeTab?.querySelector(
          selectors$T.ajaxinateContainer
        ),
        isLoaded = tabAjaxinateContainer?.classList.contains(
          classes$K.isLoaded
        );
      if (!activeTab) {
        this.initAjaxyfy(type);
        return;
      }
      !tabAjaxinateContainer &&
        this.endlessCollection &&
        this.updateAjaxinateInstancesSettings(type),
        !(!tabAjaxinateContainer || isLoaded) && this.initAjaxyfy(type);
    }
    updateAjaxinateInstancesSettings(type) {
      setTimeout(() => {
        if (this.endlessCollection.endlessScroll.length === 0) return;
        [...this.endlessCollection.endlessScroll].forEach((instance) => {
          const containerElement = instance.containerElement,
            activeTabPresent = [...this.tab].find((tab) =>
              tab.classList.contains(classes$K.current)
            );
          !(
            containerElement.closest(
              `${selectors$T.tab}.${classes$K.current}`
            ) !== null
          ) &&
            activeTabPresent &&
            (instance.settings.method = "click");
        });
        const callback = () => this.initProductGridEvents();
        if (type === "product" || type === "all") {
          const instanceIDCheck = (instance) =>
              instance.settings.container.indexOf("resultsProducts") > -1 ||
              instance.settings.container.indexOf("allTypes") > -1,
            productAjaxinateInstance = [
              ...this.endlessCollection.endlessScroll,
            ].find(instanceIDCheck);
          if (!productAjaxinateInstance) return;
          productAjaxinateInstance.settings.callback = callback;
        }
      });
    }
    initAjaxyfy(type) {
      if (typeof this.endlessCollection != "object") {
        (this.endlessCollection = new Ajaxify(this.container)),
          this.updateAjaxinateInstancesSettings(type);
        return;
      }
      this.endlessCollection.endlessScroll.length > 0 &&
        (this.endlessCollection.unload(),
        (this.endlessCollection = new Ajaxify(this.container)),
        this.updateAjaxinateInstancesSettings(type));
    }
    updateAjaxify(tab, type) {
      if (this.endlessCollection?.endlessScroll.length === 0) return;
      const ajaxinateContainer = tab.querySelector(
          selectors$T.ajaxinateContainer
        ),
        id = `${selectors$T.ajaxinateContainer}[${attributes$D.ajaxinateId}="${ajaxinateContainer?.dataset.ajaxinateId}"]`;
      ajaxinateContainer &&
        (this.endlessCollection.update(id),
        this.updateAjaxinateInstancesSettings(type));
    }
    initProductGridEvents() {
      (this.productGridEvents = new ProductGrid(this.container)),
        this.initTooltips();
    }
    initTooltips() {
      (this.tooltips = this.container.querySelectorAll(selectors$T.tooltip)),
        (this.productGrid = this.container.querySelector(
          selectors$T.productGrid
        )),
        window.innerWidth < theme.sizes.small &&
          (this.tooltips = this.productGrid?.querySelectorAll(
            selectors$T.tooltip
          )),
        this.tooltips?.forEach((tooltip2) => {
          new Tooltip(tooltip2);
        });
    }
    tabChange(element, tab) {
      if (!element.classList.contains(classes$K.current)) {
        if (this.isSearchPage) {
          this.tabChangeFetchContent(element, tab);
          return;
        }
        this.handleActiveTabClasses(element, tab),
          this.scrollToCurrentTabLink(element),
          this.triggerTabAnimations(tab),
          this.handleTabSliders(tab),
          this.checkVisibleTabsLinks();
      }
    }
    handleActiveTabClasses(element, tab) {
      const lastActiveTab = this.container.querySelector(
          `${selectors$T.tab}.${classes$K.current}`
        ),
        lastActiveTabsLink = this.container.querySelector(
          `${selectors$T.tabsLink}.${classes$K.current}`
        );
      lastActiveTab?.classList.remove(classes$K.current),
        lastActiveTabsLink?.classList.remove(classes$K.current),
        element.classList.add(classes$K.current),
        tab.classList.add(classes$K.current),
        element.classList.contains(classes$K.hide) &&
          tab.classList.add(classes$K.hide),
        this.tabRef?.forEach((refElement) => {
          const isActive = refElement.classList.contains(classes$K.current),
            shouldBeActive =
              refElement.getAttribute(attributes$D.tabRef) ===
              tab.getAttribute(attributes$D.tab);
          refElement.classList.toggle(
            classes$K.current,
            !isActive && shouldBeActive
          );
        });
    }
    scrollToCurrentTabLink(element) {
      const parent = element.closest(selectors$T.scrollableHolder)
          ? element.closest(selectors$T.scrollableHolder)
          : element.parentElement,
        parentPadding = parseInt(
          window.getComputedStyle(parent).getPropertyValue("padding-left")
        );
      parent.scrollTo({
        top: 0,
        left:
          element.offsetLeft -
          parent.offsetWidth / 2 +
          element.offsetWidth / 2 +
          parentPadding,
        behavior: "smooth",
      }),
        element.dispatchEvent(
          new CustomEvent("theme:custom-scrollbar:change", {
            bubbles: !0,
            detail: { element },
          })
        );
    }
    triggerTabAnimations(tab) {
      if (theme.settings.animationsEnabled == "false") return;
      document.dispatchEvent(new CustomEvent("theme:scroll"));
      const productTab = this.tabsContents.querySelector(
        `[${attributes$D.tab}="resultsProducts"]`
      );
      if (productTab && productTab.classList.contains(classes$K.current)) {
        const anchors = this.tabsContents.querySelectorAll(
          selectors$T.aosAnchor
        );
        initAnchorObservers(anchors);
        return;
      }
      this.tabsContents
        .querySelectorAll(selectors$T.aosItem)
        .forEach((element) => {
          element.classList.remove(classes$K.aosAnimate);
        }),
        this.animateElementsTimer && clearTimeout(this.animateElementsTimer),
        (this.animateElementsTimer = setTimeout(() => {
          tab.querySelectorAll(selectors$T.aosItem).forEach((element) => {
            element.classList.add(classes$K.aosAnimate);
          });
        }, 150));
    }
    handleInactiveTabsAnimations() {
      this.tab.forEach((tab) => {
        tab.classList.contains(classes$K.current) ||
          tab.querySelectorAll(selectors$T.aosItem).forEach((element) => {
            requestAnimationFrame(() =>
              element.classList.remove(classes$K.aosAnimate)
            );
          });
      });
    }
    handleTabSliders(tab) {
      const slider2 = tab.querySelector(selectors$T.slider);
      slider2 &&
        slider2.dispatchEvent(
          new CustomEvent("theme:tab:change", { bubbles: !1 })
        );
    }
    checkVisibleTabsLinks() {
      const tabsNavList = this.container.querySelectorAll(selectors$T.tabsLink),
        tabsNavListHidden = this.container.querySelectorAll(
          `${selectors$T.tabsLink}.${classes$K.hide}`
        );
      tabsNavList.length - tabsNavListHidden.length < 2
        ? this.container.classList.add(classes$K.alt)
        : this.container.classList.remove(classes$K.alt);
    }
    onBlockSelect(event2) {
      const element = event2.target;
      element &&
        (element.dispatchEvent(new Event("click")),
        element.parentNode.scrollTo({
          top: 0,
          left: element.offsetLeft - element.clientWidth,
          behavior: "smooth",
        }));
    }
    onUnload() {
      this.customScrollbar && this.customScrollbar.unload(),
        this.isSearchPage &&
          theme.settings.enableInfinityScroll &&
          document.removeEventListener(
            "theme:tab:ajaxinate",
            this.ajaxifyFromFiltersEvent
          ),
        document.removeEventListener(
          "theme:scroll",
          this.inactiveTabsAnimationsCallback
        );
    }
  }
  const tabs = {
      onLoad() {
        sections$A[this.id] = new Tabs(this.container);
      },
      onBlockSelect(e) {
        sections$A[this.id].onBlockSelect(e);
      },
      onUnload() {
        sections$A[this.id].onUnload();
      },
    },
    selectors$S = {
      drawer: "[data-drawer]",
      drawerToggle: "[data-drawer-toggle]",
      scroller: "[data-scroll]",
      quickviewItem: "[data-quick-view-item]",
      tabsLink: "[data-tabs-link]",
    },
    classes$J = {
      open: "is-open",
      drawerOpen: "js-drawer-open",
      drawerOpenSize: "js-drawer-open--size",
      contentVisibilityHidden: "cv-h",
      header: "site-header",
      productSingle: "product-single",
    },
    attributes$C = {
      ariaExpanded: "aria-expanded",
      ariaControls: "aria-controls",
    };
  let sections$z = {};
  class Drawer {
    constructor(container) {
      (this.container = container),
        (this.body = document.body),
        (this.drawers = this.container.querySelectorAll(selectors$S.drawer)),
        (this.drawerToggleButtons = this.container.querySelectorAll(
          selectors$S.drawerToggle
        )),
        (this.a11y = a11y),
        (this.drawerToggleEvent = throttle((event2) => {
          this.toggle(event2);
        }, 150)),
        (this.keyPressCloseEvent = throttle((event2) => {
          event2.code === theme.keyboardKeys.ESCAPE && this.close(event2);
        }, 150)),
        (this.drawerCloseEvent = (event2) => {
          const activeDrawer = document.querySelector(
            `${selectors$S.drawer}.${classes$J.open}`
          );
          let isDrawerToggle = !1;
          if (!activeDrawer) return;
          event2.type === "click" &&
            (isDrawerToggle = event2.target.matches(selectors$S.drawerToggle));
          const isDrawerChild = activeDrawer
              ? activeDrawer.contains(event2.target)
              : !1,
            quickviewItem = activeDrawer.closest(selectors$S.quickviewItem),
            isQuickviewChild = quickviewItem
              ? quickviewItem.contains(event2.target)
              : !1;
          !isDrawerToggle &&
            !isDrawerChild &&
            !isQuickviewChild &&
            this.close();
        }),
        this.initListeners();
    }
    initListeners() {
      this.drawerToggleButtons.forEach((button) => {
        button.addEventListener("click", this.drawerToggleEvent);
      }),
        this.drawers.forEach((drawer2) => {
          drawer2.addEventListener("keyup", this.keyPressCloseEvent),
            (this.collapsible = new Collapsible(drawer2)),
            (this.tabs = new Tabs(drawer2));
        }),
        document.addEventListener("click", this.drawerCloseEvent),
        document.addEventListener(
          "theme:drawer:closing",
          this.drawerCloseEvent
        );
    }
    toggle(e) {
      e.preventDefault();
      const drawer2 = document.querySelector(
        `#${e.target.getAttribute(attributes$C.ariaControls)}`
      );
      if (!drawer2) return;
      drawer2.classList.contains(classes$J.open) ? this.close() : this.open(e);
    }
    open(e) {
      const drawerOpenButton = e.target,
        drawer2 = document.querySelector(
          `#${e.target.getAttribute(attributes$C.ariaControls)}`
        );
      if (!drawer2) return;
      const drawerScroller =
        drawer2.querySelector(selectors$S.scroller) || drawer2;
      document.dispatchEvent(
        new CustomEvent("theme:scroll:lock", {
          bubbles: !0,
          detail: drawerScroller,
        })
      ),
        document.dispatchEvent(new CustomEvent("theme:drawer:open"), {
          bubbles: !0,
        }),
        this.body.classList.add(classes$J.drawerOpen),
        this.container.classList.contains(classes$J.productSingle) &&
          this.body.classList.add(classes$J.drawerOpenSize),
        drawer2.classList.add(classes$J.open),
        drawer2.classList.remove(classes$J.contentVisibilityHidden),
        drawerOpenButton.setAttribute(attributes$C.ariaExpanded, !0),
        setTimeout(() => {
          (this.a11y.state.trigger = drawerOpenButton),
            this.a11y.trapFocus({ container: drawer2 });
        });
    }
    close() {
      if (!this.body.classList.contains(classes$J.drawerOpen)) return;
      const drawer2 = document.querySelector(
        `${selectors$S.drawer}.${classes$J.open}`
      );
      this.drawerToggleButtons.forEach((button) => {
        button.setAttribute(attributes$C.ariaExpanded, !1);
      }),
        this.a11y.removeTrapFocus({ container: drawer2 }),
        drawer2.classList.remove(classes$J.open);
      const onDrawerTransitionEnd = (event2) => {
        event2.target === drawer2 &&
          (requestAnimationFrame(() => {
            drawer2.classList.add(classes$J.contentVisibilityHidden),
              document.dispatchEvent(new CustomEvent("theme:drawer:close"), {
                bubbles: !0,
              }),
              document.dispatchEvent(
                new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
              );
          }),
          drawer2.removeEventListener("transitionend", onDrawerTransitionEnd));
      };
      drawer2.addEventListener("transitionend", onDrawerTransitionEnd),
        this.body.classList.remove(classes$J.drawerOpen),
        this.body.classList.remove(classes$J.drawerOpenSize);
    }
    onUnload() {
      this.close(),
        this.drawerToggleButtons.forEach((button) => {
          button.removeEventListener("click", this.drawerToggleEvent);
        }),
        this.drawers.forEach((drawer2) => {
          drawer2.removeEventListener("keyup", this.keyPressCloseEvent);
        }),
        document.removeEventListener("click", this.drawerCloseEvent),
        document.removeEventListener(
          "theme:drawer:closing",
          this.drawerCloseEvent
        ),
        this.collapsible && this.collapsible.onUnload(),
        this.tabs && this.tabs.onUnload();
    }
  }
  const drawer = {
      onLoad() {
        this.container.classList.contains(classes$J.header) &&
          (this.container = this.container.parentNode),
          (sections$z[this.id] = new Drawer(this.container));
      },
      onUnload() {
        sections$z[this.id].onUnload();
      },
    },
    showElement = (elem, removeProp = !1, prop = "block") => {
      elem &&
        (removeProp
          ? elem.style.removeProperty("display")
          : (elem.style.display = prop));
    },
    hideElement = (elem) => {
      elem && (elem.style.display = "none");
    },
    scrollTo = (elementTop) => {
      const { stickyHeaderHeight } = readHeights();
      window.scrollTo({
        top: elementTop + Math.round(window.scrollY) - stickyHeaderHeight,
        left: 0,
        behavior: "smooth",
      });
    },
    selectors$R = { list: "[data-store-availability-list]" },
    defaults = {
      close: ".js-modal-close",
      open: ".js-modal-open-store-availability-modal",
      openClass: "modal--is-active",
      openBodyClass: "modal--is-visible",
      closeModalOnClick: !1,
      scrollIntoView: !1,
    };
  class Modals {
    constructor(id, options2) {
      if (((this.modal = document.getElementById(id)), !this.modal)) return !1;
      (this.nodes = {
        parents: [document.querySelector("html"), document.body],
      }),
        (this.config = Object.assign(defaults, options2)),
        (this.modalIsOpen = !1),
        (this.focusOnOpen = this.config.focusOnOpen
          ? document.getElementById(this.config.focusOnOpen)
          : this.modal),
        (this.openElement = document.querySelector(this.config.open)),
        (this.a11y = a11y),
        this.init();
    }
    init() {
      this.openElement.addEventListener("click", this.open.bind(this)),
        this.modal
          .querySelector(this.config.close)
          .addEventListener("click", this.closeModal.bind(this));
    }
    open(evt) {
      let externalCall = !1;
      if (
        (evt ? evt.preventDefault() : (externalCall = !0),
        this.modalIsOpen && !externalCall)
      ) {
        this.closeModal();
        return;
      }
      this.modal.classList.add(this.config.openClass),
        this.nodes.parents.forEach((node) => {
          node.classList.add(this.config.openBodyClass);
        }),
        (this.modalIsOpen = !0);
      const scrollableElement = document.querySelector(selectors$R.list);
      document.dispatchEvent(
        new CustomEvent("theme:scroll:lock", {
          bubbles: !0,
          detail: scrollableElement,
        })
      ),
        this.config.scrollIntoView && this.scrollIntoView(),
        this.bindEvents(),
        this.a11y.trapFocus({ container: this.modal });
    }
    closeModal() {
      if (!this.modalIsOpen) return;
      document.activeElement.blur(),
        this.modal.classList.remove(this.config.openClass);
      var self = this;
      this.nodes.parents.forEach(function (node) {
        node.classList.remove(self.config.openBodyClass);
      }),
        (this.modalIsOpen = !1),
        this.openElement.focus(),
        this.unbindEvents(),
        this.a11y.removeTrapFocus({ container: this.modal });
      const timeout = 400;
      document.dispatchEvent(
        new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: timeout })
      );
    }
    bindEvents() {
      (this.keyupHandler = this.keyupHandler.bind(this)),
        (this.clickHandler = this.clickHandler.bind(this)),
        document.body.addEventListener("keyup", this.keyupHandler),
        document.body.addEventListener("click", this.clickHandler);
    }
    unbindEvents() {
      document.body.removeEventListener("keyup", this.keyupHandler),
        document.body.removeEventListener("click", this.clickHandler);
    }
    keyupHandler(event2) {
      event2.code === theme.keyboardKeys.ESCAPE && this.closeModal();
    }
    clickHandler(event2) {
      this.config.closeModalOnClick &&
        !this.modal.contains(event2.target) &&
        !event2.target.matches(this.config.open) &&
        this.closeModal();
    }
    scrollIntoView() {
      this.focusOnOpen.scrollIntoView({ behavior: "smooth" });
    }
  }
  const selectors$Q = {
      body: "body",
      storeAvailabilityModal: "[data-store-availability-modal]",
      storeAvailabilityModalOpen: "[data-store-availability-modal-open]",
      storeAvailabilityModalClose: "[data-store-availability-modal-close]",
      storeAvailabilityModalProductTitle:
        "[data-store-availability-modal-product__title]",
    },
    classes$I = { openClass: "store-availabilities-modal--active" };
  class StoreAvailability {
    constructor(container) {
      this.container = container;
    }
    updateContent(variantId, productTitle) {
      this._fetchStoreAvailabilities(variantId, productTitle);
    }
    clearContent() {
      this.container.innerHTML = "";
    }
    _initModal() {
      return new Modals("StoreAvailabilityModal", {
        close: selectors$Q.storeAvailabilityModalClose,
        open: selectors$Q.storeAvailabilityModalOpen,
        closeModalOnClick: !0,
        openClass: classes$I.openClass,
        scrollIntoView: !1,
      });
    }
    _fetchStoreAvailabilities(variantId, productTitle) {
      const variantSectionUrl =
        "/variants/" + variantId + "/?section_id=store-availability";
      this.clearContent();
      const self = this;
      fetch(variantSectionUrl)
        .then(function (response) {
          return response.text();
        })
        .then(function (storeAvailabilityHTML) {
          const body = document.querySelector(selectors$Q.body);
          let storeAvailabilityModal = body.querySelector(
            selectors$Q.storeAvailabilityModal
          );
          if (
            (storeAvailabilityModal && storeAvailabilityModal.remove(),
            (self.container.innerHTML = storeAvailabilityHTML),
            (self.container.innerHTML =
              self.container.firstElementChild.innerHTML),
            self.container.firstElementChild.innerHTML.trim() === "")
          ) {
            self.clearContent();
            return;
          }
          self.container.querySelector(
            selectors$Q.storeAvailabilityModalOpen
          ) &&
            ((self.modal = self._initModal()),
            self._updateProductTitle(productTitle),
            (storeAvailabilityModal = self.container.querySelector(
              selectors$Q.storeAvailabilityModal
            )),
            storeAvailabilityModal && body.appendChild(storeAvailabilityModal));
        });
    }
    _updateProductTitle(productTitle) {
      const storeAvailabilityModalProductTitle = this.container.querySelector(
        selectors$Q.storeAvailabilityModalProductTitle
      );
      storeAvailabilityModalProductTitle.textContent = productTitle;
    }
  }
  const selectors$P = {
      form: "[data-product-form]",
      optionPosition: "[data-option-position]",
      optionInput: '[name^="options"], [data-popout-option]',
    },
    classes$H = { soldOut: "sold-out", unavailable: "unavailable" },
    attributes$B = {
      optionPosition: "data-option-position",
      selectOptionValue: "data-value",
    };
  class SelloutVariants {
    constructor(container, productJSON) {
      (this.container = container),
        (this.productJSON = productJSON),
        (this.form = this.container.querySelector(selectors$P.form)),
        (this.formData = new FormData(this.form)),
        (this.optionElements = this.container.querySelectorAll(
          selectors$P.optionInput
        )),
        this.productJSON && this.form && this.init();
    }
    init() {
      this.update();
    }
    update() {
      this.getCurrentState(),
        this.optionElements.forEach((el) => {
          const val =
              el.value || el.getAttribute(attributes$B.selectOptionValue),
            optionSelector = el.closest(selectors$P.optionPosition);
          if (!optionSelector) return;
          const positionString = optionSelector.getAttribute(
              attributes$B.optionPosition
            ),
            position = parseInt(positionString, 10) - 1;
          let newVals = [...this.selections];
          newVals[position] = val;
          const found = this.productJSON.variants.find((element) => {
            let perfectMatch = !0;
            for (let index = 0; index < newVals.length; index++)
              element.options[index] !== newVals[index] && (perfectMatch = !1);
            return perfectMatch;
          });
          el.parentElement.classList.remove(
            classes$H.soldOut,
            classes$H.unavailable
          ),
            typeof found > "u"
              ? el.parentElement.classList.add(classes$H.unavailable)
              : found?.available === !1 &&
                el.parentElement.classList.add(classes$H.soldOut);
        });
    }
    getCurrentState() {
      (this.formData = new FormData(this.form)), (this.selections = []);
      for (var value of this.formData.entries())
        value[0].includes("options[") && this.selections.push(value[1]);
    }
  }
  const settings$7 = { templateIndex: 1 },
    classes$G = { popupNotification: "pswp--notification pswp--not-close-btn" },
    attributes$A = { notificationPopup: "data-notification-popup" },
    options$1 = {
      history: !1,
      focus: !1,
      mainClass: classes$G.popupNotification,
      closeOnVerticalDrag: !1,
    };
  class NotificationPopup {
    constructor(button) {
      (this.button = button),
        (this.a11y = a11y),
        (this.notificationPopupHtml = this.button.getAttribute(
          attributes$A.notificationPopup
        )),
        this.notificationPopupHtml.trim() !== "" && this.init();
    }
    init() {
      const items = [{ html: this.notificationPopupHtml }];
      (this.a11y.state.trigger = this.button),
        new LoadPhotoswipe(items, options$1, settings$7.templateIndex);
    }
  }
  const selectors$O = {
      product: "[data-product]",
      productForm: "[data-product-form]",
      addToCart: "[data-add-to-cart]",
      addToCartText: "[data-add-to-cart-text]",
      buyItNow: "[data-buy-it-now]",
      comparePrice: "[data-compare-price]",
      formWrapper: "[data-form-wrapper]",
      header: "[data-site-header]",
      originalSelectorId: "[data-product-select]",
      preOrderTag: "_preorder",
      priceWrapper: "[data-price-wrapper]",
      priceOffWrap: "[data-price-off]",
      priceOffType: "[data-price-off-type]",
      priceOffAmount: "[data-price-off-amount]",
      productSlide: "[data-product-slide]",
      productImage: "[data-product-image]",
      productMediaSlider: "[data-product-single-media-slider]",
      productJson: "[data-product-json]",
      productPrice: "[data-product-price]",
      unitPrice: "[data-product-unit-price]",
      unitBase: "[data-product-base]",
      unitWrapper: "[data-product-unit]",
      subPrices: "[data-subscription-watch-price]",
      subSelectors: "[data-subscription-selectors]",
      subsToggle: "[data-toggles-group]",
      subsChild: "data-group-toggle",
      subDescription: "[data-plan-description]",
      remainingCount: "[data-remaining-count]",
      remainingWrapper: "[data-remaining-wrapper]",
      remainingJSON: "[data-product-remaining-json]",
      idInput: '[name="id"]',
      storeAvailabilityContainer: "[data-store-availability-container]",
      upsellButton: "[data-upsell-btn]",
      sectionNode: ".shopify-section",
      quickViewItem: "[data-quick-view-item]",
      notificationButtonText: "[data-notification-button-text]",
      swatchesContainer: "[data-swatches-container]",
      swatchesMore: "[data-swatches-more]",
      selectorWrapper: "[data-option-position]",
      shopifyPaymentButton: ".shopify-payment-button__button",
      paymentButton: '[role="button"], [type="submit"], form',
      disabled: "[disabled]",
    },
    classes$F = {
      hidden: "hidden",
      variantSoldOut: "variant--soldout",
      variantUnavailable: "variant--unavailabe",
      productPriceSale: "product__price--sale",
      priceWrapperHidden: "product__price--hidden",
      remainingLow: "count-is-low",
      remainingIn: "count-is-in",
      remainingOut: "count-is-out",
      remainingUnavailable: "count-is-unavailable",
      selectorVisible: "selector-wrapper--visible",
    },
    attributes$z = {
      productImageId: "data-image-id",
      tallLayout: "data-tall-layout",
      dataEnableHistoryState: "data-enable-history-state",
      notificationPopup: "data-notification-popup",
      swatchVariant: "data-swatch-variant",
      disabled: "disabled",
    };
  let sections$y = {};
  class ProductAddForm {
    constructor(container) {
      if (
        ((this.container = container),
        (this.product = this.container.querySelector(selectors$O.product)),
        (this.productForm = this.container.querySelector(
          selectors$O.productForm
        )),
        (this.tallLayout =
          this.container.getAttribute(attributes$z.tallLayout) === "true"),
        (this.addToCartButton = this.container.querySelector(
          selectors$O.addToCart
        )),
        (this.buyItNow = this.container.querySelector(selectors$O.buyItNow)),
        (this.hasPaymentButton = this.buyItNow !== null),
        !this.product || !this.productForm)
      ) {
        new QuantityCounter(this.container).init();
        return;
      }
      (this.storeAvailabilityContainer = this.container.querySelector(
        selectors$O.storeAvailabilityContainer
      )),
        (this.enableHistoryState =
          this.container.getAttribute(attributes$z.dataEnableHistoryState) ===
          "true"),
        (this.hasUnitPricing = this.container.querySelector(
          selectors$O.unitWrapper
        )),
        (this.subSelectors = this.container.querySelector(
          selectors$O.subSelectors
        )),
        (this.subPrices = this.container.querySelector(selectors$O.subPrices)),
        (this.priceOffWrap = this.container.querySelector(
          selectors$O.priceOffWrap
        )),
        (this.priceOffAmount = this.container.querySelector(
          selectors$O.priceOffAmount
        )),
        (this.priceOffType = this.container.querySelector(
          selectors$O.priceOffType
        )),
        (this.planDecription = this.container.querySelector(
          selectors$O.subDescription
        )),
        (this.swatchesContainer = this.container.querySelector(
          selectors$O.swatchesContainer
        )),
        (this.latestVariantId = ""),
        (this.latestVariantTitle = ""),
        (this.sellout = null),
        (this.sessionStorage = window.sessionStorage),
        (this.remainingWrapper = this.container.querySelector(
          selectors$O.remainingWrapper
        )),
        this.remainingWrapper &&
          ((this.remainingMaxInt = parseInt(
            this.remainingWrapper.dataset.remainingMax,
            10
          )),
          (this.remainingCount = this.container.querySelector(
            selectors$O.remainingCount
          )),
          (this.remainingJSONWrapper = this.container.querySelector(
            selectors$O.remainingJSON
          )),
          (this.remainingJSON = null),
          this.remainingJSONWrapper &&
            this.remainingJSONWrapper.innerHTML !== "" &&
            (this.remainingJSON = JSON.parse(
              this.remainingJSONWrapper.innerHTML
            ))),
        this.storeAvailabilityContainer &&
          (this.storeAvailability = new StoreAvailability(
            this.storeAvailabilityContainer
          )),
        new QuantityCounter(this.container).init(),
        this.init(),
        this.hasPaymentButton &&
          ((this.mutationObserver = null),
          (this.onResizeCallback = () => this.updateButtonsHeight()),
          this.observeContainer(),
          window.addEventListener("theme:resize:width", this.onResizeCallback));
    }
    init() {
      let productJSON = null;
      const productElemJSON = this.container.querySelector(
        selectors$O.productJson
      );
      productElemJSON && (productJSON = productElemJSON.innerHTML),
        productJSON
          ? ((this.productJSON = JSON.parse(productJSON)),
            this.linkForm(),
            (this.sellout = new SelloutVariants(
              this.container,
              this.productJSON
            )))
          : console.error("Missing product JSON");
    }
    observeContainer() {
      (this.mutationObserver = new MutationObserver((mutationList) => {
        for (const mutation of mutationList)
          mutation.type === "childList" &&
            mutation.target.closest(selectors$O.buyItNow) &&
            (this.updateButtonsHeight(),
            mutation.target.querySelector(selectors$O.disabled) ||
              (this.mutationObserver?.disconnect(),
              (this.mutationObserver = null)));
      })),
        this.mutationObserver.observe(this.container, {
          childList: !0,
          subtree: !0,
        });
    }
    updateButtonsHeight() {
      (this.shopifyPaymentButton = this.container.querySelector(
        selectors$O.shopifyPaymentButton
      )),
        (this.paymentButton = this.buyItNow.querySelectorAll(
          `${selectors$O.paymentButton}`
        )),
        this.shopifyPaymentButton &&
          (this.shopifyPaymentButton.hasAttribute(attributes$z.disabled) ||
            (this.shopifyPaymentButton.setAttribute(
              "style",
              "min-height: auto !important;"
            ),
            this.addToCartButton.setAttribute("style", "min-height: auto;"),
            this.paymentButton.forEach((element) =>
              element.setAttribute("style", "min-height: auto !important;")
            ),
            requestAnimationFrame(() => {
              (this.compareHeights = []),
                this.paymentButton.forEach((element) =>
                  this.compareHeights.push(element.offsetHeight)
                ),
                this.compareHeights.push(
                  this.shopifyPaymentButton.offsetHeight
                ),
                this.compareHeights.push(this.addToCartButton.offsetHeight),
                debounce(this.setButtonsStyles(), 400);
            })));
    }
    setButtonsStyles() {
      this.compareHeights.length !== 0 &&
        ((this.maxHeight = Math.max(...this.compareHeights)),
        requestAnimationFrame(() => {
          this.addToCartButton.setAttribute(
            "style",
            `min-height: ${this.maxHeight}px;`
          ),
            this.shopifyPaymentButton.setAttribute(
              "style",
              `min-height: ${this.maxHeight}px !important; height: auto !important;`
            ),
            this.paymentButton.forEach((element) =>
              element.setAttribute(
                "style",
                `min-height: ${this.maxHeight}px !important; height: auto !important;`
              )
            );
        }));
    }
    linkForm() {
      this.productForm = new ProductForm(this.productForm, this.productJSON, {
        onOptionChange: this.onOptionChange.bind(this),
        onPlanChange: this.onPlanChange.bind(this),
      });
      const formState = this.productForm.getFormState();
      if (
        (this.pushState(formState, !0),
        this.subsToggleListeners(),
        this.swatchesContainer)
      ) {
        this.observeSwatch(formState);
        const selectorWrapper = this.swatchesContainer.closest(
          selectors$O.selectorWrapper
        );
        selectorWrapper
          .querySelector(selectors$O.swatchesMore)
          ?.addEventListener("click", (event2) => {
            event2.preventDefault(),
              selectorWrapper.classList.contains(classes$F.selectorVisible)
                ? selectorWrapper.classList.remove(classes$F.selectorVisible)
                : selectorWrapper.classList.add(classes$F.selectorVisible);
          });
      }
    }
    onOptionChange(evt) {
      this.pushState(evt.dataset), this.updateProductImage(evt);
    }
    onPlanChange(evt) {
      this.subPrices && this.pushState(evt.dataset);
    }
    pushState(formState, init = !1) {
      (this.productState = this.setProductState(formState)),
        this.updateAddToCartState(formState),
        this.updateProductPrices(formState),
        this.updateSaleText(formState),
        this.updateSubscriptionText(formState),
        this.fireHookEvent(formState),
        this.updateRemaining(formState),
        this.sellout?.update(formState),
        this.enableHistoryState && !init && this.updateHistoryState(formState),
        this.storeAvailability &&
          (formState.variant
            ? this.storeAvailability.updateContent(
                formState.variant.id,
                this.productForm.product.title
              )
            : this.storeAvailability.clearContent());
    }
    updateAddToCartState(formState) {
      const variant = formState.variant,
        priceWrapper = this.container.querySelectorAll(
          selectors$O.priceWrapper
        ),
        addToCart = this.container.querySelectorAll(selectors$O.addToCart),
        addToCartText = this.container.querySelectorAll(
          selectors$O.addToCartText
        ),
        formWrapper = this.container.querySelectorAll(selectors$O.formWrapper),
        buyItNow = this.container.querySelector(selectors$O.buyItNow);
      let addText = theme.strings.add_to_cart;
      this.productJSON.tags.includes(selectors$O.preOrderTag) &&
        (addText = theme.strings.preorder),
        priceWrapper?.forEach((element) => {
          element.classList.toggle(classes$F.priceWrapperHidden, !variant);
        }),
        addToCart?.forEach((element) => {
          if (
            element.matches(selectors$O.upsellButton) ||
            ((element.disabled = !0),
            buyItNow?.classList.add(classes$F.hidden),
            !variant) ||
            ((element.disabled = !1),
            variant.available && buyItNow?.classList.remove(classes$F.hidden),
            !element.hasAttribute(attributes$z.notificationPopup))
          )
            return;
          const notificationFormId = element.id.replace(
              "AddToCart",
              "NotificationForm"
            ),
            formID = this.sessionStorage.getItem("notification_form_id");
          let notificationFormSubmitted = !1,
            variantId = variant.id,
            variantTitle = variant.title;
          if (formID) {
            const sessionId = formID.substring(0, formID.lastIndexOf("--")),
              sessionVariantId = formID.split("--").slice(-1)[0];
            (notificationFormSubmitted = notificationFormId === sessionId),
              notificationFormSubmitted &&
                ((this.latestVariantId = variantId),
                (this.latestVariantTitle = variantTitle),
                (variantId = Number(sessionVariantId)),
                this.productJSON.variants.forEach((variant2) => {
                  variant2.id === variantId && (variantTitle = variant2.title);
                }));
          }
          let notificationPopupHtml = element.getAttribute(
            attributes$z.notificationPopup
          );
          const notificationButtonText = new DOMParser()
            .parseFromString(notificationPopupHtml, "text/html")
            .querySelector(selectors$O.notificationButtonText)?.innerHTML;
          if (this.latestVariantId != "" && this.latestVariantTitle != "") {
            (notificationPopupHtml = notificationPopupHtml.replaceAll(
              this.latestVariantId,
              variantId
            )),
              (notificationPopupHtml = notificationPopupHtml.replaceAll(
                `<p class='product__notification__subtitle'>${this.latestVariantTitle}</p>`,
                `<p class='product__notification__subtitle'>${variantTitle}</p>`
              ));
            const updatedNotificationButtonText = new DOMParser()
              .parseFromString(notificationPopupHtml, "text/html")
              .querySelector(selectors$O.notificationButtonText)?.innerHTML;
            notificationPopupHtml = notificationPopupHtml.replace(
              updatedNotificationButtonText,
              notificationButtonText
            );
          }
          element.setAttribute(
            attributes$z.notificationPopup,
            notificationPopupHtml
          ),
            notificationFormSubmitted &&
              (this.scrollToForm(this.product.closest(selectors$O.sectionNode)),
              new NotificationPopup(element)),
            (this.latestVariantId = variantId),
            (this.latestVariantTitle = variantTitle);
        }),
        addToCartText?.forEach((element) => {
          if (!variant) {
            element.innerHTML = theme.strings.unavailable;
            return;
          }
          if (!variant.available) {
            if (
              ((element.innerHTML = theme.strings.sold_out),
              element.parentNode.hasAttribute(attributes$z.notificationPopup))
            ) {
              if (element.closest(selectors$O.quickViewItem)) return;
              element.innerHTML = `${theme.strings.sold_out} - ${theme.strings.newsletter_product_availability}`;
            }
            return;
          }
          element.innerHTML = addText;
        }),
        formWrapper?.forEach((element) => {
          if (!variant) {
            element.classList.add(classes$F.variantUnavailable),
              element.classList.remove(classes$F.variantSoldOut);
            return;
          }
          const formSelect = element.querySelector(
            selectors$O.originalSelectorId
          );
          if (
            (formSelect && (formSelect.value = variant.id), !variant.available)
          ) {
            element.classList.add(classes$F.variantSoldOut),
              element.classList.remove(classes$F.variantUnavailable);
            return;
          }
          element.classList.remove(
            classes$F.variantSoldOut,
            classes$F.variantUnavailable
          );
        });
    }
    updateHistoryState(formState) {
      const variant = formState.variant,
        plan = formState.plan,
        location2 = window.location.href;
      if (variant && location2.includes("/product")) {
        const url = new window.URL(location2),
          params = url.searchParams;
        params.set("variant", variant.id),
          plan && plan.detail && plan.detail.id && this.productState.hasPlan
            ? params.set("selling_plan", plan.detail.id)
            : params.delete("selling_plan"),
          (url.search = params.toString());
        const urlString = url.toString();
        window.history.replaceState({ path: urlString }, "", urlString);
      }
    }
    updateRemaining(formState) {
      const variant = formState.variant,
        remainingClasses = [
          classes$F.remainingIn,
          classes$F.remainingOut,
          classes$F.remainingUnavailable,
          classes$F.remainingLow,
        ];
      if (variant && this.remainingWrapper && this.remainingJSON) {
        const remaining = this.remainingJSON[variant.id];
        (remaining === "out" || remaining < 1) &&
          (this.remainingWrapper.classList.remove(...remainingClasses),
          this.remainingWrapper.classList.add(classes$F.remainingOut)),
          (remaining === "in" || remaining >= this.remainingMaxInt) &&
            (this.remainingWrapper.classList.remove(...remainingClasses),
            this.remainingWrapper.classList.add(classes$F.remainingIn)),
          (remaining === "low" ||
            (remaining > 0 && remaining < this.remainingMaxInt)) &&
            (this.remainingWrapper.classList.remove(...remainingClasses),
            this.remainingWrapper.classList.add(classes$F.remainingLow),
            this.remainingCount && (this.remainingCount.innerHTML = remaining));
      } else
        !variant &&
          this.remainingWrapper &&
          (this.remainingWrapper.classList.remove(...remainingClasses),
          this.remainingWrapper.classList.add(classes$F.remainingUnavailable));
    }
    getBaseUnit(variant) {
      return variant.unit_price_measurement.reference_value === 1
        ? variant.unit_price_measurement.reference_unit
        : variant.unit_price_measurement.reference_value +
            variant.unit_price_measurement.reference_unit;
    }
    subsToggleListeners() {
      this.container
        .querySelectorAll(selectors$O.subsToggle)
        .forEach((toggle) => {
          toggle.addEventListener(
            "change",
            function (e) {
              const val = e.target.value.toString(),
                selected = this.container.querySelector(
                  `[${selectors$O.subsChild}="${val}"]`
                ),
                groups = this.container.querySelectorAll(
                  `[${selectors$O.subsChild}]`
                );
              if (selected) {
                selected.classList.remove(classes$F.hidden);
                const first = selected.querySelector('[name="selling_plan"]');
                (first.checked = !0), first.dispatchEvent(new Event("change"));
              }
              groups.forEach((group) => {
                group !== selected &&
                  (group.classList.add(classes$F.hidden),
                  group
                    .querySelectorAll('[name="selling_plan"]')
                    .forEach((plan) => {
                      (plan.checked = !1),
                        plan.dispatchEvent(new Event("change"));
                    }));
              });
            }.bind(this)
          );
        });
    }
    updateSaleText(formState) {
      this.productState.planSale
        ? this.updateSaleTextSubscription(formState)
        : this.productState.onSale
        ? this.updateSaleTextStandard(formState)
        : this.priceOffWrap &&
          this.priceOffWrap.classList.add(classes$F.hidden);
    }
    updateSaleTextStandard(formState) {
      if (!this.priceOffType) return;
      this.priceOffType.innerHTML =
        window.theme.strings.sale_badge_text || "sale";
      const variant = formState.variant;
      if (
        window.theme.settings.savingBadgeType &&
        window.theme.settings.savingBadgeType === "percentage"
      ) {
        const discountFloat =
            (variant.compare_at_price - variant.price) /
            variant.compare_at_price,
          discountInt = Math.floor(discountFloat * 100);
        this.priceOffAmount.innerHTML = `${discountInt}%`;
      } else {
        const discount = variant.compare_at_price - variant.price;
        this.priceOffAmount.innerHTML = themeCurrency.formatMoney(
          discount,
          theme.moneyFormat
        );
      }
      this.priceOffWrap.classList.remove(classes$F.hidden);
    }
    updateSaleTextSubscription(formState) {
      const variant = formState.variant,
        variantFirstPlan = this.productForm.product.selling_plan_groups.find(
          (plan) =>
            plan.id ===
            variant.selling_plan_allocations[0].selling_plan_group_id
        ),
        adjustment = formState.plan
          ? formState.plan.detail.price_adjustments[0]
          : variantFirstPlan.selling_plans[0].price_adjustments[0],
        discount = adjustment.value || 0,
        saleText =
          adjustment.value_type === "percentage"
            ? `${discount}%`
            : themeCurrency.formatMoney(
                variant.price - discount,
                theme.moneyFormat
              );
      (this.priceOffType.innerHTML =
        window.theme.strings.subscription || "subscripton"),
        (this.priceOffAmount.innerHTML = saleText),
        this.priceOffWrap.classList.remove(classes$F.hidden);
    }
    updateSubscriptionText(formState) {
      formState.plan &&
      this.planDecription &&
      formState.plan.detail.description !== null
        ? ((this.planDecription.innerHTML = formState.plan.detail.description),
          this.planDecription.classList.remove(classes$F.hidden))
        : this.planDecription &&
          this.planDecription.classList.add(classes$F.hidden);
    }
    updateProductPrices(formState) {
      const variant = formState.variant,
        plan = formState.plan;
      this.container
        .querySelectorAll(selectors$O.priceWrapper)
        .forEach((wrap2) => {
          const comparePriceEl = wrap2.querySelector(selectors$O.comparePrice),
            productPriceEl = wrap2.querySelector(selectors$O.productPrice);
          let comparePrice = "",
            price = "";
          if (
            (this.productState.available &&
              ((comparePrice = variant.compare_at_price),
              (price = variant.price)),
            this.productState.hasPlan &&
              (price = plan
                ? plan.allocation.price
                : variant.selling_plan_allocations[0].per_delivery_price),
            this.productState.planSale)
          ) {
            const allocationPrice = plan
              ? plan.allocation.price
              : variant.selling_plan_allocations[0].per_delivery_price;
            (comparePrice = plan
              ? plan.allocation.compare_at_price
              : variant.selling_plan_allocations[0].compare_at_price),
              (price = allocationPrice);
          }
          comparePriceEl &&
            (this.productState.onSale || this.productState.planSale
              ? (comparePriceEl.classList.remove(classes$F.hidden),
                productPriceEl.classList.add(classes$F.productPriceSale))
              : (comparePriceEl.classList.add(classes$F.hidden),
                productPriceEl.classList.remove(classes$F.productPriceSale)),
            (comparePriceEl.innerHTML = theme.settings.currency_code_enable
              ? themeCurrency.formatMoney(
                  comparePrice,
                  theme.moneyWithCurrencyFormat
                )
              : themeCurrency.formatMoney(comparePrice, theme.moneyFormat))),
            price === 0
              ? (productPriceEl.innerHTML = window.theme.strings.free)
              : (productPriceEl.innerHTML = theme.settings.currency_code_enable
                  ? themeCurrency.formatMoney(
                      price,
                      theme.moneyWithCurrencyFormat
                    )
                  : themeCurrency.formatMoney(price, theme.moneyFormat));
        }),
        this.hasUnitPricing && this.updateProductUnits(formState);
    }
    updateProductUnits(formState) {
      const variant = formState.variant,
        plan = formState.plan;
      let unitPrice = null;
      if (
        (variant && variant.unit_price && (unitPrice = variant.unit_price),
        plan &&
          plan?.allocation &&
          plan?.allocation.unit_price &&
          (unitPrice = plan.allocation.unit_price),
        !plan &&
          variant.selling_plan_allocations &&
          variant.selling_plan_allocations.length > 0 &&
          (unitPrice = variant.selling_plan_allocations[0].unit_price),
        unitPrice)
      ) {
        const base = this.getBaseUnit(variant),
          formattedPrice =
            unitPrice === 0
              ? window.theme.strings.free
              : themeCurrency.formatMoney(unitPrice, theme.moneyFormat);
        (this.container.querySelector(selectors$O.unitPrice).innerHTML =
          formattedPrice),
          (this.container.querySelector(selectors$O.unitBase).innerHTML = base),
          showElement(this.container.querySelector(selectors$O.unitWrapper));
      } else hideElement(this.container.querySelector(selectors$O.unitWrapper));
    }
    fireHookEvent(formState) {
      const variant = formState.variant;
      this.container.dispatchEvent(
        new CustomEvent("theme:variant:change", {
          detail: { variant },
          bubbles: !0,
        })
      );
    }
    setProductState(dataset) {
      const variant = dataset.variant,
        plan = dataset.plan,
        productState = {
          available: !0,
          soldOut: !1,
          onSale: !1,
          showUnitPrice: !1,
          requiresPlan: !1,
          hasPlan: !1,
          planPerDelivery: !1,
          planSale: !1,
        };
      if (!variant) productState.available = !1;
      else {
        const requiresPlan = variant.requires_selling_plan || !1;
        variant.available || (productState.soldOut = !0),
          variant.compare_at_price > variant.price &&
            (productState.onSale = !0),
          variant.unit_price && (productState.showUnitPrice = !0),
          this.product &&
            this.product.requires_selling_plan &&
            (productState.requiresPlan = !0),
          plan &&
            this.subPrices &&
            ((productState.hasPlan = !0),
            plan.allocation.per_delivery_price !== plan.allocation.price &&
              (productState.planPerDelivery = !0),
            variant.price > plan.allocation.price &&
              (productState.planSale = !0)),
          !plan &&
            requiresPlan &&
            ((productState.hasPlan = !0),
            variant.selling_plan_allocations[0].per_delivery_price !==
              variant.selling_plan_allocations[0].price &&
              (productState.planPerDelivery = !0),
            variant.price > variant.selling_plan_allocations[0].price &&
              (productState.planSale = !0));
      }
      return productState;
    }
    updateProductImage(evt) {
      const variant = evt.dataset.variant;
      if (!variant || !variant?.featured_media) return;
      const newImg = this.container.querySelector(
          `${selectors$O.productImage}[${attributes$z.productImageId}="${variant.featured_media.id}"]`
        ),
        newImageParent = newImg?.closest(selectors$O.productSlide);
      if (newImageParent) {
        const newImagePos = parseInt(
            [...newImageParent.parentElement.children].indexOf(newImageParent)
          ),
          imgSlider = this.container.querySelector(
            selectors$O.productMediaSlider
          ),
          flkty = Flickity.data(imgSlider);
        if (flkty && flkty.isActive) {
          const variantSlide = imgSlider.querySelector(
            `[data-id="${variant.featured_media.id}"]`
          );
          if (variantSlide) {
            const slideIndex = parseInt(
              [...variantSlide.parentNode.children].indexOf(variantSlide)
            );
            flkty.select(slideIndex);
          }
          return;
        }
        if (this.tallLayout) {
          const newImgTop = newImg.getBoundingClientRect().top;
          if (
            newImagePos === 0 &&
            newImgTop + window.scrollY > window.pageYOffset
          )
            return;
          document.dispatchEvent(
            new CustomEvent("theme:tooltip:close", {
              bubbles: !1,
              detail: { hideTransition: !1 },
            })
          ),
            scrollTo(newImgTop);
        }
      }
    }
    observeSwatch(formState) {
      const swatch = this.swatchesContainer.querySelector(
        `[${attributes$z.swatchVariant}*="${formState.variant.id}"]`
      );
      this.swatchesContainer
        .closest(selectors$O.selectorWrapper)
        .classList.remove(classes$F.selectorVisible),
        new IntersectionObserver(
          (entries, observer2) => {
            entries.forEach((entry) => {
              entry.intersectionRatio == 0 &&
                this.swatchesContainer
                  .closest(selectors$O.selectorWrapper)
                  .classList.add(classes$F.selectorVisible);
            });
          },
          { root: this.container, threshold: [0.95, 1] }
        ).observe(swatch);
    }
    scrollToForm(section) {
      const headerHeight = document.querySelector(selectors$O.header)?.dataset
        .height;
      visibilityHelper.isElementPartiallyVisible(section) ||
        visibilityHelper.isElementTotallyVisible(section) ||
        setTimeout(() => {
          const sectionTop = section.getBoundingClientRect().top - headerHeight;
          window.scrollTo({ top: sectionTop, left: 0, behavior: "smooth" });
        }, 400);
    }
    onUnload() {
      this.productForm && this.productForm.destroy(),
        this.hasPaymentButton &&
          window.removeEventListener(
            "theme:resize:width",
            this.onResizeCallback
          );
    }
  }
  const productFormSection = {
      onLoad() {
        sections$y[this.id] = new ProductAddForm(this.container);
      },
      onUnload() {
        sections$y[this.id].onUnload();
      },
    },
    selectors$N = {
      form: "form",
      popoutWrapper: "[data-popout]",
      popoutList: "[data-popout-list]",
      popoutToggle: "[data-popout-toggle]",
      popoutInput: "[data-popout-input]",
      popoutOptions: "[data-popout-option]",
      popoutText: "[data-popout-text]",
      ariaCurrent: "[aria-current]",
      productGridImage: "[data-product-image]",
      productGrid: "[data-product-grid-item]",
    },
    classes$E = {
      listVisible: "select-popout__list--visible",
      popoutAlternative: "select-popout--alt",
      currentSuffix: "--current",
      visible: "is-visible",
    },
    attributes$y = {
      ariaCurrent: "aria-current",
      ariaExpanded: "aria-expanded",
      dataValue: "data-value",
      popoutPrevent: "data-popout-prevent",
      popoutQuantity: "data-quantity-field",
      quickViewItem: "data-quick-view-item",
      popoutInitialized: "data-popout-initialized",
    };
  let sections$x = {};
  class Popout {
    constructor(popout) {
      (this.popout = popout),
        (this.popoutList = this.popout.querySelector(selectors$N.popoutList)),
        (this.popoutToggle = this.popout.querySelector(
          selectors$N.popoutToggle
        )),
        (this.popoutText = this.popout.querySelector(selectors$N.popoutText)),
        (this.popoutInput = this.popout.querySelector(selectors$N.popoutInput)),
        (this.popoutOptions = this.popout.querySelectorAll(
          selectors$N.popoutOptions
        )),
        (this.popoutPrevent =
          this.popout.getAttribute(attributes$y.popoutPrevent) === "true"),
        (this.popupToggleFocusoutEvent = (evt) =>
          this.popupToggleFocusout(evt)),
        (this.popupListFocusoutEvent = (evt) => this.popupListFocusout(evt)),
        (this.popupToggleClickEvent = (evt) => this.popupToggleClick(evt)),
        (this.popoutKeyupEvent = (evt) => this.popoutKeyup(evt)),
        (this.popupOptionsClickEvent = (evt) => this.popupOptionsClick(evt)),
        (this._connectOptionsDispatchEvent = (evt) =>
          this._connectOptionsDispatch(evt)),
        (this.bodyClick = this.bodyClick.bind(this)),
        (this.updatePopout = this.updatePopout.bind(this)),
        this._connectOptions(),
        this._connectToggle(),
        this._onFocusOut(),
        this.popoutInput &&
          this.popoutInput.hasAttribute(attributes$y.popoutQuantity) &&
          document.addEventListener("theme:cart:update", this.updatePopout);
    }
    unload() {
      this.popoutOptions.length &&
        this.popoutOptions.forEach((element) => {
          element.removeEventListener(
            "theme:popout:click",
            this.popupOptionsClickEvent
          ),
            element.removeEventListener(
              "click",
              this._connectOptionsDispatchEvent
            );
        }),
        this.popoutToggle.removeEventListener(
          "click",
          this.popupToggleClickEvent
        ),
        this.popoutToggle.removeEventListener(
          "focusout",
          this.popupToggleFocusoutEvent
        ),
        this.popoutList.removeEventListener(
          "focusout",
          this.popupListFocusoutEvent
        ),
        this.popout.removeEventListener("keyup", this.popoutKeyupEvent),
        document.removeEventListener("theme:cart:update", this.updatePopout),
        document.body.removeEventListener("click", this.bodyClick);
    }
    popupToggleClick(evt) {
      const ariaExpanded =
        evt.currentTarget.getAttribute(attributes$y.ariaExpanded) === "true";
      if (this.popoutList.closest(selectors$N.productGrid)) {
        const productGridItemImage = this.popoutList
          .closest(selectors$N.productGrid)
          .querySelector(selectors$N.productGridImage);
        productGridItemImage &&
          productGridItemImage.classList.toggle(
            classes$E.visible,
            !ariaExpanded
          );
      }
      evt.currentTarget.setAttribute(attributes$y.ariaExpanded, !ariaExpanded),
        this.popoutList.classList.toggle(classes$E.listVisible);
    }
    popupToggleFocusout(evt) {
      if (!evt.relatedTarget) return;
      const popoutLostFocus = this.popout.contains(evt.relatedTarget),
        popoutFromQuickView = evt.relatedTarget.hasAttribute(
          attributes$y.quickViewItem
        );
      !popoutLostFocus && !popoutFromQuickView && this._hideList();
    }
    popupListFocusout(evt) {
      const childInFocus = evt.currentTarget.contains(evt.relatedTarget);
      this.popoutList.classList.contains(classes$E.listVisible) &&
        !childInFocus &&
        this._hideList();
    }
    popupOptionsClick(evt) {
      if (
        evt.target.closest(selectors$N.popoutOptions).attributes.href.value ===
        "#"
      ) {
        evt.preventDefault();
        let attrValue = "";
        if (
          (evt.currentTarget.getAttribute(attributes$y.dataValue) &&
            (attrValue = evt.currentTarget.getAttribute(
              attributes$y.dataValue
            )),
          (this.popoutInput.value = attrValue),
          this.popoutPrevent)
        ) {
          this.popoutInput.dispatchEvent(new Event("change")),
            !evt.detail.preventTrigger &&
              this.popoutInput.hasAttribute(attributes$y.popoutQuantity) &&
              this.popoutInput.dispatchEvent(new Event("input"));
          const currentElement = this.popoutList.querySelector(
            `[class*="${classes$E.currentSuffix}"]`
          );
          let targetClass = classes$E.currentSuffix;
          if (currentElement && currentElement.classList.length) {
            for (const currentElementClass of currentElement.classList)
              if (currentElementClass.includes(classes$E.currentSuffix)) {
                targetClass = currentElementClass;
                break;
              }
          }
          const listTargetElement = this.popoutList.querySelector(
            `.${targetClass}`
          );
          listTargetElement &&
            (listTargetElement.classList.remove(`${targetClass}`),
            evt.currentTarget.parentElement.classList.add(`${targetClass}`));
          const targetAttribute = this.popoutList.querySelector(
            selectors$N.ariaCurrent
          );
          targetAttribute &&
            (targetAttribute.removeAttribute(attributes$y.ariaCurrent),
            evt.currentTarget.setAttribute(attributes$y.ariaCurrent, "true")),
            attrValue !== "" && (this.popoutText.textContent = attrValue),
            this.popupToggleFocusout(evt),
            this.popupListFocusout(evt);
        } else this._submitForm(attrValue);
      }
    }
    updatePopout() {
      const targetElement = this.popoutList.querySelector(
        `[${attributes$y.dataValue}="${this.popoutInput.value}"]`
      );
      targetElement
        ? (targetElement.dispatchEvent(
            new CustomEvent("theme:popout:click", {
              cancelable: !0,
              bubbles: !0,
              detail: { preventTrigger: !0 },
            })
          ),
          targetElement.parentElement.nextSibling ||
            this.popout.classList.add(classes$E.popoutAlternative))
        : this.popout.classList.add(classes$E.popoutAlternative);
    }
    popoutKeyup(event2) {
      event2.code === theme.keyboardKeys.ESCAPE &&
        (this._hideList(), this.popoutToggle.focus());
    }
    bodyClick(event2) {
      const isOption = this.popout.contains(event2.target);
      this.popoutList.classList.contains(classes$E.listVisible) &&
        !isOption &&
        this._hideList();
    }
    _connectToggle() {
      this.popout.setAttribute(attributes$y.popoutInitialized, ""),
        this.popoutToggle.addEventListener("click", this.popupToggleClickEvent);
    }
    _connectOptions() {
      this.popoutOptions.length &&
        this.popoutOptions.forEach((element) => {
          element.addEventListener(
            "theme:popout:click",
            this.popupOptionsClickEvent
          ),
            element.addEventListener(
              "click",
              this._connectOptionsDispatchEvent
            );
        });
    }
    _connectOptionsDispatch(evt) {
      const event2 = new CustomEvent("theme:popout:click", {
        cancelable: !0,
        bubbles: !0,
        detail: { preventTrigger: !1 },
      });
      evt.target.dispatchEvent(event2) || evt.preventDefault();
    }
    _onFocusOut() {
      this.popoutToggle.addEventListener(
        "focusout",
        this.popupToggleFocusoutEvent
      ),
        this.popoutList.addEventListener(
          "focusout",
          this.popupListFocusoutEvent
        ),
        this.popout.addEventListener("keyup", this.popoutKeyupEvent),
        document.body.addEventListener("click", this.bodyClick);
    }
    _submitForm() {
      const form = this.popout.closest(selectors$N.form);
      form && form.submit();
    }
    _hideList() {
      this.popoutList.classList.remove(classes$E.listVisible),
        this.popoutToggle.setAttribute(attributes$y.ariaExpanded, !1);
    }
  }
  const popoutSection = {
      onLoad() {
        (sections$x[this.id] = []),
          this.container
            .querySelectorAll(selectors$N.popoutWrapper)
            .forEach((wrapper) => {
              wrapper.hasAttribute(attributes$y.popoutInitialized) ||
                sections$x[this.id].push(new Popout(wrapper));
            });
      },
      onUnload() {
        sections$x[this.id].forEach((popout) => {
          typeof popout.unload == "function" && popout.unload();
        });
      },
    },
    selectors$M = {
      addToCart: "[data-add-to-cart]",
      deferredMedia: "[data-deferred-media]",
      deferredMediaButton: "[data-deferred-media-button]",
      popupClose: "[data-popup-close]",
      popout: "[data-popout]",
      quickViewInner: "[data-quick-view-inner]",
      quickViewItemHolder: "[data-quick-view-item-holder]",
      product: "[data-product]",
      productForm: "[data-product-form]",
      productMediaSlider: "[data-product-single-media-slider]",
      productMediaWrapper: "[data-product-single-media-wrapper]",
      productModel: "[data-model]",
      productJSON: "[data-product-json]",
      quickViewFootInner: "[data-quick-view-foot-inner]",
      shopTheLookThumb: "[data-shop-the-look-thumb]",
      tooltip: "[data-tooltip]",
      drawerToggle: "[data-drawer-toggle]",
    },
    classes$D = {
      hasMediaActive: "has-media-active",
      isActive: "is-active",
      isLoading: "is-loading",
      mediaHidden: "media--hidden",
      noOutline: "no-outline",
      notificationPopupVisible: "notification-popup-visible",
      popupQuickViewAnimateIn: "popup-quick-view--animate-in",
      popupQuickViewAnimateOut: "popup-quick-view--animate-out",
      popupQuickViewAnimated: "popup-quick-view--animated",
      popupQuickView: "popup-quick-view",
      jsQuickViewVisible: "js-quick-view-visible",
      jsQuickViewFromCart: "js-quick-view-from-cart",
      drawerOpen: "js-drawer-open",
    },
    attributes$x = {
      id: "id",
      mediaId: "data-media-id",
      sectionId: "data-section-id",
      handle: "data-handle",
      loaded: "loaded",
      tabindex: "tabindex",
      quickViewOnboarding: "data-quick-view-onboarding",
      hotspot: "data-hotspot",
      hotspotRef: "data-hotspot-ref",
    },
    ids = { addToCartFormId: "AddToCartForm--", addToCartId: "AddToCart--" };
  class LoadQuickview {
    constructor(popup, pswpElement) {
      (this.popup = popup),
        (this.pswpElement = pswpElement),
        (this.quickViewFoot = this.pswpElement.querySelector(
          selectors$M.quickViewFootInner
        )),
        (this.quickViewInner = this.pswpElement.querySelector(
          selectors$M.quickViewInner
        )),
        (this.product = this.pswpElement.querySelectorAll(selectors$M.product)),
        (this.flkty = []),
        (this.videos = []),
        (this.productForms = []),
        (this.deferredMedias = this.pswpElement.querySelectorAll(
          selectors$M.deferredMedia
        )),
        (this.buttonsShopTheLookThumb = this.pswpElement.querySelectorAll(
          selectors$M.shopTheLookThumb
        )),
        (this.quickViewItemHolders = this.pswpElement.querySelectorAll(
          selectors$M.quickViewItemHolder
        )),
        (this.popupCloseButtons = this.quickViewInner.querySelectorAll(
          selectors$M.popupClose
        )),
        (this.a11y = a11y),
        (this.prevent3dModelSubmitEvent = (event2) =>
          this.prevent3dModelSubmit(event2)),
        (this.closeOnAnimationEndEvent = (event2) =>
          this.closeOnAnimationEnd(event2)),
        (this.closeOnEscapeEvent = (event2) => this.closeOnEscape(event2)),
        (this.outerCloseEvent = (event2) => {
          if (!this.quickViewInner.contains(event2.target)) {
            const drawer2 = this.quickViewInner.nextElementSibling;
            if (drawer2 && drawer2.contains(event2.target)) return;
            this.closePopup(event2);
          }
        }),
        this.product.forEach((item, index) => {
          item.hasAttribute(attributes$x.quickViewOnboarding) ||
            this.initItems(item, index);
        }),
        this.init(),
        this.initTooltips(),
        this.initPopouts(),
        (this.swatchesContainer = new SwatchesContainer(this.pswpElement));
    }
    initTooltips() {
      (this.tooltips = this.pswpElement.querySelectorAll(selectors$M.tooltip)),
        this.tooltips.forEach((tooltip2) => {
          new Tooltip(tooltip2);
        });
    }
    initPopouts() {
      (this.popoutElements = this.pswpElement.querySelectorAll(
        selectors$M.popout
      )),
        (this.popouts = {}),
        this.popoutElements?.forEach((popout, index) => {
          this.popouts[index] = new Popout(popout);
        });
    }
    handleDraggable(slider2, draggableStatus) {
      slider2 &&
        ((slider2.options.draggable = !!draggableStatus),
        slider2.updateDraggable());
    }
    initItems(item, index) {
      this.addFormSuffix(item),
        this.initProductSlider(item, index),
        this.initProductVideo(item),
        this.initProductModel(item),
        this.initShopifyXrLaunch(item),
        makeSwatches(item),
        this.pswpElement.querySelectorAll(selectors$M.drawerToggle).length &&
          new Drawer(item),
        wrapElements(item);
      const productForm = new ProductAddForm(item.parentNode);
      this.productForms.push(productForm),
        Shopify.PaymentButton && Shopify.PaymentButton.init(),
        item.classList.remove(classes$D.isLoading);
    }
    init() {
      document.addEventListener("submit", this.prevent3dModelSubmitEvent),
        this.popupCloseButtons.forEach((popupClose) => {
          popupClose.addEventListener("keyup", (event2) => {
            (event2.code === theme.keyboardKeys.ENTER ||
              event2.code === theme.keyboardKeys.NUMPADENTER ||
              event2.code === theme.keyboardKeys.SPACE) &&
              this.closePopup(event2);
          }),
            popupClose.addEventListener("click", (event2) => {
              this.closePopup(event2);
            });
        }),
        this.pswpElement.addEventListener("click", this.outerCloseEvent),
        document.dispatchEvent(
          new CustomEvent("theme:popup:open", { bubbles: !0 })
        ),
        this.popup.listen("preventDragEvent", (e, isDown, preventObj) => {
          preventObj.prevent = !1;
        }),
        this.pswpElement.addEventListener("mousedown", () => {
          this.popup.framework.unbind(
            window,
            "pointermove pointerup pointercancel",
            this.popup
          );
        }),
        this.popup.listen("initialZoomInEnd", () => {
          document.body.classList.add(classes$D.jsQuickViewVisible),
            this.a11y.trapFocus({ container: this.quickViewInner });
        }),
        this.pswpElement.addEventListener(
          "animationend",
          this.closeOnAnimationEndEvent
        ),
        this.popup.listen("destroy", () => {
          this.flkty.length > 0 &&
            requestAnimationFrame(() => {
              this.flkty.forEach((slider2) => slider2.pausePlayer());
            }),
            document.body.classList.remove(classes$D.jsQuickViewVisible),
            document.removeEventListener("keyup", this.closeOnEscapeEvent),
            document.addEventListener("keyup", this.closeOnEscapeEvent),
            this.pswpElement.removeEventListener("click", this.outerCloseEvent),
            this.pswpElement.removeEventListener(
              "animationend",
              this.closeOnAnimationEndEvent
            ),
            document.removeEventListener(
              "submit",
              this.prevent3dModelSubmitEvent
            ),
            this.deferredMedias.forEach((deferredMedia) => {
              deferredMedia.removeAttribute(attributes$x.loaded);
              const media = deferredMedia.closest(
                selectors$M.productMediaWrapper
              );
              media.dispatchEvent(new CustomEvent("theme:media:hidden"), {
                bubbles: !0,
              }),
                media.classList.add(classes$D.mediaHidden);
            });
        }),
        document.addEventListener("keyup", this.closeOnEscapeEvent),
        document.addEventListener("theme:cart:added", () => {
          this.pswpElement.classList.contains(classes$D.popupQuickView) &&
            this.pswpElement.classList.add(classes$D.popupQuickViewAnimateOut);
        }),
        this.animateInQuickview(),
        this.initShopTheLookListeners();
    }
    initShopTheLookListeners() {
      this.buttonsShopTheLookThumb?.forEach((button) => {
        button.addEventListener("click", (event2) => {
          event2.preventDefault();
          const thumb = event2.target.matches(selectors$M.shopTheLookThumb)
              ? event2.target
              : event2.target.closest(selectors$M.shopTheLookThumb),
            holder = this.pswpElement.querySelector(
              `[${attributes$x.hotspot}="${thumb.getAttribute(
                attributes$x.hotspotRef
              )}"]`
            );
          thumb.classList.contains(classes$D.isActive) ||
            !holder ||
            (this.flkty.length > 0 &&
              requestAnimationFrame(() => {
                this.flkty.forEach((slider2) => {
                  slider2.resize();
                  const allMediaItems = this.quickViewInner.querySelectorAll(
                    selectors$M.productMediaWrapper
                  );
                  allMediaItems.length &&
                    allMediaItems.forEach((media) => {
                      media.dispatchEvent(
                        new CustomEvent("theme:media:hidden"),
                        { bubbles: !0 }
                      ),
                        media.classList.add(classes$D.mediaHidden);
                    });
                });
              }),
            holder.classList.add(classes$D.isActive),
            this.quickViewItemHolders.forEach((element) => {
              element !== holder &&
                element.classList.remove(classes$D.isActive);
            }));
        });
      });
    }
    prevent3dModelSubmit(event2) {
      event2.submitter.closest(selectors$M.deferredMedia) &&
        event2.submitter.closest(selectors$M.productForm) &&
        event2.preventDefault();
    }
    closeQuickviewOnMobile() {
      window.innerWidth < window.theme.sizes.large &&
        document.body.classList.contains(classes$D.jsQuickViewVisible) &&
        this.popup.close();
    }
    animateInQuickview() {
      this.pswpElement.classList.add(classes$D.popupQuickViewAnimateIn),
        this.quickViewFoot.addEventListener("animationend", (event2) => {
          this.handleAnimatedState(event2);
        }),
        this.pswpElement.addEventListener("animationend", (event2) => {
          this.handleAnimatedState(event2, !0);
        });
    }
    handleAnimatedState(event2, isMobileAnimation = !1) {
      if (event2.animationName == "quickViewAnimateInUp") {
        if (isMobileAnimation && window.innerWidth >= window.theme.sizes.small)
          return;
        this.pswpElement.classList.add(classes$D.popupQuickViewAnimated),
          this.pswpElement.classList.remove(classes$D.popupQuickViewAnimateIn),
          document.body.classList.remove(classes$D.jsQuickViewFromCart),
          removeLoadingClassFromLoadedImages(this.pswpElement);
      }
    }
    closePopup(event2) {
      event2?.preventDefault(),
        document.body.classList.contains(classes$D.drawerOpen) &&
          document.dispatchEvent(
            new CustomEvent("theme:drawer:closing", { bubbles: !0 })
          ),
        this.pswpElement.classList.add(classes$D.popupQuickViewAnimateOut),
        this.swatchesContainer.onUnload();
    }
    closeOnAnimationEnd(event2) {
      (event2.animationName == "quickViewAnimateOutRight" ||
        event2.animationName == "quickViewAnimateOutDown") &&
        (this.popup.template.classList.remove(
          classes$D.popupQuickViewAnimateOut,
          classes$D.popupQuickViewAnimated
        ),
        this.popup.close(),
        this.productForms.length > 0 &&
          this.productForms.forEach((form) => form.onUnload()));
    }
    closeOnEscape(event2) {
      const isQuickViewVisible = document.body.classList.contains(
          classes$D.jsQuickViewVisible
        ),
        isNotificationVisible = document.body.classList.contains(
          classes$D.notificationPopupVisible
        );
      event2.code === theme.keyboardKeys.ESCAPE &&
        isQuickViewVisible &&
        !isNotificationVisible &&
        this.closePopup(event2);
    }
    initProductSlider(item, index) {
      const slider2 = item.querySelector(selectors$M.productMediaSlider),
        mediaItems = item.querySelectorAll(selectors$M.productMediaWrapper);
      if (mediaItems.length > 1) {
        const itemSlider = new Flickity(slider2, {
          wrapAround: !0,
          cellAlign: "left",
          pageDots: !1,
          prevNextButtons: !0,
          adaptiveHeight: !1,
          pauseAutoPlayOnHover: !1,
          selectedAttraction: 0.2,
          friction: 1,
          autoPlay: !1,
          on: {
            ready: () => {
              slider2.setAttribute(attributes$x.tabindex, "-1"),
                requestAnimationFrame(() => {
                  itemSlider.resize();
                });
            },
            settle: () => {
              const currentSlide = itemSlider.selectedElement,
                mediaId = currentSlide.getAttribute(attributes$x.mediaId);
              currentSlide.setAttribute(attributes$x.tabindex, "0"),
                itemSlider.cells.forEach((slide) => {
                  slide.element !== currentSlide &&
                    slide.element.setAttribute(attributes$x.tabindex, "-1");
                }),
                this.switchMedia(item, mediaId);
            },
          },
        });
        this.flkty.push(itemSlider),
          mediaItems.length &&
            mediaItems.forEach((element) => {
              element.addEventListener("theme:media:play", () => {
                this.handleDraggable(this.flkty[index], !1),
                  element
                    .closest(selectors$M.productMediaSlider)
                    .classList.add(classes$D.hasMediaActive);
              }),
                element.addEventListener("theme:media:pause", () => {
                  this.handleDraggable(this.flkty[index], !0),
                    element
                      .closest(selectors$M.productMediaSlider)
                      .classList.remove(classes$D.hasMediaActive);
                });
            }),
          flickitySmoothScrolling(slider2);
      }
    }
    switchMedia(item, mediaId) {
      const allMediaItems = this.quickViewInner.querySelectorAll(
          selectors$M.productMediaWrapper
        ),
        selectedMedia = item.querySelector(
          `${selectors$M.productMediaWrapper}[${attributes$x.mediaId}="${mediaId}"]`
        ),
        isFocusEnabled = !document.body.classList.contains(classes$D.noOutline);
      allMediaItems.length &&
        allMediaItems.forEach((media) => {
          media.dispatchEvent(new CustomEvent("theme:media:hidden"), {
            bubbles: !0,
          }),
            media.classList.add(classes$D.mediaHidden);
        }),
        isFocusEnabled && selectedMedia.focus(),
        selectedMedia
          .closest(selectors$M.productMediaSlider)
          .classList.remove(classes$D.hasMediaActive),
        selectedMedia.classList.remove(classes$D.mediaHidden),
        selectedMedia.dispatchEvent(new CustomEvent("theme:media:visible"), {
          bubbles: !0,
        });
      const deferredMedia = selectedMedia.querySelector(
        selectors$M.deferredMedia
      );
      deferredMedia &&
        deferredMedia.getAttribute(attributes$x.loaded) !== "true" &&
        selectedMedia
          .querySelector(selectors$M.deferredMediaButton)
          .dispatchEvent(new Event("click"));
    }
    initProductVideo(item) {
      const videos = new ProductVideo(item);
      this.videos.push(videos);
    }
    initProductModel(item) {
      const sectionId = item.getAttribute(attributes$x.sectionId),
        modelItems = item.querySelectorAll(selectors$M.productModel);
      modelItems.length &&
        modelItems.forEach((element) => {
          theme.ProductModel.init(element, sectionId);
        });
    }
    initShopifyXrLaunch(item) {
      document.addEventListener("shopify_xr_launch", () => {
        item
          .querySelector(
            `${selectors$M.productModel}:not(.${classes$D.mediaHidden})`
          )
          .dispatchEvent(new CustomEvent("xrLaunch"));
      });
    }
    addFormSuffix(item) {
      const sectionId = item.getAttribute(attributes$x.sectionId),
        productObject = JSON.parse(
          item.querySelector(selectors$M.productJSON).innerHTML
        ),
        formSuffix = `${sectionId}-${productObject.handle}`,
        productForm = item.querySelector(selectors$M.productForm),
        addToCart = item.querySelector(selectors$M.addToCart);
      productForm.setAttribute(
        attributes$x.id,
        ids.addToCartFormId + formSuffix
      ),
        addToCart.setAttribute(attributes$x.id, ids.addToCartId + formSuffix);
    }
  }
  const settings$6 = { unlockScrollDelay: 400 },
    selectors$L = {
      popupContainer: ".pswp",
      popupCloseBtn: ".pswp__custom-close",
      popupIframe: "iframe, video",
      popupCustomIframe: ".pswp__custom-iframe",
      popupThumbs: ".pswp__thumbs",
      popupButtons: ".pswp__button, .pswp__caption-close",
      product: "[data-product]",
      productJSON: "[data-product-json]",
    },
    classes$C = {
      current: "is-current",
      customLoader: "pswp--custom-loader",
      customOpen: "pswp--custom-opening",
      loader: "pswp__loader",
      opened: "pswp--open",
      popupCloseButton: "pswp__button--close",
      notificationPopup: "pswp--notification",
      quickviewPopup: "popup-quick-view",
      isCartDrawerOpen: "js-drawer-open-cart",
      quickViewAnimateOut: "popup-quick-view--animate-out",
    },
    attributes$w = {
      dataOptionClasses: "data-pswp-option-classes",
      dataVideoType: "data-video-type",
    },
    loaderHTML = `<div class="${classes$C.loader}"><div class="loader loader--image"><div class="loader__image"></div></div></div>`;
  class LoadPhotoswipe {
    constructor(items, options2 = "", templateIndex = 0, triggerButton = null) {
      (this.items = items),
        (this.triggerBtn = triggerButton),
        (this.pswpElements = document.querySelectorAll(
          selectors$L.popupContainer
        )),
        (this.pswpElement = this.pswpElements[templateIndex]),
        (this.popup = null),
        (this.popupThumbs = null),
        (this.popupThumbsContainer = this.pswpElement.querySelector(
          selectors$L.popupThumbs
        )),
        (this.closeBtn = this.pswpElement.querySelector(
          selectors$L.popupCloseBtn
        ));
      const defaultOptions = { history: !1, focus: !1, mainClass: "" };
      (this.options = options2 !== "" ? options2 : defaultOptions),
        (this.onCloseCallback = () => this.onClose()),
        (this.dispatchPopupInitEventCallback = () =>
          this.dispatchPopupInitEvent()),
        (this.setCurrentThumbCallback = () => this.setCurrentThumb()),
        (this.loadingStateCallback = (event2) => this.loadingState(event2)),
        (this.a11y = a11y),
        this.init();
    }
    init() {
      document.dispatchEvent(
        new CustomEvent("theme:scroll:lock", { bubbles: !0 })
      ),
        this.pswpElement.classList.add(classes$C.customOpen),
        this.initLoader(),
        loadScript({ url: window.theme.assets.photoswipe })
          .then(() => this.loadPopup())
          .catch((e) => console.error(e));
    }
    initLoader() {
      if (
        this.pswpElement.classList.contains(classes$C.customLoader) &&
        this.options !== "" &&
        this.options.mainClass
      ) {
        this.pswpElement.setAttribute(
          attributes$w.dataOptionClasses,
          this.options.mainClass
        );
        let loaderElem = document.createElement("div");
        (loaderElem.innerHTML = loaderHTML),
          (loaderElem = loaderElem.firstChild),
          this.pswpElement.appendChild(loaderElem);
      } else this.pswpElement.setAttribute(attributes$w.dataOptionClasses, "");
    }
    loadPopup() {
      const PhotoSwipe = window.themePhotoswipe.PhotoSwipe.default,
        PhotoSwipeUI = window.themePhotoswipe.PhotoSwipeUI.default;
      this.pswpElement.classList.remove(classes$C.customOpen),
        (this.popup = new PhotoSwipe(
          this.pswpElement,
          PhotoSwipeUI,
          this.items,
          this.options
        )),
        this.popup.listen("afterInit", this.dispatchPopupInitEventCallback),
        this.popup.listen("imageLoadComplete", this.setCurrentThumbCallback),
        this.popup.listen("imageLoadComplete", this.loadingStateCallback),
        this.popup.listen("beforeChange", this.setCurrentThumbCallback),
        this.popup.listen("close", this.onCloseCallback),
        this.popup.init(),
        this.initPopupCallback();
    }
    loadingState(event2) {
      event2 === this.options.index &&
        this.pswpElement.classList.contains(classes$C.customLoader) &&
        this.pswpElement.classList.remove(classes$C.customLoader);
    }
    initPopupCallback() {
      this.isVideo && this.hideUnusedButtons(),
        this.initVideo(),
        this.thumbsActions(),
        this.a11y.trapFocus({ container: this.pswpElement }),
        this.pswpElement.classList.contains(classes$C.quickviewPopup) &&
          new LoadQuickview(this.popup, this.pswpElement),
        this.pswpElement.classList.contains(classes$C.notificationPopup) &&
          new LoadNotification(this.popup, this.pswpElement),
        (this.closePopup = () => {
          this.pswpElement.classList.contains(classes$C.quickviewPopup)
            ? this.pswpElement.classList.add(classes$C.quickViewAnimateOut)
            : this.popup.close();
        }),
        this.closeBtn &&
          this.closeBtn.addEventListener("click", this.closePopup),
        document.addEventListener("theme:cart:added", this.closePopup);
    }
    dispatchPopupInitEvent() {
      this.triggerBtn &&
        this.triggerBtn.dispatchEvent(
          new CustomEvent("theme:popup:init", { bubbles: !0 })
        );
    }
    initVideo() {
      const videoContainer = this.pswpElement.querySelector(
        selectors$L.popupCustomIframe
      );
      if (videoContainer) {
        const videoType = videoContainer.getAttribute(
          attributes$w.dataVideoType
        );
        (this.isVideo = !0),
          videoType == "youtube"
            ? new LoadVideoYT(videoContainer.parentElement)
            : videoType == "vimeo" &&
              new LoadVideoVimeo(videoContainer.parentElement);
      }
    }
    thumbsActions() {
      this.popupThumbsContainer &&
        this.popupThumbsContainer.firstChild &&
        (this.popupThumbsContainer.addEventListener("wheel", (e) =>
          this.stopDisabledScroll(e)
        ),
        this.popupThumbsContainer.addEventListener("mousewheel", (e) =>
          this.stopDisabledScroll(e)
        ),
        this.popupThumbsContainer.addEventListener("DOMMouseScroll", (e) =>
          this.stopDisabledScroll(e)
        ),
        (this.popupThumbs = this.pswpElement.querySelectorAll(
          `${selectors$L.popupThumbs} > *`
        )),
        this.popupThumbs.forEach((element, i) => {
          element.addEventListener("click", (e) => {
            e.preventDefault(),
              element.parentElement
                .querySelector(`.${classes$C.current}`)
                .classList.remove(classes$C.current),
              element.classList.add(classes$C.current),
              this.popup.goTo(i);
          });
        }));
    }
    hideUnusedButtons() {
      this.pswpElement
        .querySelectorAll(selectors$L.popupButtons)
        .forEach((element) => {
          element.classList.contains(classes$C.popupCloseButton) ||
            (element.style.display = "none");
        });
    }
    stopDisabledScroll(e) {
      e.stopPropagation();
    }
    onClose() {
      const popupIframe = this.pswpElement.querySelector(
        selectors$L.popupIframe
      );
      if (
        (popupIframe && popupIframe.parentNode.removeChild(popupIframe),
        this.popupThumbsContainer && this.popupThumbsContainer.firstChild)
      )
        for (; this.popupThumbsContainer.firstChild; )
          this.popupThumbsContainer.removeChild(
            this.popupThumbsContainer.firstChild
          );
      this.pswpElement.setAttribute(attributes$w.dataOptionClasses, "");
      const loaderElem = this.pswpElement.querySelector(`.${classes$C.loader}`);
      loaderElem && this.pswpElement.removeChild(loaderElem),
        document.body.classList.contains(classes$C.isCartDrawerOpen) ||
          this.a11y.removeTrapFocus(),
        document.removeEventListener("theme:cart:added", this.closePopup),
        setTimeout(() => {
          const recentlyOpenedPopups = this.recentlyOpenedPopupsCount(),
            isCartDrawerOpen = document.body.classList.contains(
              classes$C.isCartDrawerOpen
            );
          recentlyOpenedPopups === 0 &&
            !isCartDrawerOpen &&
            document.dispatchEvent(
              new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
            );
        }, settings$6.unlockScrollDelay);
    }
    recentlyOpenedPopupsCount() {
      let count = 0;
      return (
        this.pswpElements.forEach((popup) => {
          popup.classList.contains(classes$C.opened) && (count += 1);
        }),
        count
      );
    }
    setCurrentThumb() {
      if (this.popupThumbsContainer && this.popupThumbsContainer.firstChild)
        return;
      const lastCurrentThumb = this.pswpElement.querySelector(
        `${selectors$L.popupThumbs} > .${classes$C.current}`
      );
      if (
        (lastCurrentThumb &&
          lastCurrentThumb.classList.remove(classes$C.current),
        !this.popupThumbs)
      )
        return;
      const currentThumb = this.popupThumbs[this.popup.getCurrentIndex()];
      currentThumb.classList.add(classes$C.current),
        this.scrollThumbs(currentThumb);
    }
    scrollThumbs(currentThumb) {
      const thumbsContainerLeft = this.popupThumbsContainer.scrollLeft,
        thumbsContainerWidth = this.popupThumbsContainer.offsetWidth,
        thumbsContainerPos = thumbsContainerLeft + thumbsContainerWidth,
        currentThumbLeft = currentThumb.offsetLeft,
        currentThumbWidth = currentThumb.offsetWidth,
        currentThumbPos = currentThumbLeft + currentThumbWidth;
      if (
        thumbsContainerPos <= currentThumbPos ||
        thumbsContainerPos > currentThumbLeft
      ) {
        const currentThumbMarginLeft = parseInt(
          window.getComputedStyle(currentThumb).marginLeft
        );
        this.popupThumbsContainer.scrollTo({
          top: 0,
          left: currentThumbLeft - currentThumbMarginLeft,
          behavior: "smooth",
        });
      }
    }
  }
  const settings$5 = { templateIndex: 0 },
    selectors$K = {
      buttonQuickView: "[data-button-quick-view]",
      quickViewItemsTemplate: "[data-quick-view-items-template]",
      cartDrawer: "[data-cart-drawer]",
      shopTheLookQuickViewButton: "[data-shop-the-look-quick-view-button]",
      shopTheLookThumb: "[data-shop-the-look-thumb]",
      quickViewItemHolder: "[data-quick-view-item-holder]",
    },
    classes$B = {
      loading: "is-loading",
      isActive: "is-active",
      quickViewFromCart: "js-quick-view-from-cart",
      mainClass: "popup-quick-view pswp--not-close-btn",
      shopTheLookPopupClass:
        "popup-quick-view popup-quick-view--shop-the-look pswp--not-close-btn",
    },
    attributes$v = {
      loaded: "data-loaded",
      handle: "data-handle",
      variantId: "data-variant-id",
      shopTheLookQuickView: "data-shop-the-look-quick-view",
      hotspot: "data-hotspot",
      quickButtonInit: "data-initialized",
    },
    options = {
      history: !1,
      focus: !1,
      mainClass: classes$B.mainClass,
      showHideOpacity: !1,
      closeOnVerticalDrag: !1,
      closeOnScroll: !1,
      modal: !1,
      escKey: !1,
    };
  class QuickViewPopup {
    constructor(container) {
      (this.container = container),
        (this.a11y = a11y),
        (this.buttonsQuickView = this.container.querySelectorAll(
          selectors$K.buttonQuickView
        )),
        (this.buttonsShopTheLookQuickView = this.container.querySelectorAll(
          selectors$K.shopTheLookQuickViewButton
        )),
        (this.popupInitCallback = (trigger) => this.popupInit(trigger)),
        this.buttonsQuickView?.forEach((button) => {
          button.hasAttribute(attributes$v.quickButtonInit) ||
            (button.addEventListener("click", (event2) =>
              this.initPhotoswipe(event2)
            ),
            button.addEventListener("theme:popup:init", () => {
              button.classList.remove(classes$B.loading),
                button.hasAttribute(attributes$v.shopTheLookQuickView) &&
                  this.popupInitCallback(button);
            }),
            button.setAttribute(attributes$v.quickButtonInit, ""));
        }),
        this.buttonsShopTheLookQuickView?.forEach((button) => {
          button.addEventListener("click", () => {
            this.buttonsQuickView[0]?.dispatchEvent(new Event("click"));
          });
        });
    }
    popupInit(trigger) {
      const holder = this.loadPhotoswipe.pswpElement.querySelector(
          `[${attributes$v.hotspot}="${trigger.getAttribute(
            attributes$v.hotspot
          )}"]`
        ),
        quickViewItemHolders = this.loadPhotoswipe.pswpElement.querySelectorAll(
          selectors$K.quickViewItemHolder
        );
      holder.classList.add(classes$B.isActive),
        quickViewItemHolders.forEach((element) => {
          element !== holder && element.classList.remove(classes$B.isActive);
        }),
        this.toggleQuickViewButtonsLoadingClasses(!0),
        this.toggleQuickViewThumbsLoadingClasses(!0);
      const onAnimationInEnd = (event2) => {
        event2.animationName === "quickViewAnimateInUp" &&
          requestAnimationFrame(() => {
            this.toggleQuickViewThumbsLoadingClasses(!1);
          }),
          event2.animationName === "quickViewAnimateOutDown" &&
            this.loadPhotoswipe.pswpElement.removeEventListener(
              "animationend",
              onAnimationInEnd
            );
      };
      this.loadPhotoswipe.pswpElement.addEventListener(
        "animationend",
        onAnimationInEnd
      ),
        this.loadPhotoswipe?.popup?.listen("destroy", () => {
          this.toggleQuickViewButtonsLoadingClasses(!1),
            this.toggleQuickViewThumbsLoadingClasses(!1);
        });
    }
    toggleQuickViewButtonsLoadingClasses(isLoading = !0) {
      if (isLoading) {
        this.buttonsQuickView?.forEach((element) => {
          element.classList.add(classes$B.loading);
        });
        return;
      }
      this.buttonsQuickView?.forEach((element) => {
        element.classList.remove(classes$B.loading);
      });
    }
    toggleQuickViewThumbsLoadingClasses(isLoading = !0) {
      if (
        ((this.buttonsShopTheLookThumb =
          this.loadPhotoswipe?.pswpElement.querySelectorAll(
            selectors$K.shopTheLookThumb
          )),
        isLoading)
      ) {
        this.buttonsShopTheLookThumb?.forEach((element) => {
          element.classList.add(classes$B.loading);
        });
        return;
      }
      this.buttonsShopTheLookThumb?.forEach((element) => {
        element.classList.remove(classes$B.loading);
      });
    }
    initPhotoswipe(event2) {
      event2.preventDefault();
      const button = event2.target.matches(selectors$K.buttonQuickView)
          ? event2.target
          : event2.target.closest(selectors$K.buttonQuickView),
        isMobile2 = window.innerWidth < theme.sizes.small;
      let quickViewVariant = "",
        isShopTheLookPopupTrigger = !1;
      if (button.hasAttribute(attributes$v.shopTheLookQuickView)) {
        if (!isMobile2) return;
        isShopTheLookPopupTrigger = !0;
      }
      (options.mainClass = classes$B.mainClass),
        button.classList.add(classes$B.loading),
        button.closest(selectors$K.cartDrawer) &&
          document.body.classList.add(classes$B.quickViewFromCart),
        (this.a11y.state.trigger = button),
        button.hasAttribute(attributes$v.variantId) &&
          (quickViewVariant = `&variant=${button.getAttribute(
            attributes$v.variantId
          )}`);
      const productUrl = `${theme.routes.root}products/${button.getAttribute(
        attributes$v.handle
      )}?section_id=api-quickview${quickViewVariant}`;
      if (isShopTheLookPopupTrigger) {
        (options.mainClass = classes$B.shopTheLookPopupClass),
          this.buttonsQuickView.forEach((element) => {
            element.classList.add(classes$B.loading);
          });
        const XMLS = new XMLSerializer(),
          quickViewItemsTemplate = this.container
            .querySelector(selectors$K.quickViewItemsTemplate)
            .content.firstElementChild.cloneNode(!0),
          itemsData = XMLS.serializeToString(quickViewItemsTemplate);
        this.loadPhotoswipeWithTemplate(itemsData, button);
      } else this.loadPhotoswipeFromFetch(productUrl, button);
    }
    loadPhotoswipeWithTemplate(data, button) {
      const items = [{ html: data }];
      this.loadPhotoswipe = new LoadPhotoswipe(
        items,
        options,
        settings$5.templateIndex,
        button
      );
    }
    loadPhotoswipeFromFetch(url, button) {
      fetch(url)
        .then((response) => response.text())
        .then((data) => {
          const items = [{ html: data }];
          this.loadPhotoswipe = new LoadPhotoswipe(
            items,
            options,
            settings$5.templateIndex,
            button
          );
        })
        .catch((error) => console.log("error: ", error));
    }
  }
  const settings$4 = {
      cartDrawerEnabled: window.theme.settings.cartType === "drawer",
      timers: { addProductTimeout: 1e3 },
      animations: { data: "data-aos", method: "fade-up" },
    },
    selectors$J = {
      outerSection: "[data-section-id]",
      aos: "[data-aos]",
      additionalCheckoutButtons: "[data-additional-checkout-button]",
      apiContent: "[data-api-content]",
      apiLineItems: "[data-api-line-items]",
      apiUpsellItems: "[data-api-upsell-items]",
      apiCartPrice: "[data-api-cart-price]",
      buttonAddToCart: "[data-add-to-cart]",
      upsellButtonByHandle: "[data-handle]",
      cartCloseError: "[data-cart-error-close]",
      cartDrawer: "[data-cart-drawer]",
      cartDrawerTemplate: "[data-cart-drawer-template]",
      cartDrawerToggle: "[data-cart-drawer-toggle]",
      cartDrawerBody: "[data-cart-drawer-body]",
      cartErrors: "[data-cart-errors]",
      cartForm: "[data-cart-form]",
      cartTermsCheckbox: "[data-cart-acceptance-checkbox]",
      cartCheckoutButtonWrapper: "[data-cart-checkout-buttons]",
      cartCheckoutButton: "[data-cart-checkout-button]",
      cartItemRemove: "[data-item-remove]",
      cartItemsQty: "[data-cart-items-qty]",
      cartTotal: "[data-cart-total]",
      cartTotalPrice: "[data-cart-total-price]",
      cartMessage: "[data-cart-message]",
      cartMessageDefault: "[data-message-default]",
      cartPage: "[data-cart-page]",
      cartProgress: "[data-cart-message-progress]",
      emptyMessage: "[data-empty-message]",
      buttonHolder: "[data-foot-holder]",
      item: "[data-cart-item]",
      itemsHolder: "[data-items-holder]",
      itemsWrapper: "[data-items-wrapper]",
      formCloseError: "[data-close-error]",
      formErrorsContainer: "[data-cart-errors-container]",
      upsellHolder: "[data-upsell-holder]",
      errorMessage: "[data-error-message]",
      termsErrorMessage: "[data-terms-error-message]",
      pairProductsHolder: "[data-pair-products-holder]",
      pairProducts: "[data-pair-products]",
      priceHolder: "[data-cart-price-holder]",
      leftToSpend: "[data-left-to-spend]",
      quickBuyForm: "[data-quickbuy-form]",
      qtyInput: "[data-quantity-field]",
      productMediaContainer: "[data-product-media-container]",
      formWrapper: "[data-form-wrapper]",
      productForm: "[data-product-form], [data-product-form-upsell]",
      popupQuickView: ".popup-quick-view",
      popupClose: "[data-popup-close]",
      error: "[data-error]",
      quickViewOnboarding: "[data-quick-view-onboarding]",
      flickityEnabled: ".flickity-enabled",
    },
    classes$A = {
      hidden: "hidden",
      added: "is-added",
      isHidden: "is-hidden",
      cartDrawerOpen: "js-drawer-open-cart",
      open: "is-open",
      visible: "is-visible",
      expanded: "is-expanded",
      loading: "is-loading",
      disabled: "is-disabled",
      success: "is-success",
      error: "has-error",
      cartItems: "cart__toggle--has-items",
      variantSoldOut: "variant--soldout",
      removed: "is-removed",
      aosAnimate: "aos-animate",
      updated: "is-updated",
      noOutline: "no-outline",
      productGridImageError: "product-grid-item__image--error",
      contentVisibilityHidden: "cv-h",
    },
    attributes$u = {
      shippingMessageLimit: "data-limit",
      cartMessageValue: "data-cart-message",
      cartTotal: "data-cart-total",
      ariaExpanded: "aria-expanded",
      disabled: "disabled",
      value: "value",
      dataId: "data-id",
      item: "data-item",
      itemIndex: "data-item-index",
      itemTitle: "data-item-title",
      atcTrigger: "data-atc-trigger",
      upsellButton: "data-upsell-btn",
      notificationPopup: "data-notification-popup",
      sectionId: "data-section-id",
      recipientError: "data-recipient-errors",
    };
  let sections$w = {};
  class CartDrawer {
    constructor() {
      window.location.pathname !== "/password" && this.init();
    }
    init() {
      document.addEventListener(
        "theme:cart:rerender",
        this.getCart.bind(this, !0)
      ),
        (this.cartToggleButtons = document.querySelectorAll(
          selectors$J.cartDrawerToggle
        )),
        (this.cartPage = document.querySelector(selectors$J.cartPage)),
        (this.cartDrawer = document.querySelector(selectors$J.cartDrawer)),
        (this.cart = this.cartDrawer || this.cartPage),
        (this.cartCount = this.getCartItemCount()),
        this.assignArguments(),
        (this.doNotOpen = !1),
        (this.recipientErrors =
          this.form?.getAttribute(attributes$u.recipientError) === "true"),
        (this.flktyUpsell = null),
        (this.form = null),
        (this.collapsible = null),
        (this.a11y = a11y),
        (this.build = this.build.bind(this)),
        (this.addToCart = this.addToCart.bind(this)),
        (this.updateCart = this.updateCart.bind(this)),
        (this.openCartDrawer = this.openCartDrawer.bind(this)),
        (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
        (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
        (this.formSubmitHandler = throttle(
          this.formSubmitHandler.bind(this),
          50
        )),
        (this.closeCartError = () => {
          this.cartErrorHolder.classList.remove(classes$A.expanded);
        }),
        (this.cartDrawerCloseEvent = null),
        (this.hasItemsInCart = this.hasItemsInCart.bind(this)),
        (this.isCartPage = !!(this.cart && this.cartDrawer === null)),
        (this.toggleClassesOnContainers =
          this.toggleClassesOnContainers.bind(this)),
        (this.totalItems = 0),
        (this.isCartDrawerOpen = !1),
        (this.isCartDrawerLoaded = !1),
        (this.cartDiscounts = 0),
        (this.cartDrawerEnabled = settings$4.cartDrawerEnabled),
        (this.cartUpdateFailed = !1),
        this.cartEvents(),
        this.cartAddEvent(),
        this.cartDrawerToggleEvents(),
        this.initQuantity(),
        this.buttonHolder &&
          (this.collapsible = new Collapsible(this.buttonHolder)),
        this.isCartPage && this.renderPairProducts(),
        document.addEventListener("theme:popup:open", this.closeCartDrawer);
    }
    assignArguments() {
      (this.outerSection = this.cart?.closest(selectors$J.outerSection)),
        (this.cartDrawerBody = document.querySelector(
          selectors$J.cartDrawerBody
        )),
        (this.emptyMessage = document.querySelector(selectors$J.emptyMessage)),
        (this.buttonHolder = document.querySelector(selectors$J.buttonHolder)),
        (this.itemsHolder = document.querySelector(selectors$J.itemsHolder)),
        (this.cartItemsQty = document.querySelector(selectors$J.cartItemsQty)),
        (this.itemsWrapper = document.querySelector(selectors$J.itemsWrapper)),
        (this.items = document.querySelectorAll(selectors$J.item)),
        (this.cartTotal = document.querySelector(selectors$J.cartTotal)),
        (this.cartTotalPrice = document.querySelector(
          selectors$J.cartTotalPrice
        )),
        (this.cartMessage = document.querySelectorAll(selectors$J.cartMessage)),
        (this.cartOriginalTotal = document.querySelector(
          selectors$J.cartOriginalTotal
        )),
        (this.cartErrorHolder = document.querySelector(selectors$J.cartErrors)),
        (this.cartCloseErrorMessage = document.querySelector(
          selectors$J.cartCloseError
        )),
        (this.pairProductsHolder = document.querySelector(
          selectors$J.pairProductsHolder
        )),
        (this.pairProducts = document.querySelector(selectors$J.pairProducts)),
        (this.priceHolder = document.querySelector(selectors$J.priceHolder)),
        (this.upsellHolders = document.querySelectorAll(
          selectors$J.upsellHolder
        )),
        (this.cartTermsCheckbox = document.querySelector(
          selectors$J.cartTermsCheckbox
        )),
        (this.cartCheckoutButtonWrapper = document.querySelector(
          selectors$J.cartCheckoutButtonWrapper
        )),
        (this.cartCheckoutButton = document.querySelector(
          selectors$J.cartCheckoutButton
        )),
        (this.cartForm = document.querySelector(selectors$J.cartForm)),
        (this.cartItemCount = 0),
        (this.subtotal = window.theme.subtotal),
        (this.button = null);
      const { headerInitialHeight, announcementBarHeight } = readHeights();
      (this.headerInitialHeight = headerInitialHeight),
        (this.announcementBarHeight = announcementBarHeight),
        this.cartMessage.length > 0 &&
          (this.cartFreeLimitShipping =
            Number(
              this.cartMessage[0].getAttribute(
                attributes$u.shippingMessageLimit
              )
            ) *
            100 *
            window.Shopify.currency.rate),

        console.log(this.cartFreeLimitShipping),
        this.updateProgress();
    }
    initQuantity() {
      (this.items = document.querySelectorAll(selectors$J.item)),
        this.items?.forEach((item) => {
          new QuantityCounter(item, !0).init(), this.cartUpdateEvent(item);
        });
    }
    cartUpdateEvent(item) {
      item.addEventListener("theme:cart:update", (event2) => {
        this.updateCart(
          { id: event2.detail.id, quantity: event2.detail.quantity },
          item
        );
      });
    }
    cartEvents() {
      const cartItemRemove = document.querySelectorAll(
        selectors$J.cartItemRemove
      );
      (this.totalItems = cartItemRemove.length),
        cartItemRemove?.forEach((button) => {
          const item = button.closest(selectors$J.item);
          button.addEventListener("click", (event2) => {
            event2.preventDefault(),
              !button.classList.contains(classes$A.disabled) &&
                requestAnimationFrame(() => {
                  this.updateCart(
                    { id: item.getAttribute(attributes$u.dataId), quantity: 0 },
                    item
                  );
                });
          });
        }),
        this.cartCloseErrorMessage &&
          (this.cartCloseErrorMessage.removeEventListener(
            "click",
            this.closeCartError
          ),
          this.cartCloseErrorMessage.addEventListener(
            "click",
            this.closeCartError
          )),
        this.cartTermsCheckbox &&
          (this.cartTermsCheckbox.removeEventListener(
            "change",
            this.formSubmitHandler
          ),
          this.cartCheckoutButtonWrapper.removeEventListener(
            "click",
            this.formSubmitHandler
          ),
          this.cartForm.removeEventListener("submit", this.formSubmitHandler),
          this.cartTermsCheckbox.addEventListener(
            "change",
            this.formSubmitHandler
          ),
          this.cartCheckoutButtonWrapper.addEventListener(
            "click",
            this.formSubmitHandler
          ),
          this.cartForm.addEventListener("submit", this.formSubmitHandler));
    }
    cartAddEvent() {
      document.addEventListener("click", (event2) => {
        const clickedElement = event2.target,
          isButtonATC = clickedElement?.matches(selectors$J.buttonAddToCart),
          getButtonATC = clickedElement?.closest(selectors$J.buttonAddToCart);
        if (isButtonATC || getButtonATC) {
          event2.preventDefault(),
            (this.button = isButtonATC ? clickedElement : getButtonATC),
            (this.form = clickedElement.closest("form")),
            (this.recipientErrors =
              this.form?.getAttribute(attributes$u.recipientError) === "true"),
            (this.formWrapper = this.button.closest(selectors$J.formWrapper));
          const isVariantSoldOut = this.formWrapper?.classList.contains(
              classes$A.variantSoldOut
            ),
            isButtonDisabled = this.button.hasAttribute(attributes$u.disabled),
            isQuickViewOnboarding = this.button.closest(
              selectors$J.quickViewOnboarding
            ),
            hasDataAtcTrigger = this.button.hasAttribute(
              attributes$u.atcTrigger
            ),
            hasNotificationPopup = this.button.hasAttribute(
              attributes$u.notificationPopup
            ),
            hasFileInput = this.form?.querySelector('[type="file"]');
          if (isButtonDisabled || hasFileInput || isQuickViewOnboarding) return;
          if (isVariantSoldOut && hasNotificationPopup) {
            new NotificationPopup(this.button);
            return;
          }
          hasDataAtcTrigger && (this.a11y.state.trigger = this.button);
          let hasSubscription = !1;
          const formData = new FormData(this.form);
          let itemIsSub = !0;
          if (
            (clickedElement.closest("#hidden_form") &&
              (console.log(clickedElement.closest("#hidden_form")),
              clickedElement
                .closest("#hidden_form")
                .querySelector("[data-subscription]").disabled &&
                (itemIsSub = !1)),
            document.querySelector("#hidden_form") || (itemIsSub = !1),
            event2.target.classList.contains("product-upsell__btn-progress") &&
              (itemIsSub = !1),
            hasSubscription && itemIsSub)
          ) {
            this.showNotification();
            return;
          }
          this.addToCart(formData),
            document.dispatchEvent(
              new CustomEvent("theme:cart:add", {
                bubbles: !0,
                detail: { selector: clickedElement },
              })
            );
        }
      });
    }
    showNotification() {
      const notification = document.createElement("div");
      notification.classList.add("notification--unabletoadd"),
        (notification.innerHTML = window.theme.strings.notification),
        document.body.appendChild(notification),
        requestAnimationFrame(() => {
          notification.classList.add("is-active");
        }),
        setTimeout(() => {
          notification.classList.remove("is-active"),
            setTimeout(() => {
              notification.remove();
            }, 600);
        }, 5e3);
    }
    getCookie(name) {
      for (
        var nameEQ = name + "=", ca = document.cookie.split(";"), i = 0;
        i < ca.length;
        i++
      ) {
        for (var c = ca[i]; c.charAt(0) == " "; ) c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
    getCart(open) {
      (this.doNotOpen = open),
        this.cartDrawer &&
          !this.isCartDrawerLoaded &&
          this.renderCartDrawer(!1),
        fetch(theme.routes.cart_url + "?section_id=api-cart-items")
          .then(this.handleErrors)
          .then((response) => response.text())
          .then((response) => {
            const element = document.createElement("div");
            element.innerHTML = response;
            const cleanResponse = element.querySelector(selectors$J.apiContent);
            this.build(cleanResponse);
          })
          .catch((error) => console.log(error));
    }
    addToCart(data) {
      this.cartDrawerEnabled &&
        this.button &&
        (this.button.classList.add(classes$A.loading),
        this.button.setAttribute(attributes$u.disabled, !0)),
        fetch(theme.routes.cart_add_url, {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/javascript",
          },
          body: data,
        })
          .then((response) => response.json())
          .then((response) => {
            if (
              ((this.button.disabled = !0),
              this.addLoadingClass(),
              response.status)
            ) {
              this.addToCartError(response),
                this.removeLoadingClass(),
                this.scrollToCartTop();
              return;
            }
            this.hideAddToCartErrorMessage(),
              this.cartDrawerEnabled
                ? this.getCart()
                : (window.location = theme.routes.cart_url);
          })
          .catch((error) => console.log(error));
    }
    updateCart(updateData = {}, currentItem = null) {
      let updatedQuantity = updateData.quantity;
      currentItem !== null &&
        (updatedQuantity
          ? currentItem.classList.add(classes$A.loading)
          : currentItem.classList.add(classes$A.removed)),
        this.disableCartButtons(),
        this.addLoadingClass();
      const newItem =
          this.cart.querySelector(
            `[${attributes$u.item}="${updateData.id}"]`
          ) || currentItem,
        lineIndex = newItem?.hasAttribute(attributes$u.itemIndex)
          ? parseInt(newItem.getAttribute(attributes$u.itemIndex))
          : 0,
        itemTitle = newItem?.hasAttribute(attributes$u.itemTitle)
          ? newItem.getAttribute(attributes$u.itemTitle)
          : null;
      if (lineIndex === 0) return;
      const data = { line: lineIndex, quantity: updatedQuantity };
      fetch(theme.routes.cart_change_url, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          if (response.status === 400) {
            const error = new Error(response.status);
            throw (
              (this.cartDrawerEnabled
                ? this.getCart()
                : (window.location = theme.routes.cart_url),
              error)
            );
          }
          return response.text();
        })
        .then((state) => {
          if (JSON.parse(state).errors) {
            (this.cartUpdateFailed = !0),
              this.updateErrorText(itemTitle),
              this.toggleErrorMessage(),
              this.resetLineItem(currentItem),
              this.enableCartButtons(),
              this.removeLoadingClass(),
              this.scrollToCartTop();
            return;
          }
          this.getCart();
        })
        .catch((error) => {
          console.log(error),
            this.enableCartButtons(),
            this.removeLoadingClass();
        });
    }
    resetLineItem(item) {
      const qtyInput = item.querySelector(selectors$J.qtyInput),
        qty = qtyInput.getAttribute("value");
      (qtyInput.value = qty), item.classList.remove(classes$A.loading);
    }
    disableCartButtons() {
      const inputs = this.cart.querySelectorAll("input"),
        buttons = this.cart.querySelectorAll(
          `button, ${selectors$J.cartItemRemove}`
        );
      inputs.length &&
        inputs.forEach((item) => {
          item.classList.add(classes$A.disabled),
            item.blur(),
            (item.disabled = !0);
        }),
        buttons.length &&
          buttons.forEach((item) => {
            item.setAttribute(attributes$u.disabled, !0);
          });
    }
    enableCartButtons() {
      const inputs = this.cart.querySelectorAll("input"),
        buttons = this.cart.querySelectorAll(
          `button, ${selectors$J.cartItemRemove}`
        );
      inputs.length &&
        inputs.forEach((item) => {
          item.classList.remove(classes$A.disabled), (item.disabled = !1);
        }),
        buttons.length &&
          buttons.forEach((item) => {
            item.removeAttribute(attributes$u.disabled);
          });
    }
    updateErrorText(itemTitle) {
      this.cartErrorHolder.querySelector(selectors$J.errorMessage).innerText =
        itemTitle;
    }
    toggleErrorMessage() {
      if (this.cartErrorHolder) {
        if (
          (this.cartErrorHolder.classList.toggle(
            classes$A.expanded,
            this.cartUpdateFailed
          ),
          this.cartUpdateFailed)
        ) {
          const cartCloseError = this.cartErrorHolder.querySelector(
            selectors$J.cartCloseError
          );
          this.focusOnErrorMessage(this.cartErrorHolder, cartCloseError);
        }
        this.cartUpdateFailed = !1;
      }
    }
    handleErrors(response) {
      return response.ok
        ? response
        : response.json().then(function (json) {
            throw new FetchError({
              status: response.statusText,
              headers: response.headers,
              json,
            });
          });
    }
    addToCartError(data) {
      const buttonQuickBuyForm = this.button.closest(selectors$J.quickBuyForm),
        buttonUpsellHolder = this.button.closest(selectors$J.upsellHolder),
        isFocusEnabled = !document.body.classList.contains(classes$A.noOutline);
      let errorContainer = (
        this.button.closest(selectors$J.productForm)
          ? this.button.closest(selectors$J.productForm)
          : this.button.closest(selectors$J.upsellHolder)
      ).querySelector(selectors$J.formErrorsContainer);
      buttonUpsellHolder &&
        (errorContainer = buttonUpsellHolder.querySelector(
          selectors$J.formErrorsContainer
        )),
        this.cartDrawerEnabled &&
          this.button &&
          this.button.closest(selectors$J.cartDrawer) !== null &&
          !this.button.closest(selectors$J.cartDrawer) &&
          this.closeCartDrawer(),
        this.button.classList.remove(classes$A.loading),
        this.button.removeAttribute(attributes$u.disabled);
      const closeErrorButton = buttonQuickBuyForm
        ? ""
        : `
      <button type="button" class="errors__button-close" data-close-error>
        ${theme.icons.close}
      </button>
    `;
      let errorMessages = `${data.message}: ${data.description}`;
      if (
        (data.message === data.description && (errorMessages = data.message),
        this.recipientErrors &&
          data.description &&
          typeof data.description == "object" &&
          (errorMessages = Object.entries(data.description)
            .map(([key, value]) => `${value}`)
            .join("<br>")),
        (errorContainer.innerHTML = `
      <div class="errors" data-error autofocus>
        ${errorMessages}
        ${closeErrorButton}
      </div>
    `),
        buttonQuickBuyForm)
      ) {
        const productMediaContainer = errorContainer.closest(
          selectors$J.productMediaContainer
        );
        productMediaContainer.classList.add(classes$A.productGridImageError),
          errorContainer
            .querySelector(selectors$J.error)
            .addEventListener("animationend", () => {
              productMediaContainer.classList.remove(
                classes$A.productGridImageError
              ),
                (errorContainer.innerHTML = ""),
                isFocusEnabled || document.activeElement.blur();
            });
      } else
        errorContainer.classList.add(classes$A.visible),
          errorContainer.addEventListener("transitionend", () => {
            this.resizeSliders(errorContainer);
          }),
          this.handleCloseErrorMessages(errorContainer);
    }
    handleCloseErrorMessages(container) {
      const formErrorClose = container.querySelector(
        selectors$J.formCloseError
      );
      formErrorClose?.addEventListener("click", (event2) => {
        const clickedElement = event2.target;
        (clickedElement.matches(selectors$J.formCloseError) ||
          clickedElement.closest(selectors$J.formCloseError)) &&
          (event2.preventDefault(),
          container.classList.remove(classes$A.visible),
          container
            .querySelector(selectors$J.error)
            .addEventListener("transitionend", () => {
              (container.innerHTML = ""), this.resizeSliders(clickedElement);
            }));
      }),
        this.focusOnErrorMessage(container, formErrorClose);
    }
    focusOnErrorMessage(container, button) {
      document.body.classList.contains(classes$A.noOutline) ||
        container.addEventListener("transitionend", () => {
          requestAnimationFrame(() => button?.focus({ focusVisible: !0 }));
        });
    }
    hideAddToCartErrorMessage() {
      (this.button.closest(selectors$J.upsellHolder)
        ? this.button.closest(selectors$J.upsellHolder)
        : this.button.closest(selectors$J.productForm)
      )
        ?.querySelector(selectors$J.formErrorsContainer)
        ?.classList.remove(classes$A.visible);
    }
    resizeSliders(element) {
      const slider2 = element.closest(selectors$J.flickityEnabled);
      if (!slider2) return;
      const flkty = Flickity.data(slider2);
      requestAnimationFrame(() => flkty.resize());
    }
    renderCartDrawer(alwaysOpen = !0) {
      const cartDrawerTemplate = document.querySelector(
        selectors$J.cartDrawerTemplate
      );
      cartDrawerTemplate &&
        ((this.cartDrawer.innerHTML = cartDrawerTemplate.innerHTML),
        this.assignArguments(),
        this.initQuantity(),
        this.cartEvents(),
        this.buttonHolder &&
          (this.collapsible = new Collapsible(this.buttonHolder)),
        (this.cartDrawerToggle = this.cartDrawer.querySelector(
          selectors$J.cartDrawerToggle
        )),
        this.cartDrawerToggle.addEventListener(
          "click",
          this.cartDrawerToggleClickEvent
        ),
        (this.isCartDrawerLoaded = !0),
        this.renderPairProducts(),
        document.dispatchEvent(
          new CustomEvent("theme:cart:loaded", { bubbles: !0 })
        ),
        alwaysOpen && this.openCartDrawer());
    }
    openCartDrawer() {
      lsgSlideCartOpen();
      // if (!this.isCartDrawerOpen) {
      //   if (!this.isCartDrawerLoaded) {
      //     this.renderCartDrawer();
      //     return;
      //   }
      //   // document.dispatchEvent(
      //   //   new CustomEvent("theme:cart:open", { bubbles: !0 })
      //   // ),
      //     // document.dispatchEvent(
      //     //   new CustomEvent("theme:scroll:lock", {
      //     //     bubbles: !0,
      //     //     detail: this.cartDrawer,
      //     //   })
      //     // ),
      //     // document.dispatchEvent(
      //     //   new CustomEvent("theme:scroll:lock", {
      //     //     bubbles: !0,
      //     //     detail: this.cartDrawerBody,
      //     //   })
      //     // ),
      //     // this.scrollToCartTop(),
      //     // document.body.classList.add(classes$A.cartDrawerOpen),
      //     // this.cartDrawer.classList.add(classes$A.open),
      //     // this.cartDrawer.classList.remove(classes$A.contentVisibilityHidden),
      //     // requestAnimationFrame(() => this.animateCartItems("in")),
      //     // this.cartToggleButtons.forEach((button) => {
      //     //   button.setAttribute(attributes$u.ariaExpanded, !0);
      //     // }),
      //     // this.a11y.trapFocus({ container: this.cartDrawer }),
      //     // this.observeAdditionalCheckoutButtons(),
      //     // (this.isCartDrawerOpen = !0);
      // }
    }
    animateCartItems(state = "in") {
      const items = this.cart.querySelectorAll(selectors$J.aos);
      state === "in" &&
        items.forEach((item) =>
          requestAnimationFrame(() => item.classList.add(classes$A.aosAnimate))
        ),
        state === "out" &&
          items.forEach((item) => item.classList.remove(classes$A.aosAnimate));
    }
    closeCartDrawer() {
      if (!this.isCartDrawerOpen) return;
      document.dispatchEvent(
        new CustomEvent("theme:cart:close", { bubbles: !0 })
      ),
        this.cartErrorHolder.classList.remove(classes$A.expanded),
        this.a11y.removeTrapFocus(),
        this.cartToggleButtons.forEach((button) => {
          button.setAttribute(attributes$u.ariaExpanded, !1);
        }),
        document.body.classList.remove(classes$A.cartDrawerOpen),
        this.cartDrawer.classList.remove(classes$A.open),
        this.itemsHolder.classList.remove(classes$A.updated);
      const onCartDrawerTransitionEnd = (event2) => {
        event2.target === this.cartDrawer &&
          (this.animateCartItems("out"),
          this.cartDrawer.removeEventListener(
            "transitionend",
            onCartDrawerTransitionEnd
          ));
      };
      this.cartDrawer.addEventListener(
        "transitionend",
        onCartDrawerTransitionEnd
      ),
        !document.body.classList.contains(classes$A.noOutline) ||
          requestAnimationFrame(() => {
            document.activeElement.blur();
          });
      const timeout = 400;
      document.dispatchEvent(
        new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: timeout })
      ),
        (this.isCartDrawerOpen = !1);
    }
    toggleCartDrawer() {
      this.isCartDrawerOpen ? this.closeCartDrawer() : this.openCartDrawer();
    }
    cartDrawerToggleEvents() {
      this.cartDrawer &&
        (this.cartDrawer.addEventListener("keyup", (event2) => {
          event2.code === theme.keyboardKeys.ESCAPE && this.closeCartDrawer();
        }),
        (this.cartDrawerToggleClickEvent = (event2) => {
          event2.preventDefault();
          const button = event2.target;
          button.getAttribute(attributes$u.ariaExpanded) === "false" &&
            (this.a11y.state.trigger = button),
            this.toggleCartDrawer();
        }),
        (this.cartDrawerCloseEvent = (event2) => {
          const isCartDrawerToggle = event2.target.matches(
              selectors$J.cartDrawerToggle
            ),
            isCartDrawerChild = document
              .querySelector(selectors$J.cartDrawer)
              .contains(event2.target),
            isPopupQuickView = event2.target.closest(
              selectors$J.popupQuickView
            );
          !isCartDrawerToggle &&
            !isCartDrawerChild &&
            !isPopupQuickView &&
            this.closeCartDrawer();
        }),
        this.cartToggleButtons.forEach((button) => {
          button.addEventListener("click", this.cartDrawerToggleClickEvent);
        }),
        document.addEventListener("mousedown", this.cartDrawerCloseEvent));
    }
    toggleClassesOnContainers() {
      const that = this;
      this.emptyMessage.classList.toggle(
        classes$A.hidden,
        that.hasItemsInCart()
      ),
        this.buttonHolder.classList.toggle(
          classes$A.hidden,
          !that.hasItemsInCart()
        ),
        this.itemsHolder.classList.toggle(
          classes$A.hidden,
          !that.hasItemsInCart()
        ),
        this.cartItemsQty.classList.toggle(
          classes$A.hidden,
          !that.hasItemsInCart()
        );
    }
    build(data) {
      const cartItemsData = data.querySelector(selectors$J.apiLineItems),
        upsellItemsData = data.querySelector(selectors$J.apiUpsellItems),
        cartEmptyData = cartItemsData === null && upsellItemsData === null,
        priceData = data.querySelector(selectors$J.apiCartPrice),
        cartTotal = data.querySelector(selectors$J.cartTotal);
      this.priceHolder &&
        priceData &&
        (this.priceHolder.innerHTML = priceData.innerHTML),
        this.animateCartItems("out"),
        cartEmptyData
          ? ((this.itemsHolder.innerHTML = ""),
            this.pairProductsHolder && (this.pairProductsHolder.innerHTML = ""))
          : ((this.itemsHolder.innerHTML = cartItemsData.innerHTML),
            this.pairProductsHolder &&
              (this.pairProductsHolder.innerHTML = upsellItemsData.innerHTML),
            this.renderPairProducts()),
        (this.newTotalItems =
          cartItemsData &&
          cartItemsData.querySelectorAll(selectors$J.item).length
            ? cartItemsData.querySelectorAll(selectors$J.item).length
            : 0),
        (this.subtotal =
          cartTotal && cartTotal.hasAttribute(attributes$u.cartTotal)
            ? parseInt(cartTotal.getAttribute(attributes$u.cartTotal))
            : 0),
        (this.cartCount = this.getCartItemCount()),
        this.cartMessage.length > 0 && this.updateProgress(),
        this.cartToggleButtons.forEach((button) => {
          button.classList.remove(classes$A.cartItems),
            this.newTotalItems > 0 && button.classList.add(classes$A.cartItems);
        }),
        this.toggleErrorMessage(),
        this.updateItemsQuantity(this.cartCount),
        (this.cartTotalPrice.innerHTML =
          this.subtotal === 0
            ? window.theme.strings.free
            : themeCurrency.formatMoney(
                this.subtotal,
                theme.moneyWithCurrencyFormat
              )),
        this.totalItems !== this.newTotalItems &&
          ((this.totalItems = this.newTotalItems),
          this.toggleClassesOnContainers()),
        (this.isCartDrawerOpen || this.isCartPage) &&
          this.itemsHolder.classList.add(classes$A.updated),
        this.cartEvents(),
        this.initQuantity(),
        this.enableCartButtons(),
        this.resetButtonClasses(),
        this.removeLoadingClass(),
        document.dispatchEvent(
          new CustomEvent("theme:cart:added", { bubbles: !0 })
        ),
        this.cartDrawer && this.doNotOpen != !0 && this.openCartDrawer(),
        requestAnimationFrame(() => this.animateCartItems("in"));
    }
    getCartItemCount() {
      return this.cart
        ? Array.from(this.cart.querySelectorAll(selectors$J.qtyInput)).reduce(
            (total, quantityInput) => total + parseInt(quantityInput.value),
            0
          )
        : 0;
    }
    hasItemsInCart() {
      return this.totalItems > 0;
    }
    freeShippingMessageHandle(total) {
      this.cartMessage.length > 0 &&
        document
          .querySelectorAll(selectors$J.cartMessage)
          .forEach((message) => {
            const hasFreeShipping =
                message.hasAttribute(attributes$u.cartMessageValue) &&
                message.getAttribute(attributes$u.cartMessageValue) ===
                  "true" &&
                total !== 0,
              cartMessageDefault = message.querySelector(
                selectors$J.cartMessageDefault
              );
            message.classList.toggle(
              classes$A.success,
              total >= this.cartFreeLimitShipping && hasFreeShipping
            ),
              message.classList.toggle(classes$A.isHidden, total === 0),
              cartMessageDefault.classList.toggle(
                classes$A.isHidden,
                total >= this.cartFreeLimitShipping
              );
          });
    }
    updateProgress() {
      const newPercentValue =
          (this.subtotal / this.cartFreeLimitShipping) * 100,
        leftToSpend = theme.settings.currency_code_enable
          ? themeCurrency.formatMoney(
              this.cartFreeLimitShipping - this.subtotal,
              theme.moneyWithCurrencyFormat
            )
          : themeCurrency.formatMoney(
              this.cartFreeLimitShipping - this.subtotal,
              theme.moneyFormat
            );
      this.cartMessage.length > 0 &&
        document
          .querySelectorAll(selectors$J.cartMessage)
          .forEach((message) => {
            const cartMessageProgressItems = message.querySelectorAll(
                selectors$J.cartProgress
              ),
              leftToSpendMessage = message.querySelector(
                selectors$J.leftToSpend
              );
            leftToSpendMessage &&
              (leftToSpendMessage.innerHTML = leftToSpend
                .replace(".00", "")
                .replace(",00", "")),
              cartMessageProgressItems.length &&
                cartMessageProgressItems.forEach(
                  (cartMessageProgress, index) => {
                    cartMessageProgress.classList.toggle(
                      classes$A.isHidden,
                      this.subtotal / this.cartFreeLimitShipping >= 1
                    ),
                      cartMessageProgress.style.setProperty(
                        "--progress-width",
                        `${newPercentValue}%`
                      ),
                      index === 0 &&
                        cartMessageProgress.setAttribute(
                          attributes$u.value,
                          newPercentValue
                        );
                  }
                ),
              this.freeShippingMessageHandle(this.subtotal);
          });
    }
    renderPairProducts() {
      if (
        ((this.flktyUpsell = null),
        (this.pairProductsHolder = document.querySelector(
          selectors$J.pairProductsHolder
        )),
        (this.pairProducts = document.querySelector(selectors$J.pairProducts)),
        (this.upsellHolders = document.querySelectorAll(
          selectors$J.upsellHolder
        )),
        this.pairProductsHolder === null || this.pairProductsHolder === void 0)
      )
        return;
      const that = this;
      if (this.upsellHolders.length > 1) {
        this.flktyUpsell = new Flickity(this.pairProducts, {
          wrapAround: !0,
          pageDots: !0,
          adaptiveHeight: !0,
          prevNextButtons: !1,
          on: {
            ready: function () {
              new QuickViewPopup(that.cart),
                this.reloadCells(),
                requestAnimationFrame(() => this.resize());
            },
          },
        });
        return;
      }
      new QuickViewPopup(this.cart);
    }
    updateItemsQuantity(itemsQty) {
      let oneItemText = theme.strings.cart_items_one,
        manyItemsText = theme.strings.cart_items_many;
      (oneItemText = oneItemText.split("}}")[1]),
        (manyItemsText = manyItemsText.split("}}")[1]),
        this.cartItemsQty &&
          (this.cartItemsQty.textContent =
            itemsQty === 1
              ? `${itemsQty} ${oneItemText}`
              : `${itemsQty} ${manyItemsText}`);
    }
    observeAdditionalCheckoutButtons() {
      const additionalCheckoutButtons = this.cart.querySelector(
        selectors$J.additionalCheckoutButtons
      );
      if (additionalCheckoutButtons) {
        const observer = new MutationObserver(() => {
          this.a11y.removeTrapFocus(),
            this.a11y.trapFocus({ container: this.cart }),
            observer.disconnect();
        });
        observer.observe(additionalCheckoutButtons, {
          subtree: !0,
          childList: !0,
        });
      }
    }
    formSubmitHandler() {
      const termsAccepted = document.querySelector(
          selectors$J.cartTermsCheckbox
        ).checked,
        termsError = document.querySelector(selectors$J.termsErrorMessage);
      if (termsAccepted)
        termsError.classList.remove(classes$A.expanded),
          this.cartCheckoutButton.removeAttribute(attributes$u.disabled);
      else {
        if (document.querySelector(selectors$J.termsErrorMessage).length > 0)
          return;
        (termsError.innerText = theme.strings.cart_acceptance_error),
          this.cartCheckoutButton.setAttribute(attributes$u.disabled, !0),
          termsError.classList.add(classes$A.expanded);
      }
    }
    resetButtonClasses() {
      const buttons = document.querySelectorAll(selectors$J.buttonAddToCart);
      buttons &&
        buttons.forEach((button) => {
          button.classList.contains(classes$A.loading) &&
            (button.classList.remove(classes$A.loading),
            button.classList.add(classes$A.success),
            setTimeout(() => {
              button.removeAttribute(attributes$u.disabled),
                button.classList.remove(classes$A.success);
            }, settings$4.timers.addProductTimeout));
        });
    }
    addLoadingClass() {
      this.cartDrawer
        ? this.cartDrawer.classList.add(classes$A.loading)
        : this.itemsWrapper &&
          this.itemsWrapper.classList.add(classes$A.loading);
    }
    removeLoadingClass() {
      this.cartDrawer
        ? this.cartDrawer.classList.remove(classes$A.loading)
        : this.itemsWrapper &&
          this.itemsWrapper.classList.remove(classes$A.loading);
    }
    scrollToCartTop() {
      if (this.cartDrawer) {
        this.cartDrawerBody.scrollTo({ top: 0, left: 0, behavior: "instant" });
        return;
      }
      window.scrollTo({
        top:
          this.outerSection?.offsetTop -
          this.headerInitialHeight -
          this.announcementBarHeight,
        left: 0,
        behavior: "smooth",
      });
    }
    unload() {
      this.cartDrawerToggle &&
        this.cartDrawerToggle.removeEventListener(
          "click",
          this.cartDrawerToggleClickEvent
        ),
        this.cartToggleButtons.forEach((button) => {
          button.removeEventListener("click", this.cartDrawerToggleClickEvent);
        }),
        document.removeEventListener("mousedown", this.cartDrawerCloseEvent),
        this.collapsible !== null && this.collapsible.onUnload();
    }
  }
  register("cart-template", {
    onLoad() {
      sections$w[this.id] = new CartDrawer();
    },
    onUnload() {
      typeof sections$w[this.id].unload == "function" &&
        sections$w[this.id].unload();
    },
  });
  const selectors$I = { scrollToTop: "[data-scroll-top-button]" },
    classes$z = { isVisible: "is-visible" },
    scrollTopButton = document.querySelector(selectors$I.scrollToTop);
  scrollTopButton &&
    (scrollTopButton.addEventListener("click", () => {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }),
    document.addEventListener(
      "scroll",
      throttle(() => {
        scrollTopButton.classList.toggle(
          classes$z.isVisible,
          window.pageYOffset > window.innerHeight
        );
      }, 150)
    ));
  const selectors$H = {
      details: "details",
      popdownBody: "[data-popdown-body]",
      popdownClose: "[data-popdown-close]",
      popdownToggle: "[data-popdown-toggle]",
      searchFormInner: "[data-search-form-inner]",
      input: 'input:not([type="hidden"])',
      popularSearchesLink: "[data-popular-searches-link]",
      header: "[data-site-header]",
      nav: "[data-nav]",
      navItemsCompress: "[data-nav-items-compress]",
      navIcons: "[data-nav-icons]",
      mobileMenu: "[data-mobile-menu]",
      predictiveSearch: "predictive-search",
      searchForm: "search-form",
    },
    attributes$t = {
      popdownInHeader: "data-popdown-in-header",
      popdownInPage: "data-popdown-in-page",
      searchPerformed: "data-search-performed",
      ariaActivedescendant: "aria-activedescendant",
      ariaExpanded: "aria-expanded",
      open: "open",
      role: "role",
    },
    classes$y = {
      searchOpened: "search-opened",
      headerMenuOpened: "site-header--menu-opened",
      headerCompress: "site-header--compress",
      open: "is-open",
    };
  class SearchPopdown extends HTMLElement {
    constructor() {
      super(),
        (this.isPopdownInHeader = this.hasAttribute(
          attributes$t.popdownInHeader
        )),
        (this.isPopdownInPage = this.hasAttribute(attributes$t.popdownInPage)),
        (this.popdownBody = this.querySelector(selectors$H.popdownBody)),
        (this.popdownClose = this.querySelector(selectors$H.popdownClose)),
        (this.searchFormInner = this.querySelector(
          selectors$H.searchFormInner
        )),
        (this.popularSearchesLink = this.querySelectorAll(
          selectors$H.popularSearchesLink
        )),
        (this.searchFormWrapper = this.querySelector(selectors$H.searchForm)
          ? this.querySelector(selectors$H.searchForm)
          : this.querySelector(selectors$H.predictiveSearch)),
        (this.predictiveSearch = this.searchFormWrapper.matches(
          selectors$H.predictiveSearch
        )),
        (this.header = document.querySelector(selectors$H.header)),
        (this.headerSection = this.header?.parentNode),
        (this.nav = this.header?.querySelector(selectors$H.nav)),
        (this.mobileMenu = this.headerSection?.querySelector(
          selectors$H.mobileMenu
        )),
        (this.a11y = a11y),
        (this.ensureClosingOnResizeEvent = () => this.ensureClosingOnResize()),
        (this.popdownTransitionCallbackEvent = (event2) =>
          this.popdownTransitionCallback(event2)),
        (this.detailsToggleCallbackEvent = (event2) =>
          this.detailsToggleCallback(event2)),
        this.isPopdownInHeader &&
          ((this.details = this.querySelector(selectors$H.details)),
          (this.popdownToggle = this.querySelector(selectors$H.popdownToggle)));
    }
    connectedCallback() {
      this.isPopdownInHeader &&
        (this.searchFormInner.addEventListener(
          "transitionend",
          this.popdownTransitionCallbackEvent
        ),
        this.details.addEventListener(
          "keyup",
          (event2) => event2.code.toUpperCase() === "ESCAPE" && this.close()
        ),
        this.details.addEventListener(
          "toggle",
          this.detailsToggleCallbackEvent
        ),
        this.popdownClose.addEventListener("click", (event2) =>
          this.close(event2)
        ),
        this.popdownToggle.addEventListener("click", (event2) =>
          this.onPopdownToggleClick(event2)
        ),
        this.popdownToggle.setAttribute(attributes$t.role, "button")),
        this.isPopdownInPage &&
          (this.popdownClose.addEventListener("click", () =>
            this.triggerPopdownClose()
          ),
          this.searchFormWrapper.addEventListener("focusout", () =>
            this.onFocusOut()
          ),
          this.searchFormWrapper.input.addEventListener("click", (event2) =>
            this.triggerPopdownOpen(event2)
          )),
        this.popularSearchesLink.forEach((element) => {
          element.addEventListener("click", (event2) => {
            event2.preventDefault();
            const popularSearchText = event2.target.textContent;
            (this.searchFormWrapper.input.value = popularSearchText),
              this.searchFormWrapper.submit();
          });
        });
    }
    onPopdownToggleClick(event2) {
      const isChrome = navigator.userAgent.includes("Chrome"),
        isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      isChrome &&
        !isIOS &&
        event2.target
          .closest(selectors$H.details)
          .setAttribute(attributes$t.open, ""),
        event2.target
          .closest(selectors$H.details)
          .hasAttribute(attributes$t.open) &&
          (event2.preventDefault(), this.close());
    }
    detailsToggleCallback(event2) {
      event2.target.hasAttribute(attributes$t.open) && this.open();
    }
    popdownTransitionCallback(event2) {
      event2.target === this.searchFormInner &&
        (this.details.classList.contains(classes$y.open)
          ? event2.propertyName === "transform" &&
            this.a11y.trapFocus({ container: this.searchFormInner })
          : this.onClose());
    }
    onBodyClick(event2) {
      const isTargetInPopdown = this.contains(event2.target);
      this.header?.classList.contains(classes$y.headerMenuOpened) ||
        isTargetInPopdown ||
        isTargetInPopdown ||
        this.close();
    }
    onFocusOut() {
      this.predictiveSearch &&
        requestAnimationFrame(() => {
          this.searchFormWrapper.contains(document.activeElement) ||
            this.searchFormWrapper.close();
        });
    }
    triggerPopdownOpen(event2) {
      const isSearchPageWithoutTerms = this.closest(
        `[${attributes$t.searchPerformed}="false"]`
      );
      let isTouch2 = matchMedia("(pointer:coarse)").matches;
      const viewportMobile = window.innerWidth < theme.sizes.small,
        shouldOpenPopdownOnTouchDevice = isTouch2 || viewportMobile,
        shouldOpenPopdownOnNoTerms = isSearchPageWithoutTerms != null;
      if (
        (viewportMobile && window.Shopify.designMode && (isTouch2 = !0),
        !(!this.nav || !this.mobileMenu) &&
          (shouldOpenPopdownOnTouchDevice || shouldOpenPopdownOnNoTerms))
      ) {
        event2.preventDefault();
        const isHeaderCompressed = this.header.classList.contains(
          classes$y.headerCompress
        );
        let popdownToggle = this.mobileMenu.querySelector(
          selectors$H.popdownToggle
        );
        isTouch2 ||
          (popdownToggle = isHeaderCompressed
            ? this.nav.querySelector(
                `${selectors$H.navItemsCompress} ${selectors$H.popdownToggle}`
              )
            : this.nav.querySelector(
                `${selectors$H.navIcons} ${selectors$H.popdownToggle}`
              )),
          setTimeout(() => {
            popdownToggle?.dispatchEvent(new Event("click", { bubbles: !0 }));
          }, 300);
      }
    }
    open() {
      (this.onBodyClickEvent = (event2) => this.onBodyClick(event2)),
        this.searchFormWrapper.input.setAttribute(
          attributes$t.ariaExpanded,
          !0
        ),
        document.body.classList.add(classes$y.searchOpened),
        document.body.addEventListener("click", this.onBodyClickEvent),
        document.addEventListener(
          "theme:resize",
          this.ensureClosingOnResizeEvent
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", { bubbles: !0 })
        ),
        requestAnimationFrame(() => {
          this.details.classList.add(classes$y.open);
        });
    }
    close(event2) {
      (event2 &&
        event2.target === this.popdownClose &&
        this.searchFormWrapper.input.getAttribute(
          attributes$t.ariaActivedescendant
        ) !== "") ||
        (this.a11y.removeTrapFocus(),
        this.details.classList.remove(classes$y.open),
        this.predictiveSearch && this.searchFormWrapper.close(),
        this.searchFormWrapper.handleFocusableDescendants(!0));
    }
    triggerPopdownClose() {
      this.predictiveSearch && this.searchFormWrapper.close(),
        this.searchFormWrapper.popularSearches &&
          requestAnimationFrame(() => document.activeElement.blur());
    }
    onClose() {
      this.details.removeAttribute(attributes$t.open),
        document.dispatchEvent(
          new CustomEvent("theme:search:close", { bubbles: !0 })
        ),
        document.body.classList.remove(classes$y.searchOpened),
        document.body.removeEventListener("click", this.onBodyClickEvent),
        document.removeEventListener(
          "theme:resize",
          this.ensureClosingOnResizeEvent
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        );
    }
    ensureClosingOnResize() {
      this.offsetParent === null && this.onClose();
    }
  }
  customElements.define("search-popdown", SearchPopdown),
    (Shopify.Products = (function () {
      const config = {
        howManyToShow: 4,
        howManyToStoreInMemory: 10,
        wrapperId: "recently-viewed-products",
        section: null,
        onComplete: null,
      };
      let productHandleQueue = [],
        wrapper = null,
        howManyToShowItems = null;
      const today = new Date(),
        expiresDate = new Date();
      expiresDate.setTime(today.getTime() + 36e5 * 24 * 90);
      const cookie = {
          configuration: {
            expires: expiresDate.toGMTString(),
            path: "/",
            domain: window.location.hostname,
            sameSite: "none",
            secure: !0,
          },
          name: "shopify_recently_viewed",
          write: function (recentlyViewed) {
            const recentlyViewedString = recentlyViewed.join(" ");
            document.cookie = `${this.name}=${recentlyViewedString}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
          },
          read: function () {
            let recentlyViewed = [],
              cookieValue = null;
            return (
              document.cookie.indexOf("; ") !== -1 &&
                document.cookie
                  .split("; ")
                  .find((row) => row.startsWith(this.name)) &&
                (cookieValue = document.cookie
                  .split("; ")
                  .find((row) => row.startsWith(this.name))
                  .split("=")[1]),
              cookieValue !== null && (recentlyViewed = cookieValue.split(" ")),
              recentlyViewed
            );
          },
          destroy: function () {
            document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
          },
          remove: function (productHandle) {
            const recentlyViewed = this.read(),
              position = recentlyViewed.indexOf(productHandle);
            position !== -1 &&
              (recentlyViewed.splice(position, 1), this.write(recentlyViewed));
          },
        },
        finalize = (wrapper2, section) => {
          showElement(wrapper2, !0);
          const cookieItemsLength = cookie.read().length;
          if (
            Shopify.recentlyViewed &&
            howManyToShowItems &&
            cookieItemsLength &&
            cookieItemsLength < howManyToShowItems &&
            wrapper2.children.length
          ) {
            let allClassesArr = [],
              addClassesArr = [],
              objCounter = 0;
            for (const property in Shopify.recentlyViewed) {
              objCounter += 1;
              const objArr = Shopify.recentlyViewed[property].split(" "),
                propertyIdx = parseInt(property.split("_")[1]);
              (allClassesArr = [...allClassesArr, ...objArr]),
                (cookie.read().length === propertyIdx ||
                  (objCounter === Object.keys(Shopify.recentlyViewed).length &&
                    !addClassesArr.length)) &&
                  (addClassesArr = [...addClassesArr, ...objArr]);
            }
            for (let i = 0; i < wrapper2.children.length; i++) {
              const element = wrapper2.children[i];
              allClassesArr.length &&
                element.classList.remove(...allClassesArr),
                addClassesArr.length && element.classList.add(...addClassesArr);
            }
          }
          if (config.onComplete)
            try {
              config.onComplete(wrapper2, section);
            } catch (error) {
              console.log(error);
            }
        },
        moveAlong = (shown, productHandleQueue2, wrapper2, section) => {
          productHandleQueue2.length && shown < config.howManyToShow
            ? fetch(
                `${window.theme.routes.root}products/${productHandleQueue2[0]}?section_id=api-product-grid-item`
              )
                .then((response) => response.text())
                .then((product) => {
                  const aosDelay = shown * 150,
                    aosAnchor = wrapper2.id ? `#${wrapper2.id}` : "",
                    fresh = document.createElement("div");
                  let productReplaced = product;
                  if (productReplaced.includes("data-unpublished")) {
                    cookie.remove(productHandleQueue2[0]),
                      productHandleQueue2.shift(),
                      moveAlong(shown, productHandleQueue2, wrapper2, section);
                    return;
                  }
                  (productReplaced = productReplaced.includes(
                    "||itemAosDelay||"
                  )
                    ? productReplaced.replaceAll("||itemAosDelay||", aosDelay)
                    : productReplaced),
                    (productReplaced = productReplaced.includes(
                      "||itemAosAnchor||"
                    )
                      ? productReplaced.replaceAll(
                          "||itemAosAnchor||",
                          aosAnchor
                        )
                      : productReplaced),
                    (fresh.innerHTML = productReplaced),
                    (wrapper2.innerHTML +=
                      fresh.querySelector("[data-api-content]").innerHTML),
                    productHandleQueue2.shift(),
                    shown++,
                    moveAlong(shown, productHandleQueue2, wrapper2, section);
                })
                .catch(() => {
                  cookie.remove(productHandleQueue2[0]),
                    productHandleQueue2.shift(),
                    moveAlong(shown, productHandleQueue2, wrapper2, section);
                })
            : finalize(wrapper2, section);
        };
      return {
        showRecentlyViewed: function (params) {
          const paramsNew = params || {},
            shown = 0;
          Object.assign(config, paramsNew),
            (productHandleQueue = cookie.read()),
            (wrapper = document.querySelector(`#${config.wrapperId}`)),
            (howManyToShowItems = config.howManyToShow),
            (config.howManyToShow = Math.min(
              productHandleQueue.length,
              config.howManyToShow
            )),
            config.howManyToShow &&
              wrapper &&
              moveAlong(shown, productHandleQueue, wrapper, config.section);
        },
        getConfig: function () {
          return config;
        },
        clearList: function () {
          cookie.destroy();
        },
        recordRecentlyViewed: function (params) {
          Object.assign(config, params || {});
          let recentlyViewed = cookie.read();
          if (window.location.pathname.indexOf("/products/") !== -1) {
            let productHandle = decodeURIComponent(window.location.pathname)
              .match(
                /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/
              )[0]
              .split("/products/")[1];
            config.handle && (productHandle = config.handle);
            const position = recentlyViewed.indexOf(productHandle);
            position === -1
              ? (recentlyViewed.unshift(productHandle),
                (recentlyViewed = recentlyViewed.splice(
                  0,
                  config.howManyToStoreInMemory
                )))
              : (recentlyViewed.splice(position, 1),
                recentlyViewed.unshift(productHandle)),
              cookie.write(recentlyViewed);
          }
        },
        hasProducts: cookie.read().length > 0,
      };
    })()),
    (theme.ProductModel = (function () {
      let modelJsonSections = {},
        models = {},
        xrButtons = {};
      const selectors2 = {
          productMediaWrapper: "[data-product-single-media-wrapper]",
          mediaGroup: "[data-product-single-media-group]",
          productXr: "[data-shopify-xr]",
          mediaId: "data-media-id",
          model3d: "data-shopify-model3d-id",
          modelViewer: "model-viewer",
          modelJson: "#ModelJson-",
          deferredMedia: "[data-deferred-media]",
          deferredMediaButton: "[data-deferred-media-button]",
        },
        classes2 = { isLoading: "is-loading", mediaHidden: "media--hidden" };
      function init(mediaContainer, sectionId) {
        modelJsonSections[sectionId] = { loaded: !1 };
        const deferredMediaButton = mediaContainer.querySelector(
          selectors2.deferredMediaButton
        );
        deferredMediaButton &&
          deferredMediaButton.addEventListener(
            "click",
            loadContent.bind(this, mediaContainer, sectionId)
          );
      }
      function loadContent(mediaContainer, sectionId) {
        if (
          mediaContainer
            .querySelector(selectors2.deferredMedia)
            .getAttribute("loaded")
        )
          return;
        mediaContainer.classList.add(classes2.isLoading);
        const content = document.createElement("div");
        content.appendChild(
          mediaContainer
            .querySelector("template")
            .content.firstElementChild.cloneNode(!0)
        );
        const modelViewerElement = content.querySelector("model-viewer"),
          deferredMedia = mediaContainer.querySelector(
            selectors2.deferredMedia
          );
        deferredMedia.appendChild(modelViewerElement),
          deferredMedia.setAttribute("loaded", !0);
        const mediaId = mediaContainer.dataset.mediaId,
          modelId = modelViewerElement.dataset.modelId,
          xrButton = mediaContainer
            .closest(selectors2.mediaGroup)
            .parentElement.querySelector(selectors2.productXr);
        (xrButtons[sectionId] = { element: xrButton, defaultId: modelId }),
          (models[mediaId] = {
            modelId,
            mediaId,
            sectionId,
            container: mediaContainer,
            element: modelViewerElement,
          }),
          window.ShopifyXR
            ? setupModelViewerUi()
            : window.Shopify.loadFeatures([
                { name: "shopify-xr", version: "1.0", onLoad: setupShopifyXr },
                {
                  name: "model-viewer-ui",
                  version: "1.0",
                  onLoad: setupModelViewerUi,
                },
              ]);
      }
      function setupShopifyXr(errors) {
        if (errors) {
          console.warn(errors);
          return;
        }
        if (!window.ShopifyXR) {
          document.addEventListener("shopify_xr_initialized", function () {
            setupShopifyXr();
          });
          return;
        }
        for (const sectionId in modelJsonSections)
          if (modelJsonSections.hasOwnProperty(sectionId)) {
            const modelSection = modelJsonSections[sectionId];
            if (modelSection.loaded) continue;
            const modelJson = document.querySelector(
              `${selectors2.modelJson}${sectionId}`
            );
            modelJson &&
              (window.ShopifyXR.addModels(JSON.parse(modelJson.innerHTML)),
              (modelSection.loaded = !0));
          }
        window.ShopifyXR.setupXRElements();
      }
      function setupModelViewerUi(errors) {
        if (errors) {
          console.warn(errors);
          return;
        }
        for (const key in models)
          if (models.hasOwnProperty(key)) {
            const model = models[key];
            model.modelViewerUi ||
              ((model.modelViewerUi = new Shopify.ModelViewerUI(model.element)),
              setupModelViewerListeners(model));
          }
      }
      function setupModelViewerListeners(model) {
        const xrButton = xrButtons[model.sectionId];
        model.container.addEventListener("theme:media:visible", function () {
          xrButton.element.setAttribute(selectors2.model3d, model.modelId),
            !window.theme.touch &&
              (model.modelViewerUi.play(),
              model.container.dispatchEvent(
                new CustomEvent("theme:media:play"),
                { bubbles: !0 }
              ));
        }),
          model.container.addEventListener("theme:media:hidden", function () {
            model.modelViewerUi.pause();
          }),
          model.container.addEventListener("xrLaunch", function () {
            model.modelViewerUi.pause();
          }),
          model.element.addEventListener("load", () => {
            xrButton.element.setAttribute(selectors2.model3d, model.modelId),
              model.container.classList.remove(classes2.isLoading),
              model.container.dispatchEvent(
                new CustomEvent("theme:media:play"),
                { bubbles: !0 }
              );
          }),
          model.element.addEventListener(
            "shopify_model_viewer_ui_toggle_play",
            function () {
              pauseOtherMedia(model.mediaId),
                setTimeout(() => {
                  model.container.dispatchEvent(
                    new CustomEvent("theme:media:play"),
                    { bubbles: !0 }
                  );
                }, 50);
            }
          ),
          model.element.addEventListener(
            "shopify_model_viewer_ui_toggle_pause",
            function () {
              model.container.dispatchEvent(
                new CustomEvent("theme:media:pause"),
                { bubbles: !0 }
              );
            }
          ),
          pauseOtherMedia(model.mediaId);
      }
      function pauseOtherMedia(mediaId) {
        const currentMedia = `[${selectors2.mediaId}="${mediaId}"]`,
          otherMedia = document.querySelectorAll(
            `${selectors2.productMediaWrapper}:not(${currentMedia})`
          );
        otherMedia.length &&
          otherMedia.forEach((media) => {
            media.dispatchEvent(new CustomEvent("theme:media:hidden"), {
              bubbles: !0,
            }),
              media.classList.add(classes2.mediaHidden);
          });
      }
      function removeSectionModels(sectionId) {
        for (const key in models)
          models.hasOwnProperty(key) &&
            models[key].sectionId === sectionId &&
            delete models[key];
        delete modelJsonSections[sectionId],
          delete theme.mediaInstances[sectionId];
      }
      return { init, loadContent, removeSectionModels };
    })()),
    register("collection-template", filters);
  const selectors$G = {
      templateAddresses: ".template-customers-addresses",
      accountForm: "[data-form]",
      addressNewForm: "[data-form-new]",
      btnNew: "[data-button-new]",
      btnEdit: "[data-button-edit]",
      btnDelete: "[data-button-delete]",
      btnCancel: "[data-button-cancel]",
      editAddress: "data-form-edit",
      addressCountryNew: "AddressCountryNew",
      addressProvinceNew: "AddressProvinceNew",
      addressProvinceContainerNew: "AddressProvinceContainerNew",
      addressCountryOption: "[data-country-option]",
      addressCountry: "AddressCountry",
      addressProvince: "AddressProvince",
      addressProvinceContainer: "AddressProvinceContainer",
      requiredInputs: 'input[type="text"]:not(.optional)',
    },
    attributes$s = { dataFormId: "data-form-id" },
    classes$x = { hidden: "is-hidden", validation: "validation--showup" };
  class Addresses {
    constructor(section) {
      (this.section = section),
        (this.addressNewForm = this.section.querySelector(
          selectors$G.addressNewForm
        )),
        (this.accountForms = this.section.querySelectorAll(
          selectors$G.accountForm
        )),
        this.init(),
        this.validate();
    }
    init() {
      if (this.addressNewForm) {
        const section = this.section,
          newAddressForm = this.addressNewForm;
        this.customerAddresses();
        const newButtons = section.querySelectorAll(selectors$G.btnNew);
        newButtons.length &&
          newButtons.forEach((button) => {
            button.addEventListener("click", function (e) {
              e.preventDefault(),
                button.classList.add(classes$x.hidden),
                newAddressForm.classList.remove(classes$x.hidden);
            });
          });
        const editButtons = section.querySelectorAll(selectors$G.btnEdit);
        editButtons.length &&
          editButtons.forEach((button) => {
            button.addEventListener("click", function (e) {
              e.preventDefault();
              const formId = this.getAttribute(attributes$s.dataFormId);
              section
                .querySelector(`[${selectors$G.editAddress}="${formId}"]`)
                .classList.toggle(classes$x.hidden);
            });
          });
        const deleteButtons = section.querySelectorAll(selectors$G.btnDelete);
        deleteButtons.length &&
          deleteButtons.forEach((button) => {
            button.addEventListener("click", function (e) {
              e.preventDefault();
              const formId = this.getAttribute(attributes$s.dataFormId);
              confirm(theme.strings.delete_confirm) &&
                Shopify.postLink("/account/addresses/" + formId, {
                  parameters: { _method: "delete" },
                });
            });
          });
        const cancelButtons = section.querySelectorAll(selectors$G.btnCancel);
        cancelButtons.length &&
          cancelButtons.forEach((button) => {
            button.addEventListener("click", function (e) {
              e.preventDefault(),
                this.closest(selectors$G.accountForm).classList.add(
                  classes$x.hidden
                ),
                document
                  .querySelector(selectors$G.btnNew)
                  .classList.remove(classes$x.hidden);
            });
          });
      }
    }
    customerAddresses() {
      Shopify.CountryProvinceSelector &&
        new Shopify.CountryProvinceSelector(
          selectors$G.addressCountryNew,
          selectors$G.addressProvinceNew,
          { hideElement: selectors$G.addressProvinceContainerNew }
        ),
        this.section
          .querySelectorAll(selectors$G.addressCountryOption)
          .forEach((element) => {
            const formId = element.getAttribute(attributes$s.dataFormId),
              countrySelector = `${selectors$G.addressCountry}_${formId}`,
              provinceSelector = `${selectors$G.addressProvince}_${formId}`,
              containerSelector = `${selectors$G.addressProvinceContainer}_${formId}`;
            new Shopify.CountryProvinceSelector(
              countrySelector,
              provinceSelector,
              { hideElement: containerSelector }
            );
          });
    }
    validate() {
      this.accountForms.forEach((accountForm) => {
        const form = accountForm.querySelector("form"),
          inputs = form.querySelectorAll(selectors$G.requiredInputs);
        form.addEventListener("submit", (event2) => {
          let isEmpty = !1;
          inputs.forEach((input) => {
            input.value
              ? input.nextElementSibling.classList.remove(classes$x.validation)
              : (input.nextElementSibling.classList.add(classes$x.validation),
                (isEmpty = !0));
          }),
            isEmpty && event2.preventDefault();
        });
      });
    }
  }
  const template = document.querySelector(selectors$G.templateAddresses);
  template && new Addresses(template);
  const selectors$F = {
      form: "[data-account-form]",
      showReset: "[data-show-reset]",
      hideReset: "[data-hide-reset]",
      recover: "[data-recover-password]",
      login: "[data-login-form]",
      recoverSuccess: "[data-recover-success]",
      recoverSuccessText: "[data-recover-success-text]",
      recoverHash: "#recover",
    },
    classes$w = { hidden: "is-hidden" };
  class Login {
    constructor(form) {
      (this.form = form),
        (this.showButton = form.querySelector(selectors$F.showReset)),
        (this.hideButton = form.querySelector(selectors$F.hideReset)),
        (this.recover = form.querySelector(selectors$F.recover)),
        (this.login = form.querySelector(selectors$F.login)),
        (this.success = form.querySelector(selectors$F.recoverSuccess)),
        (this.successText = form.querySelector(selectors$F.recoverSuccessText)),
        this.init();
    }
    init() {
      window.location.hash == selectors$F.recoverHash
        ? this.showRecoverPasswordForm()
        : this.hideRecoverPasswordForm(),
        this.success && this.successText.classList.remove(classes$w.hidden),
        this.showButton.addEventListener(
          "click",
          (e) => {
            e.preventDefault(), this.showRecoverPasswordForm();
          },
          !1
        ),
        this.hideButton.addEventListener(
          "click",
          (e) => {
            e.preventDefault(), this.hideRecoverPasswordForm();
          },
          !1
        );
    }
    showRecoverPasswordForm() {
      return (
        this.recover.classList.remove(classes$w.hidden),
        this.login.classList.add(classes$w.hidden),
        (window.location.hash = selectors$F.recoverHash),
        !1
      );
    }
    hideRecoverPasswordForm() {
      return (
        this.login.classList.remove(classes$w.hidden),
        this.recover.classList.add(classes$w.hidden),
        (window.location.hash = ""),
        !1
      );
    }
  }
  const loginForm = document.querySelector(selectors$F.form);
  loginForm && new Login(loginForm),
    register("search-template", [filters, tabs]);
  const selectors$E = {
      frame: "[data-ticker-frame]",
      scale: "[data-ticker-scale]",
      text: "[data-ticker-text]",
      clone: "data-clone",
    },
    attributes$r = { speed: "data-marquee-speed" },
    classes$v = {
      animationClass: "ticker--animated",
      unloadedClass: "ticker--unloaded",
      comparitorClass: "ticker__comparitor",
    },
    settings$3 = { moveTime: 1.63, space: 100 };
  class Ticker {
    constructor(el, stopClone = !1) {
      (this.frame = el),
        (this.stopClone = stopClone),
        (this.scale = this.frame.querySelector(selectors$E.scale)),
        (this.text = this.frame.querySelector(selectors$E.text)),
        (this.comparitor = this.text.cloneNode(!0)),
        this.comparitor.classList.add(classes$v.comparitorClass),
        this.frame.appendChild(this.comparitor),
        this.scale.classList.remove(classes$v.unloadedClass),
        (this.resizeEvent = debounce(() => this.checkWidth(), 100)),
        this.listen();
    }
    listen() {
      document.addEventListener("theme:resize:width", this.resizeEvent),
        this.checkWidth();
    }
    checkWidth() {
      const padding =
        window.getComputedStyle(this.frame).paddingLeft.replace("px", "") * 2;
      if (
        this.frame.clientWidth - padding < this.comparitor.clientWidth ||
        this.stopClone
      ) {
        if (this.scale.childElementCount === 1) {
          if (
            (this.text.classList.add(classes$v.animationClass),
            (this.clone = this.text.cloneNode(!0)),
            this.clone.setAttribute(selectors$E.clone, ""),
            this.scale.appendChild(this.clone),
            this.stopClone)
          )
            for (let index = 0; index < 10; index++) {
              const cloneSecond = this.text.cloneNode(!0);
              cloneSecond.setAttribute(selectors$E.clone, ""),
                this.scale.appendChild(cloneSecond);
            }
          let frameSpeed = this.frame.getAttribute(attributes$r.speed);
          frameSpeed === null && (frameSpeed = 100);
          const speed = settings$3.moveTime * (100 / parseInt(frameSpeed, 10)),
            animationTimeFrame =
              (this.text.clientWidth / settings$3.space) * speed;
          this.scale.style.setProperty(
            "--animation-time",
            `${animationTimeFrame}s`
          );
        }
      } else {
        this.text.classList.add(classes$v.animationClass);
        let clone = this.scale.querySelector(`[${selectors$E.clone}]`);
        clone && this.scale.removeChild(clone),
          this.text.classList.remove(classes$v.animationClass);
      }
    }
    unload() {
      document.removeEventListener("theme:resize:width", this.resizeEvent);
    }
  }
  const selectors$D = {
      parallaxElement: "[data-parallax]",
      shopifySection: ".shopify-section",
      main: "[data-main]",
    },
    classes$u = {
      isDisabled: "is-disabled",
      mainContent: "main-content",
      shopifySection: "shopify-section",
      sectionFooterVisible: "section-footer--visible",
      cardScrollingHidden: "card-scrolling-hidden",
      stickyTopZero: "sticky-top-zero",
    },
    attributes$q = {
      parallaxAnimation: "data-parallax",
      parallaxIntensity: "data-parallax-intensity",
      parallaxStatic: "data-parallax-static",
      singleElement: "data-parallax-single",
      disableOnMobile: "data-parallax-disable-on-mobile",
      parallaxRounded: "data-parallax-rounded-corners",
      parallaxRoundedLarge: "data-parallax-rounded-corners-large",
    },
    sections$v = {};
  class ParallaxElement {
    constructor(el) {
      (this.container = el),
        (this.percentage = 0),
        (this.percentageFull = 0),
        (this.animation = this.container.getAttribute(
          attributes$q.parallaxAnimation
        )),
        (this.animations = this.animation.split(",")),
        (this.disableOnMobile = this.container.hasAttribute(
          attributes$q.disableOnMobile
        )),
        (this.viewportHeight = Math.max(
          document.documentElement.clientHeight,
          window.innerHeight || 0
        )),
        (this.containerHeight = this.container.offsetHeight),
        (this.main = document.querySelector(selectors$D.main)),
        (this.firstSection = this.main.children[0]),
        (this.orientation = getScreenOrientation()),
        (this.scrollEvent = () => this.updateParallax()),
        (this.resizeEvent = () => this.updateHeight()),
        this.assignFooterArguments(),
        this.assignCardScrollingArguments(),
        requestAnimationFrame(() => this.init());
    }
    assignFooterArguments() {
      this.animations.includes("footer") &&
        ((this.shopifySection = this.container.closest(
          selectors$D.shopifySection
        )),
        (this.footerPrevSectionOffset = 0),
        this.container.hasAttribute(attributes$q.parallaxRounded) &&
          ((this.footerPrevSectionOffset = 8),
          this.container.hasAttribute(attributes$q.parallaxRoundedLarge) &&
            (this.footerPrevSectionOffset = 34)),
        (this.prevSection = this.container.parentNode.previousElementSibling),
        this.prevSection &&
          !this.prevSection.classList.contains(classes$u.shopifySection) &&
          !this.prevSection.classList.contains(classes$u.mainContent) &&
          (this.prevSection = this.main),
        requestAnimationFrame(() => {
          (this.containerHeight = this.container.offsetHeight),
            (this.footerOffset = 0.15 * this.containerHeight),
            (this.cachedPosition = this.footerOffset),
            (this.cachedPercentage = 0);
        }));
    }
    assignCardScrollingArguments() {
      if (!this.animations.includes("card-scrolling")) return;
      let { stickyHeaderHeight } = readHeights();
      if (
        ((this.headerHeight = stickyHeaderHeight || 0),
        (this.shopifySection = this.container.closest(
          selectors$D.shopifySection
        )),
        (this.nextSection = this.shopifySection.nextElementSibling),
        (this.cardScrollingStickyTop = this.headerHeight || 0),
        (this.cardScrollingMarginTop = this.nextSection
          ? parseInt(
              window
                .getComputedStyle(this.nextSection)
                .getPropertyValue("margin-top")
            )
          : 0),
        (this.after = !1),
        (this.prevSection = this.shopifySection.previousElementSibling),
        this.prevSection)
      ) {
        const firstSectionId = this.firstSection.id,
          matchesFirstSection = this.prevSection.matches(`#${firstSectionId}`),
          prevSectionHeight = this.prevSection.offsetHeight;
        this.shopifySection.classList.toggle(
          classes$u.stickyTopZero,
          matchesFirstSection && prevSectionHeight <= this.headerHeight * 2
        );
      }
      this.opacityValue = (delta) => {
        if (!delta || delta <= 0) return 0;
        if (delta > 0 && delta <= 100) return Number(delta / 100).toFixed(4);
        if (delta > 100) return 1;
      };
    }
    init() {
      this.updateParallax(),
        document.addEventListener("theme:scroll", this.scrollEvent),
        document.addEventListener("theme:resize", this.resizeEvent);
    }
    updateParallax() {
      this.container.classList.contains(classes$u.isDisabled) ||
        (this.disableOnMobile && isMobile()) ||
        ((this.scrollTop = Math.round(window.scrollY)),
        (this.scrollBottom = this.scrollTop + this.viewportHeight),
        (this.elementOffsetTopPoint = Math.round(
          this.container.getBoundingClientRect().top + this.scrollTop
        )),
        window.Shopify.designMode &&
          (this.assignCardScrollingArguments(),
          (this.containerHeight = this.container.offsetHeight)),
        (this.elementOffsetBottomPoint =
          this.elementOffsetTopPoint + this.containerHeight),
        (this.isBottomOfElementPassed =
          this.elementOffsetBottomPoint < this.scrollTop),
        (this.isTopOfElementReached =
          this.elementOffsetTopPoint < this.scrollBottom),
        (this.isInView =
          this.isTopOfElementReached && !this.isBottomOfElementPassed),
        this.adjustCalculations(),
        this.toggleVisibility(),
        this.isInView &&
          ((this.scrollProgress =
            this.scrollBottom - this.elementOffsetTopPoint),
          (this.percentage =
            ((this.scrollProgress - this.containerHeight / 2) * 100) /
            this.viewportHeight),
          (this.percentageFull = Number(
            this.scrollProgress / this.containerHeight
          ).toFixed(2)),
          (this.percentageVisible = Number(
            (this.scrollProgress * 100) /
              (this.viewportHeight + this.containerHeight)
          ).toFixed(2)),
          this.animations.includes("circle") && this.animateCircleText(),
          (this.animations.includes("horizontal") ||
            this.animations.includes("vertical") ||
            this.animations.includes("diagonal")) &&
            this.animateOverlappingImages(),
          (this.animations.includes("offset-ltr") ||
            this.animations.includes("offset-rtl")) &&
            this.offsetX(),
          this.animations.includes("card-scrolling") &&
            this.cardScrollingEffect(),
          this.animations.includes("zoom-on-scroll") && this.zoomInOut(),
          this.animations.includes("footer") && this.animateFooter()));
    }
    adjustCalculations() {
      this.animations.includes("card-scrolling") &&
        ((this.currentSectionTop =
          this.shopifySection.getBoundingClientRect().top),
        this.nextSection
          ? ((this.nextSectionTop =
              this.nextSection.getBoundingClientRect().top),
            (this.offsetTop =
              this.nextSectionTop -
              this.containerHeight -
              this.cardScrollingMarginTop))
          : ((this.nextSectionTop =
              this.currentSectionTop + this.containerHeight),
            (this.offsetTop = this.currentSectionTop)),
        (this.distance = Math.floor(
          this.currentSectionTop - this.headerHeight
        )),
        (this.after =
          Math.round(
            this.nextSectionTop -
              this.headerHeight -
              this.cardScrollingMarginTop +
              this.viewportHeight * 0.1
          ) < 0),
        (this.isInView = this.isTopOfElementReached && !this.after)),
        this.animations.includes("footer") &&
          ((this.elementOffsetTopPoint = Math.round(
            this.prevSection?.getBoundingClientRect().bottom -
              this.footerPrevSectionOffset +
              this.scrollTop
          )),
          (this.elementOffsetBottomPoint =
            this.elementOffsetTopPoint + this.containerHeight),
          (this.isBottomOfElementPassed =
            this.elementOffsetBottomPoint < this.scrollTop),
          (this.isTopOfElementReached =
            this.elementOffsetTopPoint < this.scrollBottom),
          (this.isInView =
            this.isTopOfElementReached && !this.isBottomOfElementPassed),
          (this.isApproaching =
            Math.round(this.elementOffsetTopPoint - this.viewportHeight / 2) <
            this.scrollBottom));
    }
    toggleVisibility() {
      this.animations.includes("card-scrolling") &&
        this.shopifySection.classList.toggle(
          classes$u.cardScrollingHidden,
          this.after
        ),
        this.animations.includes("footer") &&
          (this.isApproaching || this.isInView
            ? this.shopifySection.classList.add(classes$u.sectionFooterVisible)
            : this.shopifySection.classList.remove(
                classes$u.sectionFooterVisible
              ));
    }
    cardScrollingEffect() {
      const delta = (this.offsetTop / this.containerHeight) * -100;
      this.container.style.setProperty(
        "--card-scrolling-overlay",
        this.opacityValue(delta)
      );
    }
    zoomInOut() {
      if (this.animations.includes("card-scrolling") && this.nextSection) {
        const cumulativeTop =
            this.nextSectionTop -
            this.headerHeight -
            this.cardScrollingMarginTop -
            this.containerHeight,
          elementOffsetTopPoint = Math.round(cumulativeTop + this.scrollTop),
          scrollProgress = this.scrollBottom - elementOffsetTopPoint;
        this.percentageVisible = Number(
          (scrollProgress * 100) /
            (this.viewportHeight +
              this.containerHeight +
              this.cardScrollingMarginTop)
        ).toFixed(2);
      }
      const delta = (0.2 * this.percentageVisible) / 100;
      let scale = Number(1 + delta).toFixed(4);
      (scale = scale > 1 ? scale : 1),
        this.container.style.setProperty("--scale", scale);
    }
    offsetX() {
      const isStatic = this.container.hasAttribute(attributes$q.parallaxStatic),
        intensity =
          this.container.getAttribute(attributes$q.parallaxIntensity) || 100;
      let adjustment = this.animations.includes("offset-ltr") ? intensity : 0;
      isStatic && (adjustment = intensity / 2);
      const direction = this.animations.includes("offset-ltr") ? 1 : -1,
        offset = (intensity * this.percentageVisible) / 100 - adjustment,
        offsetX = Number(offset * direction).toFixed(2);
      this.container.style.setProperty("--offsetX", `${offsetX}%`);
    }
    updateHeight() {
      if (this.animations.includes("card-scrolling")) {
        let { stickyHeaderHeight } = readHeights();
        if (
          ((this.headerHeight = stickyHeaderHeight || 0),
          (this.cardScrollingStickyTop = this.headerHeight || 0),
          (this.cardScrollingMarginTop = this.nextSection
            ? parseInt(
                window
                  .getComputedStyle(this.nextSection)
                  .getPropertyValue("margin-top")
              )
            : 0),
          (this.containerHeight = this.container.offsetHeight),
          (this.prevSection = this.shopifySection.previousElementSibling),
          this.prevSection)
        ) {
          const firstSectionId = this.firstSection.id,
            matchesFirstSection = this.prevSection.matches(
              `#${firstSectionId}`
            ),
            prevSectionHeight = this.prevSection.offsetHeight;
          this.shopifySection.classList.toggle(
            classes$u.stickyTopZero,
            matchesFirstSection && prevSectionHeight <= this.headerHeight * 2
          );
        }
      }
      const isDesktop2 = matchMedia("(min-width: 1024px)").matches;
      (this.orientation !== getScreenOrientation() || isDesktop2) &&
        ((this.viewportHeight = Math.round(
          Math.max(
            document.documentElement.clientHeight,
            window.innerHeight || 0
          )
        )),
        (this.containerHeight = this.container.offsetHeight),
        (this.orientation = getScreenOrientation()));
    }
    animateCircleText() {
      const angle = ((70 * this.percentage) / 100) * -1,
        adjustRotateDegree = 70 / 2;
      this.percentage > 0 &&
        this.container.style.setProperty(
          "--rotate",
          `${adjustRotateDegree + angle}deg`
        );
    }
    animateOverlappingImages() {
      const offsetRange =
          0.25 * this.container.getAttribute(attributes$q.parallaxIntensity),
        offsetRangeHalf = offsetRange / 2,
        singleElement = this.container.hasAttribute(attributes$q.singleElement),
        offset = (offsetRange * this.percentage) / 100;
      let offsetXPrimary = 0,
        offsetYPrimary = 0,
        offsetXSecondary = 0,
        offsetYSecondary = 0;
      (this.animations.includes("horizontal") ||
        this.animations.includes("diagonal")) &&
        ((offsetXPrimary = -1 * offsetRangeHalf + offset),
        (offsetXSecondary = offsetRangeHalf - offset)),
        (this.animations.includes("vertical") ||
          this.animations.includes("diagonal")) &&
          ((offsetYPrimary = offsetRangeHalf - offset),
          (offsetYSecondary = -1 * offsetRangeHalf + offset)),
        this.container.style.setProperty(
          "--transformX-primary",
          `${offsetXPrimary}%`
        ),
        this.container.style.setProperty(
          "--transformY-primary",
          `${offsetYPrimary}%`
        ),
        singleElement ||
          (this.container.style.setProperty(
            "--transformX-secondary",
            `${offsetXSecondary}%`
          ),
          this.container.style.setProperty(
            "--transformY-secondary",
            `${offsetYSecondary}%`
          ));
    }
    animateFooter() {
      const offsetMove = this.footerOffset * this.percentageFull,
        percentageOfFullOffset = Number(
          (offsetMove / this.footerOffset) * 100
        ).toFixed(2),
        currentTransform = new WebKitCSSMatrix(
          window.getComputedStyle(this.container).transform
        ),
        currentOffset = Number(currentTransform.m42).toFixed(2);
      let newOffset = Number(this.footerOffset - offsetMove).toFixed(2);
      this.percentageFull >= 1 && (newOffset = 0),
        currentOffset !== newOffset &&
          this.cachedPercentage !== percentageOfFullOffset &&
          (this.container.style.setProperty("--transformY", `${newOffset}`),
          (this.cachedPercentage = percentageOfFullOffset),
          (this.cachedPosition = newOffset));
    }
    unload() {
      document.removeEventListener("theme:scroll", this.scrollEvent),
        document.removeEventListener("theme:resize", this.resizeEvent);
    }
  }
  const parallaxSection = {
      onLoad() {
        (sections$v[this.id] = []),
          this.container
            .querySelectorAll(selectors$D.parallaxElement)
            .forEach((element) => {
              sections$v[this.id].push(new ParallaxElement(element));
            });
      },
      onUnload() {
        sections$v[this.id].forEach((element) => {
          typeof element.unload == "function" && element.unload();
        });
      },
    },
    selectors$C = {
      announcement: "[data-announcement]",
      announcementSlide: "[data-announcement-slide]",
      frame: "[data-ticker-frame]",
      slide: "[data-slide]",
      slider: "[data-slider]",
      static: "[data-static]",
      tickerScale: "[data-ticker-scale]",
      tickerText: "[data-ticker-text]",
      parallax: "[data-parallax]",
      textHighlight: "text-highlight",
    },
    attributes$p = {
      slide: "data-slide",
      speed: "data-slider-speed",
      arrows: "data-slider-arrows",
      stop: "data-stop",
      style: "style",
      targetReferrer: "data-target-referrer",
      clipPath: "clip-path",
    },
    classes$t = {
      desktop: "desktop",
      mobile: "mobile",
      tickerAnimated: "ticker--animated",
      isDisabled: "is-disabled",
    },
    tags = { clipPath: "clipPath" },
    sections$u = {};
  class AnnouncementBar {
    constructor(container) {
      (this.barHolder = container),
        (this.locationPath = location.href),
        (this.slides = this.barHolder.querySelectorAll(selectors$C.slide)),
        (this.slider = this.barHolder.querySelector(selectors$C.slider)),
        (this.static = this.barHolder.querySelector(selectors$C.static)),
        (this.parallax = this.barHolder.querySelector(selectors$C.parallax)),
        (this.tickers = []),
        (this.flkty = null),
        this.init();
    }
    init() {
      this.removeAnnouncement(),
        this.slider &&
          (this.initSlider(),
          document.addEventListener(
            "theme:resize:width",
            this.initSlider.bind(this)
          )),
        this.static && (this.initTickers(), this.tickerAnimationPause()),
        !this.slider &&
          !this.static &&
          (this.initTickers(!0), this.tickerAnimationPause()),
        this.updateSVGClipPathIDs();
    }
    removeAnnouncement() {
      for (let i = 0; i < this.slides.length; i++) {
        const element = this.slides[i];
        element.hasAttribute(attributes$p.targetReferrer) &&
          this.locationPath.indexOf(
            element.getAttribute(attributes$p.targetReferrer)
          ) === -1 &&
          !window.Shopify.designMode &&
          element.parentNode.removeChild(element);
      }
    }
    checkSlidesClasses(slides, barHolder) {
      if (slides.length !== 0) {
        const slidesMobile = barHolder.querySelectorAll(
            `${selectors$C.slide}.${classes$t.mobile}`
          ),
          slidesDesktop = barHolder.querySelectorAll(
            `${selectors$C.slide}.${classes$t.desktop}`
          );
        slides.length === slidesMobile.length
          ? barHolder.parentNode.classList.add(classes$t.mobile)
          : slides.length === slidesDesktop.length &&
            barHolder.parentNode.classList.add(classes$t.desktop);
      }
    }
    initSlider() {
      const slides = this.slider.querySelectorAll(selectors$C.slide),
        sliderArrows = this.slider.hasAttribute(attributes$p.arrows);
      if ((this.checkSlidesClasses(slides, this.barHolder), slides)) {
        let slideSelector = `${selectors$C.slide}`;
        window.innerWidth < theme.sizes.small
          ? (slideSelector = `${selectors$C.slide}:not(.${classes$t.desktop})`)
          : (slideSelector = `${selectors$C.slide}:not(.${classes$t.mobile})`),
          this.flkty != null && this.flkty.destroy(),
          (this.flkty = new Flickity(this.slider, {
            cellSelector: slideSelector,
            pageDots: !1,
            prevNextButtons: sliderArrows,
            wrapAround: !0,
            autoPlay: parseInt(
              this.slider.getAttribute(attributes$p.speed),
              10
            ),
            on: {
              ready: () => {
                setTimeout(() => {
                  this.slider.dispatchEvent(
                    new CustomEvent("slider-is-loaded", {
                      bubbles: !0,
                      detail: { slider: this },
                    })
                  );
                }, 10);
              },
              change: (index) => {
                this.flkty.cells.forEach((slide, i) => {
                  slide.element
                    .querySelectorAll(selectors$C.textHighlight)
                    .forEach((highlight) => {
                      highlight.setTriggerAttribute(i === index);
                    });
                });
              },
            },
          })),
          this.flkty.reposition();
      }
      this.slider.addEventListener("slider-is-loaded", () => {
        this.initTickers(), this.updateSVGClipPathIDs();
      });
    }
    initTickers(stopClone = !1) {
      this.barHolder.querySelectorAll(selectors$C.frame).forEach((element) => {
        const ticker = new Ticker(element, stopClone);
        this.tickers.push(ticker);
        const slides = element.querySelectorAll(selectors$C.slide);
        this.checkSlidesClasses(slides, this.barHolder);
      });
    }
    toggleTicker(e, isStopped) {
      const tickerScale = e.target.closest(selectors$C.tickerScale),
        element = document.querySelector(
          `[${attributes$p.slide}="${e.detail.blockId}"]`
        );
      isStopped &&
        element &&
        (tickerScale.setAttribute(attributes$p.stop, ""),
        tickerScale
          .querySelectorAll(selectors$C.tickerText)
          .forEach((textHolder) => {
            textHolder.classList.remove(classes$t.tickerAnimated),
              (textHolder.style.transform = `translate3d(${-(
                element.offsetLeft -
                parseInt(getComputedStyle(element).marginLeft, 10)
              )}px, 0, 0)`);
          })),
        !isStopped &&
          element &&
          (tickerScale
            .querySelectorAll(selectors$C.tickerText)
            .forEach((textHolder) => {
              textHolder.classList.add(classes$t.tickerAnimated),
                textHolder.removeAttribute(attributes$p.style);
            }),
          tickerScale.removeAttribute(attributes$p.stop),
          this.static &&
            document.dispatchEvent(
              new CustomEvent("theme:resize:width", { bubbles: !0 })
            ));
    }
    tickerAnimationPause() {
      let hoverTimer = 0,
        isHovered = !1;
      const tickerContainer = this.barHolder.querySelector(
        selectors$C.announcementSlide
      );
      tickerContainer.addEventListener("mouseenter", () => {
        (isHovered = !0),
          (hoverTimer = setTimeout(() => {
            isHovered &&
              tickerContainer
                .querySelectorAll(selectors$C.tickerText)
                .forEach((element) => {
                  element.style.animationPlayState = "paused";
                }),
              clearTimeout(hoverTimer);
          }, 500));
      }),
        tickerContainer.addEventListener("mouseleave", () => {
          (isHovered = !1),
            tickerContainer
              .querySelectorAll(selectors$C.tickerText)
              .forEach((element) => {
                element.style.animationPlayState = "running";
              });
        });
    }
    updateSVGClipPathIDs() {
      this.barHolder
        .querySelectorAll(selectors$C.slide)
        .forEach((svg, index) => {
          const clipPath = svg.querySelector(tags.clipPath);
          if (clipPath) {
            const newclipPathId = `${clipPath.id}_${index}`;
            clipPath.id = newclipPathId;
            const gTag = svg.querySelector(`g[${attributes$p.clipPath}]`);
            gTag &&
              gTag.setAttribute(
                attributes$p.clipPath,
                `url(#${newclipPathId})`
              );
          }
        });
    }
    onBlockSelect(evt) {
      const index = parseInt(
        [...evt.target.parentNode.children].indexOf(evt.target)
      );
      this.slider &&
        this.flkty !== null &&
        (this.flkty.select(index), this.flkty.pausePlayer()),
        this.slider || this.toggleTicker(evt, !0),
        this.parallax &&
          (this.parallax.style.setProperty("--offsetX", "0%"),
          this.parallax.classList.add(classes$t.isDisabled));
    }
    onBlockDeselect(evt) {
      this.slider && this.flkty !== null && this.flkty.unpausePlayer(),
        this.slider || this.toggleTicker(evt, !1),
        this.parallax &&
          (this.parallax.classList.remove(classes$t.isDisabled),
          document.dispatchEvent(new CustomEvent("theme:scroll")));
    }
    onUnload() {
      document.removeEventListener(
        "theme:resize:width",
        this.initSlider.bind(this)
      ),
        this.tickers.length > 0 &&
          this.tickers.forEach((ticker) => {
            ticker.unload();
          });
    }
  }
  const announcement = {
    onLoad() {
      sections$u[this.id] = [];
      const element = this.container.querySelector(selectors$C.announcement);
      element && sections$u[this.id].push(new AnnouncementBar(element));
    },
    onBlockSelect(e) {
      sections$u[this.id].length &&
        sections$u[this.id].forEach((el) => {
          typeof el.onBlockSelect == "function" && el.onBlockSelect(e);
        });
    },
    onBlockDeselect(e) {
      sections$u[this.id].length &&
        sections$u[this.id].forEach((el) => {
          typeof el.onBlockSelect == "function" && el.onBlockDeselect(e);
        });
    },
    onUnload() {
      sections$u[this.id].forEach((el) => {
        typeof el.onUnload == "function" && el.onUnload();
      });
    },
  };
  register("announcement-bar", announcement),
    register("marquee", [announcement, parallaxSection]);
  const selectors$B = {
      disclosureWrappper: "[data-hover-disclosure]",
      header: "[data-site-header]",
      link: "[data-top-link]",
      headerBackground: "[data-header-background]",
      navItem: "[data-nav-item]",
    },
    classes$s = {
      isVisible: "is-visible",
      grandparent: "grandparent",
      headerMenuOpened: "site-header--menu-opened",
      hasScrolled: "has-scrolled",
      headerHovered: "site-header--hovered",
      searchOpened: "search-opened",
      megamenuOpened: "megamenu-opened",
    },
    attributes$o = {
      disclosureToggle: "data-hover-disclosure-toggle",
      ariaHasPopup: "aria-haspopup",
      ariaExpanded: "aria-expanded",
      ariaControls: "aria-controls",
    };
  let sections$t = {};
  class HoverDisclosure {
    constructor(el) {
      (this.disclosure = el),
        (this.body = document.body),
        (this.header = el.closest(selectors$B.header)),
        (this.key = this.disclosure.id),
        (this.trigger = document.querySelector(
          `[${attributes$o.disclosureToggle}='${this.key}']`
        )),
        (this.link = this.trigger.querySelector(selectors$B.link)),
        (this.grandparent = this.trigger.classList.contains(
          classes$s.grandparent
        )),
        (this.background = document.querySelector(
          selectors$B.headerBackground
        )),
        this.trigger.setAttribute(attributes$o.ariaHasPopup, !0),
        this.trigger.setAttribute(attributes$o.ariaExpanded, !1),
        this.trigger.setAttribute(attributes$o.ariaControls, this.key),
        (this.dropdown = this.trigger.querySelector(
          selectors$B.disclosureWrappper
        )),
        (this.setBackgroundHeightEvent = () => this.setBackgroundHeight()),
        this.connectHoverToggle(),
        this.handleTablets();
    }
    setBackgroundHeight() {
      (this.hasScrolled = this.body.classList.contains(classes$s.hasScrolled)),
        (this.headerHeight = this.hasScrolled
          ? window.stickyHeaderHeight
          : this.header.offsetHeight),
        this.grandparent
          ? ((this.dropdown.style.height = "auto"),
            (this.dropdownHeight =
              this.dropdown.offsetHeight + this.headerHeight))
          : (this.dropdownHeight = this.headerHeight),
        this.background.style.setProperty(
          "--header-background-height",
          `${this.dropdownHeight}px`
        ),
        window.innerWidth < theme.sizes.small && this.hideDisclosure();
    }
    showDisclosure() {
      this.setBackgroundHeight(),
        document.addEventListener(
          "theme:resize",
          this.setBackgroundHeightEvent
        ),
        this.trigger.setAttribute(attributes$o.ariaExpanded, !0),
        this.trigger.classList.add(classes$s.isVisible),
        this.header.classList.add(classes$s.headerMenuOpened),
        this.trigger.classList.contains(classes$s.grandparent) &&
          (this.body.classList.add(classes$s.megamenuOpened),
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", {
              bubbles: !0,
              detail: this.header,
            })
          )),
        this.updateHeaderHover();
    }
    hideDisclosure() {
      this.background.style.removeProperty("--header-background-height"),
        document.removeEventListener(
          "theme:resize",
          this.setBackgroundHeightEvent
        ),
        this.trigger.classList.remove(classes$s.isVisible),
        this.trigger.setAttribute(attributes$o.ariaExpanded, !1),
        this.header.classList.remove(classes$s.headerMenuOpened),
        this.body.classList.remove(classes$s.megamenuOpened),
        this.body.classList.contains(classes$s.searchOpened) ||
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0, detail: 1 })
          );
    }
    updateHeaderHover() {
      requestAnimationFrame(() => {
        const isHovered = this.header.matches(":hover"),
          hasHoveredClass = this.header.classList.contains(
            classes$s.headerHovered
          );
        isHovered &&
          !hasHoveredClass &&
          this.header.classList.add(classes$s.headerHovered);
      });
    }
    handleTablets() {
      this.trigger.addEventListener("touchstart", (e) => {
        if (!this.trigger.classList.contains(classes$s.isVisible)) {
          e.preventDefault();
          const activeNavItems = this.header.querySelectorAll(
            `.${classes$s.isVisible}${selectors$B.navItem}`
          );
          if (activeNavItems.length > 0) {
            activeNavItems.forEach((item) => {
              if (item !== this.trigger) {
                item.dispatchEvent(new Event("mouseleave", { bubbles: !0 }));
                const onTransitionEnd = () => {
                  requestAnimationFrame(() => {
                    this.showDisclosure();
                  }),
                    item.removeEventListener("transitionend", onTransitionEnd);
                };
                item.addEventListener("transitionend", onTransitionEnd);
              }
            });
            return;
          }
          this.showDisclosure();
        }
      });
    }
    connectHoverToggle() {
      this.trigger.addEventListener("mouseenter", () => this.showDisclosure()),
        this.link.addEventListener("focus", () => this.showDisclosure()),
        this.trigger.addEventListener("mouseleave", () =>
          this.hideDisclosure()
        ),
        this.trigger.addEventListener("focusout", (event2) => {
          this.trigger.contains(event2.relatedTarget) || this.hideDisclosure();
        }),
        this.disclosure.addEventListener("keyup", (event2) => {
          event2.code === theme.keyboardKeys.ESCAPE && this.hideDisclosure();
        });
    }
    onBlockSelect(event2) {
      this.disclosure.contains(event2.target) && this.showDisclosure(event2);
    }
    onBlockDeselect(event2) {
      this.disclosure.contains(event2.target) && this.hideDisclosure();
    }
  }
  const hoverDisclosure = {
      onLoad() {
        (sections$t[this.id] = []),
          this.container
            .querySelectorAll(selectors$B.disclosureWrappper)
            .forEach((el) => {
              sections$t[this.id].push(new HoverDisclosure(el));
            });
      },
      onBlockSelect(evt) {
        sections$t[this.id].forEach((el) => {
          typeof el.onBlockSelect == "function" && el.onBlockSelect(evt);
        });
      },
      onBlockDeselect(evt) {
        sections$t[this.id].forEach((el) => {
          typeof el.onBlockDeselect == "function" && el.onBlockDeselect(evt);
        });
      },
    },
    selectors$A = {
      header: "[data-site-header]",
      announcementBar: "[data-announcement-wrapper]",
      collectionFilters: "[data-collection-filters]",
      logoTextLink: "[data-logo-text-link]",
      mobileNavDropdownTrigger: "[data-collapsible-trigger]",
      navDrawer: "#nav-drawer",
      drawer: "[data-drawer]",
      drawerToggle: "[data-drawer-toggle]",
      popdownToggle: "[data-popdown-toggle]",
      mobileMenu: "[data-mobile-menu]",
      nav: "[data-nav]",
      navIcons: "[data-nav-icons]",
      navItem: "[data-nav-item]",
      navLinkMobile: "[data-nav-link-mobile]",
      navSearchOpen: "[data-nav-search-open]",
      wrapper: "[data-wrapper]",
      headerBackground: "[data-header-background]",
      cartPage: "[data-cart-page]",
      widthContent: "[data-takes-space]",
    },
    classes$r = {
      jsDrawerOpenAll: [
        "js-drawer-open",
        "js-drawer-open-cart",
        "js-quick-view-visible",
        "js-quick-view-from-cart",
      ],
      headerTransparent: "site-header--transparent",
      headerHovered: "site-header--hovered",
      headerMenuOpened: "site-header--menu-opened",
      hasScrolled: "has-scrolled",
      hasStickyHeader: "has-sticky-header",
      hideHeader: "hide-header",
      headerCompress: "site-header--compress",
      isVisible: "is-visible",
      isOpen: "is-open",
      searchOpened: "search-opened",
      noOutline: "no-outline",
      cloneClass: "js__header__clone",
    },
    attributes$n = {
      navAlignment: "data-nav-alignment",
      headerSticky: "data-header-sticky",
    },
    sections$s = {};
  class Header {
    constructor(container) {
      (this.container = container),
        (this.background = document.querySelector(
          selectors$A.headerBackground
        )),
        (this.header = container),
        (this.headerSection = container.parentNode),
        (this.headerWrapper = container.querySelector(selectors$A.wrapper)),
        (this.logoTextLink = container.querySelector(selectors$A.logoTextLink)),
        (this.nav = container.querySelector(selectors$A.nav)),
        (this.navIcons = container.querySelector(selectors$A.navIcons)),
        (this.headerStateEvent = (event2) => this.headerState(event2)),
        (this.handleTouchstartEvent = (event2) =>
          this.handleTouchstart(event2)),
        (this.updateBackgroundHeightEvent = (event2) =>
          this.updateBackgroundHeight(event2)),
        initTransparentHeader(),
        (this.minWidth = this.getMinWidth()),
        (this.checkWidthEvent = () => this.checkWidth()),
        this.listenWidth(),
        this.initMobileNav(),
        this.handleTextLinkLogos(),
        this.initStickyHeader(),
        this.handleBackgroundEvents(),
        document.querySelector(selectors$A.cartPage) ||
          (window.cart = new CartDrawer()),
        document.body.addEventListener(
          "touchstart",
          this.handleTouchstartEvent,
          { passive: !0 }
        ),
        this.updateHeaderHover();
    }
    updateHeaderHover() {
      requestAnimationFrame(() => {
        const isHovered = this.header.matches(":hover"),
          hasHoveredClass = this.header.classList.contains(
            classes$r.headerHovered
          );
        isHovered &&
          !hasHoveredClass &&
          this.header.classList.add(classes$r.headerHovered);
      });
    }
    handleTouchstart(event2) {
      const isInHeader = this.header.contains(event2.target),
        activeNavItem = this.header.querySelector(
          `.${classes$r.isVisible}${selectors$A.navItem}`
        );
      !isInHeader &&
        activeNavItem &&
        activeNavItem.dispatchEvent(new Event("mouseleave", { bubbles: !0 }));
    }
    handleTextLinkLogos() {
      if (this.logoTextLink === null) return;
      const headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty(
        "--header-height",
        `${headerHeight}px`
      ),
        document.documentElement.style.setProperty(
          "--header-sticky-height",
          `${headerHeight}px`
        );
    }
    initStickyHeader() {
      if (
        ((this.headerSticky = this.header.hasAttribute(
          attributes$n.headerSticky
        )),
        CSS.supports("(selector(:has(*)))") ||
          document.body.classList.toggle(
            classes$r.hasStickyHeader,
            this.headerSticky
          ),
        (this.hasScrolled = !1),
        (this.hasCollectionFilters = document.querySelector(
          selectors$A.collectionFilters
        )),
        (this.position = this.header.dataset.position),
        this.position === "fixed" && !this.hasCollectionFilters)
      ) {
        this.headerState(),
          document.addEventListener("theme:scroll", this.headerStateEvent);
        return;
      }
      document.body.classList.remove(classes$r.hasScrolled),
        window.isHeaderTransparent &&
          this.header.classList.add(classes$r.headerTransparent);
    }
    headerState(event2) {
      const headerHeight = parseInt(
          this.header.dataset.height || this.header.offsetHeight
        ),
        announcementBar = document.querySelector(selectors$A.announcementBar),
        announcementHeight = announcementBar ? announcementBar.offsetHeight : 0,
        pageOffset = headerHeight + announcementHeight,
        currentScrollTop =
          window.pageYOffset || document.documentElement.scrollTop,
        scrollUp = event2 && event2.detail && event2.detail.up;
      (this.hasScrolled = currentScrollTop > pageOffset),
        document.body.classList.toggle(classes$r.hasScrolled, this.hasScrolled);
      const hideHeaderThreshold = pageOffset + window.stickyHeaderHeight,
        shouldHideHeader = currentScrollTop < hideHeaderThreshold && scrollUp;
      if (
        (document.body.classList.toggle(classes$r.hideHeader, shouldHideHeader),
        window.isHeaderTransparent)
      ) {
        const shouldShowTransparentHeader =
          !this.hasScrolled || shouldHideHeader;
        this.header.classList.toggle(
          classes$r.headerTransparent,
          shouldShowTransparentHeader
        );
      }
      if (this.header.classList.contains(classes$r.headerHovered)) {
        const currentHeight = this.hasScrolled
          ? window.stickyHeaderHeight
          : headerHeight;
        this.background.style.setProperty(
          "--header-background-height",
          `${currentHeight}px`
        );
        const activeNavItem = this.header.querySelector(
          `.${classes$r.isVisible}${selectors$A.navItem}`
        );
        activeNavItem &&
          activeNavItem.dispatchEvent(new Event("mouseenter", { bubbles: !0 }));
      }
    }
    handleBackgroundEvents() {
      this.headerWrapper.addEventListener(
        "mouseenter",
        this.updateBackgroundHeightEvent
      ),
        this.headerWrapper.addEventListener(
          "mouseleave",
          this.updateBackgroundHeightEvent
        ),
        this.header.addEventListener(
          "focusout",
          this.updateBackgroundHeightEvent
        ),
        document.addEventListener(
          "theme:cart:close",
          this.updateBackgroundHeightEvent
        ),
        document.addEventListener(
          "theme:search:close",
          this.updateBackgroundHeightEvent
        );
    }
    updateBackgroundHeight(event2) {
      const isDesktop2 = matchMedia("(pointer:fine)").matches,
        isFocusEnabled = !document.body.classList.contains(classes$r.noOutline),
        isNotTabbingOnDesktop = isDesktop2 && !isFocusEnabled;
      if (!event2) return;
      let drawersVisible = classes$r.jsDrawerOpenAll.some((popupClass) =>
        document.body.classList.contains(popupClass)
      );
      (event2.type === "mouseenter" || drawersVisible) &&
        ((this.headerHeight = this.hasScrolled
          ? window.stickyHeaderHeight
          : this.header.offsetHeight),
        this.header.classList.add(classes$r.headerHovered),
        this.header.classList.contains(classes$r.headerMenuOpened) ||
          this.background.style.setProperty(
            "--header-background-height",
            `${this.headerHeight}px`
          )),
        event2.type !== "mouseenter" &&
          requestAnimationFrame(() => {
            if (
              ((drawersVisible = classes$r.jsDrawerOpenAll.some((popupClass) =>
                document.body.classList.contains(popupClass)
              )),
              drawersVisible ||
                (event2.type === "focusout" && !isDesktop2) ||
                (event2.type === "theme:search:close" &&
                  !isNotTabbingOnDesktop) ||
                this.hasScrolled)
            )
              return;
            const focusOutOfHeader =
                document.activeElement.closest(selectors$A.header) === null,
              isSearchOpened = document.body.classList.contains(
                classes$r.searchOpened
              ),
              headerMenuOpened = this.header.classList.contains(
                classes$r.headerMenuOpened
              );
            isSearchOpened ||
              headerMenuOpened ||
              (event2.type === "focusout" && !focusOutOfHeader) ||
              (this.header.classList.remove(classes$r.headerHovered),
              this.background.style.setProperty(
                "--header-background-height",
                "0px"
              ),
              isFocusEnabled || document.activeElement.blur());
          });
    }
    listenWidth() {
      document.addEventListener("theme:resize", this.checkWidthEvent),
        this.checkWidth();
    }
    checkWidth() {
      window.innerWidth < this.minWidth
        ? this.header.classList.add(classes$r.headerCompress)
        : this.header.classList.remove(classes$r.headerCompress);
    }
    getMinWidth() {
      const headerWrapperStyles =
          this.headerWrapper.currentStyle ||
          window.getComputedStyle(this.headerWrapper),
        headerPaddings = parseInt(headerWrapperStyles.paddingLeft) * 2,
        comparitor = this.header.cloneNode(!0);
      comparitor.classList.add(classes$r.cloneClass),
        document.body.appendChild(comparitor);
      const wideElements = comparitor.querySelectorAll(
          selectors$A.widthContent
        ),
        navAlignment = this.header.getAttribute(attributes$n.navAlignment),
        minWidth = _sumSplitWidths(wideElements, navAlignment);
      return (
        document.body.removeChild(comparitor),
        minWidth + wideElements.length * 20 + headerPaddings
      );
    }
    initMobileNav() {
      if (
        ((this.mobileMenu = this.headerSection.querySelector(
          selectors$A.mobileMenu
        )),
        (this.navDrawer = this.headerSection.querySelector(
          selectors$A.navDrawer
        )),
        (this.drawerToggle = this.navDrawer.querySelector(
          selectors$A.drawerToggle
        )),
        (this.navSearchOpen = this.navDrawer.querySelectorAll(
          selectors$A.navSearchOpen
        )),
        this.navSearchOpen?.forEach((element) => {
          element.addEventListener("click", (event2) => {
            event2.preventDefault();
            const drawer2 = this.drawerToggle.closest(
                `${selectors$A.drawer}.${classes$r.isOpen}`
              ),
              popdownToggle = matchMedia("(pointer:coarse)").matches
                ? this.mobileMenu.querySelector(selectors$A.popdownToggle)
                : this.nav.querySelector(selectors$A.popdownToggle);
            this.drawerToggle.dispatchEvent(
              new Event("click", { bubbles: !0 })
            );
            const onDrawerTransitionEnd = (e) => {
              e.target === drawer2 &&
                (requestAnimationFrame(() =>
                  popdownToggle.dispatchEvent(
                    new Event("click", { bubbles: !0 })
                  )
                ),
                drawer2.removeEventListener(
                  "transitionend",
                  onDrawerTransitionEnd
                ));
            };
            drawer2.addEventListener("transitionend", onDrawerTransitionEnd);
          });
        }),
        theme.settings.mobileMenuBehaviour === "link")
      )
        return;
      const navMobileLinks = this.headerSection.querySelectorAll(
        selectors$A.navLinkMobile
      );
      navMobileLinks.length &&
        navMobileLinks.forEach((link) => {
          link.addEventListener("click", (e) => {
            const hasDropdown = link.parentNode.querySelectorAll(
                selectors$A.mobileNavDropdownTrigger
              ).length,
              dropdownTrigger = link.nextElementSibling;
            hasDropdown &&
              (e.preventDefault(),
              dropdownTrigger.dispatchEvent(new Event("click"), {
                bubbles: !0,
              }));
          });
        });
    }
    onUnload() {
      document.documentElement.style.removeProperty("--header-height"),
        document.documentElement.style.removeProperty("--header-sticky-height"),
        this.initStickyHeader(),
        document.body.classList.remove(...classes$r.jsDrawerOpenAll),
        document.removeEventListener("theme:scroll", this.headerStateEvent),
        document.removeEventListener("theme:resize", this.checkWidthEvent),
        document.removeEventListener(
          "theme:cart:close",
          this.updateBackgroundHeightEvent
        ),
        document.removeEventListener(
          "theme:search:close",
          this.updateBackgroundHeightEvent
        ),
        document.body.removeEventListener(
          "touchstart",
          this.handleTouchstartEvent
        ),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        ),
        typeof window.cart.unload == "function" && window.cart.unload();
    }
  }
  function _sumSplitWidths(nodes, alignment) {
    let arr = [];
    nodes.forEach((el) => {
      arr.push(el.clientWidth);
    });
    let [logoWidth, navWidth, iconsWidth] = arr;
    if (alignment === "left") {
      const tempWidth = logoWidth;
      (logoWidth = navWidth), (navWidth = tempWidth);
    }
    return (
      alignment !== "right" &&
        (logoWidth > iconsWidth
          ? (iconsWidth = logoWidth)
          : (logoWidth = iconsWidth)),
      logoWidth + navWidth + iconsWidth
    );
  }
  register("header", [
    {
      onLoad() {
        sections$s[this.id] = new Header(this.container);
      },
      onUnload() {
        sections$s[this.id].onUnload();
      },
    },
    hoverDisclosure,
    drawer,
  ]);
  const selectors$z = { trigger: "[data-collapsible-trigger]" },
    classes$q = { isExpanded: "is-expanded" };
  register("accordions", [
    {
      onBlockSelect(e) {
        const trigger = e.target.querySelector(selectors$z.trigger);
        requestAnimationFrame(() => {
          trigger.classList.contains(classes$q.isExpanded) ||
            trigger.dispatchEvent(new Event("click"));
        });
      },
    },
    collapsible,
  ]);
  const selectors$y = {
      button: "[data-share-button]",
      tooltip: "[data-share-button-tooltip]",
    },
    classes$p = { visible: "is-visible", hiding: "is-hiding" },
    sections$r = {};
  class ShareButton {
    constructor(container) {
      (this.container = container),
        (this.button = this.container.querySelector(selectors$y.button)),
        (this.tooltip = this.container.querySelector(selectors$y.tooltip)),
        (this.transitionSpeed = 200),
        (this.hideTransitionTimeout = 0),
        this.init();
    }
    init() {
      this.button &&
        this.button.addEventListener("click", () => {
          let targetUrl = window.location.href;
          this.button.dataset.shareLink &&
            (targetUrl = this.button.dataset.shareLink),
            this.tooltip.classList.contains(classes$p.visible) ||
              navigator.clipboard.writeText(targetUrl).then(() => {
                this.tooltip.classList.add(classes$p.visible),
                  setTimeout(() => {
                    this.tooltip.classList.add(classes$p.hiding),
                      this.tooltip.classList.remove(classes$p.visible),
                      this.hideTransitionTimeout &&
                        clearTimeout(this.hideTransitionTimeout),
                      (this.hideTransitionTimeout = setTimeout(() => {
                        this.tooltip.classList.remove(classes$p.hiding);
                      }, this.transitionSpeed));
                  }, 1500);
              });
        });
    }
  }
  const shareButton = {
    onLoad() {
      sections$r[this.id] = new ShareButton(this.container);
    },
  };
  register("article", [shareButton]);
  const selectors$x = { videoPlay: "[data-video-play]" },
    attributes$m = { videoPlayValue: "data-video-play" };
  class VideoPlay {
    constructor(container) {
      (this.container = container),
        (this.videoPlay = this.container.querySelectorAll(
          selectors$x.videoPlay
        )),
        (this.a11y = a11y),
        this.init();
    }
    init() {
      this.videoPlay.length &&
        this.videoPlay.forEach((element) => {
          element.addEventListener("click", (e) => {
            if (
              element.hasAttribute(attributes$m.videoPlayValue) &&
              element.getAttribute(attributes$m.videoPlayValue).trim() !== ""
            ) {
              e.preventDefault();
              const items = [
                  { html: element.getAttribute(attributes$m.videoPlayValue) },
                ],
                options2 = { mainClass: "pswp--video" };
              (this.a11y.state.trigger = element),
                new LoadPhotoswipe(items, options2);
            }
          });
        });
    }
  }
  const videoPlay = {
      onLoad() {
        new VideoPlay(this.container);
      },
    },
    selectors$w = {
      imageWrapper: "[data-banner-image]",
      lazyImage: ".lazy-image",
      parallax:
        '[data-parallax="zoom-on-scroll"],[data-parallax="card-scrolling"],[data-parallax="zoom-on-scroll,card-scrolling"]',
    },
    classes$o = {
      bannerNoCachedImages: "banner--no-cached-images",
      bannerImgLoaded: "banner--img-loaded",
      imgIn: "img-in",
    },
    sections$q = {};
  class BannerImage {
    constructor(section) {
      (this.container = section.container), (this.parallax = null), this.init();
    }
    init() {
      this.handleImageAnimation(!0),
        this.container.matches(selectors$w.parallax) &&
          (this.parallax = new ParallaxElement(this.container));
    }
    handleImageAnimation(onLoad = !1) {
      if (!onLoad) {
        this.container.classList.remove(classes$o.bannerNoCachedImages),
          this.container.classList.remove(classes$o.bannerImgLoaded);
        return;
      }
      const img = this.container
          .querySelector(selectors$w.imageWrapper)
          .querySelectorAll(selectors$w.lazyImage),
        imgComplete = this.container.classList.contains(classes$o.imgIn);
      if (img.length && !imgComplete) {
        this.container.classList.add(classes$o.bannerNoCachedImages);
        const onImageTransitionEnd = (event2) => {
          requestAnimationFrame(() =>
            this.container.classList.add(classes$o.bannerImgLoaded)
          ),
            img[0].removeEventListener("transitionend", onImageTransitionEnd);
        };
        img[0].addEventListener("transitionend", onImageTransitionEnd);
      }
    }
    onReorder() {
      this.handleImageAnimation(!1);
    }
    onUnload() {
      this.handleImageAnimation(!1),
        this.parallax && (this.parallax.unload(), (this.parallax = null));
    }
  }
  register("banner-image", [
    {
      onLoad() {
        sections$q[this.id] = new BannerImage(this);
      },
      onReorder(e) {
        sections$q[this.id].onReorder(e);
      },
      onUnload(e) {
        sections$q[this.id].onUnload(e);
      },
    },
    videoPlay,
  ]);
  const selectors$v = { scrollSpy: "[data-scroll-spy]" },
    classes$n = { selected: "is-selected", isFullHeight: "is-full-height" },
    attributes$l = {
      scrollSpy: "data-scroll-spy",
      scrollSpyPrevent: "data-scroll-spy-prevent",
      mobile: "data-scroll-spy-mobile",
      desktop: "data-scroll-spy-desktop",
    },
    sections$p = {};
  class ScrollSpy {
    constructor(section, element) {
      (this.container = section),
        (this.element = element),
        this.element &&
          ((this.anchorSelector = `[${attributes$l.scrollSpy}="#${this.element.id}"]`),
          (this.anchor = this.container.querySelector(this.anchorSelector)),
          (this.anchors = this.container.querySelectorAll(
            `[${attributes$l.scrollSpy}]`
          )),
          this.anchor &&
            ((this.scrollCallback = () => this.onScroll()), this.init()));
    }
    init() {
      this.onScroll(),
        document.addEventListener("theme:scroll", this.scrollCallback),
        document.addEventListener("theme:resize:width", this.scrollCallback);
    }
    isEligible() {
      return this.container.hasAttribute(attributes$l.scrollSpyPrevent)
        ? !1
        : (isMobile() && this.anchor.hasAttribute(attributes$l.mobile)) ||
            (isDesktop() && this.anchor.hasAttribute(attributes$l.desktop)) ||
            (!this.anchor.hasAttribute(attributes$l.desktop) &&
              !this.anchor.hasAttribute(attributes$l.mobile));
    }
    onScroll() {
      if (!this.isEligible()) return;
      (this.top = this.element.getBoundingClientRect().top),
        (this.bottom = this.element.getBoundingClientRect().bottom);
      const windowHeight = Math.round(window.innerHeight),
        scrollTop = Math.round(window.scrollY),
        scrollBottom = scrollTop + windowHeight,
        elementOffsetTopPoint = Math.round(this.top + scrollTop),
        elementHeight = this.element.offsetHeight,
        isBottomOfElementPassed =
          elementOffsetTopPoint + elementHeight < scrollTop;
      if (!(elementOffsetTopPoint < scrollBottom && !isBottomOfElementPassed))
        return;
      this.anchor.parentNode.offsetHeight <= elementHeight
        ? this.container.style.setProperty(
            "--sticky-position",
            `${window.innerHeight / 2 - elementHeight / 2}px`
          )
        : this.container.classList.add(classes$n.isFullHeight),
        (this.anchorTop = this.anchor.getBoundingClientRect().top),
        (this.anchorBottom = this.anchor.getBoundingClientRect().bottom);
      const anchorTopPassedElementTop = this.top < this.anchorTop,
        anchorBottomPassedElementBottom = this.bottom < this.anchorBottom;
      anchorTopPassedElementTop &&
        !anchorBottomPassedElementBottom &&
        (this.anchors.forEach((anchor) => {
          anchor.matches(this.anchorSelector) ||
            anchor.classList.remove(classes$n.selected);
        }),
        this.anchor.classList.add(classes$n.selected));
    }
    onUnload() {
      document.removeEventListener("theme:scroll", this.scrollCallback),
        document.removeEventListener("theme:resize:width", this.scrollCallback);
    }
  }
  const scrollSpy = {
      onLoad() {
        (sections$p[this.id] = []),
          this.container
            .querySelectorAll(selectors$v.scrollSpy)
            .forEach((element) => {
              const scrollSpy2 = this.container.querySelector(
                element.getAttribute(attributes$l.scrollSpy)
              );
              sections$p[this.id].push(
                new ScrollSpy(this.container, scrollSpy2)
              );
            });
      },
      onUnload() {
        sections$p[this.id].forEach((element) => {
          typeof element.onUnload == "function" && element.onUnload();
        });
      },
    },
    selectors$u = {
      banner: "[data-banner]",
      sliderContent: "[data-slider-content]",
      sliderMedia: "[data-slider-media]",
      links: "a, button",
    },
    attributes$k = {
      index: "data-index",
      tabIndex: "tabindex",
      singleImage: "data-slider-single-image",
      scrollSpyPrevent: "data-scroll-spy-prevent",
    },
    classes$m = { isSelected: "is-selected" },
    settings$2 = { row: "row", columns: "columns" };
  let sections$o = {};
  class BannerWithTextColumns {
    constructor(section) {
      (this.container = section.container),
        (this.sliderContent = this.container.querySelector(
          selectors$u.sliderContent
        )),
        (this.singleImageEnabled = this.sliderContent?.hasAttribute(
          attributes$k.singleImage
        )),
        (this.banners = this.container.querySelectorAll(selectors$u.banner)),
        (this.links = this.container.querySelectorAll("a")),
        (this.sliderMedia = this.container.querySelector(
          selectors$u.sliderMedia
        )),
        (this.flktyContent = null),
        (this.flktyMedia = null),
        (this.onResizeCallback = () => this.handleSlidersOnResize()),
        (this.appearance = this.container.dataset.appearance),
        this.appearance === settings$2.columns
          ? this.handleColumnsLayout()
          : this.handleRowLayout();
    }
    listen() {
      document.addEventListener("theme:resize:width", this.onResizeCallback),
        this.links.forEach((link) => {
          link.addEventListener("focus", () => {
            const selectedIndex = Number(
              link.closest(selectors$u.banner).getAttribute(attributes$k.index)
            );
            window.innerWidth >= theme.sizes.small && this.sync(selectedIndex);
          });
        }),
        this.banners.forEach((slide) => {
          slide.addEventListener("mouseenter", () => {
            const selectedIndex = Number(
              slide.getAttribute(attributes$k.index)
            );
            window.innerWidth >= theme.sizes.small &&
              !window.theme.touch &&
              this.sync(selectedIndex);
          }),
            slide.addEventListener("pointerup", () => {
              const selectedIndex = Number(
                slide.getAttribute(attributes$k.index)
              );
              window.innerWidth >= theme.sizes.small &&
                window.theme.touch &&
                this.sync(selectedIndex);
            });
        });
    }
    handleColumnsLayout() {
      if (this.sliderContent.children.length <= 1) return;
      let isDraggable = window.innerWidth < window.theme.sizes.small;
      this.sliderMedia.children.length > 1 &&
        ((this.flktyMedia = new Flickity(this.sliderMedia, {
          draggable: !1,
          wrapAround: !1,
          fade: !0,
          prevNextButtons: !1,
          adaptiveHeight: !1,
          pageDots: !1,
          setGallerySize: !1,
          on: {
            change: (index) => {
              this.handleGroupItemsNavigation(index, this.flktyContent);
            },
          },
        })),
        flickitySmoothScrolling(this.sliderMedia)),
        (this.flktyContent = new Flickity(this.sliderContent, {
          draggable: isDraggable,
          prevNextButtons: !1,
          pageDots: !0,
          cellAlign: "left",
          adaptiveHeight: !1,
          imagesLoaded: !0,
          on: {
            ready: () => {
              this.listen(), this.slidesTabIndex();
            },
            change: (index) => {
              window.innerWidth < theme.sizes.small &&
                !this.singleImageEnabled &&
                this.flktyMedia.select(index),
                this.slidesTabIndex(),
                this.handleGroupItemsNavigation(index, this.flktyMedia);
            },
          },
        })),
        flickitySmoothScrolling(this.sliderContent);
    }
    handleRowLayout() {
      if (this.sliderMedia.children.length <= 1 || isMobile()) {
        this.updateState(0), this.listen();
        return;
      }
      this.initMediaSlider();
    }
    initMediaSlider() {
      (this.flktyMedia = new Flickity(this.sliderMedia, {
        draggable: !0,
        wrapAround: !1,
        fade: !0,
        prevNextButtons: !1,
        adaptiveHeight: !1,
        pageDots: !1,
        setGallerySize: !1,
        on: {
          ready: () => {
            this.updateState(0), this.listen();
          },
          change: (index) => {
            this.updateState(index);
          },
        },
      })),
        flickitySmoothScrolling(this.sliderMedia);
    }
    handleGroupItemsNavigation(index, sliderToSync = null) {
      sliderToSync !== null &&
        requestAnimationFrame(() => {
          index !== sliderToSync.selectedIndex && sliderToSync.select(index);
        });
    }
    slidesTabIndex() {
      if (!this.sliderContent) return;
      Flickity.data(this.sliderContent).cells.forEach((slide) => {
        let tabIndex = "-1";
        slide.element.classList.contains(classes$m.isSelected) &&
          (tabIndex = "0"),
          slide.element.querySelectorAll(selectors$u.links).forEach((link) => {
            link.setAttribute(attributes$k.tabIndex, tabIndex);
          });
      });
    }
    sync(index = 0) {
      this.appearance === settings$2.columns
        ? this.flktyContent.selectCell(index)
        : this.updateState(index),
        this.flktyMedia && this.flktyMedia.selectCell(index);
    }
    updateState(index = 0) {
      this.banners.forEach((element) => {
        const elementIndex = Number(element.getAttribute(attributes$k.index));
        element.classList.toggle(classes$m.isSelected, elementIndex === index);
      });
    }
    handleSlidersOnResize() {
      if (this.appearance === settings$2.row) {
        if (isMobile() && this.flktyMedia) {
          this.flktyMedia.destroy(), (this.flktyMedia = null);
          return;
        }
        if (isDesktop() && !this.flktyMedia) {
          this.initMediaSlider();
          return;
        }
      }
      this.flktyContent && (this.flktyContent.resize(), this.toggleDraggable()),
        this.flktyMedia && this.flktyMedia.resize();
    }
    toggleDraggable() {
      (this.flktyContent.options.draggable =
        window.innerWidth < window.theme.sizes.small),
        this.flktyContent.updateDraggable();
    }
    onBlockSelect(event2) {
      const selectedIndex = parseInt(
        [...event2.target.parentNode.children].indexOf(event2.target)
      );
      if ((this.sync(selectedIndex), this.appearance === settings$2.row)) {
        const target = this.sliderMedia.children[selectedIndex],
          targetOffsetTop = Math.round(target.getBoundingClientRect().top);
        this.container.setAttribute(attributes$k.scrollSpyPrevent, ""),
          setTimeout(() => scrollTo(targetOffsetTop), 400),
          setTimeout(
            () => this.container.removeAttribute(attributes$k.scrollSpyPrevent),
            1e3
          );
      }
    }
    onUnload() {
      document.removeEventListener("theme:resize:width", this.onResizeCallback);
    }
  }
  register("banner-with-text-columns", [
    {
      onLoad() {
        sections$o[this.id] = new BannerWithTextColumns(this);
      },
      onBlockSelect(event2) {
        sections$o[this.id].onBlockSelect(event2);
      },
    },
    scrollSpy,
  ]),
    register("blog-posts", ajaxify);
  const selectors$t = {
      slider: "[data-slider]",
      sliderItem: "[data-slider-item]",
      sliderItemImage: "[data-media-container]",
      links: "a, button",
      flickityButton: ".flickity-button",
    },
    classes$l = {
      carouselInactive: "carousel--inactive",
      carouselResize: "carousel--resize",
    },
    attributes$j = { tabIndex: "tabindex" },
    sections$n = {};
  class ColumnsWithImage {
    constructor(section) {
      (this.container = section.container),
        (this.slider = this.container.querySelector(selectors$t.slider)),
        (this.flkty = null),
        (this.gutter = 0),
        (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
        this.listen();
    }
    initSlider() {
      this.slider.classList.remove(classes$l.carouselInactive),
        (this.flkty = new Flickity(this.slider, {
          pageDots: !1,
          cellAlign: "left",
          groupCells: !0,
          contain: !0,
          on: {
            ready: () => {
              this.setSliderArrowsPosition(this.slider),
                setTimeout(() => {
                  this.changeTabIndex(), this.flkty.resize();
                }, 0);
            },
            change: () => {
              this.changeTabIndex();
            },
          },
        })),
        (Flickity.prototype._createResizeClass = function () {
          this.element.classList.add(classes$l.carouselResize);
        }),
        Flickity.createMethods.push("_createResizeClass");
      const resize = Flickity.prototype.resize;
      Flickity.prototype.resize = function () {
        this.element.classList.remove(classes$l.carouselResize),
          resize.call(this),
          this.element.classList.add(classes$l.carouselResize);
      };
    }
    destroySlider() {
      this.slider.classList.add(classes$l.carouselInactive),
        this.flkty !== null && (this.flkty.destroy(), (this.flkty = null));
    }
    checkSlidesSize() {
      const sliderItemStyle =
        this.container.querySelector(selectors$t.sliderItem).currentStyle ||
        window.getComputedStyle(
          this.container.querySelector(selectors$t.sliderItem)
        );
      this.gutter = parseInt(sliderItemStyle.marginRight);
      const containerWidth = this.slider.offsetWidth,
        itemsWidth = this.getItemsWidth(),
        itemsOverflowViewport = containerWidth < itemsWidth;
      window.innerWidth >= theme.sizes.small && itemsOverflowViewport
        ? this.initSlider()
        : this.destroySlider();
    }
    changeTabIndex() {
      const selectedElementsIndex = this.flkty.selectedIndex;
      this.flkty.slides.forEach((slide, index) => {
        slide.cells.forEach((cell) => {
          cell.element.querySelectorAll(selectors$t.links).forEach((link) => {
            link.setAttribute(
              attributes$j.tabIndex,
              selectedElementsIndex === index ? "0" : "-1"
            );
          });
        });
      });
    }
    getItemsWidth() {
      let itemsWidth = 0;
      const slides = this.slider.querySelectorAll(selectors$t.sliderItem);
      return (
        slides.length &&
          slides.forEach((item) => {
            itemsWidth += item.offsetWidth + this.gutter;
          }),
        itemsWidth
      );
    }
    listen() {
      this.slider &&
        (this.checkSlidesSize(),
        document.addEventListener(
          "theme:resize:width",
          this.checkSlidesSizeOnResize
        ));
    }
    setSliderArrowsPosition(slider2) {
      const arrows = slider2.querySelectorAll(selectors$t.flickityButton),
        image = slider2.querySelector(selectors$t.sliderItemImage);
      arrows.length &&
        image &&
        arrows.forEach((arrow) => {
          arrow.style.top = `${image.offsetHeight / 2}px`;
        });
    }
    onBlockSelect(evt) {
      if (this.flkty !== null) {
        const index = parseInt(
            [...evt.target.parentNode.children].indexOf(evt.target)
          ),
          slidesPerPage = parseInt(this.flkty.slides[0].cells.length),
          groupIndex = Math.floor(index / slidesPerPage);
        this.flkty.select(groupIndex);
      } else {
        const sliderStyle =
            this.slider.currentStyle || window.getComputedStyle(this.slider),
          sliderPadding = parseInt(sliderStyle.paddingLeft),
          blockPositionLeft = evt.target.offsetLeft - sliderPadding;
        this.slider.scrollTo({
          top: 0,
          left: blockPositionLeft,
          behavior: "smooth",
        });
      }
    }
    onUnload() {
      document.removeEventListener(
        "theme:resize:width",
        this.checkSlidesSizeOnResize
      );
    }
  }
  register("columns-with-image", [
    {
      onLoad() {
        sections$n[this.id] = new ColumnsWithImage(this);
      },
      onUnload(e) {
        sections$n[this.id].onUnload(e);
      },
      onBlockSelect(e) {
        sections$n[this.id].onBlockSelect(e);
      },
    },
    videoPlay,
  ]);
  const selectors$s = {
      formMessageClose: "[data-form-message-close]",
      formMessageWrapper: "[data-form-message]",
    },
    classes$k = {
      hideDown: "hide-down",
      notificationVisible: "notification-visible",
    };
  let sections$m = {};
  class ContactForm {
    constructor(section) {
      (this.container = section.container),
        (this.closeButton = this.container.querySelector(
          selectors$s.formMessageClose
        )),
        (this.messageWrapper = this.container.querySelector(
          selectors$s.formMessageWrapper
        )),
        this.messageWrapper &&
          (this.hidePopups(), this.closeFormMessage(), this.autoHideMessage());
    }
    hidePopups() {
      document.body.classList.add(classes$k.notificationVisible);
    }
    showPopups() {
      document.body.classList.remove(classes$k.notificationVisible);
    }
    closeFormMessage() {
      this.closeButton.addEventListener("click", this.closeMessage.bind(this));
    }
    closeMessage(e) {
      e.preventDefault(),
        this.messageWrapper.classList.add(classes$k.hideDown),
        this.showPopups();
    }
    autoHideMessage() {
      setTimeout(() => {
        this.messageWrapper.classList.add(classes$k.hideDown),
          this.showPopups();
      }, 1e4);
    }
  }
  register("contact-form", {
    onLoad() {
      sections$m[this.id] = new ContactForm(this);
    },
  });
  const selectors$r = {
      time: "time",
      days: "[data-days]",
      hours: "[data-hours]",
      minutes: "[data-minutes]",
      seconds: "[data-seconds]",
      sectionType: "[data-section-type]",
      shopifySection: ".shopify-section",
      aosItem: "[data-aos]",
    },
    classes$j = {
      countdownTimerShowMessage: "countdown-timer--show-message",
      hideCountdown: "hide-countdown",
      aosAnimate: "aos-animate",
      aosLoading: "aos-loading",
      countdown: "countdown",
    },
    attributes$i = {
      expirationBehavior: "data-expiration-behavior",
      leadingZero: "data-leading-zero",
    },
    settings$1 = { hide: "hide", showMessage: "show-message" };
  class CountdownTimer extends HTMLElement {
    constructor() {
      super(),
        (this.section = this.closest(selectors$r.sectionType)),
        (this.shopifySection = this.closest(selectors$r.shopifySection)),
        (this.expirationBehavior = this.getAttribute(
          attributes$i.expirationBehavior
        )),
        (this.leadingZero = this.hasAttribute(attributes$i.leadingZero)),
        (this.time = this.querySelector(selectors$r.time)),
        (this.endDate = Date.parse(this.time.dateTime)),
        (this.days = this.querySelector(selectors$r.days)),
        (this.hours = this.querySelector(selectors$r.hours)),
        (this.minutes = this.querySelector(selectors$r.minutes)),
        (this.seconds = this.querySelector(selectors$r.seconds)),
        (this.daysInMs = 1e3 * 60 * 60 * 24),
        (this.hoursInMs = this.daysInMs / 24),
        (this.minutesInMs = this.hoursInMs / 60),
        (this.secondsInMs = this.minutesInMs / 60),
        (this.isLoading = !0),
        (this.shouldHideOnComplete =
          this.expirationBehavior === settings$1.hide),
        (this.shouldShowMessage =
          this.expirationBehavior === settings$1.showMessage),
        (this.isAnimated = !1),
        (this.update = this.update.bind(this));
    }
    connectedCallback() {
      this.init();
    }
    disconnectedCallback() {
      this.stopTimer();
    }
    init() {
      if (isNaN(this.endDate)) {
        this.onComplete();
        return;
      }
      if (this.endDate <= Date.now()) {
        this.onComplete();
        return;
      }
      this.section.classList.contains(classes$j.countdown) && this.onLoad(!0),
        (this.interval = setInterval(this.update, 1e3));
    }
    stopTimer() {
      clearInterval(this.interval);
    }
    convertTime(timeInMs) {
      const days = this.formatDigits(parseInt(timeInMs / this.daysInMs, 10));
      timeInMs -= days * this.daysInMs;
      const hours = this.formatDigits(parseInt(timeInMs / this.hoursInMs, 10));
      timeInMs -= hours * this.hoursInMs;
      const minutes = this.formatDigits(
        parseInt(timeInMs / this.minutesInMs, 10)
      );
      timeInMs -= minutes * this.minutesInMs;
      const seconds = this.formatDigits(
        parseInt(timeInMs / this.secondsInMs, 10)
      );
      return { days, hours, minutes, seconds };
    }
    formatDigits(number) {
      return number < 10 && this.leadingZero && (number = "0" + number), number;
    }
    render(timer) {
      (this.days.textContent = timer.days),
        (this.hours.textContent = timer.hours),
        (this.minutes.textContent = timer.minutes),
        (this.seconds.textContent = timer.seconds);
    }
    onComplete() {
      this.render({ days: 0, hours: 0, minutes: 0, seconds: 0 }),
        this.shouldHideOnComplete &&
          this.shopifySection.classList.add(classes$j.hideCountdown),
        this.shouldShowMessage &&
          this.classList.add(classes$j.countdownTimerShowMessage);
    }
    triggerAnimations() {
      theme.settings.animations != "false" &&
        this.section
          .querySelectorAll(selectors$r.aosItem)
          .forEach((element) => {
            this.isAnimated && element.classList.add(classes$j.aosAnimate);
          });
    }
    removeAnimations() {
      this.section.querySelectorAll(selectors$r.aosItem).forEach((element) => {
        requestAnimationFrame(() => {
          element.classList.contains(classes$j.aosAnimate) &&
            (element.classList.remove(classes$j.aosAnimate),
            (this.isAnimated = !0));
        });
      });
    }
    onLoad(init) {
      if (init) {
        this.removeAnimations();
        return;
      }
      (this.isLoading = !1), this.triggerAnimations();
    }
    update() {
      const currentDate = Date.now(),
        timeDiff = this.endDate - currentDate;
      if (timeDiff <= 0) {
        this.stopTimer(), this.onComplete();
        return;
      }
      const remainingTime = this.convertTime(timeDiff);
      this.render(remainingTime), this.isLoading && this.onLoad(!1);
    }
  }
  register("countdown", [videoPlay, parallaxSection]),
    customElements.get("countdown-timer") ||
      customElements.define("countdown-timer", CountdownTimer);
  const selectors$q = {
      videoId: "[data-video-id]",
      videoPlayer: "[data-video-player]",
      videoTemplate: "[data-video-template]",
      videoAutoplay: "[data-video-autoplay]",
      videoWrapper: "[data-video-wrapper]",
      videoPlayButton: "[data-video-bg-play]",
    },
    classes$i = { loading: "is-loading", paused: "is-paused" },
    sections$l = {};
  class VideoBackground {
    constructor(container) {
      (this.container = container),
        (this.videoId = this.container.querySelector(selectors$q.videoId)),
        (this.videoPlayer = this.container.querySelector(
          selectors$q.videoPlayer
        )),
        (this.videoTemplate = this.container.querySelector(
          selectors$q.videoTemplate
        )),
        (this.videoPlayButton = this.container.querySelector(
          selectors$q.videoPlayButton
        )),
        this.init();
    }
    init() {
      if (!this.videoId) return;
      new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const videoMarkup = this.videoTemplate.innerHTML;
              (this.videoPlayer.innerHTML = videoMarkup),
                (this.video = this.container.querySelector(
                  selectors$q.videoAutoplay
                )),
                this.videoPlayer.classList.remove(classes$i.loading),
                this.container.classList.add(classes$i.paused),
                this.listen(),
                observer.unobserve(entry.target);
            }
          });
        },
        {
          root: null,
          rootMargin: "300px",
          threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
        }
      ).observe(this.videoPlayer),
        this.videoPlayButton.addEventListener("click", (event2) => {
          event2.preventDefault(), this.video?.play();
        });
    }
    listen() {
      this.video.addEventListener("play", () => {
        this.container.classList.remove(classes$i.paused);
      }),
        this.container.addEventListener(
          "touchstart",
          () => {
            this.video.play();
          },
          { passive: !0 }
        );
    }
  }
  const videoBackground = {
    onLoad() {
      (sections$l[this.id] = []),
        this.container
          .querySelectorAll(selectors$q.videoWrapper)
          .forEach((videoWrapper) => {
            sections$l[this.id].push(new VideoBackground(videoWrapper));
          });
    },
  };
  class PopupCookie {
    constructor(name, value) {
      (this.configuration = {
        expires: null,
        path: "/",
        domain: window.location.hostname,
        sameSite: "none",
        secure: !0,
      }),
        (this.name = name),
        (this.value = value);
    }
    write() {
      ((document.cookie.indexOf("; ") !== -1 &&
        !document.cookie
          .split("; ")
          .find((row) => row.startsWith(this.name))) ||
        document.cookie.indexOf("; ") === -1) &&
        (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
    }
    read() {
      return document.cookie.indexOf("; ") !== -1 &&
        document.cookie.split("; ").find((row) => row.startsWith(this.name))
        ? document.cookie
            .split("; ")
            .find((row) => row.startsWith(this.name))
            .split("=")[1]
        : !1;
    }
    destroy() {
      document.cookie.split("; ").find((row) => row.startsWith(this.name)) &&
        (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
    }
  }
  const selectors$p = {
      newsletterForm: "[data-newsletter-form]",
      popup: "[data-popup]",
    },
    classes$h = { success: "has-success", error: "has-error" },
    attributes$h = { storageNewsletterFormId: "newsletter_form_id" },
    sections$k = {};
  class Newsletter {
    constructor(newsletter) {
      (this.newsletter = newsletter),
        (this.sessionStorage = window.sessionStorage),
        (this.popup = this.newsletter.closest(selectors$p.popup)),
        (this.stopSubmit = !0),
        (this.isChallengePage = !1),
        (this.formID = null),
        (this.formIdSuccess = null),
        this.checkForChallengePage(),
        (this.newsletterSubmit = (e) => this.newsletterSubmitEvent(e)),
        this.isChallengePage || this.init();
    }
    init() {
      this.newsletter.addEventListener("submit", this.newsletterSubmit),
        this.showMessage();
    }
    newsletterSubmitEvent(e) {
      this.stopSubmit &&
        (e.preventDefault(),
        this.removeStorage(),
        this.writeStorage(),
        (this.stopSubmit = !1),
        this.newsletter.submit());
    }
    checkForChallengePage() {
      this.isChallengePage =
        window.location.pathname === theme.routes.root + "challenge";
    }
    writeStorage() {
      this.sessionStorage !== void 0 &&
        this.sessionStorage.setItem(
          attributes$h.storageNewsletterFormId,
          this.newsletter.id
        );
    }
    readStorage() {
      this.formID = this.sessionStorage.getItem(
        attributes$h.storageNewsletterFormId
      );
    }
    removeStorage() {
      this.sessionStorage.removeItem(attributes$h.storageNewsletterFormId);
    }
    showMessage() {
      if ((this.readStorage(), this.newsletter.id === this.formID)) {
        const newsletter = document.getElementById(this.formID),
          submissionSuccess =
            window.location.search.indexOf("?customer_posted=true") !== -1,
          submissionFailure =
            window.location.search.indexOf("accepts_marketing") !== -1;
        submissionSuccess
          ? (newsletter.classList.remove(classes$h.error),
            newsletter.classList.add(classes$h.success),
            this.popup &&
              ((this.cookie = new PopupCookie(
                this.popup.dataset.cookieName,
                "user_has_closed"
              )),
              this.cookie.write()))
          : submissionFailure &&
            (newsletter.classList.remove(classes$h.success),
            newsletter.classList.add(classes$h.error)),
          (submissionSuccess || submissionFailure) &&
            this.scrollToForm(newsletter);
      }
    }
    scrollToForm(newsletter) {
      const rect = newsletter.getBoundingClientRect();
      visibilityHelper.isElementPartiallyVisible(newsletter) ||
        visibilityHelper.isElementTotallyVisible(newsletter) ||
        setTimeout(() => {
          window.scrollTo({ top: rect.top, left: 0, behavior: "smooth" });
        }, 400);
    }
    onUnload() {
      this.newsletter.removeEventListener("submit", this.newsletterSubmit);
    }
  }
  const newsletterSection = {
      onLoad() {
        (sections$k[this.id] = []),
          this.container
            .querySelectorAll(selectors$p.newsletterForm)
            .forEach((form) => {
              sections$k[this.id].push(new Newsletter(form));
            });
      },
      onUnload() {
        sections$k[this.id].forEach((form) => {
          typeof form.onUnload == "function" && form.onUnload();
        });
      },
    },
    selectors$o = {
      product: "[data-product]",
      productSlider: "[data-slider]",
      productSlide: "[data-slide]",
      productGridItemImage: "[data-product-media-container]",
      flickityButton: ".flickity-button",
      item: "[data-slide]",
      links: "a, button",
    },
    attributes$g = { tabIndex: "tabindex" },
    sections$j = {};
  class CustomContent {
    constructor(container) {
      (this.container = container),
        (this.product = this.container.querySelectorAll(selectors$o.product)),
        (this.productSlider = this.container.querySelectorAll(
          selectors$o.productSlider
        )),
        (this.checkSliderOnResize = () => this.checkSlider()),
        (this.resizeSliderEvent = (event2) => this.resizeSlider(event2)),
        (this.flkty = []),
        (this.videoObj = []),
        (this.quickViewObj = []),
        this.listen();
    }
    checkSlider() {
      window.innerWidth >= theme.sizes.small
        ? this.productSlider.forEach((slider2) => {
            this.initProductSlider(slider2);
          })
        : this.productSlider.forEach((slider2) => {
            this.destroyProductSlider(slider2);
          });
    }
    initProductSlider(slider2) {
      const slidesCount = slider2.querySelectorAll(
          selectors$o.productSlide
        ).length,
        sliderId = slider2.dataset.slider;
      slidesCount > 1 &&
        (this.flkty[sliderId] === void 0 || !this.flkty[sliderId].isActive
          ? (this.flkty[sliderId] = new Flickity(slider2, {
              prevNextButtons: !0,
              adaptiveHeight: !0,
              pageDots: !0,
              wrapAround: !0,
              on: {
                ready: () => {
                  this.setSliderArrowsPosition(slider2);
                },
                change: (index) => {
                  this.flkty[sliderId].cells.forEach((slide, i) => {
                    slide.element
                      .querySelectorAll(selectors$o.links)
                      .forEach((link) => {
                        link.setAttribute(
                          attributes$g.tabIndex,
                          i === index ? "0" : "-1"
                        );
                      });
                  });
                },
              },
            }))
          : this.setSliderArrowsPosition(slider2));
    }
    destroyProductSlider(slider2) {
      const sliderId = slider2.dataset.slider;
      typeof this.flkty[sliderId] == "object" && this.flkty[sliderId].destroy();
    }
    setSliderArrowsPosition(slider2) {
      const arrows = slider2.querySelectorAll(selectors$o.flickityButton),
        image = slider2.querySelector(selectors$o.productGridItemImage);
      arrows.length &&
        image &&
        arrows.forEach((arrow) => {
          arrow.style.top = `${image.offsetHeight / 2}px`;
        });
    }
    resizeSlider(event2) {
      const slider2 = event2.target,
        flkty = Flickity.data(slider2) || null;
      flkty && flkty.resize();
    }
    listen() {
      this.checkSlider(),
        document.addEventListener(
          "theme:resize:width",
          this.checkSliderOnResize
        ),
        this.productSlider.forEach((slider2) => {
          slider2.addEventListener(
            "theme:slider:resize",
            this.resizeSliderEvent
          );
        });
    }
    onUnload() {
      if (this.flkty)
        for (const key in this.flkty)
          this.flkty.hasOwnProperty(key) && this.flkty[key].destroy();
      document.removeEventListener(
        "theme:resize:width",
        this.checkSliderOnResize
      ),
        this.productSlider.forEach((slider2) => {
          slider2.removeEventListener(
            "theme:slider:resize",
            this.resizeSliderEvent
          );
        });
    }
  }
  register("custom-content", [
    {
      onLoad() {
        sections$j[this.id] = new CustomContent(this.container);
      },
      onUnload(e) {
        sections$j[this.id].onUnload(e);
      },
    },
    newsletterSection,
    videoPlay,
    tooltip,
    videoBackground,
    productGrid,
  ]);
  const selectors$n = {
      slider: "[data-slider]",
      sliderItem: "[data-slide]",
      productGridItemImage: "[data-product-media-container]",
      links: "a, button",
      flickityButton: ".flickity-button",
      promo: "[data-promo]",
      productGridItems: "[data-product-block]",
    },
    classes$g = {
      carousel: "carousel",
      carouselInactive: "carousel--inactive",
      isLastSlideVisible: "is-last-slide-visible",
      featuredCollection: "featured-collection",
      promoFullWidth: "collection-promo--full",
      promoTwoItemsWidth: "collection-promo--two-columns",
    },
    attributes$f = {
      sliderId: "data-slider-id",
      showImage: "data-slider-show-image",
      tabIndex: "tabindex",
    },
    sections$i = {};
  class GridSlider {
    constructor(container) {
      (this.container = container),
        (this.columns = parseInt(this.container.dataset.columns)),
        (this.sliders = this.container.querySelectorAll(selectors$n.slider)),
        (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
        (this.resetSliderEvent = (e) => this.resetSlider(e)),
        (this.resizeSliderEvent = (event2) => this.resizeSlider(event2)),
        (this.flkty = []),
        this.listen(),
        this.handleLastSlideOverlayOnMobile();
    }
    initSlider(slider2) {
      const sliderId = slider2.getAttribute(attributes$f.sliderId);
      slider2.classList.remove(classes$g.carouselInactive),
        this.flkty[sliderId] === void 0 || !this.flkty[sliderId].isActive
          ? ((this.flkty[sliderId] = new Flickity(slider2, {
              pageDots: !1,
              cellSelector: selectors$n.sliderItem,
              cellAlign: "left",
              groupCells: !0,
              contain: !0,
              wrapAround: !1,
              adaptiveHeight: !1,
              on: {
                ready: () => {
                  this.setSliderArrowsPosition(slider2),
                    setTimeout(() => {
                      this.changeTabIndex(slider2);
                    }, 0);
                },
                change: () => {
                  this.changeTabIndex(slider2);
                },
              },
            })),
            this.handleLastSlideOverlayOnTablet(slider2))
          : this.setSliderArrowsPosition(slider2);
    }
    destroySlider(slider2) {
      const sliderId = slider2.getAttribute(attributes$f.sliderId);
      slider2.classList.contains(classes$g.carousel) &&
        slider2.classList.add(classes$g.carouselInactive),
        typeof this.flkty[sliderId] == "object" &&
          this.flkty[sliderId].destroy();
    }
    resetSlider(e) {
      const slider2 = e.target,
        sliderId = slider2.getAttribute(attributes$f.sliderId);
      typeof this.flkty[sliderId] == "object"
        ? this.flkty[sliderId].select(0, !1, !0)
        : slider2.scrollTo({ left: 0, behavior: "instant" });
    }
    resizeSlider(event2) {
      const slider2 = event2.target,
        flkty = Flickity.data(slider2) || null;
      flkty && flkty.resize();
    }
    checkSlidesSize() {
      this.sliders.length &&
        this.sliders.forEach((slider2) => {
          const columns = this.columns,
            isDesktop2 = window.innerWidth >= theme.sizes.large,
            isTablet =
              window.innerWidth >= theme.sizes.small &&
              window.innerWidth < theme.sizes.large;
          let itemsCount = slider2.querySelectorAll(
            selectors$n.sliderItem
          ).length;
          const promos = slider2.querySelectorAll(selectors$n.promo);
          promos.length &&
            isDesktop2 &&
            promos.forEach((promo) => {
              promo.classList.contains(classes$g.promoFullWidth)
                ? (itemsCount += columns - 1)
                : promo.classList.contains(classes$g.promoTwoItemsWidth) &&
                  (itemsCount += 1);
            }),
            slider2.hasAttribute(attributes$f.showImage) && (itemsCount += 1),
            (isDesktop2 && itemsCount > columns) || (isTablet && itemsCount > 2)
              ? (this.initSlider(slider2),
                this.getTallestProductGridItem(slider2))
              : this.destroySlider(slider2);
        });
    }
    changeTabIndex(slider2) {
      const sliderId = slider2.getAttribute(attributes$f.sliderId),
        selectedElementsIndex = this.flkty[sliderId].selectedIndex;
      this.flkty[sliderId].slides.forEach((slide, index) => {
        slide.cells.forEach((cell) => {
          cell.element.querySelectorAll(selectors$n.links).forEach((link) => {
            link.setAttribute(
              attributes$f.tabIndex,
              selectedElementsIndex === index ? "0" : "-1"
            );
          });
        });
      });
    }
    setSliderArrowsPosition(slider2) {
      const arrows = slider2.querySelectorAll(selectors$n.flickityButton),
        image = slider2.querySelector(selectors$n.productGridItemImage);
      arrows.length &&
        image &&
        arrows.forEach((arrow) => {
          arrow.style.top = `${image.offsetHeight / 2}px`;
        });
    }
    handleLastSlideOverlayOnTablet(slider2) {
      const sliderId = slider2.getAttribute(attributes$f.sliderId);
      this.flkty[sliderId].on("select", () => {
        if (
          !(
            window.innerWidth >= theme.sizes.small &&
            window.innerWidth < theme.sizes.large
          )
        )
          return;
        const selectedIndex = this.flkty[sliderId].selectedIndex,
          isLastSliderGroup =
            this.flkty[sliderId].slides.length - 1 === selectedIndex;
        slider2.parentNode.classList.toggle(
          classes$g.isLastSlideVisible,
          isLastSliderGroup
        );
      });
    }
    getTallestProductGridItem(slider2) {
      if (slider2.querySelectorAll(selectors$n.promo).length) {
        const productGridItems = slider2.querySelectorAll(
            selectors$n.productGridItems
          ),
          tallestGridItemHeight = Math.max(
            ...Array.from(productGridItems).map(
              (productGridItem) => productGridItem.offsetHeight
            )
          );
        slider2.style.setProperty(
          "--carousel-promo-height",
          `${tallestGridItemHeight}px`
        );
      }
    }
    handleLastSlideOverlayOnMobile() {
      this.sliders.forEach((slider2) => {
        slider2.addEventListener("scroll", (event2) => {
          if (!(window.innerWidth < theme.sizes.small)) return;
          const offsetWidth = event2.target.offsetWidth,
            isLastSlideVisible =
              Array.from(slider2.children).pop().getBoundingClientRect().left +
                80 <
              offsetWidth;
          slider2.parentNode.classList.toggle(
            classes$g.isLastSlideVisible,
            isLastSlideVisible
          );
        });
      });
    }
    listen() {
      this.sliders.length &&
        (this.checkSlidesSize(),
        document.addEventListener(
          "theme:resize:width",
          this.checkSlidesSizeOnResize
        ),
        this.sliders.forEach((slider2) => {
          slider2.addEventListener("theme:tab:change", this.resetSliderEvent),
            slider2.addEventListener(
              "theme:slider:resize",
              this.resizeSliderEvent
            );
        }));
    }
    onBlockSelect(evt) {
      const slider2 = evt.target.closest(selectors$n.slider),
        flkty = Flickity.data(slider2) || null;
      if (!slider2) return;
      let parent = evt.target.parentNode,
        target = evt.target;
      if (
        (this.container.classList.contains(classes$g.featuredCollection) &&
          ((parent = parent.parentNode), (target = target.parentNode)),
        flkty !== null && flkty.isActive)
      ) {
        const index = parseInt([...parent.children].indexOf(target)),
          slidesPerPage = parseInt(flkty.slides[0].cells.length),
          groupIndex = Math.floor(index / slidesPerPage);
        flkty.select(groupIndex);
      } else {
        const sliderStyle =
            slider2.currentStyle || window.getComputedStyle(slider2),
          sliderPadding = parseInt(sliderStyle.paddingLeft),
          blockPositionLeft = target.offsetLeft - sliderPadding;
        slider2.scrollTo({
          top: 0,
          left: blockPositionLeft,
          behavior: "smooth",
        });
      }
    }
    onUnload() {
      if (this.flkty)
        for (const key in this.flkty)
          this.flkty.hasOwnProperty(key) && this.flkty[key].destroy();
      document.removeEventListener(
        "theme:resize:width",
        this.checkSlidesSizeOnResize
      ),
        this.sliders.length &&
          this.sliders.forEach((slider2) => {
            slider2.removeEventListener(
              "theme:tab:change",
              this.resetSliderEvent
            ),
              slider2.removeEventListener(
                "theme:slider:resize",
                this.resizeSliderEvent
              );
          });
    }
  }
  const gridSlider = {
    onLoad() {
      (sections$i[this.id] = []),
        this.container.querySelectorAll(selectors$n.slider).forEach((el) => {
          sections$i[this.id].push(new GridSlider(this.container));
        });
    },
    onUnload() {
      sections$i[this.id].forEach((el) => {
        typeof el.onUnload == "function" && el.onUnload();
      });
    },
    onBlockSelect(e) {
      sections$i[this.id].forEach((el) => {
        typeof el.onBlockSelect == "function" && el.onBlockSelect(e);
      });
    },
  };
  register("featured-collection", [productGrid, tooltip, gridSlider]),
    register("featured-video", [videoPlay, videoBackground]);
  const selectors$m = {
      shopPayWrapper: "[data-shop-pay-wrapper]",
      shopLoginButton: "shop-login-button",
      shopFollowButton: "shop-follow-button",
      followOnShopButton: "follow-on-shop-button",
      heartIcon: "heart-icon",
      shopLogo: "shop-logo",
    },
    sections$h = {};
  class ShopPayLink {
    constructor(container) {
      (this.container = container),
        (this.shopPayWrapper = document.querySelector(
          selectors$m.shopPayWrapper
        )),
        (this.shopLoginButton = document.querySelector(
          selectors$m.shopLoginButton
        )),
        this.init();
    }
    init() {
      if (!this.shopLoginButton || !this.shopPayWrapper) return;
      const bgColor = this.shopPayWrapper.dataset.bg || "transparent",
        textColor = this.shopPayWrapper.dataset.text || "#fff",
        hoverColor = this.shopPayWrapper.dataset.hover || "#fff";
      (this.mainButtonStyles = `
      :host {
        --bg-color: ${bgColor};
        --text-color: ${textColor};
        --hover-color: ${hoverColor};
      }

      .follow-icon-wrapper:before {
        background: var(--bg-color);
        border-color: var(--text-color);
        transition: border 0.3s ease;
      }

      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,
      .button:not(.button--following):hover .follow-icon-wrapper:before {
        background: var(--bg-color);
        border-color: var(--hover-color);
      }

      .button {
        background: transparent;
        color: var(--text-color);
      }

      .following-text {
        color: var(--text-color);
      }

      .button--following:focus-visible,
      .button--following:hover {
        background: var(--bg-color);
      }

      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,
      .button:not(.button--following):hover .follow-icon-wrapper:before {
        background: var(--bg-color);
        border-color: var(--hover-color);
      }
    `),
        (this.svgIconsStyles = `
      :host {
        color: ${textColor};
      }
    `),
        customElements.whenDefined(selectors$m.shopLoginButton).then((res) => {
          requestAnimationFrame(() => {
            const shadowRoot3 = this.shopLoginButton.shadowRoot
              ?.querySelector(selectors$m.shopFollowButton)
              ?.shadowRoot?.querySelector(
                selectors$m.followOnShopButton
              )?.shadowRoot;
            shadowRoot3 &&
              this.overwriteStyles(
                shadowRoot3.host.shadowRoot,
                this.mainButtonStyles
              );
            const shadowRoot4 = shadowRoot3.querySelector(
                selectors$m.heartIcon
              )?.shadowRoot,
              shadowRoot5 = shadowRoot3.querySelector(
                selectors$m.shopLogo
              )?.shadowRoot;
            shadowRoot4 &&
              this.overwriteStyles(
                shadowRoot4.host.shadowRoot,
                this.svgIconsStyles
              ),
              shadowRoot5 &&
                this.overwriteStyles(
                  shadowRoot5.host.shadowRoot,
                  this.svgIconsStyles
                );
          });
        });
    }
    overwriteStyles(element, styles) {
      let style = document.createElement("style");
      (style.innerHTML = styles), element.appendChild(style);
    }
  }
  const shopPayLink = {
      onLoad() {
        sections$h[this.id] = new ShopPayLink(this.container);
      },
    },
    selectors$l = {
      wave: ":scope > [data-wave]",
      main: "[data-main]",
      trigger: "[data-collapsible-trigger-mobile]",
      footerParallax: '[data-parallax="footer"]',
    },
    classes$f = {
      isExpanded: "is-expanded",
      wavy: "wavy",
      shadow: "parallax-shadow",
      rounded: "parallax-rounded-corners",
      mainParallax: "main-content--parallax",
      footerParallax: "section-footer--parallax",
      sectionFooterVisible: "section-footer--visible",
      mainContent: "main-content",
      shopifySection: "shopify-section",
      bodyRoundedCornersLarge: "body--rounded-corners-large",
    },
    attributes$e = {
      bg: "--bg",
      footerBg: "--footer-bg",
      parallax: "data-parallax",
      parallaxWavy: "data-parallax-wavy",
      parallaxRounded: "data-parallax-rounded-corners",
      parallaxRoundedLarge: "data-parallax-rounded-corners-large",
      parallaxSafari: "data-parallax-disable-on-safari",
    },
    sections$g = {};
  class Footer {
    constructor(section) {
      (this.container = section.container),
        (this.main = document.querySelector(selectors$l.main)),
        (this.footerParallax = null),
        (this.wavyEnabled = this.container.hasAttribute(
          attributes$e.parallaxWavy
        )),
        (this.parentContainer = this.container.parentNode),
        (this.resizeEvent = () => this.resize()),
        (this.unloadEvent = () => this.onUnload()),
        requestIdleCallback(() => {
          this.container.hasAttribute(attributes$e.parallax) &&
            !this.main.classList.contains(classes$f.mainParallax) &&
            (this.init(),
            document.addEventListener("theme:resize", this.resizeEvent),
            document.addEventListener("theme:footer:unload", this.unloadEvent));
        });
    }
    init() {
      const isSafari =
          /^((?!chrome|android).)*safari/i.test(navigator.userAgent) &&
          this.container.hasAttribute(attributes$e.parallaxSafari),
        stopParallax =
          this.isViewportSmaller() ||
          window.innerWidth < theme.sizes.small ||
          isSafari,
        body = document.body;
      body.classList.remove(classes$f.bodyRoundedCornersLarge);
      const bgColor = getComputedStyle(this.container).getPropertyValue(
        attributes$e.bg
      );
      this.parentContainer.style.setProperty(
        "--footer-parallax-height",
        "auto"
      );
      let prevSection = this.parentContainer.previousElementSibling;
      if (prevSection) {
        if (
          (!prevSection.classList.contains(classes$f.shopifySection) &&
            !prevSection.classList.contains(classes$f.mainContent) &&
            (prevSection = this.main),
          this.wavyEnabled && !stopParallax)
        ) {
          [...prevSection.querySelectorAll(selectors$l.wave)].map((wave2) =>
            wave2.remove()
          );
          const wave = this.container.querySelector(selectors$l.wave);
          prevSection.append(wave.cloneNode(!0)),
            prevSection.classList.add(classes$f.wavy),
            this.container.classList.remove(classes$f.wavy);
        } else
          this.container.hasAttribute(attributes$e.parallaxRounded) &&
          !this.wavyEnabled
            ? (prevSection.classList.toggle(classes$f.rounded, !stopParallax),
              prevSection.classList.toggle(classes$f.shadow, !stopParallax),
              this.container.hasAttribute(attributes$e.parallaxRoundedLarge) &&
                body.classList.toggle(
                  classes$f.bodyRoundedCornersLarge,
                  !stopParallax
                ))
            : stopParallax || prevSection.classList.add(classes$f.shadow);
        prevSection.style.setProperty(attributes$e.footerBg, bgColor);
      }
      stopParallax ||
        (this.main.classList.add(classes$f.mainParallax),
        this.parentContainer.classList.add(classes$f.footerParallax),
        this.parentContainer.style.setProperty(
          "--footer-parallax-height",
          `${this.container.clientHeight}px`
        ),
        (this.footerParallax = new ParallaxElement(this.container)));
    }
    resize() {
      this.parentContainer.style.setProperty(
        "--footer-parallax-height",
        "auto"
      ),
        (this.isViewportSmaller() ||
          window.innerWidth < theme.sizes.small ||
          !this.footerParallax) &&
          this.onUnload(!0),
        this.parentContainer.style.setProperty(
          "--footer-parallax-height",
          `${this.container.clientHeight}px`
        );
    }
    isViewportSmaller() {
      const viewportHeight = Math.round(
          Math.max(
            document.documentElement.clientHeight,
            window.innerHeight || 0
          )
        ),
        footerHeight = this.container.clientHeight;
      let waveHeight = 0;
      return (
        this.wavyEnabled && (waveHeight = 50),
        viewportHeight < footerHeight + waveHeight
      );
    }
    onBlockSelect(e) {
      const trigger = e.target.querySelector(selectors$l.trigger);
      requestAnimationFrame(() => {
        trigger &&
          !trigger.classList.contains(classes$f.isExpanded) &&
          trigger.dispatchEvent(new Event("click"));
      });
    }
    onBlockDeselect(e) {
      const trigger = e.target.querySelector(selectors$l.trigger);
      requestAnimationFrame(() => {
        trigger &&
          trigger.classList.contains(classes$f.isExpanded) &&
          trigger.dispatchEvent(new Event("click"));
      });
    }
    onUnload(reset = !1) {
      document.removeEventListener("theme:resize", this.resizeEvent),
        document.removeEventListener("theme:footer:unload", this.unloadEvent),
        this.footerParallax &&
          (this.footerParallax.unload(),
          reset && removeFooterWave(this.parentContainer)),
        (this.footerParallax || reset) &&
          setTimeout(() => {
            const shopifyInstances = Shopify.theme.sections.instances,
              parallaxFooters = document.querySelectorAll(
                selectors$l.footerParallax
              ),
              footerInstance = shopifyInstances.filter(
                (instance) => instance.container === parallaxFooters[0]
              );
            this.main.classList.remove(classes$f.mainParallax),
              this.parentContainer.classList.remove(classes$f.footerParallax),
              this.parentContainer.classList.remove(
                classes$f.sectionFooterVisible
              ),
              footerInstance[0] && footerInstance[0].onLoad();
          });
    }
  }
  register("footer", [
    popoutSection,
    newsletterSection,
    collapsible,
    {
      onLoad() {
        sections$g[this.id] = new Footer(this);
      },
      onBlockSelect(e) {
        sections$g[this.id].onBlockSelect(e);
      },
      onBlockDeselect(e) {
        sections$g[this.id].onBlockDeselect(e);
      },
      onReorder() {
        sections$g[this.id].onUnload();
      },
      onUnload() {
        sections$g[this.id].onUnload();
      },
    },
    shopPayLink,
  ]);
  const selectors$k = { slider: "[data-slider]" };
  let sections$f = {};
  class IconsRow {
    constructor(section) {
      (this.container = section.container),
        (this.slider = this.container.querySelector(selectors$k.slider));
    }
    onBlockSelect(evt) {
      const sliderStyle =
          this.slider.currentStyle || window.getComputedStyle(this.slider),
        sliderPadding = parseInt(sliderStyle.paddingLeft),
        blockPositionLeft = evt.target.offsetLeft - sliderPadding;
      this.slider.scrollTo({
        top: 0,
        left: blockPositionLeft,
        behavior: "smooth",
      });
    }
  }
  register("icons-row", {
    onLoad() {
      sections$f[this.id] = new IconsRow(this);
    },
    onBlockSelect(e) {
      sections$f[this.id].onBlockSelect(e);
    },
  });
  const selectors$j = {
      item: "[data-accordion-item]",
      button: "[data-accordion-button]",
    },
    classes$e = {
      isActive: "is-active",
      toAnimate: "to-animate",
      isAnimating: "is-animating",
    },
    sections$e = {};
  class ImageAccordions {
    constructor(section) {
      (this.container = section.container),
        (this.controller = new AbortController()),
        (this.imageAccordionsItems = this.container.querySelectorAll(
          selectors$j.item
        )),
        (this.buttons = this.container.querySelectorAll(selectors$j.button)),
        (this.accordionExpandEvent = (item) => this.accordionExpand(item)),
        (this.accordionFocusEvent = (item) => this.accordionFocus(item)),
        this.init();
    }
    init() {
      this.triggerLoadingAnimation(),
        this.imageAccordionsItems.forEach((item) => {
          item.addEventListener(
            "mouseenter",
            this.accordionExpandEvent.bind(this, item)
          );
        }),
        this.buttons.forEach((button) => {
          button.addEventListener(
            "focusin",
            this.accordionFocusEvent.bind(this, button)
          );
        });
    }
    triggerLoadingAnimation() {
      if (theme.settings.animationsEnabled == "false" || isMobile()) return;
      const onAnimationEnd = (event2) => {
          event2.animationName === "expandAccordion" &&
            (this.accordionExpand(this.imageAccordionsItems[0]),
            this.container.classList.remove(classes$e.toAnimate),
            this.container.classList.remove(classes$e.isAnimating),
            this.container.removeEventListener("animationend", onAnimationEnd));
        },
        onTransitionEnd = (event2) => {
          requestAnimationFrame(() => {
            event2.target === this.container &&
              (this.container.classList.add(classes$e.isAnimating),
              this.container.removeEventListener(
                "transitionend",
                onTransitionEnd
              ));
          });
        };
      this.container.addEventListener("transitionend", onTransitionEnd, {
        signal: this.controller.signal,
      }),
        this.container.addEventListener("animationend", onAnimationEnd, {
          signal: this.controller.signal,
        });
    }
    accordionExpand(item) {
      item.classList.contains(classes$e.isActive) ||
        (this.imageAccordionsItems.forEach((item2) => {
          item2.classList.remove(classes$e.isActive);
        }),
        item.classList.add(classes$e.isActive));
    }
    accordionFocus(button) {
      button.closest(selectors$j.item).dispatchEvent(new Event("mouseenter"));
    }
    onBlockSelect(event2) {
      const element = event2.target;
      element &&
        (this.controller.abort(),
        this.container.classList.remove(
          classes$e.toAnimate,
          classes$e.isAnimating
        ),
        this.accordionExpand(element),
        isMobile() &&
          element.parentNode.scrollTo({
            top: 0,
            left: element.offsetLeft,
            behavior: "smooth",
          }));
    }
  }
  register("image-accordions", {
    onLoad() {
      sections$e[this.id] = new ImageAccordions(this);
    },
    onBlockSelect(event2) {
      sections$e[this.id].onBlockSelect(event2);
    },
  }),
    register("image-with-text", videoPlay),
    register("list-collections", gridSlider);
  const sections$d = {},
    selectors$i = {
      slider: "[data-slider-gallery]",
      sliderNav: "[data-slider-info]",
      item: "[data-slide-item]",
    };
  class Locations {
    constructor(section) {
      (this.container = section.container),
        (this.slider = this.container.querySelector(selectors$i.slider)),
        (this.sliderNav = this.container.querySelector(selectors$i.sliderNav)),
        this.initSlider();
    }
    initSlider() {
      const slidesCount = this.container.querySelectorAll(
        selectors$i.item
      ).length;
      let flkty = Flickity.data(this.slider) || null,
        flktyNav = Flickity.data(this.sliderNav) || null;
      slidesCount <= 1 ||
        ((flkty = new Flickity(this.slider, {
          fade: !0,
          wrapAround: !0,
          adaptiveHeight: !0,
          prevNextButtons: !1,
          pageDots: !1,
        })),
        flickitySmoothScrolling(this.slider),
        (flktyNav = new Flickity(this.sliderNav, {
          fade: !0,
          wrapAround: !0,
          imagesLoaded: !0,
          asNavFor: this.slider,
          prevNextButtons: !0,
          pageDots: !1,
        })),
        flktyNav.on("change", () => {
          flkty.selectCell(flktyNav.selectedIndex);
        }),
        flkty.on("change", () => {
          flktyNav.selectCell(flkty.selectedIndex);
        }));
    }
    onBlockSelect(evt) {
      const flkty = Flickity.data(this.slider) || null,
        flktyNav = Flickity.data(this.sliderNav) || null,
        index = parseInt(
          [...evt.target.parentNode.children].indexOf(evt.target)
        );
      flkty !== null && flkty.select(index),
        flktyNav !== null && flktyNav.select(index);
    }
  }
  register("locations", {
    onLoad() {
      sections$d[this.id] = new Locations(this);
    },
    onBlockSelect(e) {
      sections$d[this.id].onBlockSelect(e);
    },
  });
  const sections$c = {},
    selectors$h = {
      slider: "[data-slider]",
      sliderItem: "[data-slide-item]",
      pointer: "[data-pointer]",
      productGridItemImage: "[data-product-media-container]",
      quickViewItemHolder: "[data-quick-view-item-holder]",
      flickityButton: ".flickity-button",
      links: "a, button",
      tooltip: "[data-tooltip]",
    },
    attributes$d = {
      pointer: "data-pointer",
      hotspot: "data-hotspot",
      tabIndex: "tabindex",
    },
    classes$d = {
      productGridItemImageHover: "product-grid-item__image--hovered",
      pointerSelected: "pointer--selected",
      isSelected: "is-selected",
      isActive: "is-active",
      popupOpen: "pswp--open",
    };
  class Look {
    constructor(container) {
      (this.container = container),
        (this.slider = this.container.querySelector(selectors$h.slider)),
        (this.slides = this.container.querySelectorAll(selectors$h.sliderItem)),
        (this.pointers = this.container.querySelectorAll(selectors$h.pointer)),
        (this.flkty = null),
        (this.observer = null),
        (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
        (this.resizeSliderEvent = (event2) => this.resizeSlider(event2)),
        (this.pointersInit = (event2) => this.dotPointers(event2)),
        (this.pointersOver = (event2) => this.dotPointerIn(event2)),
        (this.pointersOut = (event2) => this.dotPointerOut(event2)),
        (this.debouncedBlockSelectCallback = debounce(
          (event2) => this.debouncedBlockSelect(event2),
          500
        )),
        (this.quickViewPopup = new QuickViewPopup(this.container)),
        this.listen();
    }
    listen() {
      this.slider &&
        (this.checkSlidesSize(),
        document.addEventListener(
          "theme:resize:width",
          this.checkSlidesSizeOnResize
        ),
        this.slider.addEventListener(
          "theme:slider:resize",
          this.resizeSliderEvent
        )),
        this.pointers.length > 0 &&
          this.pointers.forEach((pointer) => {
            pointer.addEventListener("click", this.pointersInit),
              pointer.addEventListener("mouseover", this.pointersOver),
              pointer.addEventListener("mouseleave", this.pointersOut);
          });
    }
    checkSlidesSize() {
      const isDesktop2 = window.innerWidth >= theme.sizes.small;
      if ((this.initTooltips(), isDesktop2)) {
        this.slides.length > 2
          ? this.initSlider()
          : (this.destroySlider(), this.slidesTabIndex());
        return;
      }
      if (!isDesktop2 && this.slides.length > 1) {
        this.initSlider();
        return;
      }
      this.destroySlider();
    }
    initTooltips() {
      (this.tooltips = this.container.querySelectorAll(selectors$h.tooltip)),
        this.tooltips.forEach((tooltip2) => {
          new Tooltip(tooltip2);
        });
    }
    initSlider() {
      if (this.flkty === null) {
        this.flkty = new Flickity(this.slider, {
          prevNextButtons: !0,
          wrapAround: !0,
          adaptiveHeight: !1,
          cellAlign: "left",
          groupCells: !1,
          contain: !0,
          on: {
            ready: () => {
              this.slidesTabIndex(),
                this.setSliderArrowsPosition(),
                this.dotPointers();
            },
            change: () => {
              this.slidesTabIndex(), this.dotPointers();
            },
          },
        });
        return;
      }
      this.setSliderArrowsPosition();
    }
    setSliderArrowsPosition() {
      if (!(window.innerWidth >= theme.sizes.small)) return;
      const arrows = this.slider.querySelectorAll(selectors$h.flickityButton),
        image = this.slider.querySelector(selectors$h.productGridItemImage);
      arrows.length &&
        image &&
        arrows.forEach((arrow) => {
          arrow.style.top = `${image.offsetHeight / 2}px`;
        });
    }
    slidesTabIndex() {
      if (this.slides.length < 3) {
        this.slider.querySelectorAll(selectors$h.links).forEach((link) => {
          link.setAttribute(attributes$d.tabIndex, "0");
        });
        return;
      }
      Flickity.data(this.slider).cells.forEach((slide) => {
        let tabIndex = "-1";
        slide.element.classList.contains(classes$d.isSelected) &&
          (tabIndex = "0"),
          slide.element.querySelectorAll(selectors$h.links).forEach((link) => {
            link.setAttribute(attributes$d.tabIndex, tabIndex);
          });
      });
    }
    destroySlider() {
      typeof this.flkty == "object" &&
        this.flkty !== null &&
        (this.flkty.destroy(), (this.flkty = null));
    }
    resizeSlider(event2) {
      const slider2 = event2.target,
        flkty = Flickity.data(slider2) || null;
      flkty && flkty.resize();
    }
    dotPointers(event2) {
      if (this.pointers.length === 0) return;
      if (
        (this.pointers.forEach((button) => {
          button.classList.remove(classes$d.pointerSelected);
        }),
        event2)
      ) {
        const dotIndex = event2.target.getAttribute(attributes$d.pointer);
        this.flkty?.select(dotIndex);
        return;
      }
      const slideIndex = this.flkty == null ? 0 : this.flkty.selectedIndex;
      slideIndex >= 0 &&
        this.pointers[slideIndex].classList.add(classes$d.pointerSelected);
    }
    dotPointerIn(event2) {
      const dotIndex = event2.target.getAttribute(attributes$d.pointer),
        image = this.slides[dotIndex].querySelector(
          selectors$h.productGridItemImage
        ),
        isTouch2 = matchMedia("(pointer:coarse)").matches;
      !(window.innerWidth < theme.sizes.small) &&
        !isTouch2 &&
        this.observeImage(image),
        this.pointers.forEach((pointer) => {
          pointer.style.setProperty("--look-animation", "none");
        });
    }
    dotPointerOut(event2) {
      const dotIndex = event2.target.getAttribute(attributes$d.pointer),
        image = this.slides[dotIndex].querySelector(
          selectors$h.productGridItemImage
        );
      image.classList.remove(classes$d.productGridItemImageHover),
        image.dispatchEvent(new Event("mouseleave")),
        this.observer && this.observer.disconnect(),
        this.pointers.forEach((pointer) => {
          pointer.style.removeProperty("--look-animation");
        });
    }
    observeImage(image) {
      (this.observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            const target = entry.target;
            entry.intersectionRatio == 0 ||
              (target.dispatchEvent(new Event("mouseenter")),
              target.classList.add(classes$d.productGridItemImageHover));
          });
        },
        { root: this.slider, threshold: [0.95, 1] }
      )),
        this.observer.observe(image);
    }
    triggerClick(target) {
      requestAnimationFrame(() => target.dispatchEvent(new Event("click")));
    }
    destroyQuickViewPopup() {
      const pswpElement = this.quickViewPopup?.loadPhotoswipe?.pswpElement;
      pswpElement &&
        pswpElement.classList.contains(classes$d.popupOpen) &&
        this.quickViewPopup.loadPhotoswipe.popup.close();
    }
    onBlockSelect(event2) {
      this.debouncedBlockSelectCallback(event2);
    }
    debouncedBlockSelect(event2) {
      const pswpElement = this.quickViewPopup?.loadPhotoswipe?.pswpElement;
      if (!pswpElement) {
        setTimeout(() => this.triggerClick(event2.target), 400);
        return;
      }
      setTimeout(() => {
        if (pswpElement.classList.contains(classes$d.popupOpen)) {
          const holder =
              this.quickViewPopup.loadPhotoswipe.pswpElement.querySelector(
                `[${attributes$d.hotspot}="${event2.target.getAttribute(
                  attributes$d.hotspot
                )}"]`
              ),
            quickViewItemHolders =
              this.quickViewPopup.loadPhotoswipe.pswpElement.querySelectorAll(
                selectors$h.quickViewItemHolder
              );
          holder.classList.add(classes$d.isActive),
            quickViewItemHolders.forEach((element) => {
              element !== holder &&
                element.classList.remove(classes$d.isActive);
            });
        } else this.triggerClick(event2.target);
      });
    }
    onUnload() {
      this.destroyQuickViewPopup(),
        document.removeEventListener(
          "theme:resize:width",
          this.checkSlidesSizeOnResize
        ),
        this.slider &&
          this.slider.removeEventListener(
            "theme:slider:resize",
            this.resizeSliderEvent
          );
    }
    onDeselect() {
      this.destroyQuickViewPopup();
    }
  }
  register("look", [
    {
      onLoad() {
        sections$c[this.id] = new Look(this.container);
      },
      onUnload() {
        sections$c[this.id].onUnload();
      },
      onBlockSelect(event2) {
        sections$c[this.id].onBlockSelect(event2);
      },
      onDeselect() {
        sections$c[this.id].onDeselect();
      },
    },
  ]);
  const selectors$g = { grid: "[data-grid]" };
  register("mosaic", {
    onBlockSelect(e) {
      const grid = e.target.closest(selectors$g.grid),
        wrapperStyle = grid.currentStyle || window.getComputedStyle(grid),
        wrapperPadding = parseInt(wrapperStyle.paddingLeft),
        blockPositionLeft = e.target.offsetLeft - wrapperPadding;
      grid.scrollTo({ top: 0, left: blockPositionLeft, behavior: "smooth" });
    },
  }),
    register("newsletter", newsletterSection),
    register("overlapping-images", [videoPlay, parallaxSection]);
  const selectors$f = {
    toggleAdmin: "[data-toggle-admin]",
    toggleNewsletter: "[data-toggle-newsletter]",
    adminForm: "[data-form-admin]",
    newsletterForm: "[data-form-newsletter]",
  };
  let sections$b = {};
  class Password {
    constructor(section) {
      (this.container = section.container),
        (this.toggleAdmin = this.container.querySelector(
          selectors$f.toggleAdmin
        )),
        (this.toggleNewsletter = this.container.querySelector(
          selectors$f.toggleNewsletter
        )),
        (this.adminForm = this.container.querySelector(selectors$f.adminForm)),
        (this.newsletterForm = this.container.querySelector(
          selectors$f.newsletterForm
        )),
        (this.adminErrors = this.adminForm.querySelector(".errors")),
        (this.newsletterErrors = this.newsletterForm.querySelector(".errors")),
        this.init();
    }
    init() {
      this.toggleAdmin.addEventListener("click", (e) => {
        e.preventDefault(), this.showPasswordForm();
      }),
        this.toggleNewsletter.addEventListener("click", (e) => {
          e.preventDefault(), this.hidePasswordForm();
        }),
        window.location.hash == "#login" || this.adminErrors
          ? this.showPasswordForm()
          : this.hidePasswordForm();
    }
    showPasswordForm() {
      showElement(this.adminForm),
        hideElement(this.newsletterForm),
        (window.location.hash = "#login");
    }
    hidePasswordForm() {
      showElement(this.newsletterForm),
        hideElement(this.adminForm),
        (window.location.hash = "");
    }
  }
  register("password-template", {
    onLoad() {
      sections$b[this.id] = new Password(this);
    },
  });
  const selectors$e = {
      largePromo: "[data-large-promo]",
      largePromoInner: "[data-large-promo-inner]",
      tracking: "[data-tracking-consent]",
      trackingInner: "[data-tracking-consent-inner]",
      trackingAccept: "[data-confirm-cookies]",
      popupBar: "[data-popup-bar]",
      popupBarHolder: "[data-popup-bar-holder]",
      popupBarToggle: "[data-popup-bar-toggle]",
      popupBody: "[data-popup-body]",
      popupClose: "[data-popup-close]",
      popupUnderlay: "[data-popup-underlay]",
      newsletterForm: "[data-newsletter-form]",
    },
    attributes$c = {
      cookieName: "data-cookie-name",
      targetReferrer: "data-target-referrer",
      preventScrollLock: "data-prevent-scroll-lock",
    },
    classes$c = {
      success: "has-success",
      error: "has-error",
      selected: "selected",
      hasBlockSelected: "has-block-selected",
      expanded: "popup--expanded",
      visible: "popup--visible",
      mobile: "mobile",
      desktop: "desktop",
      popupBar: "popup--bar",
      barIsVisible: "popup-bar-is-visible",
    };
  let sections$a = {},
    scrollLockTimer = 0,
    activePopups = 0,
    popups = [];
  class DelayShow {
    constructor(popupContainer, popup) {
      if (
        ((this.popupContainer = popupContainer),
        (this.popup = popup),
        (this.popupBody = popup.querySelector(selectors$e.popupBody)),
        (this.delay = popupContainer.dataset.popupDelay),
        (this.isSubmitted =
          window.location.href.indexOf("accepts_marketing") !== -1 ||
          window.location.href.indexOf("customer_posted=true") !== -1),
        (this.a11y = a11y),
        (this.showPopupOnScrollEvent = () => this.showPopupOnScroll()),
        (this.delay === "always" || this.isSubmitted) && this.always(),
        this.delay && this.delay.includes("delayed") && !this.isSubmitted)
      ) {
        const seconds = this.delay.includes("_")
          ? parseInt(this.delay.split("_")[1])
          : 10;
        this.delayed(seconds);
      }
      this.delay === "bottom" && !this.isSubmitted && this.bottom(),
        this.delay === "idle" && !this.isSubmitted && this.idle();
    }
    always() {
      this.showPopup();
    }
    delayed(seconds = 10) {
      setTimeout(() => {
        this.showPopup();
      }, seconds * 1e3);
    }
    bottom() {
      document.addEventListener("theme:scroll", this.showPopupOnScrollEvent);
    }
    idle() {
      if (!(this.checkPopupTarget() === !0)) return;
      let timer = 0,
        idleTime = 6e4;
      const documentEvents = [
          "mousemove",
          "mousedown",
          "click",
          "touchmove",
          "touchstart",
          "touchend",
          "keydown",
          "keypress",
        ],
        windowEvents = ["load", "resize", "scroll"],
        startTimer = () => {
          (timer = setTimeout(() => {
            (timer = 0), this.showPopup();
          }, idleTime)),
            documentEvents.forEach((eventType) => {
              document.addEventListener(eventType, resetTimer);
            }),
            windowEvents.forEach((eventType) => {
              window.addEventListener(eventType, resetTimer);
            });
        },
        resetTimer = () => {
          timer && clearTimeout(timer),
            documentEvents.forEach((eventType) => {
              document.removeEventListener(eventType, resetTimer);
            }),
            windowEvents.forEach((eventType) => {
              window.removeEventListener(eventType, resetTimer);
            }),
            startTimer();
        };
      startTimer();
    }
    showPopup() {
      const popupElement = { id: this.popup.id, body: this.popupBody };
      if ((popups.push(popupElement), this.checkPopupTarget() === !0)) {
        if (
          ((activePopups += 1),
          this.popup.classList.add(classes$c.visible),
          this.popup.classList.contains(classes$c.popupBar) &&
            document.body.classList.add(classes$c.barIsVisible),
          this.a11y.trapFocus({ container: this.popupBody }),
          this.popup.hasAttribute(attributes$c.preventScrollLock))
        )
          return !1;
        this.scrollLock();
      }
    }
    checkPopupTarget() {
      const targetMobile = this.popup.parentNode.classList.contains(
          classes$c.mobile
        ),
        targetDesktop = this.popup.parentNode.classList.contains(
          classes$c.desktop
        );
      return !(
        (targetMobile && window.innerWidth >= theme.sizes.small) ||
        (targetDesktop && window.innerWidth < theme.sizes.small)
      );
    }
    scrollLock() {
      document.dispatchEvent(
        new CustomEvent("theme:scroll:lock", {
          bubbles: !0,
          detail: this.popupBody,
        })
      );
    }
    showPopupOnScroll() {
      window.scrollY + window.innerHeight >= document.body.clientHeight &&
        (this.showPopup(),
        document.removeEventListener(
          "theme:scroll",
          this.showPopupOnScrollEvent
        ));
    }
    onUnload() {
      document.removeEventListener("theme:scroll", this.showPopupOnScrollEvent);
    }
  }
  class TargetReferrer {
    constructor(el) {
      if (
        ((this.popupContainer = el),
        (this.locationPath = location.href),
        !this.popupContainer.hasAttribute(attributes$c.targetReferrer))
      )
        return !1;
      this.locationPath.indexOf(
        this.popupContainer.getAttribute(attributes$c.targetReferrer)
      ) === -1 &&
        !window.Shopify.designMode &&
        this.popupContainer.parentNode.removeChild(this.popupContainer);
    }
  }
  class LargePopup {
    constructor(el) {
      (this.popupContainer = el),
        (this.popup = this.popupContainer.querySelector(
          selectors$e.largePromoInner
        )),
        (this.popupBody = this.popup.querySelector(selectors$e.popupBody)),
        (this.popupId = this.popup.id),
        (this.close = this.popup.querySelector(selectors$e.popupClose)),
        (this.underlay = this.popup.querySelector(selectors$e.popupUnderlay)),
        (this.form = this.popup.querySelector(selectors$e.newsletterForm)),
        (this.cookie = new PopupCookie(
          this.popupContainer.dataset.cookieName,
          "user_has_closed"
        )),
        (this.isTargeted = new TargetReferrer(this.popupContainer)),
        (this.a11y = a11y),
        this.init();
    }
    init() {
      (!(this.cookie.read() !== !1) || window.Shopify.designMode) &&
        (window.Shopify.designMode
          ? this.showPopup()
          : new DelayShow(this.popupContainer, this.popup),
        this.form &&
          setTimeout(() => {
            this.form.classList.contains(classes$c.success) &&
              (this.showPopupIfNoCookie(), (activePopups -= 1));
          }),
        this.initClosers());
    }
    checkPopupTarget() {
      const targetMobile = this.popup.parentNode.classList.contains(
          classes$c.mobile
        ),
        targetDesktop = this.popup.parentNode.classList.contains(
          classes$c.desktop
        );
      return !(
        (targetMobile && window.innerWidth >= theme.sizes.small) ||
        (targetDesktop && window.innerWidth < theme.sizes.small)
      );
    }
    showPopupIfNoCookie() {
      this.showPopup();
    }
    initClosers() {
      this.close.addEventListener("click", this.closePopup.bind(this)),
        this.underlay.addEventListener("click", this.closePopup.bind(this)),
        this.popupContainer.addEventListener("keyup", (event2) => {
          event2.code === theme.keyboardKeys.ESCAPE && this.closePopup(event2);
        });
    }
    closePopup(event2) {
      event2.preventDefault(), this.hidePopup(), this.cookie.write();
    }
    scrollLock() {
      this.resetScrollUnlock(),
        this.a11y.trapFocus({ container: this.popupBody }),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:lock", {
            bubbles: !0,
            detail: this.popupBody,
          })
        );
    }
    scrollUnlock() {
      this.resetScrollUnlock(),
        (scrollLockTimer = setTimeout(() => {
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          );
        }, 300));
    }
    resetScrollUnlock() {
      scrollLockTimer && clearTimeout(scrollLockTimer);
    }
    showPopup() {
      const isTargetValid = this.checkPopupTarget() === !0,
        popupElement = { id: this.popupId, body: this.popup };
      popups.push(popupElement),
        isTargetValid &&
          ((activePopups += 1),
          this.popup.classList.add(classes$c.visible),
          this.scrollLock());
    }
    hidePopup() {
      this.popup.classList.remove(classes$c.visible);
      const popupIndex = popups.findIndex((x) => x.id === this.popupId);
      if (
        ((activePopups -= 1),
        popups.splice(popupIndex, 1),
        activePopups == 1 &&
          document.body.classList.contains(classes$c.barIsVisible))
      )
        this.scrollUnlock();
      else if (activePopups < 1)
        this.scrollUnlock(), this.a11y.removeTrapFocus();
      else if (popups.length > 0) {
        const nextPopup = popups[popups.length - 1].body;
        this.a11y.trapFocus({ container: nextPopup });
      }
    }
    onBlockSelect(evt) {
      this.popupContainer.contains(evt.target) &&
        !this.popup.classList.contains(classes$c.visible) &&
        (this.popup.classList.add(classes$c.selected),
        this.popupContainer.classList.add(classes$c.hasBlockSelected),
        this.showPopup());
    }
    onBlockDeselect(evt) {
      this.popupContainer.contains(evt.target) &&
        (this.popup.classList.remove(classes$c.selected),
        this.popupContainer.classList.remove(classes$c.hasBlockSelected),
        this.hidePopup());
    }
    onUnload() {
      this.scrollUnlock();
    }
    onDeselect() {
      this.popup.classList.remove(classes$c.selected),
        this.popupContainer.classList.remove(classes$c.hasBlockSelected),
        this.hidePopup();
    }
  }
  class Tracking {
    constructor(el) {
      (this.popupContainer = el),
        (this.popup = this.popupContainer.querySelector(
          selectors$e.trackingInner
        )),
        (this.popupId = this.popup.id),
        (this.close = this.popup.querySelector(selectors$e.popupClose)),
        (this.acceptButton = this.popup.querySelector(
          selectors$e.trackingAccept
        )),
        (this.enable = this.popupContainer.dataset.enable === "true"),
        (this.a11y = a11y),
        window.Shopify.loadFeatures(
          [{ name: "consent-tracking-api", version: "0.1" }],
          (error) => {
            if (error) throw error;
            const userCanBeTracked =
                window.Shopify.customerPrivacy.userCanBeTracked(),
              userTrackingConsent =
                window.Shopify.customerPrivacy.getTrackingConsent();
            (this.enableTracking =
              !userCanBeTracked &&
              userTrackingConsent === "no_interaction" &&
              this.enable),
              window.Shopify.designMode && (this.enableTracking = !0),
              this.init();
          }
        );
    }
    init() {
      this.enableTracking && this.showPopup(), this.clickEvents();
    }
    clickEvents() {
      this.close.addEventListener("click", (event2) => {
        event2.preventDefault(),
          window.Shopify.customerPrivacy.setTrackingConsent(!1, () =>
            this.hidePopup()
          );
      }),
        this.acceptButton.addEventListener("click", (event2) => {
          event2.preventDefault(),
            window.Shopify.customerPrivacy.setTrackingConsent(!0, () =>
              this.hidePopup()
            );
        }),
        document.addEventListener("trackingConsentAccepted", () => {
          console.log("trackingConsentAccepted event fired");
        });
    }
    showPopup() {
      const popupElement = { id: this.popupId, body: this.popup };
      popups.push(popupElement),
        this.popup.classList.add(classes$c.visible),
        this.a11y.trapFocus({ container: this.popup });
    }
    hidePopup() {
      this.popup.classList.remove(classes$c.visible);
      const popupIndex = popups.findIndex((x) => x.id === this.popupId);
      if ((popups.splice(popupIndex, 1), activePopups < 1))
        this.a11y.removeTrapFocus();
      else if (popups.length > 0) {
        const nextPopup = popups[popups.length - 1].body;
        this.a11y.trapFocus({ container: nextPopup });
      }
    }
    onBlockSelect(evt) {
      this.popupContainer.contains(evt.target) &&
        this.enableTracking &&
        !this.popup.classList.contains(classes$c.visible) &&
        (this.showPopup(),
        this.popup.classList.add(classes$c.selected),
        this.popup.parentNode.classList.add(classes$c.hasBlockSelected));
    }
    onBlockDeselect(evt) {
      this.popupContainer.contains(evt.target) &&
        (this.popup.classList.remove(classes$c.selected),
        this.popupContainer.classList.remove(classes$c.hasBlockSelected),
        this.hidePopup());
    }
    onDeselect() {
      this.popup.classList.remove(classes$c.selected),
        this.popupContainer.classList.remove(classes$c.hasBlockSelected),
        this.hidePopup();
    }
  }
  class PopupBar {
    constructor(el) {
      (this.popupContainer = el),
        (this.popup = this.popupContainer.querySelector(
          selectors$e.popupBarHolder
        )),
        (this.popupBody = this.popup.querySelector(selectors$e.popupBody)),
        (this.popupId = this.popup.id),
        (this.close = this.popup.querySelector(selectors$e.popupClose)),
        (this.underlay = this.popup.querySelector(selectors$e.popupUnderlay)),
        (this.toggle = this.popup.querySelector(selectors$e.popupBarToggle)),
        (this.cookie = new PopupCookie(
          this.popupContainer.dataset.cookieName,
          "user_has_closed"
        )),
        (this.form = this.popup.querySelector(selectors$e.newsletterForm)),
        (this.isTargeted = new TargetReferrer(this.popupContainer)),
        (this.a11y = a11y),
        this.init();
    }
    init() {
      (!(this.cookie.read() !== !1) || window.Shopify.designMode) &&
        (window.Shopify.designMode
          ? this.showPopup()
          : new DelayShow(this.popupContainer, this.popup),
        this.initPopupToggleButton(),
        this.initClosers(),
        this.form &&
          setTimeout(() => {
            this.form.classList.contains(classes$c.success) &&
              this.showPopupIfNoCookie(),
              this.form.classList.contains(classes$c.error) &&
                this.toggle.dispatchEvent(new Event("click"));
          }));
    }
    checkPopupTarget() {
      const targetMobile = this.popup.parentNode.classList.contains(
          classes$c.mobile
        ),
        targetDesktop = this.popup.parentNode.classList.contains(
          classes$c.desktop
        );
      return !(
        (targetMobile && window.innerWidth >= theme.sizes.small) ||
        (targetDesktop && window.innerWidth < theme.sizes.small)
      );
    }
    showPopupIfNoCookie() {
      this.showPopup(), this.toggle.dispatchEvent(new Event("click"));
    }
    initPopupToggleButton() {
      this.toggle.addEventListener("click", (event2) => {
        event2.preventDefault(),
          this.popup.classList.toggle(classes$c.expanded),
          this.popup.classList.contains(classes$c.expanded)
            ? this.scrollLock()
            : this.scrollUnlock();
      });
    }
    showPopup() {
      const popupElement = { id: this.popupId, body: this.popup };
      popups.push(popupElement),
        this.a11y.trapFocus({ container: this.popupBody }),
        this.checkPopupTarget() === !0 &&
          ((activePopups += 1),
          document.body.classList.add(classes$c.barIsVisible),
          this.popup.classList.add(classes$c.visible));
    }
    hidePopup() {
      this.popup.classList.remove(classes$c.visible),
        document.body.classList.remove(classes$c.barIsVisible);
      const popupIndex = popups.findIndex((x) => x.id === this.popupId);
      if (
        (popups.splice(popupIndex, 1),
        activePopups >= 1 && (activePopups -= 1),
        activePopups < 1)
      )
        this.scrollUnlock(), this.a11y.removeTrapFocus();
      else if (popups.length > 0) {
        const nextPopup = popups[popups.length - 1].body;
        this.a11y.trapFocus({ container: nextPopup });
      }
    }
    initClosers() {
      this.close.addEventListener("click", this.closePopup.bind(this)),
        this.underlay.addEventListener("click", () =>
          this.toggle.dispatchEvent(new Event("click"))
        ),
        this.popupContainer.addEventListener("keyup", (event2) => {
          event2.code === theme.keyboardKeys.ESCAPE &&
            (this.popup.classList.remove(classes$c.expanded),
            this.scrollUnlock());
        });
    }
    closePopup(event2) {
      event2.preventDefault(), this.cookie.write(), this.hidePopup();
    }
    scrollLock() {
      document.dispatchEvent(
        new CustomEvent("theme:scroll:lock", {
          bubbles: !0,
          detail: this.popupBody,
        })
      );
    }
    scrollUnlock() {
      this.resetScrollUnlock(),
        (scrollLockTimer = setTimeout(() => {
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          );
        }, 300));
    }
    resetScrollUnlock() {
      scrollLockTimer && clearTimeout(scrollLockTimer);
    }
    onBlockSelect(evt) {
      this.popupContainer.contains(evt.target) &&
        !this.popup.classList.contains(classes$c.visible) &&
        (this.showPopup(),
        this.popup.classList.add(classes$c.expanded),
        this.popup.classList.add(classes$c.selected),
        this.popup.parentNode.classList.add(classes$c.hasBlockSelected),
        this.resetScrollUnlock(),
        this.scrollLock());
    }
    onBlockDeselect(evt) {
      this.popupContainer.contains(evt.target) &&
        (this.popup.classList.remove(classes$c.expanded),
        this.popup.classList.remove(classes$c.selected),
        this.popup.parentNode.classList.remove(classes$c.hasBlockSelected),
        this.hidePopup());
    }
    onUnload() {
      this.scrollUnlock();
    }
    onDeselect() {
      this.popup.classList.remove(classes$c.expanded),
        this.popup.classList.remove(classes$c.selected),
        this.popup.parentNode.classList.remove(classes$c.hasBlockSelected),
        this.hidePopup();
    }
  }
  register("popups", [
    {
      onLoad() {
        (sections$a[this.id] = []),
          window.Shopify.designMode && (activePopups = 0);
        const popupsLarge = this.container.querySelectorAll(
          selectors$e.largePromo
        );
        popupsLarge.length &&
          popupsLarge.forEach((el) => {
            sections$a[this.id].push(new LargePopup(el));
          });
        const popupBars = this.container.querySelectorAll(selectors$e.popupBar);
        popupBars.length &&
          popupBars.forEach((el) => {
            sections$a[this.id].push(new PopupBar(el));
          });
        const cookiesPopups = this.container.querySelectorAll(
          selectors$e.tracking
        );
        cookiesPopups.length &&
          cookiesPopups.forEach((el) => {
            sections$a[this.id].push(new Tracking(el));
          });
      },
      onDeselect() {
        sections$a[this.id].forEach((el) => {
          typeof el.onDeselect == "function" && el.onDeselect();
        });
      },
      onBlockSelect(evt) {
        sections$a[this.id].forEach((el) => {
          typeof el.onBlockSelect == "function" && el.onBlockSelect(evt);
        });
      },
      onBlockDeselect(evt) {
        sections$a[this.id].forEach((el) => {
          typeof el.onBlockDeselect == "function" && el.onBlockDeselect(evt);
        });
      },
      onUnload(evt) {
        sections$a[this.id].forEach((el) => {
          typeof el.onUnload == "function" && el.onUnload(evt);
        });
      },
    },
    newsletterSection,
  ]);
  const selectors$d = {
      pressItems: "[data-press-items]",
      logoSlider: "[data-logo-slider]",
      logoSlide: "[data-logo-slide]",
      links: "a, button",
    },
    attributes$b = { logoSlide: "data-logo-index", tabIndex: "tabindex" };
  let sections$9 = {};
  class Press {
    constructor(section) {
      (this.container = section.container),
        (this.slider = this.container.querySelector(selectors$d.pressItems)),
        (this.sliderNav = this.container.querySelector(selectors$d.logoSlider)),
        (this.sliderResizeEvent = () => this.checkSlides()),
        this.initSlider(),
        this.checkSlides(),
        window.addEventListener("load", this.resizeSlider.bind(this)),
        document.addEventListener("theme:resize:width", this.sliderResizeEvent);
    }
    checkSlides() {
      const containerWidth = this.container.offsetWidth,
        slides = this.container.querySelectorAll(selectors$d.logoSlide),
        sliderNav = Flickity.data(this.sliderNav) || null;
      sliderNav !== null &&
        ((sliderNav.options.draggable = !1),
        (sliderNav.options.wrapAround = !1),
        (sliderNav.options.contain = !0),
        this.getSlidesWidth() > containerWidth &&
          slides.length > 2 &&
          ((sliderNav.options.draggable = !0),
          (sliderNav.options.wrapAround = !0),
          (sliderNav.options.contain = !1)),
        sliderNav.resize(),
        sliderNav.updateDraggable());
    }
    getSlidesWidth() {
      const slides = this.container.querySelectorAll(selectors$d.logoSlide);
      let slidesTotalWidth = 0;
      return (
        slides.length &&
          slides.forEach((slide) => {
            slidesTotalWidth += slide.offsetWidth;
          }),
        slidesTotalWidth
      );
    }
    initSlider() {
      let flkty = Flickity.data(this.slider) || null,
        flktyNav = Flickity.data(this.sliderNav) || null;
      const duration = parseInt(this.container.dataset.duration),
        autoplay = this.container.dataset.autoplay === "true" ? duration : !1;
      (flkty = new Flickity(this.slider, {
        fade: !0,
        wrapAround: !0,
        adaptiveHeight: !1,
        prevNextButtons: !1,
        pageDots: !1,
        autoPlay: autoplay,
      })),
        (flktyNav = new Flickity(this.sliderNav, {
          draggable: !1,
          wrapAround: !1,
          contain: !0,
          imagesLoaded: !0,
          asNavFor: this.slider,
          prevNextButtons: !1,
          adaptiveHeight: !1,
          pageDots: !1,
          on: {
            ready: () => {
              this.container
                .querySelectorAll(selectors$d.logoSlide)
                .forEach((slide) => {
                  slide.addEventListener("keyup", (event2) => {
                    if (
                      event2.code === theme.keyboardKeys.ENTER ||
                      event2.code === theme.keyboardKeys.NUMPADENTER ||
                      event2.code === theme.keyboardKeys.SPACE
                    ) {
                      const selectedIndex = Number(
                        slide.getAttribute(attributes$b.logoSlide)
                      );
                      flkty.selectCell(selectedIndex);
                    }
                  });
                });
            },
          },
        })),
        flickitySmoothScrolling(this.slider),
        flickitySmoothScrolling(this.sliderNav),
        flktyNav.on("change", (index) => {
          flkty.selectCell(index);
        }),
        flkty.on("change", (index) => {
          flktyNav.selectCell(index),
            flkty.cells.forEach((slide, i) => {
              slide.element
                .querySelectorAll(selectors$d.links)
                .forEach((link) => {
                  link.setAttribute(
                    attributes$b.tabIndex,
                    i === index ? "0" : "-1"
                  );
                });
            });
        });
    }
    resizeSlider() {
      const hasSlider = Flickity.data(this.slider);
      hasSlider && hasSlider.resize();
    }
    onBlockSelect(event2) {
      const slider2 = Flickity.data(this.slider) || null,
        sliderNav = Flickity.data(this.sliderNav) || null,
        index = parseInt(
          [...event2.target.parentNode.children].indexOf(event2.target)
        );
      slider2 !== null && (slider2.select(index), slider2.pausePlayer()),
        sliderNav !== null && sliderNav.select(index);
    }
    onBlockDeselect() {
      const slider2 = Flickity.data(this.slider) || null;
      this.container.dataset.autoplay === "true" &&
        slider2 !== null &&
        slider2.playPlayer();
    }
    onUnload() {
      document.removeEventListener(
        "theme:resize:width",
        this.sliderResizeEvent
      );
    }
  }
  register("press", {
    onLoad() {
      sections$9[this.id] = new Press(this);
    },
    onUnload(e) {
      sections$9[this.id].onUnload(e);
    },
    onBlockSelect(e) {
      sections$9[this.id].onBlockSelect(e);
    },
    onBlockDeselect() {
      sections$9[this.id].onBlockDeselect();
    },
  });
  const selectors$c = {
      slideshow: "[data-product-single-media-slider]",
      productInfo: "[data-product-info]",
      headerSticky: "[data-header-sticky]",
      headerHeight: "[data-header-height]",
    },
    classes$b = { sticky: "is-sticky" },
    attributes$a = { stickyEnabled: "data-sticky-enabled" };
  window.theme.variables = { productPageSticky: !1 };
  const sections$8 = {};
  class ProductSticky {
    constructor(section) {
      (this.container = section.container),
        (this.stickyEnabled =
          this.container.getAttribute(attributes$a.stickyEnabled) === "true"),
        (this.productInfo = this.container.querySelector(
          selectors$c.productInfo
        )),
        (this.stickyScrollTop = 0),
        (this.scrollLastPosition = 0),
        (this.stickyDefaultTop = 0),
        (this.currentPoint = 0),
        (this.defaultTopBottomSpacings = 30),
        (this.scrollTop = window.scrollY),
        (this.scrollDirectionDown = !0),
        (this.requestAnimationSticky = null),
        (this.stickyFormLoad = !0),
        (this.stickyFormLastHeight = null),
        (this.onChangeCounter = 0),
        (this.scrollEvent = (e) => this.scrollEvents(e)),
        (this.resizeEvent = (e) => this.resizeEvents(e)),
        this.init();
    }
    init() {
      this.stickyEnabled &&
        (this.stickyScrollCheck(),
        document.addEventListener("theme:resize", this.resizeEvent)),
        this.initSticky();
    }
    initSticky() {
      theme.variables.productPageSticky &&
        ((this.requestAnimationSticky = requestAnimationFrame(() =>
          this.calculateStickyPosition()
        )),
        this.productInfo.addEventListener("theme:form:sticky", (e) => {
          this.removeAnimationFrame(),
            (this.requestAnimationSticky = requestAnimationFrame(() =>
              this.calculateStickyPosition(e)
            ));
        }),
        document.addEventListener("theme:scroll", this.scrollEvent));
    }
    scrollEvents(e) {
      e.detail !== null &&
        ((this.scrollTop = e.detail.position),
        (this.scrollDirectionDown = e.detail.down)),
        this.requestAnimationSticky ||
          (this.requestAnimationSticky = requestAnimationFrame(() =>
            this.calculateStickyPosition()
          ));
    }
    resizeEvents() {
      this.stickyScrollCheck(),
        document.removeEventListener("theme:scroll", this.scrollEvent),
        this.initSticky();
    }
    stickyScrollCheck() {
      const isDesktop2 =
          (window.innerWidth ||
            document.documentElement.clientWidth ||
            document.body.clientWidth) >= window.theme.sizes.large,
        targetProductInfo = this.container.querySelector(
          selectors$c.productInfo
        );
      if (targetProductInfo)
        if (isDesktop2) {
          const productInfo = this.container.querySelector(
              selectors$c.productInfo
            ),
            slideshow = this.container.querySelector(selectors$c.slideshow);
          if (!productInfo || !slideshow) return;
          const productCopyHeight = productInfo.offsetHeight,
            productImagesHeight = slideshow.offsetHeight;
          productCopyHeight < productImagesHeight
            ? ((theme.variables.productPageSticky = !0),
              targetProductInfo.classList.add(classes$b.sticky))
            : ((theme.variables.productPageSticky = !1),
              targetProductInfo.classList.remove(classes$b.sticky));
        } else
          (theme.variables.productPageSticky = !1),
            targetProductInfo.classList.remove(classes$b.sticky);
    }
    calculateStickyPosition(e = null) {
      const isAccordion = !!(
          !!(e && e.detail) &&
          e.detail.element &&
          e.detail.element === "accordion"
        ),
        productInfoHeight = this.productInfo.offsetHeight,
        heightDifference =
          window.innerHeight -
          productInfoHeight -
          this.defaultTopBottomSpacings,
        scrollDifference = Math.abs(this.scrollTop - this.scrollLastPosition);
      this.scrollDirectionDown
        ? (this.stickyScrollTop -= scrollDifference)
        : (this.stickyScrollTop += scrollDifference),
        this.stickyFormLoad &&
          (document.querySelector(selectors$c.headerSticky) &&
          document.querySelector(selectors$c.headerHeight)
            ? (this.stickyDefaultTop = parseInt(
                document
                  .querySelector(selectors$c.headerHeight)
                  .getBoundingClientRect().height
              ))
            : (this.stickyDefaultTop = this.defaultTopBottomSpacings),
          (this.stickyScrollTop = this.stickyDefaultTop)),
        (this.stickyScrollTop = Math.min(
          Math.max(this.stickyScrollTop, heightDifference),
          this.stickyDefaultTop
        ));
      const differencePoint = this.stickyScrollTop - this.currentPoint;
      (this.currentPoint = this.stickyFormLoad
        ? this.stickyScrollTop
        : this.currentPoint + differencePoint * 0.5),
        this.productInfo.style.setProperty(
          "--sticky-top",
          `${this.currentPoint}px`
        ),
        (this.scrollLastPosition = this.scrollTop),
        (this.stickyFormLoad = !1),
        (isAccordion && this.onChangeCounter <= 10) ||
        (isAccordion && this.stickyFormLastHeight !== productInfoHeight) ||
        (this.stickyScrollTop !== this.currentPoint &&
          this.requestAnimationSticky)
          ? (isAccordion && (this.onChangeCounter += 1),
            isAccordion &&
              this.stickyFormLastHeight !== productInfoHeight &&
              (this.onChangeCounter = 11),
            (this.requestAnimationSticky = requestAnimationFrame(() =>
              this.calculateStickyPosition(e)
            )))
          : this.requestAnimationSticky && this.removeAnimationFrame(),
        (this.stickyFormLastHeight = productInfoHeight);
    }
    removeAnimationFrame() {
      this.requestAnimationSticky &&
        (cancelAnimationFrame(this.requestAnimationSticky),
        (this.requestAnimationSticky = null),
        (this.onChangeCounter = 0));
    }
    onUnload() {
      this.stickyEnabled &&
        document.removeEventListener("theme:resize", this.resizeEvent),
        theme.variables.productPageSticky &&
          document.removeEventListener("theme:scroll", this.scrollEvent);
    }
  }
  const productStickySection = {
      onLoad() {
        sections$8[this.id] = new ProductSticky(this);
      },
      onUnload() {
        sections$8[this.id].onUnload();
      },
    },
    selectors$b = {
      mediaContainer: "[data-product-single-media-group]",
      productMediaSlider: "[data-product-single-media-slider]",
      zoomWrapper: "[data-zoom-wrapper]",
    },
    classes$a = {
      popupClass: "pswp-zoom-gallery",
      popupClassNoThumbs: "pswp-zoom-gallery--single",
      isMoving: "is-moving",
    },
    attributes$9 = {
      dataImageWidth: "data-image-width",
      dataImageHeight: "data-image-height",
    };
  class Zoom {
    constructor(container) {
      (this.container = container),
        (this.mediaContainer = this.container.querySelector(
          selectors$b.mediaContainer
        )),
        (this.slider = this.container.querySelector(
          selectors$b.productMediaSlider
        )),
        (this.zoomWrappers = this.container.querySelectorAll(
          selectors$b.zoomWrapper
        )),
        (this.zoomEnable = this.mediaContainer.dataset.gallery === "true"),
        (this.a11y = a11y),
        this.zoomEnable && this.init();
    }
    init() {
      this.zoomWrappers.length &&
        this.zoomWrappers.forEach((element, i) => {
          element.addEventListener("click", (e) => {
            e.preventDefault(),
              (this.slider &&
                this.slider.classList.contains(classes$a.isMoving)) ||
                ((this.a11y.state.trigger = element), this.createZoom(i));
          });
        });
    }
    createZoom(indexImage) {
      const instance = this;
      let items = [],
        counter = 0;
      this.zoomWrappers.forEach((elementImage) => {
        const imgSrc = elementImage.getAttribute("href"),
          imgWidth = parseInt(
            elementImage.getAttribute(attributes$9.dataImageWidth)
          ),
          imgHeight = parseInt(
            elementImage.getAttribute(attributes$9.dataImageHeight)
          );
        if (
          (items.push({ src: imgSrc, w: imgWidth, h: imgHeight, msrc: imgSrc }),
          (counter += 1),
          instance.zoomWrappers.length === counter)
        ) {
          let popupClass = `${classes$a.popupClass}`;
          counter === 1 &&
            (popupClass = `${classes$a.popupClass} ${classes$a.popupClassNoThumbs}`);
          const options2 = {
            barsSize: { top: 60, bottom: 60 },
            history: !1,
            focus: !1,
            index: indexImage,
            mainClass: popupClass,
            showHideOpacity: !0,
            showAnimationDuration: 250,
            hideAnimationDuration: 250,
            closeOnScroll: !1,
            closeOnVerticalDrag: !1,
            captionEl: !1,
            closeEl: !0,
            closeElClasses: ["caption-close"],
            tapToClose: !1,
            clickToCloseNonZoomable: !1,
            maxSpreadZoom: 2,
            loop: !0,
            spacing: 0,
            allowPanToNext: !0,
            pinchToClose: !1,
          };
          new LoadPhotoswipe(items, options2);
        }
      });
    }
  }
  const selectors$a = {
      complementaryProducts: "[data-complementary-products]",
      buttonQuickView: "[data-button-quick-view]",
    },
    attributes$8 = { url: "data-url" };
  class ComplementaryProducts extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        entries[0].isIntersecting &&
          (observer.unobserve(this),
          this.hasAttribute(attributes$8.url) &&
            this.getAttribute(attributes$8.url) !== "" &&
            fetch(this.getAttribute(attributes$8.url))
              .then((response) => response.text())
              .then((text) => {
                const html = document.createElement("div");
                html.innerHTML = text;
                const recommendations = html.querySelector(
                  selectors$a.complementaryProducts
                );
                recommendations &&
                  recommendations.innerHTML.trim().length &&
                  (this.innerHTML = recommendations.innerHTML),
                  html.querySelector(selectors$a.buttonQuickView) &&
                    new QuickViewPopup(this);
              })
              .catch((e) => {
                console.error(e);
              }));
      };
      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: "0px 0px 400px 0px",
      }).observe(this);
    }
  }
  const selectors$9 = {
      recipientCheckbox: "[data-recipient-checkbox]",
      recipientEmail: "[data-recipient-email]",
      recipientName: "[data-recipient-name]",
      recipientMessage: "[data-recipient-message]",
      recipientSendOn: "[data-recipient-send-on]",
      recipientControl: "[data-recipient-control]",
      recipientOffset: "[data-recipient-offset]",
      productForm: "[data-product-form]",
      cartDrawer: "[data-cart-drawer]",
    },
    classes$9 = { quickViewVisible: "js-quick-view-visible" };
  class RecipientForm extends HTMLElement {
    constructor() {
      super(),
        (this.recipientCheckbox = this.querySelector(
          selectors$9.recipientCheckbox
        )),
        (this.recipientControl = this.querySelector(
          selectors$9.recipientControl
        )),
        (this.recipientControl.disabled = !0),
        (this.recipientEmail = this.querySelector(selectors$9.recipientEmail)),
        (this.recipientName = this.querySelector(selectors$9.recipientName)),
        (this.recipientMessage = this.querySelector(
          selectors$9.recipientMessage
        )),
        (this.recipientSendOn = this.querySelector(
          selectors$9.recipientSendOn
        )),
        (this.recipientOffset = this.querySelector(
          selectors$9.recipientOffset
        )),
        this.recipientOffset &&
          (this.recipientOffset.value = new Date().getTimezoneOffset()),
        (this.cartDrawer = document.querySelector(selectors$9.cartDrawer)),
        (this.onChangeEvent = (event2) => this.onChange(event2)),
        (this.onCartAddedEvent = () => this.onCartAdded());
    }
    connectedCallback() {
      this.recipientCheckbox &&
        (this.disableInputFields(),
        this.recipientCheckbox.addEventListener("change", this.onChangeEvent),
        document.addEventListener("theme:cart:added", this.onCartAddedEvent));
    }
    onChange(event2) {
      if (!event2.target.checked) {
        this.clearInputFields(), this.disableInputFields();
        return;
      }
      this.enableInputFields();
    }
    onCartAdded() {
      const scrollToPosition = this.closest(selectors$9.productForm).offsetTop,
        isQuickBuyForm = document.body.classList.contains(
          classes$9.quickViewVisible
        );
      if (!(this.recipientCheckbox.checked === !0)) return;
      isQuickBuyForm ||
        window.scrollTo({ top: scrollToPosition, left: 0, behavior: "smooth" });
      const onCartDrawerTransitionEnd = (event2) => {
        event2.target === this.cartDrawer &&
          (requestAnimationFrame(() => {
            (this.recipientCheckbox.checked = !1),
              this.recipientCheckbox.dispatchEvent(new Event("change"));
          }),
          this.cartDrawer.removeEventListener(
            "transitionend",
            onCartDrawerTransitionEnd
          ));
      };
      this.cartDrawer.addEventListener(
        "transitionend",
        onCartDrawerTransitionEnd
      );
    }
    inputFields() {
      return [
        this.recipientEmail,
        this.recipientName,
        this.recipientMessage,
        this.recipientSendOn,
      ];
    }
    disableableFields() {
      return [...this.inputFields(), this.recipientOffset];
    }
    clearInputFields() {
      this.inputFields().forEach((field) => (field.value = ""));
    }
    enableInputFields() {
      this.disableableFields().forEach((field) => (field.disabled = !1));
    }
    disableInputFields() {
      this.disableableFields().forEach((field) => (field.disabled = !0));
    }
    disconnectedCallback() {
      this.recipientCheckbox.removeEventListener("change", this.onChangeEvent),
        document.removeEventListener("theme:cart:added", this.onCartAddedEvent);
    }
  }
  const selectors$8 = {
      option: "[data-option]",
      popout: "[data-popout]",
      productMediaSlider: "[data-product-single-media-slider]",
      productMediaThumb: "[data-thumbnail-id]",
      productMediaThumbs: "[data-product-single-media-thumbs]",
      productMediaWrapper: "[data-product-single-media-wrapper]",
      productModel: "[data-model]",
      productSingleThumbnailLink: ".product-single__thumbnail-link",
      deferredMedia: "[data-deferred-media]",
      deferredMediaButton: "[data-deferred-media-button]",
      modalScrollContainer: "[data-tabs-holder]",
      tooltip: "[data-tooltip]",
      productRating: "[data-product-rating]",
      productReviews: "#shopify-product-reviews",
      links: "a, button",
      upsellProduct: "[data-upsell-holder]",
      upsellProductSlider: "[data-upsell-slider]",
      featureSlider: "[data-slider]",
      productJson: "[data-product-json]",
    },
    classes$8 = {
      featuredProduct: "featured-product",
      featuredProductOnboarding: "featured-product--onboarding",
      hasMediaActive: "has-media-active",
      isSelected: "is-selected",
      mediaHidden: "media--hidden",
      noOutline: "no-outline",
      hasPopup: "has-popup",
      isMoving: "is-moving",
    },
    attributes$7 = {
      mediaId: "data-media-id",
      sectionId: "data-section-id",
      thumbId: "data-thumbnail-id",
      dataTallLayout: "data-tall-layout",
      loaded: "loaded",
      tabindex: "tabindex",
    },
    sections$7 = {};
  class Product {
    constructor(section) {
      if (
        ((this.container = section.container),
        (this.sectionId = this.container.getAttribute(attributes$7.sectionId)),
        (this.tallLayout =
          this.container.getAttribute(attributes$7.dataTallLayout) === "true"),
        (this.featureSliders = this.container.querySelectorAll(
          selectors$8.featureSlider
        )),
        (this.flkty = null),
        (this.flktyNav = null),
        (this.isFlickityDragging = !1),
        (this.enableHistoryState = !this.container.classList.contains(
          classes$8.featuredProduct
        )),
        (this.checkSliderOnResize = () => this.checkSlider()),
        (this.flktyNavOnResize = () => this.resizeFlickityNav()),
        this.scrollToReviews(),
        this.initUpsellSlider(),
        this.initFeatureSlider(),
        new QuickViewPopup(this.container),
        this.container.classList.contains(classes$8.featuredProductOnboarding))
      )
        return;
      const productJson = this.container.querySelector(selectors$8.productJson);
      if (productJson && productJson.innerHTML) {
        const productJsonHandle = JSON.parse(productJson.innerHTML).handle;
        let recentObj = {};
        productJsonHandle && (recentObj = { handle: productJsonHandle }),
          Shopify.Products.recordRecentlyViewed(recentObj);
      } else Shopify.Products.recordRecentlyViewed();
      new Zoom(this.container),
        this.productSlider(),
        this.initMediaSwitch(),
        this.initProductVideo(),
        this.initProductModel(),
        this.initShopifyXrLaunch();
    }
    productSlider() {
      this.checkSlider(),
        document.addEventListener(
          "theme:resize:width",
          this.checkSliderOnResize
        );
    }
    checkSlider() {
      if (!this.tallLayout || window.innerWidth < theme.sizes.large) {
        this.initProductSlider();
        return;
      }
      this.destroyProductSlider();
    }
    resizeFlickityNav() {
      this.flktyNav !== null && this.flktyNav.resize();
    }
    initProductSlider() {
  const slider2 = this.container.querySelector(selectors$8.productMediaSlider),
        thumbs = this.container.querySelector(selectors$8.productMediaThumbs),
        media = this.container.querySelectorAll(selectors$8.productMediaWrapper);

  if (media.length > 1) {

    /* -----------------------------------------
     * MAIN FLICKITY SLIDER
     * ----------------------------------------- */
    this.flkty = new Flickity(slider2, {
      wrapAround: true,
      pageDots: true,
      adaptiveHeight: true,
      contain: true,
      cellAlign: 'center',
      imagesLoaded: true,
      on: {
        ready: () => {
          slider2.setAttribute(attributes$7.tabindex, "-1");
          media.forEach((item) => {
            if (!item.classList.contains(classes$8.isSelected)) {
              const links = item.querySelectorAll(selectors$8.links);
              links.forEach((link) => link.setAttribute(attributes$7.tabindex, "-1"));
            }
          });
        },

        dragStart: () => slider2.classList.add(classes$8.isMoving),
        dragMove: () => (this.isFlickityDragging = true),
        staticClick: () => (this.isFlickityDragging = false),

        settle: (index) => {
          const mediaId = this.flkty.selectedElement.getAttribute(attributes$7.mediaId);

          this.flkty.cells.forEach((slide, i) => {
            const links = slide.element.querySelectorAll(selectors$8.links);
            links.forEach((link) => {
              link.setAttribute(
                attributes$7.tabindex,
                i === index ? "0" : "-1"
              );
            });
          });

          this.switchMedia(mediaId);
          slider2.classList.remove(classes$8.isMoving);
        }
      }
    });

    /* -----------------------------------------
     * FIX: RECENTER MAIN SLIDER ON PAGE LOAD
     * ----------------------------------------- */
    imagesLoaded(slider2, () => {
      setTimeout(() => {
        this.flkty.reloadCells();
        this.flkty.resize();
        this.flkty.updateSlides();
        this.flkty.positionSlider();
        this.flkty.reposition();
      }, 30);
    });

    /* -----------------------------------------
     * MEDIA EVENTS (video)
     * ----------------------------------------- */
    media.forEach((el) => {
      el.addEventListener("theme:media:play", () => {
        this.flkty.options.draggable = false;
        this.flkty.updateDraggable();
        el.closest(selectors$8.productMediaSlider)
          .classList.add(classes$8.hasMediaActive);
      });

      el.addEventListener("theme:media:pause", () => {
        this.flkty.options.draggable = true;
        this.flkty.updateDraggable();
        el.closest(selectors$8.productMediaSlider)
          .classList.remove(classes$8.hasMediaActive);
      });
    });

    flickitySmoothScrolling(slider2);

    /* -----------------------------------------
     * THUMBNAIL NAV
     * ----------------------------------------- */
    if (thumbs !== null) {
      this.flktyNav = new Flickity(thumbs, {
        asNavFor: slider2,
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        resize: true,
        on: {
          ready: () => {
            thumbs.setAttribute(attributes$7.tabindex, "-1");
          }
        }
      });

      /* FIX: RECENTER MAIN SLIDER AFTER NAV SELECT
       * Listens to "change", not "select": resize() re-emits "select" on the same index, the
       * asNavFor strip echoes it back, and a "select" listener kept the two sliders resizing
       * each other about 60 times a second forever. "change" only fires on a real new slide. */
      this.flktyNav.on('change', () => {
        setTimeout(() => {
          this.flkty.resize();
          this.flkty.reposition();
        }, 20);
      });

      document.addEventListener("theme:resize:width", this.flktyNavOnResize);

      flickitySmoothScrolling(thumbs);

      const thumbLinks = this.container.querySelectorAll(
        selectors$8.productSingleThumbnailLink
      );

      thumbLinks.forEach((el) => {
        el.addEventListener("click", (e) => e.preventDefault());
      });
    }
  }

  window.addEventListener('load', () => {
  setTimeout(() => {
    if (this.flkty) {
      this.flkty.reloadCells();
      this.flkty.resize();
      this.flkty.reposition();
    }
  }, 100);
});

document.addEventListener('shopify:section:load', () => {
  setTimeout(() => {
    if (this.flkty) {
      this.flkty.reloadCells();
      this.flkty.resize();
      this.flkty.reposition();
    }
  }, 120);
});
}

    destroyProductSlider() {
      this.flkty !== null &&
        (this.flkty.destroy(),
        this.flktyNav.destroy(),
        (this.flkty = null),
        (this.flktyNav = null));
    }
    initUpsellSlider() {
      const slider2 = this.container.querySelector(
        selectors$8.upsellProductSlider
      );
      if (
        this.container.querySelectorAll(selectors$8.upsellProduct).length > 1
      ) {
        const flktyUpsell = new Flickity(slider2, {
          wrapAround: !0,
          pageDots: !0,
          adaptiveHeight: !0,
          prevNextButtons: !1,
        });
        flktyUpsell.on("change", (index) => {
          flktyUpsell.cells.forEach((slide, i) => {
            const links = slide.element.querySelectorAll(selectors$8.links);
            links.length &&
              links.forEach((link) => {
                link.setAttribute(
                  attributes$7.tabindex,
                  i === index ? "0" : "-1"
                );
              });
          });
        });
      }
    }
    initFeatureSlider() {
      this.featureSliders.forEach((featureSliders) => {
        Array.from(featureSliders.children).length > 1 &&
          (this.flktyFeature = new Flickity(featureSliders, {
            wrapAround: !0,
            pageDots: !0,
            adaptiveHeight: !0,
            prevNextButtons: !1,
          }));
      });
    }
    handleMediaFocus(event2) {
      if (
        event2.code !== theme.keyboardKeys.ENTER &&
        event2.code !== theme.keyboardKeys.TAB
      )
        return;
      const mediaId = event2.currentTarget.getAttribute(attributes$7.thumbId),
        activeSlide = this.container.querySelector(
          `[${attributes$7.mediaId}="${mediaId}"]`
        ),
        slideIndex = parseInt(
          [...activeSlide.parentNode.children].indexOf(activeSlide)
        ),
        slider2 = this.container.querySelector(selectors$8.productMediaSlider),
        sliderNav = this.container.querySelector(
          selectors$8.productMediaThumbs
        ),
        flkty = Flickity.data(slider2) || null,
        flktyNav = Flickity.data(sliderNav) || null;
      flkty &&
        flkty.isActive &&
        slideIndex > -1 &&
        (event2.code === theme.keyboardKeys.ENTER ||
          event2.code === theme.keyboardKeys.NUMPADENTER) &&
        flkty.select(slideIndex),
        flktyNav &&
          flktyNav.isActive &&
          slideIndex > -1 &&
          flktyNav.select(slideIndex);
    }
    switchMedia(mediaId) {
      const mediaItems = document.querySelectorAll(
          `${selectors$8.productMediaWrapper}`
        ),
        selectedMedia = this.container.querySelector(
          `${selectors$8.productMediaWrapper}[${attributes$7.mediaId}="${mediaId}"]`
        ),
        isFocusEnabled = !document.body.classList.contains(classes$8.noOutline);
      mediaItems.length &&
        mediaItems.forEach((media) => {
          media.dispatchEvent(new CustomEvent("theme:media:hidden"), {
            bubbles: !0,
          }),
            media.classList.add(classes$8.mediaHidden);
        }),
        isFocusEnabled && selectedMedia.focus(),
        selectedMedia
          .closest(selectors$8.productMediaSlider)
          .classList.remove(classes$8.hasMediaActive),
        selectedMedia.classList.remove(classes$8.mediaHidden),
        selectedMedia.dispatchEvent(new CustomEvent("theme:media:visible"), {
          bubbles: !0,
        });
      const deferredMedia = selectedMedia.querySelector(
        selectors$8.deferredMedia
      );
      deferredMedia &&
        deferredMedia.getAttribute(attributes$7.loaded) !== "true" &&
        selectedMedia
          .querySelector(selectors$8.deferredMediaButton)
          .dispatchEvent(new Event("click"));
    }
    initMediaSwitch() {
      const productThumbImages = this.container.querySelectorAll(
        selectors$8.productMediaThumb
      );
      productThumbImages.length &&
        productThumbImages.forEach((el) => {
          el.addEventListener("keyup", this.handleMediaFocus.bind(this)),
            el.addEventListener("click", (e) => {
              e.preventDefault();
            });
        });
    }
    initProductVideo() {
      this.videos = new ProductVideo(this.container);
    }
    initProductModel() {
      const modelItems = this.container.querySelectorAll(
        selectors$8.productModel
      );
      modelItems.length &&
        modelItems.forEach((element) => {
          theme.ProductModel.init(element, this.sectionId);
        });
    }
    initShopifyXrLaunch() {
      document.addEventListener("shopify_xr_launch", () => {
        this.container
          .querySelector(
            `${selectors$8.productModel}:not(.${classes$8.mediaHidden})`
          )
          .dispatchEvent(new CustomEvent("xrLaunch"));
      });
    }
    onUnload() {
      this.flktyNav !== null &&
        document.removeEventListener(
          "theme:resize:width",
          this.flktyNavOnResize
        ),
        document.removeEventListener(
          "theme:resize:width",
          this.checkSliderOnResize
        );
    }
    scrollToReviews() {
      const productRating = this.container.querySelector(
          selectors$8.productRating
        ),
        events = ["click", "keydown"];
      productRating &&
        events.forEach((eventName) => {
          productRating.addEventListener(eventName, (event2) => {
            if (
              (event2.code !== theme.keyboardKeys.ENTER &&
                event2.code !== theme.keyboardKeys.NUMPADENTER) ||
              event2.type != "click"
            ) {
              const reviewsContainer = document.querySelector(
                selectors$8.productReviews
              );
              if (!reviewsContainer) return;
              reviewsContainer.scrollIntoView({ behavior: "smooth" });
            }
          });
        });
    }
    onBlockSelect(event2) {
      const flkty = Flickity.data(
          event2.target.closest(selectors$8.featureSlider)
        ),
        index = parseInt(
          [...event2.target.parentNode.children].indexOf(event2.target)
        );
      flkty && flkty.select(index);
    }
  }
  const productSection = {
    onLoad() {
      sections$7[this.id] = new Product(this);
    },
    onUnload: function () {
      sections$7[this.id].onUnload();
    },
    onBlockSelect(event2) {
      sections$7[this.id].onBlockSelect(event2);
    },
  };
  register("product-template", [
    productFormSection,
    productSection,
    swatchSection,
    swatchesContainer,
    shareButton,
    collapsible,
    tooltip,
    popoutSection,
    drawer,
    productStickySection,
  ]),
    register("featured-product", [
      productFormSection,
      productSection,
      swatchSection,
      swatchesContainer,
      shareButton,
      collapsible,
      tooltip,
      popoutSection,
      drawer,
      productStickySection,
    ]),
    customElements.get("complementary-products") ||
      customElements.define("complementary-products", ComplementaryProducts),
    customElements.get("recipient-form") ||
      customElements.define("recipient-form", RecipientForm);
  const attributes$6 = {
      href: "href",
      mediaId: "data-media-id",
      deferredMediaLoaded: "data-deferred-media-loaded",
    },
    selectors$7 = {
      deferredMedia: "[data-deferred-media]",
      deferredMediaButton: "[data-deferred-media-button]",
      productContentWrapper: "[data-product-content-wrapper]",
      productMediaWrapper: "[data-product-single-media-wrapper]",
      productModel: "[data-model]",
      productLink: "[data-product-link]",
      productSingleMediaImage: "[data-product-single-media-image]",
      sliderContents: "[data-slider-contents]",
      sliderImages: "[data-slider-images]",
      tabButton: "[data-tab-button]",
      tabItem: "[data-tab-item]",
      circleText: "[data-circle-text]",
    },
    classes$7 = {
      aosAnimate: "aos-animate",
      tabButtonActive: "products-list__nav__button--active",
      tabItemActive: "products-list__item--active",
      mediaHidden: "media--hidden",
      isDisabled: "is-disabled",
    },
    sections$6 = {};
  class ProductsList {
    constructor(section) {
      (this.container = section.container),
        (this.sectionId = this.container.dataset.sectionId),
        (this.tabButtons = this.container.querySelectorAll(
          selectors$7.tabButton
        )),
        (this.tabItems = this.container.querySelectorAll(selectors$7.tabItem)),
        (this.slidersImages = this.container.querySelectorAll(
          selectors$7.sliderImages
        )),
        (this.slidersContents = this.container.querySelectorAll(
          selectors$7.sliderContents
        )),
        (this.videos = []),
        (this.flktyImages = []),
        (this.flktyContent = []),
        (this.sliderResizeEvent = () => this.resizeSlider()),
        this.initButtons(),
        this.initSliders(),
        this.initProductVideos(),
        this.initProductModel(),
        this.initShopifyXrLaunch(),
        this.listen();
    }
    listen() {
      (this.slidersImages.length > 0 || this.slidersContents.length > 0) &&
        document.addEventListener("theme:resize", this.sliderResizeEvent);
    }
    resizeSlider() {
      this.flktyImages.length > 0 &&
        requestAnimationFrame(() => {
          this.flktyImages.forEach((flktyImages) => flktyImages.resize());
        }),
        this.flktyContent.length > 0 &&
          requestAnimationFrame(() => {
            this.flktyContent.forEach((flktyContent) => flktyContent.resize());
          });
    }
    initButtons() {
      this.tabButtons.length &&
        this.tabButtons.forEach((tabButton) => {
          tabButton.addEventListener("click", (e) => {
            if (tabButton.classList.contains(classes$7.tabButtonActive)) return;
            const currentTabAnchor = tabButton.getAttribute(attributes$6.href),
              currentTab = this.container.querySelector(currentTabAnchor),
              currentMedia = currentTab.querySelector(
                selectors$7.productMediaWrapper
              ),
              mediaId = currentMedia ? currentMedia.dataset.mediaId : null,
              currentCircleText = currentTab.querySelector(
                selectors$7.circleText
              );
            this.tabButtons.forEach((button) => {
              button.classList.remove(classes$7.tabButtonActive);
            }),
              this.tabItems.forEach((item) => {
                const circleText = item.querySelector(selectors$7.circleText);
                item.classList.remove(classes$7.tabItemActive),
                  circleText?.classList.add(classes$7.isDisabled),
                  theme.settings.animationsEnabled &&
                    item
                      .querySelectorAll(`.${classes$7.aosAnimate}`)
                      .forEach((element) => {
                        element.classList.remove(classes$7.aosAnimate),
                          setTimeout(() => {
                            element.classList.add(classes$7.aosAnimate);
                          });
                      });
              }),
              tabButton.classList.add(classes$7.tabButtonActive),
              currentTab.classList.add(classes$7.tabItemActive),
              document.dispatchEvent(new CustomEvent("theme:resize")),
              currentCircleText &&
                (currentCircleText.classList.remove(classes$7.isDisabled),
                document.dispatchEvent(new CustomEvent("theme:scroll"))),
              this.handleProductVideos(currentTab, mediaId),
              e.preventDefault();
          });
        });
    }
    initSliders() {
      this.slidersImages.forEach((sliderImages, idx) => {
        const contentsElement = sliderImages
            .closest(selectors$7.tabItem)
            .querySelector(selectors$7.sliderContents),
          flktyImages = new Flickity(sliderImages, {
            fade: !0,
            pageDots: !1,
            prevNextButtons: !0,
            wrapAround: !0,
            adaptiveHeight: !0,
            asNavFor: contentsElement,
            on: {
              change: (index) => {
                this.flktyContent.length > 0 &&
                  this.flktyContent[idx].select(index);
              },
            },
          });
        flktyImages.on("settle", (index) => {
          const elements = sliderImages.querySelectorAll(
            selectors$7.productMediaWrapper
          );
          for (let i = 0; i < elements.length; i++)
            i === index
              ? elements[i]
                  .querySelector(selectors$7.productSingleMediaImage)
                  .removeAttribute("tabindex")
              : elements[i]
                  .querySelector(selectors$7.productSingleMediaImage)
                  .setAttribute("tabindex", "-1");
        }),
          this.flktyImages.push(flktyImages);
      }),
        this.slidersContents.forEach((sliderContent) => {
          const flktyContent = new Flickity(sliderContent, {
            fade: !0,
            pageDots: !1,
            prevNextButtons: !1,
            wrapAround: !0,
            adaptiveHeight: !0,
          });
          flktyContent.on("settle", (index) => {
            const elements = sliderContent.querySelectorAll(
              selectors$7.productContentWrapper
            );
            for (let i = 0; i < elements.length; i++)
              i === index
                ? elements[i]
                    .querySelectorAll(selectors$7.productLink)
                    .forEach((element) => {
                      element.removeAttribute("tabindex");
                    })
                : elements[i]
                    .querySelectorAll(selectors$7.productLink)
                    .forEach((element) => {
                      element.setAttribute("tabindex", "-1");
                    });
          }),
            this.flktyContent.push(flktyContent);
        });
    }
    initProductVideos() {
      this.tabItems.forEach((item) => {
        item.classList.contains(classes$7.tabItemActive) &&
          this.handleProductVideos(item);
      });
    }
    loadVideos(container, mediaId = null) {
      new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const productVideo = new ProductVideo(container);
              this.videos.push(productVideo),
                container.setAttribute(attributes$6.deferredMediaLoaded, ""),
                this.playToggle(mediaId),
                observer.unobserve(entry.target);
            }
          });
        },
        {
          root: null,
          rootMargin: "300px",
          threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
        }
      ).observe(container);
    }
    handleProductVideos(container, mediaId = null) {
      if (!container.hasAttribute(attributes$6.deferredMediaLoaded)) {
        this.loadVideos(container, mediaId);
        return;
      }
      this.playToggle(mediaId);
    }
    playToggle(mediaId) {
      this.videos.forEach((element) => {
        typeof element.pauseContainerMedia == "function" &&
          mediaId &&
          (element.pauseContainerMedia(mediaId, this.container),
          this.switchMedia(mediaId)),
          !mediaId &&
            Object.keys(element.players).length === 0 &&
            this.pauseContainerMedia(this.container);
      });
    }
    switchMedia(mediaId) {
      const selectedMedia = this.container.querySelector(
        `${selectors$7.productMediaWrapper}[${attributes$6.mediaId}="${mediaId}"]`
      );
      !document.body.classList.contains(classes$7.noOutline) &&
        selectedMedia.focus(),
        selectedMedia.classList.remove(classes$7.mediaHidden),
        selectedMedia.dispatchEvent(new CustomEvent("theme:media:visible"), {
          bubbles: !0,
        });
    }
    pauseContainerMedia(container) {
      const mediaItems = container.querySelectorAll(
        selectors$7.productMediaWrapper
      );
      mediaItems.length !== 0 &&
        mediaItems.forEach((media) => {
          media.dispatchEvent(new CustomEvent("theme:media:hidden"), {
            bubbles: !0,
          }),
            media.classList.add(classes$7.mediaHidden);
        });
    }
    initProductModel() {
      const modelItems = this.container.querySelectorAll(
        selectors$7.productModel
      );
      modelItems.length &&
        modelItems.forEach((element) => {
          theme.ProductModel.init(element, this.sectionId);
        });
    }
    initShopifyXrLaunch() {
      document.addEventListener("shopify_xr_launch", () => {
        this.container
          .querySelector(
            `${selectors$7.productModel}:not(.${classes$7.mediaHidden})`
          )
          .dispatchEvent(new CustomEvent("xrLaunch"));
      });
    }
    onBlockSelect(evt) {
      evt.target.dispatchEvent(new Event("click"));
    }
    onUnload() {
      (this.slidersImages.length > 0 || this.slidersContents.length > 0) &&
        document.removeEventListener("theme:resize", this.sliderResizeEvent);
    }
  }
  register("products-list", [
    {
      onLoad() {
        sections$6[this.id] = new ProductsList(this);
      },
      onUnload() {
        sections$6[this.id].onUnload();
      },
      onBlockSelect(e) {
        sections$6[this.id].onBlockSelect(e);
      },
    },
    parallaxSection,
  ]);
  const selectors$6 = {
      product: "[data-product-block]",
      relatedProducts: "[data-related-products]",
      recentlyViewed: "[data-recent-wrapper]",
      recentlyViewedWrapper: "[data-recently-viewed-wrapper]",
      slider: "[data-slider]",
      slide: "[data-slide]",
      aos: "[data-aos]",
      tabsHolder: "[data-tabs-holder]",
      tabsLink: "[data-tabs-link]",
      tab: "[data-tab]",
      tooltip: "[data-tooltip]",
    },
    attributes$5 = {
      sectionId: "data-section-id",
      productId: "data-product-id",
      limit: "data-limit",
      minimum: "data-minimum",
      tabsLink: "data-tabs-link",
      columnsMobile: "data-column-mobile",
    },
    classes$6 = {
      hidden: "hidden",
      aosAnimate: "aos-animate",
      oneWhole: "mobile--one-whole",
      oneHalf: "mobile--one-half",
    },
    sections$5 = {};
  class RelatedProducts {
    constructor(section) {
      (this.section = section),
        (this.sectionId = section.id),
        (this.container = section.container),
        this.related(),
        this.recent(),
        (this.tabs = new Tabs(this.container));
    }
    related() {
      if (
        ((this.relatedProducts = this.container.querySelector(
          selectors$6.relatedProducts
        )),
        !this.relatedProducts)
      )
        return;
      const sectionId = this.container.getAttribute(attributes$5.sectionId),
        productId = this.container.getAttribute(attributes$5.productId),
        limit = this.container.getAttribute(attributes$5.limit),
        requestUrl = `${theme.routes.product_recommendations_url}?section_id=${sectionId}&limit=${limit}&product_id=${productId}`;
      fetch(requestUrl)
        .then((response) => {
          if (!response.ok) {
            const error = new Error(response.status);
            throw (this.hideRelated(), error);
          }
          return response.text();
        })
        .then((data) => {
          const createdElement = document.createElement("div");
          createdElement.innerHTML = data;
          const inner = createdElement.querySelector(
            selectors$6.relatedProducts
          );
          inner &&
            inner.querySelectorAll(selectors$6.product).length &&
            ((this.relatedProducts.innerHTML = inner.innerHTML),
            (this.relatedProductGrid = new ProductGrid(this.relatedProducts)),
            (this.relatedGridSlider = new GridSlider(this.container)),
            this.initTooltips(this.relatedProducts));
        });
    }
    recent() {
      const recentlyViewed = this.container.querySelector(
          selectors$6.recentlyViewed
        ),
        howManyToshow = recentlyViewed
          ? parseInt(recentlyViewed.getAttribute(attributes$5.limit))
          : 4;
      Shopify.Products.showRecentlyViewed({
        howManyToShow: howManyToshow,
        wrapperId: `recently-viewed-products-${this.sectionId}`,
        section: this.section,
        onComplete: (wrapper, section) => {
          const container = section.container,
            recentlyViewedHolder = container.querySelector(
              selectors$6.recentlyViewed
            ),
            recentlyViewedWrapper = container.querySelector(
              selectors$6.recentlyViewedWrapper
            ),
            recentProducts = wrapper.querySelectorAll(selectors$6.product),
            aosItem = recentlyViewedHolder.querySelectorAll(selectors$6.aos),
            slider2 = recentlyViewedHolder.querySelector(selectors$6.slider),
            minimumNumberProducts = recentlyViewedHolder.hasAttribute(
              attributes$5.minimum
            )
              ? parseInt(
                  recentlyViewedHolder.getAttribute(attributes$5.minimum)
                )
              : 1,
            checkRecentInRelated =
              !recentlyViewedWrapper && recentProducts.length > 0,
            checkRecentOutsideRelated =
              recentlyViewedWrapper &&
              recentProducts.length >= minimumNumberProducts,
            columnsMobile = slider2.getAttribute(attributes$5.columnsMobile);
          if (checkRecentInRelated || checkRecentOutsideRelated) {
            (this.recentProductGrid = new ProductGrid(recentlyViewedHolder)),
              this.initTooltips(recentlyViewedHolder),
              checkRecentOutsideRelated &&
                container.classList.remove(classes$6.hidden),
              slider2 &&
                ((this.recentGridSlider = new GridSlider(container)),
                requestAnimationFrame(() => {
                  this.recentGridSlider.sliders.forEach((slider3) => {
                    slider3.dispatchEvent(
                      new CustomEvent("theme:slider:resize", { bubbles: !0 })
                    ),
                      this.recentGridSlider.setSliderArrowsPosition(slider3);
                  });
                }),
                slider2
                  .querySelectorAll(selectors$6.slide)
                  .forEach((slides) => {
                    columnsMobile == 2
                      ? (slides.classList.add(classes$6.oneHalf),
                        slides.classList.remove(classes$6.oneWhole))
                      : (slides.classList.add(classes$6.oneWhole),
                        slides.classList.remove(classes$6.oneHalf));
                  }));
            let itemsSet = [];
            recentlyViewedHolder.addEventListener(
              "theme:target:animate",
              (event2) => {
                itemsSet.push(event2.detail),
                  itemsSet.length === aosItem.length &&
                    requestAnimationFrame(() =>
                      aosItem.forEach((item) =>
                        item.classList.add(classes$6.aosAnimate)
                      )
                    );
              }
            );
          }
        },
      });
    }
    hideRelated() {
      const tab = this.relatedProducts.closest(selectors$6.tab),
        tabsHolder = this.relatedProducts.closest(selectors$6.tabsHolder),
        tabsLink = tabsHolder.querySelector(
          `[${attributes$5.tabsLink}="${tab.dataset.tab}"]`
        );
      tab.remove(),
        tabsLink &&
          (tabsLink.remove(),
          tabsHolder
            .querySelector(selectors$6.tabsLink)
            .dispatchEvent(new Event("click")),
          this.tabs.customScrollbar.unload(),
          requestAnimationFrame(() => {
            this.tabs.customScrollbar = new CustomScrollbar(
              this.tabs.container
            );
          }));
    }
    initTooltips(container) {
      (this.tooltips = container.querySelectorAll(selectors$6.tooltip)),
        this.tooltips.forEach((tooltip2) => {
          new Tooltip(tooltip2);
        });
    }
    onDeselect() {
      this.relatedProductGrid && this.relatedProductGrid.onDeselect(),
        this.recentProductGrid && this.recentProductGrid.onDeselect();
    }
    onBlockSelect(event2) {
      const element = event2.target,
        tab = this.container.querySelectorAll(selectors$6.tab);
      !element ||
        tab.length < 2 ||
        (element.dispatchEvent(new Event("click")),
        element.parentNode.scrollTo({
          top: 0,
          left: element.offsetLeft - element.clientWidth,
          behavior: "smooth",
        }));
    }
    onUnload() {
      this.relatedProductGrid && this.relatedProductGrid.onUnload(),
        this.relatedGridSlider && this.relatedGridSlider.onUnload(),
        this.recentProductGrid && this.recentProductGrid.onUnload(),
        this.recentGridSlider && this.recentGridSlider.onUnload();
    }
  }
  const relatedProductsSection = {
    onLoad() {
      sections$5[this.id] = new RelatedProducts(this);
    },
    onDeselect() {
      sections$5[this.id].onDeselect();
    },
    onBlockSelect(event2) {
      sections$5[this.id].onBlockSelect(event2);
    },
    onUnload() {
      sections$5[this.id].onUnload();
    },
  };
  register("related-products", relatedProductsSection),
    register("recent-products", relatedProductsSection);
  const sections$4 = {},
    selectors$5 = {
      slider: "[data-slider]",
      sliderItem: "[data-item]",
      buttonProductsShow: "[data-button-show]",
      buttonProductsHide: "[data-button-hide]",
      itemProducts: "[data-item-products]",
      itemProductSlider: "[data-item-products-slider]",
      itemProduct: "[data-item-product]",
      links: "a, button",
    },
    classes$5 = {
      itemActive: "blog-item--active",
      itemProductsVisible: "blog-item__products--visible",
      featuredBlogSlider: "shoppable-blog__slider",
      flickityEnabled: "flickity-enabled",
      isSelected: "is-selected",
    },
    attributes$4 = {
      slider: "data-slider",
      slidePosition: "data-slide-position",
      sectionId: "data-section-id",
      tabIndex: "tabindex",
    };
  class ShoppableBlog {
    constructor(section) {
      (this.container = section.container),
        (this.flkty = null),
        (this.slider = this.container.querySelector(selectors$5.slider)),
        (this.checkSlidesSizeOnResize = () => this.checkSlidesSize()),
        (this.isFullWidth = this.container.hasAttribute(
          attributes$4.fullWidth
        )),
        (this.gutter = 0),
        (this.a11y = a11y),
        (this.clickOutsideItemEvent = (e) => {
          if (
            !(
              e.target.matches(selectors$5.sliderItem) ||
              e.target.closest(selectors$5.sliderItem)
            )
          ) {
            const sliderItem = this.container.querySelectorAll(
              selectors$5.sliderItem
            );
            sliderItem.length &&
              sliderItem.forEach((item) => {
                const itemProducts = item.querySelector(
                  selectors$5.itemProducts
                );
                itemProducts &&
                  (itemProducts.classList.remove(classes$5.itemProductsVisible),
                  this.changeTabIndex(itemProducts)),
                  item.classList.remove(classes$5.itemActive);
              });
          }
        }),
        this.bindButtons(),
        this.listen();
    }
    initSlider() {
      (this.flkty = new Flickity(this.slider, {
        prevNextButtons: !0,
        pageDots: !1,
        cellAlign: "left",
        wrapAround: !1,
        groupCells: !0,
        contain: !0,
        on: {
          ready: () => {
            this.handleFocus();
          },
        },
      })),
        this.flkty.on("change", () => {
          const slides = this.container.querySelectorAll(
            selectors$5.sliderItem
          );
          this.handleFocus(),
            slides.length &&
              slides.forEach((el) => {
                const itemProducts = el.querySelector(selectors$5.itemProducts);
                el.classList.remove(classes$5.itemActive),
                  itemProducts &&
                    el
                      .querySelector(selectors$5.itemProducts)
                      .classList.remove(classes$5.itemProductsVisible);
              }),
            this.flkty &&
              !this.flkty.options.draggable &&
              ((this.flkty.options.draggable = !0),
              this.flkty.updateDraggable());
        });
    }
    destroySlider() {
      this.flkty !== null && (this.flkty.destroy(), (this.flkty = null));
    }
    checkSlidesSize() {
      const sliderItemStyle =
        this.container.querySelector(selectors$5.sliderItem).currentStyle ||
        window.getComputedStyle(
          this.container.querySelector(selectors$5.sliderItem)
        );
      this.gutter = parseInt(sliderItemStyle.marginRight);
      const containerWidth = this.slider.offsetWidth + this.gutter,
        itemsWidth = this.getItemsWidth(),
        itemsOverflowViewport = containerWidth < itemsWidth;
      window.innerWidth >= theme.sizes.small && itemsOverflowViewport
        ? this.initSlider()
        : this.destroySlider();
    }
    getItemsWidth() {
      let itemsWidth = 0;
      const slides = this.slider.querySelectorAll(selectors$5.sliderItem);
      return (
        slides.length &&
          slides.forEach((item) => {
            itemsWidth += item.offsetWidth + this.gutter;
          }),
        itemsWidth
      );
    }
    bindButtons() {
      const itemProductSlider = this.container.querySelectorAll(
          selectors$5.itemProductSlider
        ),
        buttonProductsShow = this.container.querySelectorAll(
          selectors$5.buttonProductsShow
        ),
        buttonProductsHide = this.container.querySelectorAll(
          selectors$5.buttonProductsHide
        );
      buttonProductsShow.length &&
        buttonProductsShow.forEach((button) => {
          button.addEventListener("click", (e) => {
            e.preventDefault(),
              this.container
                .querySelectorAll(selectors$5.sliderItem)
                .forEach((item2) => {
                  const itemProducts2 = item2.querySelector(
                    selectors$5.itemProducts
                  );
                  item2.classList.remove(classes$5.itemActive),
                    itemProducts2 &&
                      (itemProducts2.classList.remove(
                        classes$5.itemProductsVisible
                      ),
                      this.changeTabIndex(itemProducts2));
                });
            const item = button.closest(selectors$5.sliderItem),
              itemProducts = item.querySelector(selectors$5.itemProducts);
            if ((item.classList.add(classes$5.itemActive), itemProducts)) {
              itemProducts.classList.add(classes$5.itemProductsVisible),
                this.changeTabIndex(itemProducts, "enable");
              const itemProductsSlider = itemProducts.querySelector(
                  selectors$5.itemProductSlider
                ),
                allSlides = itemProductsSlider.querySelectorAll(
                  selectors$5.itemProduct
                );
              if (
                itemProductsSlider.classList.contains(classes$5.flickityEnabled)
              ) {
                const currentSlideIndex = itemProductsSlider
                  .querySelector(`.${classes$5.isSelected}`)
                  .getAttribute(attributes$4.slidePosition);
                allSlides.forEach((slide, i) => {
                  slide.setAttribute(
                    attributes$4.tabIndex,
                    i === currentSlideIndex ? "0" : "-1"
                  );
                });
              }
            }
            this.flkty !== null &&
              ((this.flkty.options.draggable = !1),
              this.flkty.updateDraggable()),
              (this.a11y.state.trigger = button);
          });
        }),
        buttonProductsHide.length &&
          buttonProductsHide.forEach((button) => {
            button.addEventListener("click", (e) => {
              e.preventDefault();
              const item = button.closest(selectors$5.sliderItem),
                itemProducts = item.querySelector(selectors$5.itemProducts);
              item.classList.remove(classes$5.itemActive),
                itemProducts &&
                  (itemProducts.classList.remove(classes$5.itemProductsVisible),
                  this.changeTabIndex(itemProducts)),
                this.flkty !== null &&
                  ((this.flkty.options.draggable = !0),
                  this.flkty.updateDraggable()),
                this.a11y.state.trigger.focus();
            });
          }),
        itemProductSlider.length &&
          itemProductSlider.forEach((slider2) => {
            if (slider2.querySelectorAll(selectors$5.itemProduct).length > 1) {
              const flktyProducts = new Flickity(slider2, {
                prevNextButtons: !0,
                contain: !0,
                pageDots: !1,
                wrapAround: !0,
                on: {
                  change: (index) => {
                    flktyProducts.cells.forEach((slide, i) => {
                      slide.element
                        .querySelectorAll(selectors$5.links)
                        .forEach((link) => {
                          link.setAttribute(
                            attributes$4.tabIndex,
                            i === index ? "0" : "-1"
                          );
                        });
                    });
                  },
                },
              });
            }
          }),
        this.slider.addEventListener("keyup", (event2) => {
          if (event2.code === theme.keyboardKeys.ESCAPE) {
            const sliderItem = event2.target.hasAttribute(attributes$4.slider)
              ? event2.target.querySelectorAll(selectors$5.sliderItem)
              : event2.target
                  .closest(selectors$5.slider)
                  .querySelectorAll(selectors$5.sliderItem);
            sliderItem.length &&
              (sliderItem.forEach((item) => {
                const itemProducts = item.querySelector(
                  selectors$5.itemProducts
                );
                item.classList.remove(classes$5.itemActive),
                  itemProducts &&
                    (itemProducts.classList.remove(
                      classes$5.itemProductsVisible
                    ),
                    this.changeTabIndex(itemProducts));
              }),
              this.flkty &&
                ((this.flkty.options.draggable = !0),
                this.flkty.updateDraggable())),
              this.a11y.state.trigger.focus();
          }
        });
    }
    handleFocus() {
      const sliderItems = this.container.querySelectorAll(
        selectors$5.sliderItem
      );
      sliderItems.length &&
        sliderItems.forEach((item) => {
          const selected = item.classList.contains(classes$5.isSelected),
            itemProducts = item.querySelector(selectors$5.itemProducts);
          selected
            ? (this.changeTabIndex(item, "enable"),
              itemProducts && this.changeTabIndex(itemProducts))
            : (this.changeTabIndex(item),
              itemProducts &&
                itemProducts.classList.remove(classes$5.itemProductsVisible));
        });
    }
    listen() {
      this.slider &&
        (this.checkSlidesSize(),
        document.addEventListener(
          "theme:resize:width",
          this.checkSlidesSizeOnResize
        )),
        document.addEventListener("mousedown", this.clickOutsideItemEvent);
    }
    changeTabIndex(items, state = "") {
      const tabIndex = state === "enable" ? "0" : "-1";
      items.querySelectorAll(selectors$5.links).forEach((link) => {
        link.setAttribute(attributes$4.tabIndex, tabIndex);
      });
    }
    onBlockSelect(evt) {
      if (this.flkty !== null) {
        const index = parseInt(
            [...evt.target.parentNode.children].indexOf(evt.target)
          ),
          slidesPerPage = parseInt(this.flkty.slides[0].cells.length),
          groupIndex = Math.floor(index / slidesPerPage);
        this.flkty.select(groupIndex);
      } else {
        const sliderStyle =
            this.slider.currentStyle || window.getComputedStyle(this.slider),
          sliderPadding = parseInt(sliderStyle.paddingLeft),
          blockPositionLeft = evt.target.offsetLeft - sliderPadding;
        this.slider.scrollTo({
          top: 0,
          left: blockPositionLeft,
          behavior: "smooth",
        });
      }
    }
    onUnload() {
      document.removeEventListener(
        "theme:resize:width",
        this.checkSlidesSizeOnResize
      ),
        document.removeEventListener("mousedown", this.clickOutsideItemEvent);
    }
  }
  register("shoppable-blog", {
    onLoad() {
      sections$4[this.id] = new ShoppableBlog(this);
    },
    onUnload(e) {
      sections$4[this.id].onUnload(e);
    },
    onBlockSelect(e) {
      sections$4[this.id].onBlockSelect(e);
    },
  });
  const selectors$4 = {
      arrowScrollDown: "[data-scroll-down]",
      header: "[data-site-header]",
      item: "[data-slide]",
      links: "a, button",
      slider: "[data-slider]",
      lazyImage: ".lazy-image",
      textHighlight: "text-highlight",
      parallax:
        '[data-parallax="zoom-on-scroll"],[data-parallax="card-scrolling"],[data-parallax="zoom-on-scroll,card-scrolling"]',
    },
    attributes$3 = {
      style: "data-style",
      currentStyle: "data-current-style",
      tabIndex: "tabindex",
      slidePosition: "data-slide-position",
    },
    classes$4 = {
      headerFixed: "site-header--fixed",
      sliderNoCachedImages: "slider--no-cached-images",
      sliderImgLoaded: "slider--img-loaded",
      imgIn: "img-in",
    },
    sections$3 = {};
  class Slider {
    constructor(section) {
      (this.container = section.container),
        (this.header = document.querySelector(selectors$4.header)),
        (this.flkty = null),
        (this.parallax = null),
        (this.resizeEvent = () => {
          this.flkty.resize();
        }),
        this.initSlider(),
        this.bindScrollButton(),
        this.container.matches(selectors$4.parallax) &&
          (this.parallax = new ParallaxElement(this.container));
    }
    initSlider() {
      const slidesCount = this.container.querySelectorAll(
          selectors$4.item
        ).length,
        duration = parseInt(this.container.dataset.duration),
        pageDots =
          this.container.dataset.pageDots === "true" && slidesCount > 1,
        prevNextButtons =
          this.container.dataset.navArrows === "true" && slidesCount > 1;
      let autoplay = this.container.dataset.autoplay === "true";
      if ((autoplay && (autoplay = duration), slidesCount > 1))
        (this.flkty = new Flickity(this.container, {
          fade: !0,
          cellSelector: selectors$4.item,
          autoPlay: autoplay,
          wrapAround: !0,
          adaptiveHeight: !0,
          setGallerySize: !0,
          imagesLoaded: !0,
          pageDots,
          prevNextButtons,
          dragThreshold: 25,
          on: {
            ready: () => {
              const currentStyle = this.container
                .querySelector(
                  `${selectors$4.item}[${attributes$3.slidePosition}="1"]`
                )
                .getAttribute(attributes$3.style);
              this.container.setAttribute(
                attributes$3.currentStyle,
                currentStyle
              ),
                requestAnimationFrame(this.resizeEvent),
                document.addEventListener("theme:vars", this.resizeEvent),
                this.handleFirstSlideAnimation(!0);
            },
            change: (index) => {
              const currentStyle = this.flkty.selectedElement.getAttribute(
                attributes$3.style
              );
              this.container.setAttribute(
                attributes$3.currentStyle,
                currentStyle
              ),
                this.handleFirstSlideAnimation(!1),
                this.flkty.cells.forEach((slide, i) => {
                  slide.element
                    .querySelectorAll(selectors$4.links)
                    .forEach((link) => {
                      link.setAttribute(
                        attributes$3.tabIndex,
                        i === index ? "0" : "-1"
                      );
                    }),
                    slide.element
                      .querySelectorAll(selectors$4.textHighlight)
                      .forEach((highlight) => {
                        highlight.setTriggerAttribute(i === index);
                      });
                });
            },
          },
        })),
          flickitySmoothScrolling(this.container);
      else if (slidesCount === 1) {
        const currentStyle = this.container
          .querySelector(selectors$4.item)
          .getAttribute(attributes$3.style);
        this.container.setAttribute(attributes$3.currentStyle, currentStyle);
      }
    }
    handleFirstSlideAnimation(onLoad = !1) {
      if (!onLoad) {
        this.container.classList.remove(classes$4.sliderNoCachedImages),
          this.container.classList.remove(classes$4.sliderImgLoaded);
        return;
      }
      const slideImage = this.container
          .querySelectorAll(selectors$4.item)[0]
          .querySelectorAll(selectors$4.lazyImage),
        slideImgComplete = this.container.classList.contains(classes$4.imgIn);
      if (slideImage.length && !slideImgComplete) {
        this.container.classList.add(classes$4.sliderNoCachedImages);
        const onImageTransitionEnd = (event2) => {
          requestAnimationFrame(() =>
            this.container.classList.add(classes$4.sliderImgLoaded)
          ),
            slideImage[0].removeEventListener(
              "transitionend",
              onImageTransitionEnd
            );
        };
        slideImage[0].addEventListener("transitionend", onImageTransitionEnd);
      }
    }
    bindScrollButton() {
      const arrowDown = this.container.querySelector(
        selectors$4.arrowScrollDown
      );
      arrowDown &&
        arrowDown.addEventListener("click", (e) => {
          e.preventDefault();
          const headerHeight = this.header.classList.contains(
              classes$4.headerFixed
            )
              ? 60
              : 0,
            scrollToPosition = parseInt(
              Math.ceil(
                this.container.offsetTop +
                  this.container.offsetHeight -
                  headerHeight
              )
            );
          window.scrollTo({
            top: scrollToPosition,
            left: 0,
            behavior: "smooth",
          });
        });
    }
    onBlockSelect(evt) {
      const index = parseInt(
        [...evt.target.parentNode.children].indexOf(evt.target)
      );
      this.flkty !== null &&
        (this.flkty.select(index), this.flkty.pausePlayer());
    }
    onBlockDeselect(evt) {
      evt.target.closest(selectors$4.slider).dataset.autoplay === "true" &&
        this.flkty !== null &&
        this.flkty.playPlayer();
    }
    onReorder() {
      this.handleFirstSlideAnimation(!1),
        this.flkty !== null && this.flkty.resize();
    }
    onUnload() {
      this.handleFirstSlideAnimation(!1),
        this.flkty !== null &&
          (document.removeEventListener("theme:vars", this.resizeEvent),
          this.flkty.destroy(),
          (this.flkty = null)),
        this.parallax && (this.parallax.unload(), (this.parallax = null));
    }
  }
  register("slider", [
    {
      onLoad() {
        sections$3[this.id] = new Slider(this);
      },
      onReorder(e) {
        sections$3[this.id].onReorder(e);
      },
      onUnload(e) {
        sections$3[this.id].onUnload(e);
      },
      onBlockSelect(e) {
        sections$3[this.id].onBlockSelect(e);
      },
      onBlockDeselect(e) {
        sections$3[this.id].onBlockDeselect(e);
      },
    },
    videoPlay,
  ]);
  const selectors$3 = {
      body: "[data-sticky-card-body]",
      wrapper: "[data-sticky-card-wrapper]",
      content: "[data-sticky-card-content]",
      aside: "[data-sticky-card-aside]",
      text: "[data-sticky-card-text]",
      image: "[data-sticky-card-image]",
      vh: "[data-sticky-vh]",
    },
    classes$3 = {
      isStuckUp: "is-stuck-up",
      hasPassedSticky: "has-passed-sticky",
      spillover: "spillover",
    },
    attributes$2 = { layoutMobile: "data-sticky-card-layout-mobile" },
    sections$2 = {};
  class StickyImageCards {
    constructor(section) {
      (this.container = section.container),
        (this.body = this.container.querySelector(selectors$3.body)),
        (this.wrapper = this.container.querySelectorAll(selectors$3.wrapper)),
        (this.content = this.container.querySelector(selectors$3.content)),
        (this.aside = this.container.querySelector(selectors$3.aside)),
        (this.text = this.container.querySelectorAll(selectors$3.text)),
        (this.image = this.container.querySelectorAll(selectors$3.image)),
        (this.textInContent = this.content?.querySelectorAll(selectors$3.text)),
        (this.vh = this.container.querySelector(selectors$3.vh)),
        (this.layoutMobile = this.container.getAttribute(
          attributes$2.layoutMobile
        )),
        (this.isDesktop = getWindowWidth() >= window.theme.sizes.large),
        (this.isMobile = isMobile()),
        (this.orientation = getScreenOrientation()),
        this.image.length !== 0 &&
          ((this.onScrollCallback = () => this.onScroll()),
          (this.onResizeCallback = () => this.onResize()),
          this.init());
    }
    init() {
      requestAnimationFrame(() => {
        this.calculateHeights(), this.onScroll();
      }),
        document.addEventListener("theme:scroll", this.onScrollCallback),
        document.addEventListener("theme:resize", this.onResizeCallback);
    }
    onScroll() {
      this.isEligible() && this.detectStickyPositions();
    }
    isEligible() {
      const elementOffsetTopPoint = Math.round(
          this.container.getBoundingClientRect().top + window.scrollY
        ),
        isBottomOfElementPassed =
          elementOffsetTopPoint + this.container.offsetHeight <
          Math.round(window.scrollY);
      return (
        elementOffsetTopPoint <
          Math.round(window.scrollY + window.innerHeight) &&
        !isBottomOfElementPassed
      );
    }
    detectStickyPositions() {
      const parentOffset = Math.round(
        this.body.getBoundingClientRect().top -
          this.headerHeight -
          this.wrapperTop
      );
      [...this.wrapper].forEach((item, i) => {
        const distance = Math.floor(
          item.getBoundingClientRect().top - this.headerHeight
        );
        if (this.isMobile) {
          if (i !== this.lastIndex) {
            const nextOneDistance = Math.floor(
              this.wrapper[i + 1].getBoundingClientRect().top -
                this.headerHeight
            );
            item.classList.toggle(
              classes$3.hasPassedSticky,
              nextOneDistance <= this.stickyTop
            );
          }
          this.container.classList.toggle(
            `checkpoint-${i + 1}`,
            parentOffset <= this.cumulativeHeights[i] * -1
          );
        }
        item.classList.toggle(classes$3.isStuckUp, distance <= this.stickyTop);
      });
    }
    calculateHeights() {
      let { stickyHeaderHeight } = readHeights();
      (this.headerHeight = stickyHeaderHeight || 0),
        (this.spacingTop =
          parseInt(
            window
              .getComputedStyle(this.container)
              .getPropertyValue("--padding")
          ) || 20),
        (this.wrapperTop =
          parseInt(
            window.getComputedStyle(this.wrapper[0]).getPropertyValue("top")
          ) || 0),
        (this.stickyTop = Math.floor(this.wrapperTop - this.headerHeight)),
        (this.gap =
          parseInt(
            window.getComputedStyle(this.aside).getPropertyValue("gap")
          ) || 0),
        (this.viewportHeight = this.vh.offsetHeight),
        (this.lastIndex = [...this.wrapper].length - 1),
        (this.cumulativeHeights = []),
        this.isMobile &&
          ((this.wrapperTop = this.spacingTop),
          (this.stickyTop = this.spacingTop)),
        this.textInContent &&
          (this.isDesktop &&
            this.textInContent.length > 0 &&
            this.textInContent.forEach((element, i) => {
              element.style.setProperty("--row-height", "auto"),
                this.wrapper[i].style.setProperty("--row-height", "auto");
              const elementHeight = element.offsetHeight,
                imageHeight = this.image[i].offsetHeight,
                maxHeight = Math.max(elementHeight, imageHeight);
              element.style.setProperty("--row-height", `${maxHeight}px`),
                this.wrapper[i].style.setProperty(
                  "--row-height",
                  `${maxHeight}px`
                );
            }),
          [...this.wrapper].forEach((item, i) => {
            item.style.setProperty("--item-height", "auto"),
              item.style.setProperty("--item-double-height", "auto"),
              requestAnimationFrame(() => {
                const itemHeight = item.offsetHeight,
                  isExceeding =
                    itemHeight + this.wrapperTop + this.headerHeight >
                    this.viewportHeight,
                  heights = [...this.wrapper].map((element) =>
                    Number(element.dataset.index) >= i
                      ? 0
                      : element.offsetHeight
                  );
                this.cumulativeHeights.push(heights.reduce((a, b) => a + b, 0)),
                  item.classList.toggle(classes$3.spillover, isExceeding),
                  isExceeding &&
                    this.isMobile &&
                    (item.style.setProperty("--item-height", `${itemHeight}px`),
                    item.style.setProperty(
                      "--item-double-height",
                      `${itemHeight * 2}px`
                    ));
              });
          }));
    }
    onResize() {
      requestAnimationFrame(() => {
        (this.isDesktop = getWindowWidth() >= window.theme.sizes.large),
          (this.isMobile = isMobile());
        const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
        let isEligible = this.isDesktop || (!isIOS && this.isMobile);
        this.orientation !== getScreenOrientation() &&
          isIOS &&
          ((isEligible = !0), (this.orientation = getScreenOrientation())),
          isEligible && this.calculateHeights();
      });
    }
    onUnload() {
      document.removeEventListener("theme:scroll", this.onScrollCallback),
        document.removeEventListener("theme:resize", this.onResizeCallback);
    }
    onBlockSelect(event2) {
      requestAnimationFrame(() => {
        const index = Number(event2.target.dataset.index),
          parentOffset = Math.round(
            this.body.getBoundingClientRect().top + window.scrollY
          ),
          cumulativeHeight = [...this.wrapper]
            .map((element) =>
              Number(element.dataset.index) >= index ? 0 : element.offsetHeight
            )
            .reduce((a, b) => a + b, 0),
          adjustTop = () => {
            if (this.isMobile && this.layoutMobile === "stacked") {
              const gapAdjustment = this.gap * index * -1,
                breathingSpace = this.gap / 2;
              return gapAdjustment + breathingSpace;
            }
            return this.stickyTop;
          },
          distance =
            parentOffset + cumulativeHeight - adjustTop() - this.headerHeight;
        setTimeout(() => {
          window.scrollTo({ top: distance, left: 0, behavior: "smooth" });
        }, 400);
      });
    }
  }
  register("sticky-image-cards", {
    onLoad() {
      sections$2[this.id] = new StickyImageCards(this);
    },
    onUnload() {
      sections$2[this.id].onUnload();
    },
    onBlockSelect(event2) {
      sections$2[this.id].onBlockSelect(event2);
    },
  });
  const selectors$2 = {
      wrapper: "[data-sticky-wrapper]",
      aside: "[data-sticky-aside]",
      inner: "[data-sticky-inner]",
      content: "[data-sticky-content]",
      text: ".js-only [data-sticky-text]",
      textInner: ".js-only [data-sticky-text-inner]",
      image: ".js-only [data-sticky-image]",
      images: "[data-sticky-images]",
      imageWrapper: ".image-wrapper",
      dot: "[data-sticky-dot]",
      textHighlight: "text-highlight",
    },
    attributes$1 = {
      withGaps: "data-sticky-with-gaps",
      singleText: "data-sticky-single-text",
      index: "data-index",
    },
    settings = {
      intersectionRatio: 0.5,
      scrollDirection: {
        horizontal: "horizontal",
        horizontalReversed: "horizontal-reversed",
        vertical: "vertical",
        verticalReversed: "vertical-reversed",
      },
      typeOfIntersecting: {
        maxVisibility: "maximum-visibility-of-each-image-in-viewport",
        middleOfViewport: "image-in-the-middle-of-viewport",
      },
    },
    classes$2 = { isActive: "is-active" },
    sections$1 = {};
  class StickyImagesAndText {
    constructor(section) {
      (this.container = section.container),
        (this.scrollDirection = this.container.dataset.scrollDirection),
        (this.horizontalScroll =
          this.scrollDirection === settings.scrollDirection.horizontal ||
          this.scrollDirection === settings.scrollDirection.horizontalReversed),
        (this.verticalScroll =
          this.scrollDirection === settings.scrollDirection.vertical ||
          this.scrollDirection === settings.scrollDirection.verticalReversed),
        (this.reverseDirection =
          this.scrollDirection ===
            settings.scrollDirection.horizontalReversed ||
          this.scrollDirection === settings.scrollDirection.verticalReversed),
        (this.direction = this.reverseDirection ? 1 : -1),
        (this.withGaps = this.container.hasAttribute(attributes$1.withGaps)),
        (this.singleText = this.container.hasAttribute(
          attributes$1.singleText
        )),
        (this.image = this.container.querySelectorAll(selectors$2.image)),
        (this.text = this.container.querySelectorAll(selectors$2.text)),
        (this.textInner = this.container.querySelectorAll(
          selectors$2.textInner
        )),
        (this.images = this.container.querySelector(selectors$2.images)),
        (this.dot = this.container.querySelectorAll(selectors$2.dot)),
        (this.aside = this.container.querySelector(selectors$2.aside)),
        (this.inner = this.container.querySelector(selectors$2.inner)),
        (this.content = this.container.querySelector(selectors$2.content)),
        (this.wrapper = this.container.querySelector(selectors$2.wrapper)),
        (this.textHighlight = this.container.querySelectorAll(
          selectors$2.textHighlight
        )),
        (this.performAnimation = null),
        (this.lastOffset = 0),
        (this.activeIndex = 0),
        (this.lastActiveIndex = this.activeIndex),
        this.wrapper &&
          ((this.onScrollCallback = () => this.onScroll()),
          (this.onResizeCallback = () => this.onResize()),
          (this.calculateImagesOffsetCallback = () =>
            this.calculateImagesOffset()),
          this.init());
    }
    init() {
      this.getTypeOfIntersecting(),
        this.observeImagesIntersecting(),
        this.calculateHeights(),
        (this.performAnimation = requestAnimationFrame(
          this.calculateImagesOffsetCallback
        )),
        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.calculateHeights());
        }),
        document.addEventListener("theme:scroll", this.onScrollCallback),
        document.addEventListener("theme:resize:width", this.onResizeCallback),
        this.syncDots();
    }
    getTypeOfIntersecting() {
      (this.typeOfIntersecting = settings.typeOfIntersecting.maxVisibility),
        (this.fractionOfViewport =
          this.image[0].offsetHeight / window.innerHeight),
        !(!this.verticalScroll || isMobile()) &&
          this.fractionOfViewport < 0.6 &&
          (this.typeOfIntersecting =
            settings.typeOfIntersecting.middleOfViewport);
    }
    observeImagesIntersecting() {
      (this.observersCollection = new Set()),
        (this.compareIntersectionRatio = []),
        (this.maxVisibility = 0),
        (this.observer = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              const targetHeight = entry.target.offsetHeight,
                intersectionRatio = entry.intersectionRatio,
                isIntersecting = entry.isIntersecting,
                currentStats = {
                  target: entry.target,
                  intersectionRatio: entry.intersectionRatio,
                },
                checkMaxVisibility =
                  this.typeOfIntersecting ===
                  settings.typeOfIntersecting.maxVisibility;
              let intersectAt = settings.intersectionRatio;
              this.windowHeight <= targetHeight && (intersectAt = 0),
                checkMaxVisibility &&
                  isIntersecting &&
                  (this.observersCollection.forEach((item) => {
                    item.target === entry.target &&
                      this.observersCollection.delete(item);
                  }),
                  this.observersCollection.add(currentStats),
                  (this.compareIntersectionRatio = [
                    ...this.observersCollection,
                  ].map((item) => item.intersectionRatio)),
                  (this.maxVisibility = Math.max(
                    ...this.compareIntersectionRatio
                  ))),
                isIntersecting &&
                  intersectionRatio > intersectAt &&
                  checkMaxVisibility &&
                  this.maxVisibility === intersectionRatio &&
                  ((this.maxVisibilityItem = [...this.observersCollection].find(
                    (item) => item.intersectionRatio === this.maxVisibility
                  )),
                  (this.activeIndex = Number(
                    this.maxVisibilityItem.target.dataset.index
                  )),
                  this.lastActiveIndex !== this.activeIndex &&
                    (this.sync(), (this.lastActiveIndex = this.activeIndex)));
            });
          },
          {
            root: null,
            rootMargin: "0px",
            threshold: [
              0, 0.15, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.85, 1,
            ],
          }
        )),
        this.image.forEach((image) => this.observer.observe(image));
    }
    onScroll() {
      this.performAnimation ||
        (this.performAnimation = requestAnimationFrame(
          this.calculateImagesOffsetCallback
        )),
        this.typeOfIntersecting ===
          settings.typeOfIntersecting.middleOfViewport &&
          this.image.forEach((image) =>
            this.checkImagePositionInViewport(image)
          );
    }
    removeAnimationFrame() {
      this.performAnimation &&
        (cancelAnimationFrame(this.performAnimation),
        (this.performAnimation = null));
    }
    checkImagePositionInViewport(element) {
      if (!element) return;
      const windowHeight = window.innerHeight,
        scrollTop = window.scrollY,
        scrollMiddle = scrollTop + windowHeight / 2,
        scrollBottom = scrollTop + windowHeight,
        elementOffsetTopPoint = Math.round(
          element.getBoundingClientRect().top + scrollTop
        ),
        elementHeight = element.offsetHeight,
        elementOffsetBottomPoint = elementOffsetTopPoint + elementHeight,
        isBottomOfElementPassed = elementOffsetBottomPoint < scrollTop;
      elementOffsetTopPoint < scrollBottom &&
        !isBottomOfElementPassed &&
        scrollMiddle > elementOffsetTopPoint &&
        elementOffsetBottomPoint > scrollMiddle &&
        ((this.activeIndex = Number(element.dataset.index)),
        this.lastActiveIndex !== this.activeIndex &&
          (this.sync(), (this.lastActiveIndex = this.activeIndex)));
    }
    calculateImagesOffset() {
      const asideTop =
          this.aside.getBoundingClientRect().top - this.headerHeight,
        stickyStartingPoint = asideTop - this.innerStickyTop;
      let percent = 0,
        offset = 0;
      const triggerPoint = this.hasShortImages ? stickyStartingPoint : asideTop;
      triggerPoint < 0
        ? (percent = (triggerPoint / this.bottomEndingPoint) * -1 * 100)
        : triggerPoint >= 0
        ? (percent = 0)
        : (percent = 100),
        (offset = percent > 100 ? 100 : percent),
        (offset *= this.image.length - 1),
        (isMobile() || this.horizontalScroll) &&
          this.aside.style.setProperty(
            "--translateX",
            `${Number(offset * this.direction).toFixed(2)}%`
          ),
        this.lastOffset !== offset
          ? (this.performAnimation = requestAnimationFrame(
              this.calculateImagesOffsetCallback
            ))
          : this.performAnimation && this.removeAnimationFrame(),
        (this.lastOffset = offset);
    }
    calculateHeights() {
      let { stickyHeaderHeight, windowHeight } = readHeights();
      if (
        ((this.headerHeight = stickyHeaderHeight || 0),
        (this.windowHeight = windowHeight || window.innerHeight),
        this.text.length > 0)
      ) {
        const contentPaddingTop = this.content
            ? parseInt(
                window
                  .getComputedStyle(this.content)
                  .getPropertyValue("padding-top")
              )
            : 0,
          contentPaddingBottom = this.content
            ? parseInt(
                window
                  .getComputedStyle(this.content)
                  .getPropertyValue("padding-bottom")
              )
            : 0,
          textElementsHeights = [...this.text].map(
            (element) =>
              element.offsetHeight + contentPaddingTop + contentPaddingBottom
          ),
          textInnerElementsHeights = [...this.textInner].map(
            (element) => element.offsetHeight
          ),
          maxTextHeight = Math.max(...textElementsHeights),
          maxTextInnerHeight = Math.max(...textInnerElementsHeights),
          highestText = isMobile() ? maxTextInnerHeight : maxTextHeight,
          textElementsHeightsSum = textElementsHeights.reduce(
            (a, b) => a + b,
            0
          ),
          averageTextHeight =
            Math.floor(textElementsHeightsSum / textElementsHeights.length) ||
            this.text[0].offsetHeight;
        this.container.style.removeProperty("--average-text-height"),
          this.container.style.setProperty(
            "--average-text-height",
            `${averageTextHeight}px`
          ),
          this.container.style.removeProperty("--highest-text"),
          this.container.style.setProperty(
            "--highest-text",
            `${highestText}px`
          );
      }
      (this.imagesHeight = this.images.offsetHeight),
        (this.hasShortImages = !1),
        this.image.length > 0 &&
          ((this.imgHeight = this.image[0].querySelector(
            selectors$2.imageWrapper
          ).offsetHeight),
          (this.imgPadding = parseInt(
            window
              .getComputedStyle(this.image[0])
              .getPropertyValue("padding-top")
          )),
          this.container.style.removeProperty("--images-height"),
          this.container.style.setProperty(
            "--images-height",
            `${this.imagesHeight}px`
          ),
          this.container.style.removeProperty("--img-height"),
          this.container.style.setProperty(
            "--img-height",
            `${this.imgHeight + 2 * this.imgPadding}px`
          )),
        (this.asideHeight = this.aside.offsetHeight),
        (this.asidePadding = parseInt(
          window.getComputedStyle(this.aside).getPropertyValue("padding-top")
        )),
        (this.breathingSpace = (this.windowHeight - this.imagesHeight) / 2 / 2),
        (this.innerStickyTop =
          parseInt(
            window.getComputedStyle(this.inner).getPropertyValue("top")
          ) -
          this.headerHeight -
          this.breathingSpace),
        (this.gutters = this.withGaps ? 2 * this.asidePadding : 0),
        (this.additionalSpace = isMobile()
          ? this.withGaps
            ? this.asidePadding + 10
            : 10
          : this.gutters),
        (this.minHeightForEndingPoing =
          this.imagesHeight + this.additionalSpace),
        !isMobile() &&
          this.horizontalScroll &&
          ((this.minHeightForEndingPoing =
            this.windowHeight - this.headerHeight),
          (this.hasShortImages = this.fractionOfViewport <= 0.6),
          this.hasShortImages &&
            (this.minHeightForEndingPoing =
              this.imagesHeight -
              this.innerStickyTop +
              this.breathingSpace * 3)),
        (this.bottomEndingPoint =
          this.asideHeight - this.minHeightForEndingPoing);
    }
    refreshImagesOffsetValues() {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          document.dispatchEvent(new CustomEvent("theme:scroll"));
        });
      });
    }
    onResize() {
      this.calculateHeights(),
        requestAnimationFrame(() => this.calculateHeights()),
        this.getTypeOfIntersecting(),
        this.refreshImagesOffsetValues();
    }
    sync() {
      const textsToSync = this.singleText ? [] : this.text;
      [...this.image, ...textsToSync, ...this.dot].forEach((element) => {
        const elementIndex = Number(element.getAttribute(attributes$1.index));
        element.classList.toggle(
          classes$2.isActive,
          elementIndex === Number(this.activeIndex)
        );
      }),
        this.textHighlight.forEach((highlight) => highlight.shouldAnimate());
    }
    syncDots() {
      this.dot.forEach((element) => {
        element.addEventListener("click", (event2) => {
          event2.preventDefault();
          const activeIndex = Number(event2.target.dataset.index),
            imageToScrollTo = this.image[activeIndex],
            targetOffsetTop = Math.round(
              imageToScrollTo.getBoundingClientRect().top + window.scrollY
            ),
            targetHeight = imageToScrollTo.offsetHeight,
            containerTop = this.wrapper.offsetTop,
            imagesHeight = this.images.offsetHeight;
          let distance =
            containerTop + imagesHeight * activeIndex - this.headerHeight;
          this.verticalScroll &&
            isDesktop() &&
            ((distance = targetOffsetTop - this.headerHeight),
            this.typeOfIntersecting ===
              settings.typeOfIntersecting.middleOfViewport &&
              (distance =
                targetOffsetTop -
                window.innerHeight / 2 +
                targetHeight / 2 -
                this.headerHeight)),
            window.scrollTo({ top: distance, left: 0, behavior: "smooth" });
        });
      });
    }
    onUnload() {
      this.image.forEach((image) => this.observer.unobserve(image)),
        document.removeEventListener("theme:scroll", this.onScrollCallback),
        document.removeEventListener(
          "theme:resize:width",
          this.onResizeCallback
        );
    }
    onBlockSelect(event2) {
      const activeIndex = Number(event2.target.dataset.index),
        targetOffsetTop = Math.round(
          event2.target.getBoundingClientRect().top + window.scrollY
        ),
        targetHeight = event2.target.offsetHeight,
        containerTop = this.wrapper.offsetTop,
        imagesHeight = this.images.offsetHeight,
        scrollOffset = containerTop + imagesHeight * activeIndex,
        additionalSpace = isMobile()
          ? Math.round(10 / (this.image.length - 1)) * activeIndex
          : 0;
      let distance = scrollOffset - this.headerHeight - additionalSpace;
      this.verticalScroll &&
        isDesktop() &&
        ((distance = targetOffsetTop - this.headerHeight),
        this.typeOfIntersecting ===
          settings.typeOfIntersecting.middleOfViewport &&
          (distance =
            targetOffsetTop -
            window.innerHeight / 2 +
            targetHeight / 2 -
            this.headerHeight)),
        setTimeout(() => {
          window.scrollTo({ top: distance, left: 0, behavior: "smooth" });
        }, 500);
    }
  }
  register("sticky-images-and-text", [
    {
      onLoad() {
        sections$1[this.id] = new StickyImagesAndText(this);
      },
      onUnload() {
        sections$1[this.id].onUnload();
      },
      onBlockSelect(event2) {
        sections$1[this.id].onBlockSelect(event2);
      },
    },
    videoPlay,
  ]),
    register("subcollections", gridSlider),
    register("tab-collections", [productGrid, gridSlider, tabs]);
  const sections = {},
    selectors$1 = {
      slider: "[data-slider]",
      item: "[data-item]",
      button: ".flickity-button",
    },
    classes$1 = {
      flickityEnabled: "flickity-enabled",
      hasArrows: "has-arrows",
      carouselResize: "carousel--resize",
      buttonHolder: "flickity-button-holder",
    },
    attributes = { sectionId: "data-section-id" };
  class Testimonials {
    constructor(section) {
      (this.container = section.container),
        (this.sectionId = this.container.getAttribute(attributes.sectionId)),
        (this.slider = this.container.querySelector(selectors$1.slider)),
        this.slider &&
          ((this.slidesCount = this.slider.querySelectorAll(
            selectors$1.item
          ).length),
          (this.flkty = null),
          (this.onResizeCallback = () => this.onResize()),
          this.init());
    }
    init() {
      this.checkSlideCount(), this.listen();
    }
    onResize() {
      this.checkSlideCount(), this.flkty !== null && this.flkty.resize();
    }
    checkSlideCount() {
      const twoSlidesOnTablet =
          this.slidesCount == 2 && window.innerWidth >= theme.sizes.small,
        singleSlide = this.slidesCount == 1,
        isMobile2 = window.innerWidth < theme.sizes.small;
      if (twoSlidesOnTablet || singleSlide || isMobile2) {
        this.destroySlider();
        return;
      }
      if (!this.flkty) {
        this.initSlider(), this.onResize();
        return;
      }
      this.flkty &&
        (this.flkty.isActive || this.initSlider(),
        this.flkty.slideableWidth > this.flkty.size.width
          ? this.initSlider()
          : this.destroySlider());
    }
    initSlider() {
      (this.flkty = new Flickity(this.slider, {
        cellSelector: selectors$1.item,
        prevNextButtons: !0,
        pageDots: !1,
        groupCells: !0,
        cellAlign: "left",
        contain: !0,
        adaptiveHeight: !1,
        on: {
          ready: () => {
            requestAnimationFrame(() => {
              this.slider
                .querySelectorAll(selectors$1.button)
                .forEach((button) => {
                  wrap(button, classes$1.buttonHolder);
                });
            });
          },
        },
      })),
        this.container.classList.add(classes$1.hasArrows),
        this.createResizeClass();
    }
    createResizeClass() {
      if (typeof Flickity.prototype._createResizeClass == "function") return;
      (Flickity.prototype._createResizeClass = function () {
        this.element.classList.add(classes$1.carouselResize);
      }),
        Flickity.createMethods.push("_createResizeClass");
      const resize = Flickity.prototype.resize;
      Flickity.prototype.resize = function () {
        this.element.classList.remove(classes$1.carouselResize),
          resize.call(this),
          this.element.classList.add(classes$1.carouselResize);
      };
    }
    destroySlider() {
      this.slider.classList.contains(classes$1.flickityEnabled) &&
        (this.flkty !== null &&
          (this.slider
            .querySelectorAll(selectors$1.button)
            ?.forEach((button) => {
              const parent = button.parentNode;
              parent &&
                parent.classList.contains(classes$1.buttonHolder) &&
                (parent.parentNode.insertBefore(button, parent),
                parent.parentNode.removeChild(parent));
            }),
          this.flkty.destroy()),
        this.container.classList.remove(classes$1.hasArrows));
    }
    listen() {
      document.addEventListener("theme:resize:width", this.onResizeCallback);
    }
    onBlockSelect(evt) {
      if (this.flkty !== null && this.flkty.isActive) {
        const index = parseInt(
            [...evt.target.parentNode.children].indexOf(evt.target)
          ),
          slidesPerPage = parseInt(this.flkty.slides[0].cells.length),
          groupIndex = Math.floor(index / slidesPerPage);
        this.flkty.select(groupIndex);
      } else {
        const sliderStyle =
            this.slider.currentStyle || window.getComputedStyle(this.slider),
          sliderPadding = parseInt(sliderStyle.paddingLeft),
          blockPositionLeft = evt.target.offsetLeft - sliderPadding;
        this.slider.scrollTo({
          top: 0,
          left: blockPositionLeft,
          behavior: "smooth",
        });
      }
    }
    onUnload() {
      document.removeEventListener("theme:resize:width", this.onResizeCallback);
    }
  }
  register("testimonials", {
    onLoad() {
      sections[this.id] = new Testimonials(this);
    },
    onUnload(e) {
      sections[this.id].onUnload(e);
    },
    onBlockSelect(e) {
      sections[this.id].onBlockSelect(e);
    },
  });
  const classes = { noOutline: "no-outline" },
    selectors = {
      inPageLink: "[data-skip-content]",
      linkesWithOnlyHash: 'a[href="#"]',
    };
  class Accessibility {
    constructor() {
      this.init();
    }
    init() {
      (this.body = document.body),
        (this.inPageLink = document.querySelector(selectors.inPageLink)),
        (this.linkesWithOnlyHash = document.querySelectorAll(
          selectors.linkesWithOnlyHash
        )),
        (this.isFocused = !1),
        this.focusHash(),
        this.bindInPageLinks(),
        this.clickEvents(),
        this.focusEvents(),
        this.focusEventsOff();
    }
    clickEvents() {
      this.inPageLink &&
        this.inPageLink.addEventListener("click", (event2) => {
          event2.preventDefault();
        }),
        this.linkesWithOnlyHash &&
          this.linkesWithOnlyHash.forEach((item) => {
            item.addEventListener("click", (event2) => {
              event2.preventDefault();
            });
          });
    }
    focusEvents() {
      document.addEventListener("keyup", (event2) => {
        event2.code === theme.keyboardKeys.TAB &&
          (this.body.classList.remove(classes.noOutline),
          (this.isFocused = !0));
      });
    }
    focusEventsOff() {
      document.addEventListener("mousedown", () => {
        this.body.classList.add(classes.noOutline), (this.isFocused = !1);
      });
    }
    forceFocus(element, options2) {
      options2 = options2 || {};
      var savedTabIndex = element.tabIndex;
      (element.tabIndex = -1),
        (element.dataset.tabIndex = savedTabIndex),
        element.focus(),
        typeof options2.className < "u" &&
          element.classList.add(options2.className),
        element.addEventListener("blur", callback);
      function callback(event2) {
        event2.target.removeEventListener(event2.type, callback),
          (element.tabIndex = savedTabIndex),
          delete element.dataset.tabIndex,
          typeof options2.className < "u" &&
            element.classList.remove(options2.className);
      }
    }
    focusHash(options2) {
      options2 = options2 || {};
      let hash = window.location.hash;
      typeof theme.settings.newHash < "u" &&
        ((hash = theme.settings.newHash), (window.location.hash = `#${hash}`));
      const element = document.getElementById(hash.slice(1));
      if (element && options2.ignore && element.matches(options2.ignore))
        return !1;
      hash && element && this.forceFocus(element, options2);
    }
    bindInPageLinks(options2) {
      options2 = options2 || {};
      const links = Array.prototype.slice.call(
        document.querySelectorAll('a[href^="#"]')
      );
      function queryCheck(selector) {
        return document.getElementById(selector) !== null;
      }
      return links.filter((link) => {
        if (
          link.hash === "#" ||
          link.hash === "" ||
          (options2.ignore && link.matches(options2.ignore)) ||
          !queryCheck(link.hash.substr(1))
        )
          return !1;
        var element = document.querySelector(link.hash);
        return element
          ? (link.addEventListener("click", () => {
              this.forceFocus(element, options2);
            }),
            !0)
          : !1;
      });
    }
  }
  const getScrollbarWidth = () => {
    const outer = document.createElement("div");
    (outer.style.visibility = "hidden"),
      (outer.style.overflow = "scroll"),
      (outer.style.msOverflowStyle = "scrollbar"),
      document.body.appendChild(outer);
    const inner = document.createElement("div");
    outer.appendChild(inner);
    const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
    return outer.parentNode.removeChild(outer), scrollbarWidth;
  };
  document.documentElement.style.setProperty(
    "--scrollbar-width",
    `${getScrollbarWidth()}px`
  ),
    document.addEventListener("DOMContentLoaded", function () {
      load("*"),
        new Accessibility(),
        !customElements.get("product-grid-item-swatch") &&
          window.theme.settings.colorSwatchesType != "disabled" &&
          customElements.define("product-grid-item-swatch", GridSwatch),
        "scrollBehavior" in document.documentElement.style ||
          loadScript({ url: theme.assets.smoothscroll });
    });
  class productCoffy extends HTMLElement {
    constructor() {
      super(),
        (this.delegateElement = new Delegate(this)),
        this.querySelector(".c-quantity__block") &&
          ((this.buyButton = this.querySelector(".product__submit__bundle")),
          this.changeQuantity(),
          (this.subscriptionActive = !0),
          this.setUpSubscriptions(),
          this.onVariantChange());
    }
    connectedCallback() {
      console.log("connected"),
        this.delegateElement.on(
          "click",
          '[data-action="update-quantity"]',
          this.onUpdateQuantity.bind(this)
        ),
        this.delegateElement.on(
          "click",
          '[data-action="toggle-quantity"]',
          this.changeQuantity.bind(this)
        ),
        this.delegateElement.on(
          "click",
          '[data-action="toggle-subscription"]',
          this.toggleSubscription.bind(this)
        ),
        this.delegateElement.on(
          "click",
          '[data-action="toggle-color"]',
          this.changeColor.bind(this)
        );
    }
    toggleSubscription() {
      const target = event.target,
        activeIcon = this.querySelector(
          '.subscriptions__icons--active[aria-hidden="false"]'
        ),
        inactiveIcon = this.querySelector(
          '.subscriptions__icons--nactive[aria-hidden="true"]'
        );
      activeIcon &&
        inactiveIcon &&
        (activeIcon.setAttribute("aria-hidden", "true"),
        inactiveIcon.setAttribute("aria-hidden", "false"),
        requestAnimationFrame(() => {
          target
            .querySelector(".subscriptions__icons--active")
            .setAttribute("aria-hidden", "false"),
            target
              .querySelector(".subscriptions__icons--nactive")
              .setAttribute("aria-hidden", "true");
        })),
        (this.subscriptionActive = event.target.dataset.option === "recurring"),
        this.setUpSubscriptions(),
        this.onVariantChange();
    }
    setUpSubscriptions() {
      const currentSelector = this.querySelector(
        ".c-quantity__block.is-active"
      );
      if (
        ((this.subscriptionElement = this.querySelector(
          ".product__block.subscriptions"
        )),
        !currentSelector || !this.subscriptionElement)
      )
        return;
      const currentQuantity = parseInt(currentSelector.dataset.quantity, 10),
        currentPrice = parseFloat(currentSelector.dataset.price);
      this.updatePrice(currentPrice, currentQuantity);
    }
    updatePrice(price, quantity) {
      const discounts = JSON.parse(this.subscriptionElement.dataset.discounts),
        discountArray = this.parseDiscounts(discounts),
        discount = discountArray.find((item) => item.quantity === quantity) || {
          discount: 0,
        },
        newPrice = price * (1 - discount.discount / 100);
      this.updatePriceDisplay(price, newPrice, quantity, discount.discount),
        this.updateQuantitySelectorPrices(discountArray);
    }
    parseDiscounts(discounts) {
      return discounts
        .split(
          `
`
        )
        .map((line) => {
          const [quantity, discount] = line.split(":").map(Number);
          return { quantity, discount };
        });
    }
    updatePriceDisplay(oldPrice, newPrice, quantity, discountPercentage) {
      const oldFormattedPrice = themeVendor.themeCurrency.formatMoney(
          oldPrice,
          theme.moneyFormat
        ),
        newFormattedPrice = themeVendor.themeCurrency.formatMoney(
          newPrice,
          theme.moneyFormat
        ),
        unitPrice = themeVendor.themeCurrency.formatMoney(
          newPrice / quantity,
          "{{ amount }} kr"
        ),
        unitPriceBefore = themeVendor.themeCurrency.formatMoney(
          oldPrice / quantity,
          "{{ amount }} kr"
        );
      this.setTextContent(
        ".subscriptions__header-price--before",
        oldFormattedPrice
      ),
        this.setTextContent(
          ".subscriptions__header-price--after",
          newFormattedPrice
        ),
        this.setTextContent(
          ".subscriptions__header-price--onetime",
          oldFormattedPrice
        );
      const quantityString = window.theme.strings.capsules.replace(
          "{{ amount }}",
          quantity
        ),
        pricePerString = window.theme.strings.price_per.replace(
          "{{ amount }}",
          unitPrice
        ),
        pricePerStringBefore = window.theme.strings.price_per.replace(
          "{{ amount }}",
          unitPriceBefore
        );
      discountPercentage = Math.ceil(discountPercentage);
      const subscriptionPercentageString =
        window.theme.strings.save_amount.replace(
          "{{ amount }}",
          discountPercentage
        );
      this.setTextContent(
        ".subscriptions__option--recurring .subscriptions__amount--number",
        quantityString
      ),
        this.setTextContent(
          ".subscriptions__option--recurring .subscriptions__amount--per",
          pricePerString
        ),
        this.setTextContent(
          ".subscriptions__option--recurring .subscriptions__header-price--percentage",
          subscriptionPercentageString
        ),
        this.setTextContent(
          ".subscriptions__option--onetime .subscriptions__amount--number",
          quantityString
        ),
        this.setTextContent(
          ".subscriptions__option--onetime .subscriptions__amount--per",
          pricePerStringBefore
        );
    }
    setTextContent(selector, text) {
      const element = this.subscriptionElement.querySelector(selector);
      element && (element.textContent = text);
    }
    updateQuantitySelectorPrices(discountArray) {
      this.querySelectorAll(".c-quantity__block").forEach((selector) => {
        const quantity = parseInt(selector.dataset.quantity, 10),
          price = parseFloat(selector.dataset.price);
        let newPrice;
        if (this.subscriptionActive) {
          const discount = discountArray.find(
            (item) => item.quantity === quantity
          ) || { discount: 0 };
          newPrice = price * (1 - discount.discount / 100);
        } else
            (newPrice = price);
        const formattedPrice = themeVendor.themeCurrency.formatMoney(
            newPrice,
            theme.moneyFormat
          ),
          perFormattedPrice = themeVendor.themeCurrency.formatMoney(
            newPrice / quantity,
            "{{ amount }} kr"
          ),
          pricePerString = window.theme.strings.price_per.replace(
            "{{ amount }}",
            perFormattedPrice
          );
        this.setTextContentForSelector(
          selector,
          ".c-quantity__money",
          formattedPrice
        ),
          this.setTextContentForSelector(
            selector,
            ".c-quantity__money--per",
            pricePerString
          );
      });
    }
    setTextContentForSelector(selector, childSelector, text) {
      const element = selector.querySelector(childSelector);
      element && (element.textContent = text);
    }
    changeQuantity(event2) {
      const quantity = parseInt(
          event2
            ? event2.target.dataset.quantity
            : this.querySelector(".c-quantity__block.is-active").dataset
                .quantity
        ),
        totalElement = this.querySelector(".c-flavor__amount"),
        currentActive = this.querySelector(".c-quantity__block.is-active"),
        productI = parseInt(
          event2
            ? event2.target.dataset.base
            : this.querySelector(".c-quantity__block.is-active").dataset.base
        ),
        productV = parseInt(
          event2
            ? event2.target.dataset.baseVariant
            : this.querySelector(".c-quantity__block.is-active").dataset
                .baseVariant
        );
      currentActive && event2 && currentActive.classList.remove("is-active"),
        (this.dataset.productId = productI),
        (this.dataset.variantId = productV),
        (totalElement.dataset.current = 0),
        (totalElement.textContent = `0 / ${quantity}`),
        (totalElement.dataset.max = quantity),
        event2 && event2.target.classList.add("is-active"),
        this.resetTotals(),
        this.setUpSubscriptions(),
        this.onVariantChange();
    }
    changeColor(event2) {
      const currentActive = this.querySelector(".c-color__block.is-active");
      currentActive && event2 && currentActive.classList.remove("is-active"),
        event2 && event2.target.classList.add("is-active"),
        this.onVariantChange();
    }
    resetTotals() {
      const allInputs = this.querySelectorAll(".c-flavor__item-quantity input");
      let totalElement = parseFloat(
        this.querySelector(".c-flavor__amount").dataset.max
      );
      const numInputs = allInputs.length - 1;
      let valuePerInput = Math.floor(totalElement / (numInputs * 10)) * 10,
        distributedTotal = valuePerInput * numInputs,
        remainingTotal = totalElement - distributedTotal;
      allInputs.forEach((input, index) => {
        index < numInputs
          ? remainingTotal >= 10
            ? ((input.value = valuePerInput + 10), (remainingTotal -= 10))
            : (input.value = valuePerInput)
          : (input.value = 0);
      }),
        (this.querySelector(
          ".c-flavor__amount"
        ).innerText = `${totalElement} / ${totalElement}`),
        (this.querySelector(".c-flavor__amount").dataset.current =
          totalElement),
        this.updateButtonStates();
    }
    updateButtonStates() {
      const allInputs = this.querySelectorAll(".c-flavor__item-quantity input"),
        totalElement = this.querySelector(".c-flavor__amount"),
        currentQuantity = parseInt(totalElement.dataset.current),
        maxQuantity = parseInt(totalElement.dataset.max);
      console.log("maxQuantity", maxQuantity),
        console.log("currentQuantity", currentQuantity),
        allInputs.forEach((input) => {
          const value = parseInt(input.value),
            minusButton = input
              .closest(".c-flavor__item-quantity")
              .querySelector('[data-direction="minus"]'),
            plusButton = input
              .closest(".c-flavor__item-quantity")
              .querySelector('[data-direction="plus"]');
          (minusButton.disabled = value <= 0),
            (plusButton.disabled = currentQuantity >= maxQuantity),
            (this.buyButton.disabled = currentQuantity < maxQuantity);
        });
    }
    async onUpdateQuantity(event2) {
      const inputElement = event2.target
          .closest(".c-flavor__item-quantity")
          .querySelector("input"),
        inputValue = parseInt(inputElement.value),
        direction = event2.target.dataset.direction,
        totalElement = this.querySelector(".c-flavor__amount"),
        maxQuantity = parseInt(totalElement.dataset.max);
      let currentQuantity = parseInt(totalElement.dataset.current),
        newValue = inputValue;
      direction === "plus" && currentQuantity + 10 <= maxQuantity
        ? ((newValue += 10), (currentQuantity += 10))
        : direction === "minus" &&
          inputValue - 10 >= 0 &&
          ((newValue -= 10), (currentQuantity -= 10)),
        (inputElement.value = newValue),
        (totalElement.dataset.current = currentQuantity),
        (totalElement.textContent = `${currentQuantity} / ${maxQuantity}`),
        this.updateButtonStates();
    }
    onVariantChange() {
      let productData = JSON.parse(
        document.querySelector("[data-main-json]").innerHTML
      );
      this.querySelector(".c-quantity__block.is-active") &&
        (productData = JSON.parse(
          this.querySelector(
            ".c-quantity__block.is-active [data-variants-json]"
          ).innerHTML
        ));
      let currentColor = null,
        currentSubscription = null;
      const activeColorBlock = this.querySelector(".c-color__block.is-active");
      activeColorBlock && (currentColor = activeColorBlock.dataset.color);
      const activeSubscriptionBlock = this.querySelector(
          ".subscriptions__option--recurring"
        ),
        onetimeSubscriptionBlock = this.querySelector(
          ".subscriptions__option--onetime"
        );
      if (
        (activeSubscriptionBlock && this.subscriptionActive === !0
          ? (currentSubscription = activeSubscriptionBlock.dataset.type)
          : onetimeSubscriptionBlock &&
            (currentSubscription = onetimeSubscriptionBlock.dataset.type),
        !currentSubscription && !currentColor)
      ) {
        console.error("Either a color or a subscription option is required.");
        return;
      }
      const isMatchingVariant = (variant, options2) => {
          const variantOptions = [
            variant.option1,
            variant.option2,
            variant.option3,
          ].filter((opt) => opt !== null);
          return (
            console.log(`Variant options: ${variantOptions}`),
            console.log(`Selected options: ${options2}`),
            options2.every((option) => variantOptions.includes(option))
          );
        },
        selectedOptions = [];
      currentColor && selectedOptions.push(currentColor),
        currentSubscription && selectedOptions.push(currentSubscription),
        console.log(selectedOptions),
        console.log(productData);
      const matchingVariant = productData.find((variant) =>
        isMatchingVariant(variant, selectedOptions)
      );
      if (!matchingVariant) {
        console.error("No matching variant found for the selected options.");
        return;
      }
      const activeBlock = this.querySelector(".c-quantity__block.is-active");
      activeBlock && (this.dataset.productId = activeBlock.dataset.base),
        (this.dataset.variantId = matchingVariant.id);
    }
  }
  customElements.define("product-coffy", productCoffy);

  class coffyUpsell extends HTMLElement {
    constructor() {
      super(),
        (this.delegateElement = new Delegate(this)),
        (this.delegateBody = new Delegate(document.body));
    }
    connectedCallback() {
      this.delegateElement.on(
        "click",
        '[data-action="open-upsell"]',
        this.fetchProduct.bind(this)
      ),
        this.delegateBody.on(
          "click",
          '[data-action="close-upsell"]',
          this.closeModal.bind(this)
        );
    }
    fetchProduct() {
      const productHandle = event.target.dataset.handle;
      (async (productHandle2) => {
        const url = `/products/${productHandle2}`;
        try {
          const response = await fetch(url);
          if (response.ok) {
            const htmlContent = await response.text();
            (this.newContent = new DOMParser().parseFromString(
              htmlContent,
              "text/html"
            )),
              (this.newPopup = this.newContent.querySelector(
                '[data-section-type="product-template"] .wrapper'
              ).innerHTML),
              this.createModal();
          } else
            console.error("Error fetching data. HTTP status:", response.status);
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      })(productHandle);
    }
    createModal() {
      const modal = document.createElement("div"),
        close = document.createElement("button");
      (close.innerHTML = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.79825 7.9733L12.7582 4.0133C12.9428 3.79778 12.9304 3.47651 12.7298 3.27586C12.5291 3.07522 12.2078 3.06281 11.9923 3.24738L8.03232 7.20737L4.07233 3.24195C3.85681 3.05738 3.53554 3.06979 3.33489 3.27043C3.13425 3.47108 3.12184 3.79235 3.30641 4.00787L7.2664 7.9733L3.30098 11.9333C3.14596 12.066 3.07843 12.2745 3.12617 12.4729C3.1739 12.6714 3.32883 12.8263 3.52727 12.874C3.7257 12.9218 3.93415 12.8542 4.0669 12.6992L8.03232 8.73922L11.9923 12.6992C12.2078 12.8838 12.5291 12.8714 12.7298 12.6707C12.9304 12.4701 12.9428 12.1488 12.7582 11.9333L8.79825 7.9733Z" fill="black"/>
    </svg>`),
        (close.dataset.action = "close-upsell"),
        close.classList.add("upsell__close"),
        modal.classList.add("upsell__modal"),
        modal.setAttribute("aria-hidden", "true"),
        (modal.innerHTML = this.newPopup),
        modal.appendChild(close),
        document.querySelector(".page__overlay").classList.add("is-visible"),
        document
          .querySelector(".page__overlay")
          .addEventListener("click", () => {
            this.closeModal();
          });
      const accordians = modal.querySelectorAll(".product__accordions");
      accordians &&
        accordians.forEach((item) => {
          item.remove();
        }),
        window.scrollTo(0, 0),
        document.body.appendChild(modal),
        new Popout(modal.querySelector("[data-popout]"));
    }
    closeModal() {
      document.querySelector(".upsell__modal").remove(),
        document.querySelector(".page__overlay").classList.remove("is-visible");
    }
  }
  customElements.define("coffy-upsell", coffyUpsell),
    window.addEventListener("DOMContentLoaded", async () => {
      console.log("DOMContentLoaded fired");
      console.log(
        "checkoutVisited:",
        sessionStorage.getItem("checkoutVisited")
      );
      if (sessionStorage.getItem("checkoutVisited") === "true") {
        console.log("Session value is true, proceeding to clear cart...");
        
      } else {
        console.log("checkoutVisited is not true");
        fetch("/cart.js")
          .then((response) => response.json())
          .then((cart) => {
            // Cart fetched successfully
          })
          .catch((error) => {
            console.error("Error fetching the cart:", error);
          });
      }
    });
  function getCookie(name) {
    let cookieArr = document.cookie.split(";");
    for (let i = 0; i < cookieArr.length; i++) {
      let cookiePair = cookieArr[i].split("=");
      if (name === cookiePair[0].trim())
        return decodeURIComponent(cookiePair[1]);
    }
    return null;
  }
})(
  themeVendor.ScrollLock,
  themeVendor.Flickity,
  themeVendor.themeCurrency,
  themeVendor.ajaxinate
);
//# sourceMappingURL=/s/files/1/0275/4782/8291/t/82/assets/theme.dev.js.map?v=1739197018
